import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Object: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Asrs19AssessmentCompletionData = AssessmentCompletionData & {
  __typename?: 'ASRS19AssessmentCompletionData';
  schemaType: AssessmentSchemaType;
  subscores: Array<Asrs19SubscoreCompletionData>;
};

export enum Asrs19Subscale {
  HyperactivityImpulsivity = 'HyperactivityImpulsivity',
  Inattention = 'Inattention'
}

export type Asrs19SubscoreCompletionData = {
  __typename?: 'ASRS19SubscoreCompletionData';
  categorization: Scalars['String']['output'];
  color: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  subscale: Asrs19Subscale;
};

export type AcceptCollaboratorInvitationInput = {
  membershipId: Scalars['ID']['input'];
};

export type AcceptCollaboratorInvitationResponse = {
  __typename?: 'AcceptCollaboratorInvitationResponse';
  membership?: Maybe<ProviderUserMembership>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Activity = {
  activityType: ActivityType;
  id: Scalars['String']['output'];
  providerCollectionIds: Array<Scalars['String']['output']>;
};

export type ActivityAction = Activity & {
  __typename?: 'ActivityAction';
  activityType: ActivityType;
  id: Scalars['String']['output'];
  providerCollectionIds: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivityAssessment = Activity & {
  __typename?: 'ActivityAssessment';
  activityType: ActivityType;
  assessment: Assessment;
  id: Scalars['String']['output'];
  providerCollectionIds: Array<Scalars['String']['output']>;
};

export type ActivityAudio = Activity & {
  __typename?: 'ActivityAudio';
  activityType: ActivityType;
  activityUseType: ActivityUseType;
  createdAt: Scalars['Datetime']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  media: Media;
  providerCollectionIds: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivityAudioInput = {
  activityUseType?: InputMaybe<ActivityUseType>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  file: Scalars['Upload']['input'];
  title: Scalars['String']['input'];
};

export type ActivityFeedResult = {
  __typename?: 'ActivityFeedResult';
  activities?: Maybe<Array<PatientTask>>;
  checkIns?: Maybe<Array<CheckIn>>;
};

export enum ActivityFileCompletionType {
  Esign = 'Esign',
  Upload = 'Upload',
  View = 'View'
}

export type ActivityImage = Activity & {
  __typename?: 'ActivityImage';
  activityType: ActivityType;
  activityUseType: ActivityUseType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  media: Media;
  providerCollectionIds: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivityImageInput = {
  activityUseType?: InputMaybe<ActivityUseType>;
  file: Scalars['Upload']['input'];
  title: Scalars['String']['input'];
};

export type ActivityImageUploadLimits = {
  __typename?: 'ActivityImageUploadLimits';
  maxSize: Scalars['Int']['output'];
};

export type ActivityLink = Activity & {
  __typename?: 'ActivityLink';
  activityType: ActivityType;
  activityUseType: ActivityUseType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  providerCollectionIds: Array<Scalars['String']['output']>;
  thumbnailMedia?: Maybe<Media>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ActivityLinkInput = {
  activityUseType?: InputMaybe<ActivityUseType>;
  thumbnailImageURL?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ActivityPdf = Activity & {
  __typename?: 'ActivityPDF';
  activityType: ActivityType;
  activityUseType: ActivityUseType;
  completionType: ActivityFileCompletionType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  media: Media;
  providerCollectionIds: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ActivityPdfInput = {
  activityUseType?: InputMaybe<ActivityUseType>;
  completionType?: InputMaybe<ActivityFileCompletionType>;
  file: Scalars['Upload']['input'];
  title: Scalars['String']['input'];
};

export type ActivityTemplate = {
  __typename?: 'ActivityTemplate';
  activity?: Maybe<Activity>;
  activityType: ActivityType;
  name: Scalars['String']['output'];
  providerNote: Scalars['String']['output'];
};

export type ActivityText = Activity & {
  __typename?: 'ActivityText';
  activityType: ActivityType;
  activityUseType: ActivityUseType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  providerCollectionIds: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ActivityTextInput = {
  activityUseType?: InputMaybe<ActivityUseType>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum ActivityType {
  Action = 'Action',
  Assessment = 'Assessment',
  Audio = 'Audio',
  Esign = 'Esign',
  Image = 'Image',
  Link = 'Link',
  Pdf = 'PDF',
  PdfForm = 'PdfForm',
  Text = 'Text'
}

export enum ActivityUseType {
  OneTimeUse = 'OneTimeUse',
  Reusable = 'Reusable'
}

export type AddPatientsV2Input = {
  newPatientLeads: Array<NewPatientLead>;
};

export type AddPatientsV2Result = {
  __typename?: 'AddPatientsV2Result';
  newPatients?: Maybe<Array<Patient>>;
  validationErrors?: Maybe<Array<AddPatientsV2ValidationError>>;
};

export type AddPatientsV2ValidationError = {
  __typename?: 'AddPatientsV2ValidationError';
  emailInvalid?: Maybe<Scalars['Boolean']['output']>;
  inputId: Scalars['Int']['output'];
  isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  nameInvalid?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberInvalid?: Maybe<Scalars['Boolean']['output']>;
  tagsInvalid?: Maybe<Scalars['Boolean']['output']>;
};

export type AddProgramTagInput = {
  programId: Scalars['String']['input'];
  programTagId?: InputMaybe<Scalars['String']['input']>;
  programTagName?: InputMaybe<Scalars['String']['input']>;
};

export type AddProgramTagResult = {
  __typename?: 'AddProgramTagResult';
  updatedProgramTags: Array<ProgramTag>;
};

export type Appointment = {
  __typename?: 'Appointment';
  endTime?: Maybe<Scalars['Datetime']['output']>;
  startTime: Scalars['Datetime']['output'];
};

export type ArchiveActivitiesInput = {
  activities: Array<ArchiveActivityInput>;
};

export type ArchiveActivityInput = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
};

export type AskInviteeLocation = Location & {
  __typename?: 'AskInviteeLocation';
  location?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type Assessment = {
  __typename?: 'Assessment';
  assessmentSignatureUsers?: Maybe<Array<AssessmentSignatureUser>>;
  category: AssessmentCategory;
  completableByProviderOnly: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  description: Scalars['String']['output'];
  estimatedLengthInMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  increasingScoreTowardsHealth?: Maybe<Scalars['Boolean']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  moreInfoLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  oneTimeAssessment?: Maybe<Scalars['Boolean']['output']>;
  patientInterpretation?: Maybe<Scalars['String']['output']>;
  programTemplateAssessment?: Maybe<ProgramTemplateAssessment>;
  providerInterpretation?: Maybe<Scalars['String']['output']>;
  questionFrame?: Maybe<Scalars['String']['output']>;
  questions: Array<AssessmentQuestion>;
  schemaType: AssessmentSchemaType;
  scoreRange?: Maybe<ScoreRange>;
  scoreRanges?: Maybe<Array<AssessmentScoreRange>>;
  shortName: Scalars['String']['output'];
  type: AssessmentType;
};


export type AssessmentProgramTemplateAssessmentArgs = {
  programTemplateId: Scalars['String']['input'];
};

export type AssessmentAnswer = {
  questionType: AssessmentQuestionType;
};

export enum AssessmentCategory {
  Custom = 'Custom',
  Diagnostic = 'Diagnostic',
  Intake = 'Intake',
  Psychedelic = 'Psychedelic',
  Reflective = 'Reflective'
}

export type AssessmentCompletionData = {
  schemaType: AssessmentSchemaType;
};

export enum AssessmentFocalEvent {
  ClientActivation = 'ClientActivation',
  FirstSession = 'FirstSession'
}

export type AssessmentQuestion = {
  questionType: AssessmentQuestionType;
};

export enum AssessmentQuestionType {
  Autofill = 'Autofill',
  ConditionalMultipleChoice = 'ConditionalMultipleChoice',
  DatePicker = 'DatePicker',
  FileUpload = 'FileUpload',
  FreeText = 'FreeText',
  Initials = 'Initials',
  MultiSelect = 'MultiSelect',
  MultiSignature = 'MultiSignature',
  MultipleChoice = 'MultipleChoice',
  MultipleChoiceScored = 'MultipleChoiceScored',
  PatientContact = 'PatientContact',
  ProviderSignature = 'ProviderSignature',
  RichText = 'RichText',
  Signature = 'Signature',
  Statement = 'Statement',
  Unsupported = 'Unsupported'
}

export type AssessmentScheduleItemInput = {
  focalEvent: AssessmentFocalEvent;
  recurrenceInterval?: InputMaybe<Scalars['Duration']['input']>;
  timingOffset?: InputMaybe<Scalars['Duration']['input']>;
};

export enum AssessmentSchemaType {
  Asrs19 = 'ASRS19',
  Cbi = 'CBI',
  Ceq = 'CEQ',
  Custom = 'Custom',
  Hads = 'HADS',
  Meq30 = 'MEQ30',
  MultipleChoiceAverageScored = 'MultipleChoiceAverageScored',
  MultipleChoiceSumScored = 'MultipleChoiceSumScored',
  NonScored = 'NonScored',
  Piq = 'PIQ',
  Scs = 'SCS',
  Unsupported = 'Unsupported'
}

export type AssessmentScoreRange = {
  __typename?: 'AssessmentScoreRange';
  categorization: Scalars['String']['output'];
  color: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type AssessmentSignatureUser = {
  __typename?: 'AssessmentSignatureUser';
  id: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  signatureUserType: SignatureUser;
};

export type AssessmentSignatureUserInput = {
  orderIndex: Scalars['Int']['input'];
  signatureUserType: SignatureUser;
};

export enum AssessmentType {
  Ace = 'ACE',
  Asrs19 = 'ASRS19',
  Cbi = 'CBI',
  Ceq = 'CEQ',
  Cia = 'CIA',
  Csi16 = 'CSI16',
  Custom = 'Custom',
  Dadds = 'DADDS',
  Fs = 'FS',
  Gad7 = 'GAD7',
  Hads = 'HADS',
  Hit6 = 'HIT6',
  Icg = 'ICG',
  Isi = 'ISI',
  K6 = 'K6',
  Meq30 = 'MEQ30',
  Oha_303ClientDataForm = 'OHA_303_CLIENT_DATA_FORM',
  Pacs = 'PACS',
  Pcl5Monthly = 'PCL5_MONTHLY',
  Pcl5Weekly = 'PCL5_WEEKLY',
  Peg3 = 'PEG3',
  Phq9 = 'PHQ9',
  Piq = 'PIQ',
  PpsProspective = 'PPS_PROSPECTIVE',
  PpsRetrospective = 'PPS_RETROSPECTIVE',
  Scs = 'SCS',
  SelfConnectionScale = 'SELF_CONNECTION_SCALE',
  Spin = 'SPIN',
  Tsk11 = 'TSK11',
  Unsupported = 'Unsupported',
  Ybocs = 'YBOCS'
}

export type AssignPatientsToProgramInput = {
  programInstanceIds: Array<Scalars['String']['input']>;
  programTemplateId: Scalars['String']['input'];
};

export type AssignPatientsToProgramResult = {
  __typename?: 'AssignPatientsToProgramResult';
  updatedPatients: Array<Patient>;
};

export type AssignedClient = {
  __typename?: 'AssignedClient';
  id: Scalars['ID']['output'];
  latestProgramId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<ProgramTag>;
};

export type AuditLog = {
  __typename?: 'AuditLog';
  activityCategory?: Maybe<Scalars['String']['output']>;
  activityType: Scalars['String']['output'];
  actorType: AuditLogActorType;
  context?: Maybe<Scalars['JSON']['output']>;
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  extraMetadata?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  performedAt: Scalars['Datetime']['output'];
  performedByProviderUser?: Maybe<ProviderUserMember>;
};

/**
 * Audit log infrastructure types.
 * Can be used by any entity that needs activity tracking.
 */
export enum AuditLogActorType {
  External = 'EXTERNAL',
  ProviderUser = 'PROVIDER_USER',
  System = 'SYSTEM'
}

export type AuthResponse = {
  __typename?: 'AuthResponse';
  meProvider: MeProvider;
  signUpConfig?: Maybe<SignUpConfig>;
  tokenPayload: TokenPayload;
};

export enum AuthSessionRole {
  Admin = 'ADMIN',
  Patient = 'PATIENT',
  PatientLead = 'PATIENT_LEAD',
  Provider = 'PROVIDER',
  ProviderAdministrator = 'PROVIDER_ADMINISTRATOR',
  ProviderOwner = 'PROVIDER_OWNER',
  ProviderPractitioner = 'PROVIDER_PRACTITIONER'
}

export type AuthenticationCodeVerificationResponse = {
  __typename?: 'AuthenticationCodeVerificationResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  nextResendAllowedAt?: Maybe<Scalars['Datetime']['output']>;
  providerWordmarkLogoUrl?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  verificationId?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationLogoutResponse = {
  __typename?: 'AuthenticationLogoutResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export enum AuthenticationMethod {
  Auth0 = 'AUTH0',
  Otp = 'OTP'
}

export type AuthenticationRequestCodeInput = {
  email: Scalars['String']['input'];
  forceNew?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

export type AuthenticationRequestCodeResponse = {
  __typename?: 'AuthenticationRequestCodeResponse';
  codeSent: Scalars['Boolean']['output'];
  errors?: Maybe<Array<CommonFormValidationError>>;
  maskedEmail?: Maybe<Scalars['String']['output']>;
  nextResendAllowedAt?: Maybe<Scalars['Datetime']['output']>;
  success: Scalars['Boolean']['output'];
  verificationId?: Maybe<Scalars['ID']['output']>;
};

export type AuthenticationResendCodeInput = {
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  verificationId: Scalars['ID']['input'];
};

export type AuthenticationSession = {
  __typename?: 'AuthenticationSession';
  authenticationMethod: AuthenticationMethod;
  createdAt: Scalars['Datetime']['output'];
  durationType: AuthenticationSessionDuration;
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  lastActiveAt: Scalars['Datetime']['output'];
  providerId?: Maybe<Scalars['ID']['output']>;
  token: Scalars['ID']['output'];
};

export enum AuthenticationSessionDuration {
  Default = 'DEFAULT',
  Extended = 'EXTENDED'
}

export enum AuthenticationSource {
  Api = 'API',
  Internal = 'INTERNAL',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type AuthenticationVerifyCodeInput = {
  code: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  verificationId: Scalars['ID']['input'];
};

export type AuthenticationVerifyCodeResponse = {
  __typename?: 'AuthenticationVerifyCodeResponse';
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  errors?: Maybe<Array<CommonFormValidationError>>;
  expiresAt?: Maybe<Scalars['Datetime']['output']>;
  sessionToken?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type AutofillAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'AutofillAssessmentAnswer';
  answer?: Maybe<Scalars['String']['output']>;
  autofillSource: AutofillSource;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type AutofillAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'AutofillAssessmentQuestion';
  autofillSource: AutofillSource;
  autofillValue?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export enum AutofillSource {
  AddressCity = 'AddressCity',
  AddressCountry = 'AddressCountry',
  AddressPostalCode = 'AddressPostalCode',
  AddressState = 'AddressState',
  AddressStreet = 'AddressStreet',
  DateOfBirth = 'DateOfBirth',
  Email = 'Email',
  FullName = 'FullName',
  ParticipantId = 'ParticipantId',
  PhoneNumber = 'PhoneNumber',
  PractitionerName = 'PractitionerName',
  PractitionerRole = 'PractitionerRole',
  PreferredLanguage = 'PreferredLanguage',
  Timezone = 'Timezone'
}

export type AutomationExecution = {
  __typename?: 'AutomationExecution';
  actionsExecuted: Scalars['Int']['output'];
  actionsFailed: Scalars['Int']['output'];
  actionsSucceeded: Scalars['Int']['output'];
  /** @deprecated Use 'id' instead, will be removed in v2.0 */
  automationExecutionId: Scalars['String']['output'];
  automationRuleId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  conditionsMet: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventData?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  executionResults?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  status: AutomationExecutionStatus;
  triggerEventType: Scalars['String']['output'];
};

export enum AutomationExecutionStatus {
  Failure = 'failure',
  Skipped = 'skipped',
  Success = 'success'
}

export type AutomationRule = {
  __typename?: 'AutomationRule';
  actions: Array<AutomationRuleActionOutput>;
  /** @deprecated Use 'id' instead, will be removed in v2.0 */
  automationRuleId: Scalars['String']['output'];
  conditions: AutomationRuleConditionsOutput;
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  failureCount: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastTriggeredAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  triggerConfig?: Maybe<Scalars['String']['output']>;
  triggerCount: Scalars['Int']['output'];
  triggerEvent: AutomationRuleTriggerEvent;
  updatedAt: Scalars['String']['output'];
};

export type AutomationRuleAction = {
  params: Array<AutomationRuleActionParam>;
  type: Scalars['String']['input'];
};

export type AutomationRuleActionOutput = {
  __typename?: 'AutomationRuleActionOutput';
  params: Array<AutomationRuleActionParamOutput>;
  type: Scalars['String']['output'];
};

export type AutomationRuleActionParam = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AutomationRuleActionParamOutput = {
  __typename?: 'AutomationRuleActionParamOutput';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AutomationRuleCondition = {
  field: Scalars['String']['input'];
  operator: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type AutomationRuleConditionOutput = {
  __typename?: 'AutomationRuleConditionOutput';
  field: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AutomationRuleConditions = {
  logic: Scalars['String']['input'];
  rules: Array<AutomationRuleCondition>;
};

export type AutomationRuleConditionsOutput = {
  __typename?: 'AutomationRuleConditionsOutput';
  logic: Scalars['String']['output'];
  rules: Array<AutomationRuleConditionOutput>;
};

export enum AutomationRuleTriggerEvent {
  AppointmentMissed = 'appointment_missed',
  AppointmentScheduled = 'appointment_scheduled',
  AssessmentCompleted = 'assessment_completed',
  AssessmentSubmitted = 'assessment_submitted',
  ClientCreated = 'client_created',
  ClientTagAdded = 'client_tag_added',
  ClientTagChanged = 'client_tag_changed',
  ClientTagRemoved = 'client_tag_removed',
  InvoicePaid = 'invoice_paid',
  PractitionerAssigned = 'practitioner_assigned',
  PractitionerProfileUpdated = 'practitioner_profile_updated',
  ProgramEndDate = 'program_end_date',
  ProgramStartDate = 'program_start_date',
  ServiceArchived = 'service_archived',
  ServiceBooked = 'service_booked',
  ServiceCreated = 'service_created',
  ServiceUpdated = 'service_updated',
  SessionCompleted = 'session_completed',
  StorefrontUpdated = 'storefront_updated'
}

export type AutomationWebhookConfig = {
  __typename?: 'AutomationWebhookConfig';
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type AvailableProviderContextsInput = {
  statuses?: InputMaybe<Array<MembershipStatus>>;
};

export type BookableProviderService = {
  __typename?: 'BookableProviderService';
  calendlyEventColor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  hasCalendlyEvent: Scalars['Boolean']['output'];
  hasIntakeForm: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPriceLabelShown: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  serviceGroupName?: Maybe<Scalars['String']['output']>;
  serviceIcon: ServiceIcon;
  serviceIconColorUseCalendlyDefault?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
};

export type BrandingBrandSettings = {
  __typename?: 'BrandingBrandSettings';
  createdAt: Scalars['Datetime']['output'];
  emailImageMedia?: Maybe<Media>;
  id: Scalars['ID']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  squareLogoMedia?: Maybe<Media>;
  updatedAt: Scalars['Datetime']['output'];
  verifiedEmailSender?: Maybe<BrandingVerifiedEmailSender>;
  wordmarkLogoMedia?: Maybe<Media>;
};

export type BrandingCreateVerifiedEmailSenderInput = {
  address: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type BrandingCreateVerifiedEmailSenderResponse = {
  __typename?: 'BrandingCreateVerifiedEmailSenderResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
  verificationId?: Maybe<Scalars['String']['output']>;
  verificationStatus?: Maybe<Scalars['String']['output']>;
};

export type BrandingDeleteVerifiedEmailSenderResponse = {
  __typename?: 'BrandingDeleteVerifiedEmailSenderResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type BrandingImageUploadLimits = {
  __typename?: 'BrandingImageUploadLimits';
  maxBannerSize: Scalars['Int']['output'];
  maxLogoSize: Scalars['Int']['output'];
  maxWordmarkSize: Scalars['Int']['output'];
};

export type BrandingUpdateBrandSettingsInput = {
  emailImageMediaId?: InputMaybe<Scalars['ID']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  squareLogoMediaId?: InputMaybe<Scalars['ID']['input']>;
  wordmarkLogoMediaId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrandingUpdateBrandSettingsResponse = {
  __typename?: 'BrandingUpdateBrandSettingsResponse';
  brandSettings?: Maybe<BrandingBrandSettings>;
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type BrandingVerifiedEmailSender = {
  __typename?: 'BrandingVerifiedEmailSender';
  createdAt: Scalars['Datetime']['output'];
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: BrandingVerifiedEmailSenderStatus;
  updatedAt: Scalars['Datetime']['output'];
};

export enum BrandingVerifiedEmailSenderStatus {
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Verified = 'VERIFIED'
}

export type BrandingVerifyEmailSenderResponse = {
  __typename?: 'BrandingVerifyEmailSenderResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
  verificationStatus?: Maybe<Scalars['String']['output']>;
  verified?: Maybe<Scalars['Boolean']['output']>;
};

export type CbiAssessmentCompletionData = AssessmentCompletionData & {
  __typename?: 'CBIAssessmentCompletionData';
  schemaType: AssessmentSchemaType;
  subscores: Array<CbiSubscoreCompletionData>;
};

export enum CbiSubscale {
  ClientRelatedBurnout = 'ClientRelatedBurnout',
  PersonalBurnout = 'PersonalBurnout',
  WorkRelatedBurnout = 'WorkRelatedBurnout'
}

export type CbiSubscoreCompletionData = {
  __typename?: 'CBISubscoreCompletionData';
  categorization: Scalars['String']['output'];
  color: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  subscale: CbiSubscale;
};

export enum CalendarProvider {
  Google = 'GOOGLE',
  Microsoft = 'MICROSOFT'
}

export type CalendlyConnectedByProviderUser = {
  __typename?: 'CalendlyConnectedByProviderUser';
  name: Scalars['String']['output'];
  profileImageMedia?: Maybe<Media>;
};

export type CalendlyEventType = {
  __typename?: 'CalendlyEventType';
  calendlyEventTypeUri: Scalars['String']['output'];
  color: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  isVisible: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  schedulingUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export enum CalendlyImportStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  NotStarted = 'NotStarted',
  Started = 'Started'
}

export type CalendlyIntegration = {
  __typename?: 'CalendlyIntegration';
  connectedByProviderUser?: Maybe<CalendlyConnectedByProviderUser>;
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lookBackUntil: Scalars['Datetime']['output'];
};

export type CalendlyPractitionerEventTypes = {
  __typename?: 'CalendlyPractitionerEventTypes';
  eventTypes: Array<CalendlyEventType>;
  practitioner: PractitionerBasic;
};

export type CalendlyProfile = {
  __typename?: 'CalendlyProfile';
  eventTypes: Array<CalendlyEventType>;
  name: Scalars['String']['output'];
  ownerUri: Scalars['String']['output'];
};

export type CalendlyTeamProviderUser = {
  __typename?: 'CalendlyTeamProviderUser';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
};

export type ChatImageUploadLimits = {
  __typename?: 'ChatImageUploadLimits';
  maxSize: Scalars['Int']['output'];
};

export type CheckIn = {
  __typename?: 'CheckIn';
  createdAt: Scalars['Datetime']['output'];
  score: Scalars['Float']['output'];
};

export type CheckInData = {
  __typename?: 'CheckInData';
  last7DaysAverage: Scalars['Float']['output'];
  last7DaysAverageDifference: Scalars['Float']['output'];
  last7DaysCheckInsCount: Scalars['Float']['output'];
  last7DaysCheckInsCountDifference: Scalars['Float']['output'];
  lastCheckIn?: Maybe<CheckIn>;
  recent3CheckIns?: Maybe<Array<CheckIn>>;
  totalCheckIns: Scalars['Int']['output'];
};

export type ClientCalendarSessionSyncSettings = {
  __typename?: 'ClientCalendarSessionSyncSettings';
  enableCalendarSyncForSessions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  includeArchivedPatients: Scalars['Boolean']['output'];
  includeDeactivatedStaff: Scalars['Boolean']['output'];
  providerId: Scalars['ID']['output'];
  syncCalendarSessionsForCollaborators: Scalars['Boolean']['output'];
};

export type ClientFile = {
  __typename?: 'ClientFile';
  createdAt: Scalars['Datetime']['output'];
  /** When file was uploaded via external form completion, the name entered by the completer. */
  externalCompleterName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  media: Media;
  name: Scalars['String']['output'];
  programAssessmentId?: Maybe<Scalars['String']['output']>;
};

export type ClientFilesDeleteFileResponse = {
  __typename?: 'ClientFilesDeleteFileResponse';
  success: Scalars['Boolean']['output'];
};

export type ClientFilesUploadFileInput = {
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  programAssessmentId?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInput = {
  clientIds: Array<Scalars['ID']['input']>;
  practitionerId: Scalars['ID']['input'];
};

export type ClientPerformanceMetrics = {
  __typename?: 'ClientPerformanceMetrics';
  averageResponseTime?: Maybe<Scalars['Float']['output']>;
  averageTimeToFirstResponse?: Maybe<Scalars['Float']['output']>;
  totalAlerts?: Maybe<Scalars['Int']['output']>;
  totalSessions?: Maybe<Scalars['Int']['output']>;
};

export type ClientPerformanceSummary = {
  __typename?: 'ClientPerformanceSummary';
  id: Scalars['ID']['output'];
  metrics: ClientPerformanceMetrics;
  name: Scalars['String']['output'];
  startedAt: Scalars['Datetime']['output'];
  tags: Array<ProgramTag>;
};

export type ClientSession = ClientSessionGroup | ClientSessionIndividual;

export type ClientSessionBase = {
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser: ProviderUserMember;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  practitioners: Array<ClientSessionPractitioner>;
  provider: Provider;
  reviewStatus: ClientSessionReviewStatus;
  source: ClientSessionSource;
  startTime: Scalars['Datetime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ClientSessionConnection = {
  __typename?: 'ClientSessionConnection';
  edges: Array<ClientSession>;
  pageInfo: CommonPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClientSessionFilterInput = {
  patientId?: InputMaybe<Scalars['ID']['input']>;
  reviewStatus?: InputMaybe<ClientSessionReviewStatus>;
};

export type ClientSessionForm = {
  __typename?: 'ClientSessionForm';
  clientSessionId: Scalars['ID']['output'];
  createdAt: Scalars['Datetime']['output'];
  data: Scalars['JSON']['output'];
  formType: ClientSessionFormType;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ClientSessionFormSubmitInput = {
  clientSessionId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  formType: ClientSessionFormType;
};

export type ClientSessionFormSubmitResponse = {
  __typename?: 'ClientSessionFormSubmitResponse';
  errors?: Maybe<Array<CommonFormValidationError>>;
  form?: Maybe<ClientSessionForm>;
  success: Scalars['Boolean']['output'];
};

export enum ClientSessionFormType {
  Sb303V1 = 'SB303_V1'
}

export type ClientSessionFormUpdateInput = {
  data: Scalars['JSON']['input'];
  formId: Scalars['ID']['input'];
};

export type ClientSessionGroup = ClientSessionBase & {
  __typename?: 'ClientSessionGroup';
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser: ProviderUserMember;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  participants: Array<ClientSessionParticipant>;
  practitioners: Array<ClientSessionPractitioner>;
  provider: Provider;
  reviewStatus: ClientSessionReviewStatus;
  source: ClientSessionSource;
  startTime: Scalars['Datetime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ClientSessionIndividual = ClientSessionBase & {
  __typename?: 'ClientSessionIndividual';
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser: ProviderUserMember;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Datetime']['output'];
  id: Scalars['ID']['output'];
  participant: ClientSessionParticipant;
  practitioners: Array<ClientSessionPractitioner>;
  provider: Provider;
  reviewStatus: ClientSessionReviewStatus;
  source: ClientSessionSource;
  startTime: Scalars['Datetime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ClientSessionListInput = {
  filter?: InputMaybe<ClientSessionFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientSessionParticipant = {
  __typename?: 'ClientSessionParticipant';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImageMedia?: Maybe<Media>;
};

export type ClientSessionPractitioner = {
  __typename?: 'ClientSessionPractitioner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  profileImageMedia?: Maybe<Media>;
};

export enum ClientSessionReviewStatus {
  Confirmed = 'CONFIRMED',
  Dismissed = 'DISMISSED',
  PendingReview = 'PENDING_REVIEW'
}

export enum ClientSessionSource {
  CalendarAuto = 'CALENDAR_AUTO',
  CalendarManual = 'CALENDAR_MANUAL',
  Manual = 'MANUAL'
}

export type ClientsPerformanceSummaryInput = {
  clientIds: Array<Scalars['ID']['input']>;
  dateRange: DateRangeInput;
  interval: TimeSeriesInterval;
  practitionerId: Scalars['ID']['input'];
};

export type ClientsPerformanceSummaryResponse = {
  __typename?: 'ClientsPerformanceSummaryResponse';
  clients: Array<ClientPerformanceSummary>;
  totals: ClientPerformanceMetrics;
};

export type Comment = {
  __typename?: 'Comment';
  authorPatientId?: Maybe<Scalars['String']['output']>;
  authorProviderUserId?: Maybe<Scalars['String']['output']>;
  authorUserType: UserType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  imageMedia?: Maybe<Media>;
  sentByName: Scalars['String']['output'];
  sentByProfileImageUrl?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  voiceNote?: Maybe<VoiceNote>;
};

export type CommentInput = {
  imageMediaId?: InputMaybe<Scalars['String']['input']>;
  programFollowUpId?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  voiceNoteId?: InputMaybe<Scalars['String']['input']>;
};

/** Standard batch operation summary */
export type CommonBatchOperationSummary = {
  __typename?: 'CommonBatchOperationSummary';
  /** Number of items that encountered errors */
  errorCount: Scalars['Int']['output'];
  /** Number of items successfully processed */
  processedCount: Scalars['Int']['output'];
  /** Total number of items requested to be processed */
  requestedCount: Scalars['Int']['output'];
  /** Number of items skipped (already in desired state) */
  skippedCount: Scalars['Int']['output'];
};

export type CommonFormValidationError = {
  __typename?: 'CommonFormValidationError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CommonPageInfo = {
  __typename?: 'CommonPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CommonWhen = CommonWhenDate | CommonWhenDatespan | CommonWhenTime | CommonWhenTimespan;

export type CommonWhenDate = {
  __typename?: 'CommonWhenDate';
  date: Scalars['String']['output'];
  type: CommonWhenType;
};

export type CommonWhenDatespan = {
  __typename?: 'CommonWhenDatespan';
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  type: CommonWhenType;
};

export type CommonWhenInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  endTimezone?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  startTimezone?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CommonWhenTime = {
  __typename?: 'CommonWhenTime';
  time: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  type: CommonWhenType;
};

export type CommonWhenTimespan = {
  __typename?: 'CommonWhenTimespan';
  endTime: Scalars['String']['output'];
  endTimezone: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  startTimezone: Scalars['String']['output'];
  type: CommonWhenType;
};

export enum CommonWhenType {
  Date = 'DATE',
  Datespan = 'DATESPAN',
  Time = 'TIME',
  Timespan = 'TIMESPAN'
}

export type CompleteAssessmentAnswerInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  contactId?: InputMaybe<Scalars['String']['input']>;
  newContactDraftJson?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  questionType: AssessmentQuestionType;
  score?: InputMaybe<Scalars['Int']['input']>;
  signatureName?: InputMaybe<Scalars['String']['input']>;
  subscale?: InputMaybe<Scalars['String']['input']>;
};

export type CompleteProgramActivityInput = {
  assessmentAnswers?: InputMaybe<Array<CompleteAssessmentAnswerInput>>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  programActivityId: Scalars['String']['input'];
  signatureData?: InputMaybe<SignatureInput>;
};

export type CompleteProviderOnlyFormInput = {
  answers: Array<CompleteAssessmentAnswerInput>;
  assessmentId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  signatureName?: InputMaybe<Scalars['String']['input']>;
  signatureRole?: InputMaybe<Scalars['String']['input']>;
};

export type ConditionalMultipleChoiceAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'ConditionalMultipleChoiceAssessmentQuestion';
  answerOptions: Array<MultipleChoiceAssessmentQuestionAnswerOption>;
  followUp: ConditionalMultipleChoiceFollowUp;
  followUpWhen: Array<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type ConditionalMultipleChoiceFollowUp = {
  __typename?: 'ConditionalMultipleChoiceFollowUp';
  answerOptions: Array<MultipleChoiceAssessmentQuestionAnswerOption>;
  question: Scalars['String']['output'];
};

export type ContactDeletionImpact = {
  __typename?: 'ContactDeletionImpact';
  activeFormInvites: Array<ContactDeletionImpactFormInvite>;
  activeNoteShares: Array<ContactDeletionImpactNoteShare>;
  hasActiveLinks: Scalars['Boolean']['output'];
};

export type ContactDeletionImpactFormInvite = {
  __typename?: 'ContactDeletionImpactFormInvite';
  expiresAt: Scalars['Datetime']['output'];
  formName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ContactDeletionImpactNoteShare = {
  __typename?: 'ContactDeletionImpactNoteShare';
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  noteTitle: Scalars['String']['output'];
};

export enum ContactType {
  Custodian = 'CUSTODIAN',
  EmergencyContact = 'EMERGENCY_CONTACT',
  Guardian = 'GUARDIAN',
  Interpreter = 'INTERPRETER',
  Minor = 'MINOR',
  Other = 'OTHER',
  ParticipantSupportPerson = 'PARTICIPANT_SUPPORT_PERSON',
  Therapist = 'THERAPIST'
}

export type Content = {
  __typename?: 'Content';
  audioDuration?: Maybe<Scalars['Int']['output']>;
  audioFileName?: Maybe<Scalars['String']['output']>;
  audioMediaId?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  htmlMediaId?: Maybe<Scalars['String']['output']>;
  htmlUrl?: Maybe<Scalars['String']['output']>;
  imageMediaId?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CopyAutomationRuleResult = {
  __typename?: 'CopyAutomationRuleResult';
  automationRule: AutomationRule;
};

export type CopyCollectionToLibraryInput = {
  providerCollectionId: Scalars['String']['input'];
};

export type CreateAutomationRuleInput = {
  actions: Array<AutomationRuleAction>;
  conditions: AutomationRuleConditions;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  triggerConfig?: InputMaybe<Scalars['String']['input']>;
  triggerEvent: AutomationRuleTriggerEvent;
};

export type CreateClientSessionFromEventInput = {
  calendarId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};

export type CreateClientSessionFromEventResponse = {
  __typename?: 'CreateClientSessionFromEventResponse';
  clientSession?: Maybe<ClientSession>;
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomAssessmentInput = {
  assessmentSignatureUsers?: InputMaybe<Array<AssessmentSignatureUserInput>>;
  completableByProviderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  questions: Array<CustomAssessmentQuestionInput>;
};

export type CreateExternalPractitionerFormInviteInput = {
  assessmentId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  recipientContactId: Scalars['String']['input'];
};

export type CreateExternalPractitionerFormInvitePayload = {
  __typename?: 'CreateExternalPractitionerFormInvitePayload';
  expiresAt: Scalars['Datetime']['output'];
  inviteId: Scalars['String']['output'];
  programAssessmentId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateFollowUpDraftInput = {
  activities?: InputMaybe<Array<SendFollowUpActivityInput>>;
  isIntake?: InputMaybe<Scalars['Boolean']['input']>;
  programId: Scalars['String']['input'];
  providerNote?: InputMaybe<Scalars['String']['input']>;
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManualClientSessionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['ID']['input'];
  practitionerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  when?: InputMaybe<CommonWhenInput>;
};

export type CreateManualClientSessionResponse = {
  __typename?: 'CreateManualClientSessionResponse';
  clientSession?: Maybe<ClientSession>;
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type CreateMediaFileFromImageUrlInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  imageURL: Scalars['String']['input'];
};

export type CreateMediaFileInput = {
  category: MediaCategory;
  file: Scalars['Upload']['input'];
};

export type CreateNylasCalendarEventInput = {
  calendarId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
};

export type CreateNylasCalendarEventResponse = {
  __typename?: 'CreateNylasCalendarEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  event?: Maybe<NylasCalendarEvent>;
  success: Scalars['Boolean']['output'];
};

export type CreateProgramNoteInput = {
  note: Scalars['String']['input'];
  programId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProgramNoteShareInput = {
  programNoteId: Scalars['String']['input'];
  recipientContactId: Scalars['String']['input'];
};

export type CreateProgramTemplateInput = {
  cloneProgramTemplateId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  programLengthInMonths: Scalars['Int']['input'];
  useBaselineContent: Scalars['Boolean']['input'];
};

export type CreateProviderNoteTemplateInput = {
  isSharedNoteTemplate: Scalars['Boolean']['input'];
  note: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateProviderServiceInput = {
  assignedProviderUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  calendlyEventColor?: InputMaybe<Scalars['String']['input']>;
  calendlyEventTypeUri?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  intakeFormAssessmentId?: InputMaybe<Scalars['String']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  isPaid: Scalars['Boolean']['input'];
  isPriceLabelShown?: InputMaybe<Scalars['Boolean']['input']>;
  isShownOnStorefront: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  patientAccessLevel: PatientAccessLevel;
  price?: InputMaybe<Scalars['Int']['input']>;
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceIcon: ServiceIcon;
  serviceIconColorUseCalendlyDefault?: InputMaybe<Scalars['Boolean']['input']>;
  serviceSubmissionBody?: InputMaybe<Scalars['String']['input']>;
  serviceSubmissionRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  serviceSubmissionTitle?: InputMaybe<Scalars['String']['input']>;
  serviceTags?: InputMaybe<Array<ProgramTagInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateServiceGroupInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTaskGroupInput = {
  isResourceGroup?: InputMaybe<Scalars['Boolean']['input']>;
  programTemplateId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CuratedProviderCollection = {
  __typename?: 'CuratedProviderCollection';
  createdAt: Scalars['Datetime']['output'];
  curatorAvatarMedia: Media;
  curatorName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  headerMedia: Media;
  id: Scalars['String']['output'];
  providerCollection: ProviderCollection;
  updatedAt: Scalars['Datetime']['output'];
};

export type CustomAssessmentAutofillQuestionInput = {
  autofillSource: AutofillSource;
  question: Scalars['String']['input'];
};

export type CustomAssessmentCompletionData = AssessmentCompletionData & {
  __typename?: 'CustomAssessmentCompletionData';
  schemaType: AssessmentSchemaType;
};

export type CustomAssessmentDatePickerQuestionInput = {
  defaultToToday?: InputMaybe<Scalars['Boolean']['input']>;
  question: Scalars['String']['input'];
};

export type CustomAssessmentFileUploadQuestionInput = {
  allowedExtensions?: InputMaybe<Array<Scalars['String']['input']>>;
  question: Scalars['String']['input'];
};

export type CustomAssessmentFreeTextQuestionInput = {
  question: Scalars['String']['input'];
};

export type CustomAssessmentInitialsQuestionInput = {
  question: Scalars['String']['input'];
};

export type CustomAssessmentMultiSelectQuestionInput = {
  answerOptions: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CustomAssessmentMultiSignatureQuestionInput = {
  assessmentUserOrderIndices: Array<Scalars['Int']['input']>;
  question: Scalars['String']['input'];
};

export type CustomAssessmentMultipleChoiceQuestionInput = {
  answerOptions: Array<Scalars['String']['input']>;
  question: Scalars['String']['input'];
};

export type CustomAssessmentPatientContactQuestionInput = {
  contactType: ContactType;
  question: Scalars['String']['input'];
};

export type CustomAssessmentProviderSignatureQuestionInput = {
  question: Scalars['String']['input'];
};

export type CustomAssessmentQuestionInput = {
  autofillQuestion?: InputMaybe<CustomAssessmentAutofillQuestionInput>;
  datePickerQuestion?: InputMaybe<CustomAssessmentDatePickerQuestionInput>;
  fileUploadQuestion?: InputMaybe<CustomAssessmentFileUploadQuestionInput>;
  freeTextQuestion?: InputMaybe<CustomAssessmentFreeTextQuestionInput>;
  initialsQuestion?: InputMaybe<CustomAssessmentInitialsQuestionInput>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  multiSelectQuestion?: InputMaybe<CustomAssessmentMultiSelectQuestionInput>;
  multiSignatureQuestion?: InputMaybe<CustomAssessmentMultiSignatureQuestionInput>;
  multipleChoiceQuestion?: InputMaybe<CustomAssessmentMultipleChoiceQuestionInput>;
  patientContactQuestion?: InputMaybe<CustomAssessmentPatientContactQuestionInput>;
  providerSignatureQuestion?: InputMaybe<CustomAssessmentProviderSignatureQuestionInput>;
  questionType: AssessmentQuestionType;
  richTextQuestion?: InputMaybe<CustomAssessmentFreeTextQuestionInput>;
  signatureQuestion?: InputMaybe<CustomAssessmentSignatureQuestionInput>;
  statement?: InputMaybe<CustomAssessmentStatementQuestionInput>;
};

export type CustomAssessmentRichTextQuestionInput = {
  question: Scalars['String']['input'];
};

export type CustomAssessmentSignatureQuestionInput = {
  question: Scalars['String']['input'];
};

export type CustomAssessmentStatementQuestionInput = {
  statement: Scalars['String']['input'];
};

export type CustomLocation = Location & {
  __typename?: 'CustomLocation';
  location?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type DatePickerAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'DatePickerAssessmentAnswer';
  answer?: Maybe<Scalars['Date']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type DatePickerAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'DatePickerAssessmentQuestion';
  defaultToToday?: Maybe<Scalars['Boolean']['output']>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type DateRangeInput = {
  endDate: Scalars['Datetime']['input'];
  startDate: Scalars['Datetime']['input'];
};

export type DeactivatePatientsInput = {
  programInstanceIds: Array<Scalars['String']['input']>;
};

export type DeactivatePatientsResult = {
  __typename?: 'DeactivatePatientsResult';
  deactivatedPatients?: Maybe<Array<Patient>>;
};

export type DeclineCollaboratorInvitationInput = {
  membershipId: Scalars['ID']['input'];
};

export type DeclineCollaboratorInvitationResponse = {
  __typename?: 'DeclineCollaboratorInvitationResponse';
  membership?: Maybe<ProviderUserMembership>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFollowUpTemplateInput = {
  id: Scalars['String']['input'];
};

export type DeleteNylasCalendarEventInput = {
  calendarId: Scalars['String']['input'];
  eventId: Scalars['String']['input'];
};

export enum Direction {
  Down = 'DOWN',
  Neutral = 'NEUTRAL',
  Up = 'UP'
}

export type DismissClientSessionError = {
  __typename?: 'DismissClientSessionError';
  message: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
};

export type DismissClientSessionsResponse = {
  __typename?: 'DismissClientSessionsResponse';
  errors: Array<DismissClientSessionError>;
  /** Indicates if the operation was at least partially successful */
  success: Scalars['Boolean']['output'];
  summary: CommonBatchOperationSummary;
};

export type DismissProgramActivityInput = {
  programActivityId: Scalars['String']['input'];
};

export type DuplicateActivityInput = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
};

export type DuplicateFollowUpTemplateInput = {
  id: Scalars['String']['input'];
};

export type EditActivityFileSettingsInput = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
  activityUseType?: InputMaybe<ActivityUseType>;
  completionType?: InputMaybe<ActivityFileCompletionType>;
};

export type EditActivityTextInput = {
  activityTextId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditActivityTitleInput = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
  title: Scalars['String']['input'];
};

export type EditSentMailMessageInput = {
  programFollowUpId: Scalars['String']['input'];
  providerNote?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type EntityMetrics = {
  __typename?: 'EntityMetrics';
  id: Scalars['ID']['output'];
  metrics: Array<MetricDataPoint>;
  name: Scalars['String']['output'];
};

export type EventInvitee = {
  __typename?: 'EventInvitee';
  calendlyCancelUrl?: Maybe<Scalars['String']['output']>;
  calendlyEventUri: Scalars['String']['output'];
  calendlyInviteeUri: Scalars['String']['output'];
  calendlyRescheduleUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  program?: Maybe<Patient>;
  questionsAndAnswers?: Maybe<Array<EventInviteeQuestionAndAnswer>>;
  updatedAt: Scalars['Datetime']['output'];
};

export type EventInviteeQuestionAndAnswer = {
  __typename?: 'EventInviteeQuestionAndAnswer';
  answer: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type ExternalPractitionerFormInviteInfo = {
  __typename?: 'ExternalPractitionerFormInviteInfo';
  expiresAt: Scalars['Datetime']['output'];
  formName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  status: ExternalPractitionerFormInviteStatus;
  url: Scalars['String']['output'];
};

export enum ExternalPractitionerFormInviteStatus {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export enum Feature {
  ArticleCreationEditing = 'ArticleCreationEditing',
  AssessmentAssignment = 'AssessmentAssignment',
  AssessmentResultsSkip = 'AssessmentResultsSkip',
  Assessments = 'Assessments',
  BrandingVerifiedEmailSender = 'BrandingVerifiedEmailSender',
  CalendarSync = 'CalendarSync',
  CalendlyIntegration = 'CalendlyIntegration',
  ClientHideBookASession = 'ClientHideBookASession',
  ClientSessions = 'ClientSessions',
  Community = 'Community',
  DeepLinkSignup = 'DeepLinkSignup',
  EnableSwitchingProviderContext = 'EnableSwitchingProviderContext',
  ExternalNoteShare = 'ExternalNoteShare',
  MailSequences = 'MailSequences',
  PatientProfile = 'PatientProfile',
  PublicApiAccess = 'PublicApiAccess',
  StripeIntegration = 'StripeIntegration',
  TeamPerformance = 'TeamPerformance'
}

export enum FeedType {
  Activities = 'Activities',
  CheckIns = 'CheckIns'
}

export type FileUploadAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'FileUploadAssessmentAnswer';
  fileName?: Maybe<Scalars['String']['output']>;
  mediaId?: Maybe<Scalars['String']['output']>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type FileUploadAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'FileUploadAssessmentQuestion';
  allowedExtensions?: Maybe<Array<Scalars['String']['output']>>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type FileUploadConstants = {
  __typename?: 'FileUploadConstants';
  activityImage: ActivityImageUploadLimits;
  brandingImage: BrandingImageUploadLimits;
  chatImage: ChatImageUploadLimits;
  profileImage: ProfileImageUploadLimits;
  storefrontImage: StorefrontImageUploadLimits;
};

export enum FilterOperator {
  And = 'AND',
  Or = 'OR'
}

export type FollowUpTemplate = {
  __typename?: 'FollowUpTemplate';
  activityTemplates: Array<ActivityTemplate>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  isDraft: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  patients: Array<PatientName>;
  programTags: Array<ProgramTag>;
  providerNote: Scalars['String']['output'];
  providerVoiceNote?: Maybe<VoiceNote>;
  subject: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type FollowUpTemplatesInput = {
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FreeTextAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'FreeTextAssessmentAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type FreeTextAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'FreeTextAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type GoToMeetingLocation = Location & {
  __typename?: 'GoToMeetingLocation';
  joinUrl?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type GoogleConferenceLocation = Location & {
  __typename?: 'GoogleConferenceLocation';
  joinUrl?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type HadsAssessmentCompletionData = AssessmentCompletionData & {
  __typename?: 'HADSAssessmentCompletionData';
  schemaType: AssessmentSchemaType;
  subscores: Array<HadsSubscoreCompletionData>;
};

export enum HadsSubscale {
  Anxiety = 'Anxiety',
  Depression = 'Depression'
}

export type HadsSubscoreCompletionData = {
  __typename?: 'HADSSubscoreCompletionData';
  categorization: Scalars['String']['output'];
  color: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  subscale: HadsSubscale;
};

export enum ImageExtension {
  Jpeg = 'Jpeg',
  Jpg = 'Jpg',
  Png = 'Png'
}

export enum ImageMimeType {
  ImageJpeg = 'ImageJpeg',
  ImageJpg = 'ImageJpg',
  ImagePng = 'ImagePng'
}

export enum Impact {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type InboundCallLocation = Location & {
  __typename?: 'InboundCallLocation';
  location?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type InitialsAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'InitialsAssessmentAnswer';
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
  signatureName?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signingIpAddress?: Maybe<Scalars['String']['output']>;
};

export type InitialsAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'InitialsAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type IntakePackage = {
  __typename?: 'IntakePackage';
  calendlyEventType?: Maybe<CalendlyEventType>;
  completedStorefrontCalendlyBookingAt?: Maybe<Scalars['Datetime']['output']>;
  intakeFormProgramActivity?: Maybe<ProgramActivity>;
  storefrontSlug: Scalars['String']['output'];
};

export type InviteExternalCollaboratorInput = {
  accessExpiresInDays?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  patientDataPermission: PatientDataPermission;
  providerId: Scalars['ID']['input'];
  role: ProviderUserRole;
};

export type InviteExternalCollaboratorResponse = {
  __typename?: 'InviteExternalCollaboratorResponse';
  membership?: Maybe<ProviderUserMembership>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type InvitedProviderUser = {
  __typename?: 'InvitedProviderUser';
  email: Scalars['String']['output'];
  inviterProviderUserName?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerSquareLogoUrl?: Maybe<Scalars['String']['output']>;
  role: ProviderUserRole;
};

export enum InvoiceOfflinePaymentMethod {
  BankTransfer = 'BankTransfer',
  Cash = 'Cash',
  Check = 'Check',
  Other = 'Other'
}

export type LineItemInput = {
  existingStripePriceId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity: Scalars['Int']['input'];
};

export type LinkPreview = {
  __typename?: 'LinkPreview';
  imageURL?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  type: LocationType;
};

export enum LocationType {
  AskInvitee = 'AskInvitee',
  Custom = 'Custom',
  GoToMeeting = 'GoToMeeting',
  GoogleConference = 'GoogleConference',
  InboundCall = 'InboundCall',
  MicrosoftTeamsConference = 'MicrosoftTeamsConference',
  OutboundCall = 'OutboundCall',
  Physical = 'Physical',
  WebexConference = 'WebexConference',
  ZoomConference = 'ZoomConference'
}

export type MailSequenceActivityInput = {
  activityAudioId?: InputMaybe<Scalars['String']['input']>;
  activityImageId?: InputMaybe<Scalars['String']['input']>;
  activityLinkId?: InputMaybe<Scalars['String']['input']>;
  activityPdfId?: InputMaybe<Scalars['String']['input']>;
  activityTextId?: InputMaybe<Scalars['String']['input']>;
  activityType: Scalars['String']['input'];
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  isCompletable?: InputMaybe<Scalars['Boolean']['input']>;
  programAssessmentSignatureUsers?: InputMaybe<Array<MailSequenceSignatureUserInput>>;
  providerNote?: InputMaybe<Scalars['String']['input']>;
};

export type MailSequenceCancelEnrollmentResponse = {
  __typename?: 'MailSequenceCancelEnrollmentResponse';
  enrollment?: Maybe<MailSequenceEnrollment>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MailSequenceClientPreview = {
  __typename?: 'MailSequenceClientPreview';
  error?: Maybe<Scalars['String']['output']>;
  programId: Scalars['String']['output'];
  referenceDate?: Maybe<Scalars['Date']['output']>;
  steps: Array<MailSequenceClientPreviewStep>;
};

export type MailSequenceClientPreviewStep = {
  __typename?: 'MailSequenceClientPreviewStep';
  offsetDays: Scalars['Int']['output'];
  scheduledDate: Scalars['Date']['output'];
  skipReason?: Maybe<MailSequenceSkipReason>;
  stepIndex: Scalars['Int']['output'];
  willBeSkippedAtEnroll: Scalars['Boolean']['output'];
};

export type MailSequenceCustomReferenceDateInput = {
  programId: Scalars['String']['input'];
  referenceDate: Scalars['Date']['input'];
};

export type MailSequenceDeleteTemplateResponse = {
  __typename?: 'MailSequenceDeleteTemplateResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MailSequenceEnrollInput = {
  activities: Array<MailSequenceActivityInput>;
  customReferenceDates?: InputMaybe<Array<MailSequenceCustomReferenceDateInput>>;
  defaultSendTime: Scalars['String']['input'];
  isIntake?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programIds: Array<Scalars['String']['input']>;
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
  referenceDateType: MailSequenceReferenceDateType;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  sourceFollowUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  steps: Array<MailSequenceStepInput>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type MailSequenceEnrollResponse = {
  __typename?: 'MailSequenceEnrollResponse';
  enrollments: Array<MailSequenceEnrollment>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MailSequenceEnrollment = {
  __typename?: 'MailSequenceEnrollment';
  activities: Array<MailSequenceEnrollmentActivity>;
  cancelledAt?: Maybe<Scalars['Datetime']['output']>;
  cancelledByProviderUserId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  defaultSendTime: Scalars['String']['output'];
  enrolledByProviderUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isIntake: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  programId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  providerVoiceNoteId?: Maybe<Scalars['String']['output']>;
  referenceDate: Scalars['Date']['output'];
  referenceDateType: MailSequenceReferenceDateType;
  scheduledSends: Array<MailSequenceScheduledSend>;
  sendEmail: Scalars['Boolean']['output'];
  sendSms: Scalars['Boolean']['output'];
  snapshotVersion: Scalars['Int']['output'];
  sourceFollowUpTemplateId?: Maybe<Scalars['String']['output']>;
  status: MailSequenceEnrollmentStatus;
  templateId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Datetime']['output'];
};

export type MailSequenceEnrollmentActivity = {
  __typename?: 'MailSequenceEnrollmentActivity';
  activityType: Scalars['String']['output'];
  isAvailable: Scalars['Boolean']['output'];
  isCompletable: Scalars['Boolean']['output'];
  providerNote?: Maybe<Scalars['String']['output']>;
  signerCount: Scalars['Int']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  unavailableReason?: Maybe<Scalars['String']['output']>;
};

export enum MailSequenceEnrollmentStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED'
}

export type MailSequencePreviewDatesInput = {
  customReferenceDates?: InputMaybe<Array<MailSequenceCustomReferenceDateInput>>;
  programIds: Array<Scalars['String']['input']>;
  referenceDateType: MailSequenceReferenceDateType;
  steps: Array<MailSequenceStepInput>;
};

export type MailSequencePreviewDatesResponse = {
  __typename?: 'MailSequencePreviewDatesResponse';
  error?: Maybe<Scalars['String']['output']>;
  previews: Array<MailSequenceClientPreview>;
  success: Scalars['Boolean']['output'];
};

export enum MailSequenceReferenceDateType {
  Custom = 'CUSTOM',
  ProgramEndDate = 'PROGRAM_END_DATE',
  ProgramStartDate = 'PROGRAM_START_DATE'
}

export type MailSequenceSaveTemplateInput = {
  defaultActivities?: InputMaybe<Array<MailSequenceActivityInput>>;
  defaultSendTime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  referenceDateType?: InputMaybe<MailSequenceReferenceDateType>;
  steps: Array<MailSequenceStepInput>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type MailSequenceSaveTemplateResponse = {
  __typename?: 'MailSequenceSaveTemplateResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  template?: Maybe<MailSequenceTemplate>;
};

export type MailSequenceScheduledSend = {
  __typename?: 'MailSequenceScheduledSend';
  activities: Array<MailSequenceEnrollmentActivity>;
  attemptCount: Scalars['Int']['output'];
  enrollmentId: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  hasActivityOverride: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  programFollowUpId?: Maybe<Scalars['String']['output']>;
  providerNote: Scalars['String']['output'];
  scheduledDate: Scalars['Date']['output'];
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  skipReason?: Maybe<MailSequenceSkipReason>;
  status: MailSequenceScheduledSendStatus;
  stepIndex: Scalars['Int']['output'];
  subject: Scalars['String']['output'];
};

export enum MailSequenceScheduledSendStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Sending = 'SENDING',
  Sent = 'SENT',
  Skipped = 'SKIPPED'
}

export type MailSequenceSignatureUserInput = {
  assessmentSignatureUserId: Scalars['String']['input'];
  providerUserId?: InputMaybe<Scalars['String']['input']>;
};

export enum MailSequenceSkipReason {
  AssessmentArchived = 'ASSESSMENT_ARCHIVED',
  EnrollerDisabled = 'ENROLLER_DISABLED',
  PastDueAtEnroll = 'PAST_DUE_AT_ENROLL',
  PastDueBeyondLookback = 'PAST_DUE_BEYOND_LOOKBACK',
  PatientRemoved = 'PATIENT_REMOVED',
  ProgramDeactivated = 'PROGRAM_DEACTIVATED',
  ProviderDeleted = 'PROVIDER_DELETED',
  ProviderOnlyAfterEnroll = 'PROVIDER_ONLY_AFTER_ENROLL',
  ResourceArchived = 'RESOURCE_ARCHIVED',
  ResourceUnavailable = 'RESOURCE_UNAVAILABLE',
  SendFailed = 'SEND_FAILED',
  SignerUnavailable = 'SIGNER_UNAVAILABLE'
}

export type MailSequenceSkipScheduledSendResponse = {
  __typename?: 'MailSequenceSkipScheduledSendResponse';
  error?: Maybe<Scalars['String']['output']>;
  scheduledSend?: Maybe<MailSequenceScheduledSend>;
  success: Scalars['Boolean']['output'];
};

export type MailSequenceSnapshotActivity = {
  __typename?: 'MailSequenceSnapshotActivity';
  activityAudioId?: Maybe<Scalars['String']['output']>;
  activityImageId?: Maybe<Scalars['String']['output']>;
  activityLinkId?: Maybe<Scalars['String']['output']>;
  activityPdfId?: Maybe<Scalars['String']['output']>;
  activityTextId?: Maybe<Scalars['String']['output']>;
  activityType: Scalars['String']['output'];
  assessmentId?: Maybe<Scalars['String']['output']>;
  isCompletable?: Maybe<Scalars['Boolean']['output']>;
  programAssessmentSignatureUsers?: Maybe<Array<MailSequenceSnapshotSignatureUser>>;
  providerNote?: Maybe<Scalars['String']['output']>;
};

export type MailSequenceSnapshotSignatureUser = {
  __typename?: 'MailSequenceSnapshotSignatureUser';
  assessmentSignatureUserId: Scalars['String']['output'];
  providerUserId?: Maybe<Scalars['String']['output']>;
};

export type MailSequenceStepInput = {
  activities?: InputMaybe<Array<MailSequenceActivityInput>>;
  offsetDays: Scalars['Int']['input'];
  providerNote: Scalars['String']['input'];
  sourceFollowUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type MailSequenceTemplate = {
  __typename?: 'MailSequenceTemplate';
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUserId: Scalars['String']['output'];
  defaultActivities: Array<MailSequenceEnrollmentActivity>;
  defaultActivityInputs: Array<MailSequenceSnapshotActivity>;
  defaultSendTime?: Maybe<Scalars['String']['output']>;
  hasDefaultActivities: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  referenceDateType?: Maybe<MailSequenceReferenceDateType>;
  steps: Array<MailSequenceTemplateStep>;
  updatedAt: Scalars['Datetime']['output'];
};

export type MailSequenceTemplateStep = {
  __typename?: 'MailSequenceTemplateStep';
  activities: Array<MailSequenceEnrollmentActivity>;
  activityInputs: Array<MailSequenceSnapshotActivity>;
  hasActivityOverride: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  offsetDays: Scalars['Int']['output'];
  providerNote: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  sourceFollowUpTemplateId?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
};

export type MailSequenceUpdateEnrollmentNameResponse = {
  __typename?: 'MailSequenceUpdateEnrollmentNameResponse';
  enrollment?: Maybe<MailSequenceEnrollment>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type MailSequenceUpdateScheduledSendInput = {
  providerNote: Scalars['String']['input'];
  scheduledSendId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type MailSequenceUpdateScheduledSendResponse = {
  __typename?: 'MailSequenceUpdateScheduledSendResponse';
  error?: Maybe<Scalars['String']['output']>;
  scheduledSend?: Maybe<MailSequenceScheduledSend>;
  success: Scalars['Boolean']['output'];
};

export type MarkCommentsReadInput = {
  programFollowUpId?: InputMaybe<Scalars['String']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
};

export type MarkInvoicePaidInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: InvoiceOfflinePaymentMethod;
  programInvoiceId: Scalars['String']['input'];
};

export type MeProvider = {
  __typename?: 'MeProvider';
  billingInfo?: Maybe<ProviderBillingInfo>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  email: Scalars['String']['output'];
  emailImageMedia?: Maybe<Media>;
  hasBeenSubscribed: Scalars['Boolean']['output'];
  hasCreatedAProviderService: Scalars['Boolean']['output'];
  hasMultipleTeamMembers: Scalars['Boolean']['output'];
  hasNylasIntegration: Scalars['Boolean']['output'];
  hasPremiumAccess: Scalars['Boolean']['output'];
  hasSentFollowUps: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /**
   * Short-lived JWT proving this provider user's identity to the Intercom Messenger.
   * Only minted when this MeProvider is the provider user the request is authenticated
   * as; null on every other path that returns MeProvider, such as auth0GetUserByEmail.
   * Also null when the signing secret is unset and when signing fails, so callers must
   * not treat a token as guaranteed. A null only degrades to an unverified Messenger
   * while Messenger Security is unenforced in the Intercom workspace; once enforced, a
   * null stops the Messenger loading at all. Minted per request, only when selected.
   */
  intercomUserJwt?: Maybe<Scalars['String']['output']>;
  isExternalCollaborator: Scalars['Boolean']['output'];
  isProviderSubscribed: Scalars['Boolean']['output'];
  isTrialing: Scalars['Boolean']['output'];
  isV2: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notificationControls?: Maybe<ProviderUserNotificationControls>;
  notifications: Array<ProviderUserNotification>;
  nylasCalendarProvider?: Maybe<Scalars['String']['output']>;
  onboardingCompletedAt?: Maybe<Scalars['Datetime']['output']>;
  patientDataPermission: PatientDataPermission;
  primaryColor?: Maybe<Scalars['String']['output']>;
  profileImageMedia?: Maybe<Media>;
  provider: Provider;
  role: ProviderUserRole;
  seatUsage: SeatUsage;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  signUpConfig?: Maybe<SignUpConfig>;
  squareLogoMedia?: Maybe<Media>;
  storefrontSlug?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  trialEndsAt: Scalars['Datetime']['output'];
  wordmarkLogoMedia?: Maybe<Media>;
};

export type Media = {
  __typename?: 'Media';
  category: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  fileExtension?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDocument?: Maybe<Scalars['Boolean']['output']>;
  isPdf?: Maybe<Scalars['Boolean']['output']>;
  isPdfEditable?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export enum MediaCategory {
  JournalAudio = 'journal_audio',
  ModuleAudio = 'module_audio',
  ModuleFile = 'module_file',
  ModuleHtml = 'module_html',
  ModuleImage = 'module_image',
  ModulePdf = 'module_pdf',
  ModuleVideo = 'module_video'
}

export enum MembershipStatus {
  Active = 'ACTIVE',
  Invited = 'INVITED',
  Revoked = 'REVOKED',
  Suspended = 'SUSPENDED'
}

export type MetricComparison = {
  __typename?: 'MetricComparison';
  changeInPercentage: Scalars['Float']['output'];
  changeInValue: Scalars['Float']['output'];
  current: Scalars['Float']['output'];
  direction: Direction;
  impact: Impact;
  previous: Scalars['Float']['output'];
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  date: Scalars['Datetime']['output'];
  value: Scalars['Float']['output'];
};

export enum MetricType {
  ChatResponseTime = 'CHAT_RESPONSE_TIME',
  ChatTimeToFirstResponse = 'CHAT_TIME_TO_FIRST_RESPONSE',
  TotalClients = 'TOTAL_CLIENTS',
  TotalPractitioners = 'TOTAL_PRACTITIONERS',
  TotalSessions = 'TOTAL_SESSIONS'
}

export type MicrosoftTeamsConferenceLocation = Location & {
  __typename?: 'MicrosoftTeamsConferenceLocation';
  joinUrl?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type MoveProgramTemplateTaskInGroupInput = {
  newTaskGroupId?: InputMaybe<Scalars['String']['input']>;
  programTemplateId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
  taskIdsByWeight: Array<Scalars['String']['input']>;
};

export type MultiSelectAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'MultiSelectAssessmentAnswer';
  answers: Array<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type MultiSelectAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'MultiSelectAssessmentQuestion';
  answerOptions: Array<MultipleChoiceAssessmentQuestionAnswerOption>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type MultiSignatureAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'MultiSignatureAssessmentAnswer';
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
  signatures: Array<SignatureDetail>;
};

export type MultiSignatureAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'MultiSignatureAssessmentQuestion';
  assessmentSignatureOrderIndices: Array<Maybe<Scalars['Int']['output']>>;
  assessmentSignatureUsers?: Maybe<Array<AssessmentSignatureUser>>;
  existingSignatures?: Maybe<Array<SignatureDetail>>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type MultipleChoiceAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'MultipleChoiceAssessmentAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type MultipleChoiceAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'MultipleChoiceAssessmentQuestion';
  answerOptions: Array<MultipleChoiceAssessmentQuestionAnswerOption>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type MultipleChoiceAssessmentQuestionAnswerOption = {
  __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption';
  answerOption: Scalars['String']['output'];
};

export type MultipleChoiceScoredAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'MultipleChoiceScoredAssessmentAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
  score?: Maybe<Scalars['Int']['output']>;
  subscale?: Maybe<Scalars['String']['output']>;
};

export type MultipleChoiceScoredAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'MultipleChoiceScoredAssessmentQuestion';
  answerOptions: Array<MultipleChoiceScoredAssessmentQuestionAnswerOption>;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionFrame?: Maybe<Scalars['String']['output']>;
  questionType: AssessmentQuestionType;
  subscale?: Maybe<Scalars['String']['output']>;
};

export type MultipleChoiceScoredAssessmentQuestionAnswerOption = {
  __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption';
  answerOption: Scalars['String']['output'];
  score?: Maybe<Scalars['Int']['output']>;
};

export type MultipleChoiceSumScoredAssessmentCompletionData = AssessmentCompletionData & {
  __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData';
  categorization?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  schemaType: AssessmentSchemaType;
  score: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['String']['output']>;
  acceptCollaboratorInvitation: AcceptCollaboratorInvitationResponse;
  addActivityAudio: ActivityAudio;
  addActivityImage: ActivityImage;
  addActivityLink: ActivityLink;
  addActivityPDF: ActivityPdf;
  addActivityText: ActivityText;
  addActivityToProviderCollection: Activity;
  addCalendlyIntegration: CalendlyIntegration;
  addComment: Comment;
  addNylasIntegration: Scalars['Boolean']['output'];
  addPatientsToProviderUsers: Scalars['Boolean']['output'];
  addPatientsV2: AddPatientsV2Result;
  addProgramTag: AddProgramTagResult;
  addStripeIntegration: Scalars['Boolean']['output'];
  addVoiceNote: VoiceNote;
  archiveActivities: Array<Activity>;
  archiveActivity: Activity;
  /** @deprecated Use archiveActivity instead */
  archiveActivityAudio: ActivityAudio;
  /** @deprecated Use archiveActivity instead */
  archiveActivityImage: ActivityImage;
  /** @deprecated Use archiveActivity instead */
  archiveActivityLink: ActivityLink;
  /** @deprecated Use archiveActivity instead */
  archiveActivityPDF: ActivityPdf;
  /** @deprecated Use archiveActivity instead */
  archiveActivityText: ActivityText;
  /** @deprecated Use archiveActivity instead */
  archiveCustomAssessment: Assessment;
  archiveProviderService: Scalars['Boolean']['output'];
  assignAssessment: ProgramAssessment;
  assignPatientsToProgram: AssignPatientsToProgramResult;
  authenticationLogout: AuthenticationLogoutResponse;
  authenticationRequestCode: AuthenticationRequestCodeResponse;
  authenticationResendCode: AuthenticationRequestCodeResponse;
  authenticationVerifyCode: AuthenticationVerifyCodeResponse;
  brandingCreateVerifiedEmailSender: BrandingCreateVerifiedEmailSenderResponse;
  brandingDeleteVerifiedEmailSender: BrandingDeleteVerifiedEmailSenderResponse;
  brandingUpdateBrandSettings: BrandingUpdateBrandSettingsResponse;
  brandingVerifyEmailSender: BrandingVerifyEmailSenderResponse;
  cancelCalendlyEvent: Scalars['Boolean']['output'];
  changeCalendlyEventTypeVisibility: Scalars['Boolean']['output'];
  changePassword: Scalars['Boolean']['output'];
  changePasswordWithRecoveryCode: Scalars['Boolean']['output'];
  clearFormDraft: Scalars['Boolean']['output'];
  clientFilesDeleteFile: ClientFilesDeleteFileResponse;
  clientFilesUploadFile: ClientFile;
  completeAssessment: ProgramAssessment;
  completeOnboarding: Scalars['Boolean']['output'];
  completeProgramActivity: ProgramActivity;
  completeProviderOnlyForm: ProgramAssessment;
  completeServiceCalendlyBooking: Scalars['Boolean']['output'];
  completeServiceIntake: Scalars['Boolean']['output'];
  completeStorefrontCalendlyBooking: Scalars['Boolean']['output'];
  completeStorefrontIntake: Scalars['Boolean']['output'];
  copyAutomationRule: CopyAutomationRuleResult;
  copyCollectionToLibrary: ProviderCollection;
  createAutomationRule: AutomationRule;
  createClientSessionFromEvent: CreateClientSessionFromEventResponse;
  createCustomAssessment: Assessment;
  createExternalPractitionerFormInvite: CreateExternalPractitionerFormInvitePayload;
  createFollowUpDraft: ProgramFollowUp;
  createManualClientSession: CreateManualClientSessionResponse;
  createMediaFile: Media;
  createMediaFileFromImageURL: Media;
  createNylasCalendarEvent: CreateNylasCalendarEventResponse;
  createProgramNote: ProgramNote;
  createProgramNoteShare: ProgramNoteSharePayload;
  createProgramTag: ProgramTag;
  createProgramTask: Scalars['String']['output'];
  createProgramTemplate: ProgramTemplate;
  createProviderCollection: ProviderCollection;
  createProviderNoteTemplate: ProviderNoteTemplate;
  createProviderService: ProviderService;
  createServiceGroup: ServiceGroup;
  createTaskGroup: ProgramTemplateTaskGroup;
  deactivatePatients: DeactivatePatientsResult;
  deactivateProviderUser: ProviderUserMember;
  declineCollaboratorInvitation: DeclineCollaboratorInvitationResponse;
  deleteAutomationRule: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteFollowUpDraft: Scalars['Boolean']['output'];
  deleteFollowUpTemplate: Scalars['Boolean']['output'];
  deleteNylasCalendarEvent: Scalars['Boolean']['output'];
  deleteProgramNote: Scalars['Boolean']['output'];
  deleteProgramTag: ProgramTag;
  deleteProviderCollection: Scalars['Boolean']['output'];
  deleteProviderProgramMedia: Scalars['Boolean']['output'];
  deleteProviderUserInvite: Scalars['Boolean']['output'];
  deleteServiceGroup: Scalars['Boolean']['output'];
  deleteTaskGroup: Scalars['Boolean']['output'];
  disableAutomationRule: AutomationRule;
  dismissAssessment: ProgramAssessment;
  dismissClientSessions: DismissClientSessionsResponse;
  dismissProgramActivity: ProgramActivity;
  duplicateActivity: Activity;
  duplicateFollowUpTemplate: FollowUpTemplate;
  editActivityFileSettings: Activity;
  /** @deprecated Use editActivityFileSettings instead */
  editActivityPDFCompletionType: ActivityPdf;
  editActivityText: ActivityText;
  editActivityTitle: Activity;
  editSentMailMessage: ProgramFollowUp;
  enableAutomationRule: AutomationRule;
  /** @deprecated Using Auth0 instead */
  forgotPassword: Scalars['Boolean']['output'];
  importCalendlyData: Scalars['Boolean']['output'];
  inviteExternalCollaborator: InviteExternalCollaboratorResponse;
  isFilePdfEditable: Scalars['Boolean']['output'];
  linkInviteeEmailToProgram: Scalars['Boolean']['output'];
  mailSequenceCancelEnrollment: MailSequenceCancelEnrollmentResponse;
  mailSequenceDeleteTemplate: MailSequenceDeleteTemplateResponse;
  mailSequenceEnroll: MailSequenceEnrollResponse;
  mailSequencePreviewDates: MailSequencePreviewDatesResponse;
  mailSequenceSaveTemplate: MailSequenceSaveTemplateResponse;
  mailSequenceSkipScheduledSend: MailSequenceSkipScheduledSendResponse;
  mailSequenceUpdateEnrollmentName: MailSequenceUpdateEnrollmentNameResponse;
  mailSequenceUpdateScheduledSend: MailSequenceUpdateScheduledSendResponse;
  markAllProviderUserNotificationsRead: Scalars['Boolean']['output'];
  markCommentsRead: Scalars['Boolean']['output'];
  markInvoicePaid: ProgramInvoice;
  markProgramActivitiesSeen: Array<ProgramActivity>;
  markProgramSeen: Patient;
  markProviderUserNotificationRead: Scalars['Boolean']['output'];
  moveProgramTemplateTaskInGroup: Array<ProgramTemplateTaskGroup>;
  notifyProgramNote: ProgramNoteNotificationResult;
  patientCreatePatientContact: PatientContact;
  patientDeletePatientContact: Scalars['Boolean']['output'];
  patientPortalBookService: PatientPortalBookServiceResult;
  patientUpdatePatientContact: PatientContact;
  patientUpdateProfile: Patient;
  providerCompleteForm: ProgramAssessment;
  providerCreatePatientContact: PatientContact;
  providerDeletePatientContact: Scalars['Boolean']['output'];
  /** @deprecated Use providerCompleteForm instead */
  providerSignMultiSignatureAssessment: ProgramAssessment;
  providerSignUp: AuthResponse;
  providerUpdatePatientContact: PatientContact;
  providerUpdatePatientEmail: Patient;
  providerUpdatePatientProfile: Patient;
  providerUserInviteSignup: AuthResponse;
  providerUserLogin: AuthResponse;
  providerUserLogout: Scalars['Boolean']['output'];
  providersCreateApiCredential: ProvidersCreateApiCredentialResponse;
  providersDeactivateApiCredential: ProvidersDeactivateApiCredentialResponse;
  publicServiceSignUp: PublicServiceSignUpResult;
  reactivatePatients: ReactivatePatientsResult;
  reactivateProviderUser: ProviderUserMember;
  recordInvoiceDownload: Scalars['Boolean']['output'];
  recordInvoiceListExport: Scalars['Boolean']['output'];
  recordProgramActivityPdfDownload: Scalars['Boolean']['output'];
  recordProgramActivityResponsesViewed: Scalars['Boolean']['output'];
  recordProgramNotePdfDownload: Scalars['Boolean']['output'];
  refreshProgramInvoiceUrls: ProgramInvoice;
  removeActivityFromProviderCollection: Activity;
  removeCalendlyIntegration: CalendlyIntegration;
  removePatientsFromProviderUsers: Scalars['Boolean']['output'];
  removeProgramTag: RemoveProgramTagResult;
  removeProviderNoteTemplate: Scalars['Boolean']['output'];
  removeStripeIntegration: Scalars['Boolean']['output'];
  removeTaskFromProgramTemplate: Scalars['Boolean']['output'];
  renameFollowUpTemplate: FollowUpTemplate;
  renameTaskGroup: Scalars['Boolean']['output'];
  reorderProgramTags: Scalars['Boolean']['output'];
  reorderServiceGroups: Scalars['Boolean']['output'];
  reorderServices: Scalars['Boolean']['output'];
  reportUsageToStripe: Scalars['Boolean']['output'];
  resendPatientInvites: ResendPatientInvitesResult;
  resendProviderUserInvite: Scalars['Boolean']['output'];
  resetOnboarding: Scalars['Boolean']['output'];
  restoreClientSessions: RestoreClientSessionsResponse;
  revokeMembership: UpdateMembershipStatusResponse;
  revokeNylasIntegration: Scalars['Boolean']['output'];
  revokeProgramNoteShare: Scalars['Boolean']['output'];
  saveAdditionalThoughts: ProgramAssessment;
  saveFollowUpTemplate: FollowUpTemplate;
  saveFormDraft: SaveFormDraftPayload;
  scheduleAssessment: ScheduleAssessmentResult;
  sendAssessmentNotifications?: Maybe<Scalars['Boolean']['output']>;
  sendFollowUpEmail: Scalars['Boolean']['output'];
  sendFollowUpToMany: Array<Maybe<ProgramFollowUp>>;
  sendInvoice: ProgramInvoice;
  sendInvoiceReminder: Scalars['Boolean']['output'];
  sendPdfFormToEmail: Scalars['Boolean']['output'];
  sendProgramInvitesToPatients: SendProgramInvitesToPatientsResult;
  sendProviderUserInvites: Scalars['Boolean']['output'];
  sendTestProviderEmail: Scalars['Boolean']['output'];
  setPatientFirstAppointmentDate: Patient;
  softDeletePatient?: Maybe<Scalars['Boolean']['output']>;
  stripeCheckoutSuccess?: Maybe<Scalars['Boolean']['output']>;
  submitClientSessionForm: ClientSessionFormSubmitResponse;
  submitPdfForm: Scalars['Boolean']['output'];
  switchProviderContext: SwitchProviderContextResponse;
  testAutomationRule: TestAutomationRuleResult;
  testAutomationWebhook: TestAutomationWebhookResult;
  testDailyDigestEmail: Scalars['Boolean']['output'];
  unlinkInviteeEmailFromProgram: Scalars['Boolean']['output'];
  updateAutomationRule: AutomationRule;
  updateAutomationWebhookConfig: AutomationWebhookConfig;
  updateClientSession: UpdateClientSessionResponse;
  updateClientSessionForm: ClientSessionFormSubmitResponse;
  updateCustomAssessment: Assessment;
  updateFollowUpDraft: ProgramFollowUp;
  updateMediaContent: Scalars['Boolean']['output'];
  updateMediaFile: Scalars['Boolean']['output'];
  updateMembershipStatus: UpdateMembershipStatusResponse;
  updateNylasCalendar: NylasCalendar;
  updateNylasCalendarEvent: UpdateNylasCalendarEventResponse;
  /** @deprecated Use patientUpdateProfile, providerUpdatePatientProfile, or providerUpdatePatientEmail instead. Will be removed after frontend migration (target: Q2 2026) */
  updatePatient: Patient;
  updateProgramNote: ProgramNote;
  updateProgramTag: ProgramTag;
  updateProgramTask: Scalars['Boolean']['output'];
  updateProvider: Provider;
  updateProviderCalendarSessionSyncSettings: UpdateProviderCalendarSessionSyncSettingsResponse;
  updateProviderCollection: ProviderCollection;
  updateProviderNoteTemplate: ProviderNoteTemplate;
  updateProviderService: ProviderService;
  updateProviderStorefront: ProviderStorefront;
  updateProviderUser: MeProvider;
  updateProviderUserNotificationControls: ProviderUserNotificationControls;
  updateProviderUserRole: ProviderUserMember;
  updateServiceGroup: ServiceGroup;
  updateStripeSubscription?: Maybe<Scalars['Boolean']['output']>;
  uploadPatientProfileImage: Media;
  uploadProviderProgramMedia: ProviderProgramMedia;
  uploadProviderUserProfileImage: Scalars['Boolean']['output'];
  validateProviderUserEmail: Scalars['Boolean']['output'];
  voidInvoice: Scalars['Boolean']['output'];
  voidProgramActivity: ProgramActivity;
};


export type MutationAcceptCollaboratorInvitationArgs = {
  input: AcceptCollaboratorInvitationInput;
};


export type MutationAddActivityAudioArgs = {
  input: ActivityAudioInput;
};


export type MutationAddActivityImageArgs = {
  input: ActivityImageInput;
};


export type MutationAddActivityLinkArgs = {
  input: ActivityLinkInput;
};


export type MutationAddActivityPdfArgs = {
  input: ActivityPdfInput;
};


export type MutationAddActivityTextArgs = {
  input: ActivityTextInput;
};


export type MutationAddActivityToProviderCollectionArgs = {
  input: ProviderCollectionActivityInput;
};


export type MutationAddCalendlyIntegrationArgs = {
  authorizationCode: Scalars['String']['input'];
};


export type MutationAddCommentArgs = {
  input: CommentInput;
};


export type MutationAddNylasIntegrationArgs = {
  code: Scalars['String']['input'];
  provider: CalendarProvider;
};


export type MutationAddPatientsToProviderUsersArgs = {
  input: ProviderUsersToPatientsInput;
};


export type MutationAddPatientsV2Args = {
  input: AddPatientsV2Input;
};


export type MutationAddProgramTagArgs = {
  input: AddProgramTagInput;
};


export type MutationAddStripeIntegrationArgs = {
  authorizationCode: Scalars['String']['input'];
};


export type MutationAddVoiceNoteArgs = {
  input: VoiceNoteInput;
};


export type MutationArchiveActivitiesArgs = {
  input: ArchiveActivitiesInput;
};


export type MutationArchiveActivityArgs = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
};


export type MutationArchiveActivityAudioArgs = {
  activityAudioId: Scalars['String']['input'];
};


export type MutationArchiveActivityImageArgs = {
  activityImageId: Scalars['String']['input'];
};


export type MutationArchiveActivityLinkArgs = {
  activityLinkId: Scalars['String']['input'];
};


export type MutationArchiveActivityPdfArgs = {
  activityPDFId: Scalars['String']['input'];
};


export type MutationArchiveActivityTextArgs = {
  activityTextId: Scalars['String']['input'];
};


export type MutationArchiveCustomAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
};


export type MutationArchiveProviderServiceArgs = {
  providerServiceId: Scalars['String']['input'];
};


export type MutationAssignAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type MutationAssignPatientsToProgramArgs = {
  input: AssignPatientsToProgramInput;
};


export type MutationAuthenticationRequestCodeArgs = {
  input: AuthenticationRequestCodeInput;
};


export type MutationAuthenticationResendCodeArgs = {
  input: AuthenticationResendCodeInput;
};


export type MutationAuthenticationVerifyCodeArgs = {
  input: AuthenticationVerifyCodeInput;
};


export type MutationBrandingCreateVerifiedEmailSenderArgs = {
  input: BrandingCreateVerifiedEmailSenderInput;
};


export type MutationBrandingUpdateBrandSettingsArgs = {
  input: BrandingUpdateBrandSettingsInput;
};


export type MutationCancelCalendlyEventArgs = {
  calendlyEventUri: Scalars['String']['input'];
  reasonForCancellation?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeCalendlyEventTypeVisibilityArgs = {
  calendlyEventTypeUri: Scalars['String']['input'];
  shouldBeVisible: Scalars['Boolean']['input'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationChangePasswordWithRecoveryCodeArgs = {
  newPassword: Scalars['String']['input'];
  recoveryCode: Scalars['String']['input'];
};


export type MutationClearFormDraftArgs = {
  programAssessmentId: Scalars['String']['input'];
};


export type MutationClientFilesDeleteFileArgs = {
  clientFileId: Scalars['String']['input'];
};


export type MutationClientFilesUploadFileArgs = {
  input: ClientFilesUploadFileInput;
};


export type MutationCompleteAssessmentArgs = {
  answers: Array<CompleteAssessmentAnswerInput>;
  programAssessmentId: Scalars['String']['input'];
};


export type MutationCompleteProgramActivityArgs = {
  input: CompleteProgramActivityInput;
};


export type MutationCompleteProviderOnlyFormArgs = {
  input: CompleteProviderOnlyFormInput;
};


export type MutationCompleteServiceCalendlyBookingArgs = {
  serviceIntakePackageId: Scalars['String']['input'];
};


export type MutationCompleteServiceIntakeArgs = {
  serviceIntakePackageId: Scalars['String']['input'];
};


export type MutationCopyAutomationRuleArgs = {
  automationRuleId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCopyCollectionToLibraryArgs = {
  input: CopyCollectionToLibraryInput;
};


export type MutationCreateAutomationRuleArgs = {
  input: CreateAutomationRuleInput;
};


export type MutationCreateClientSessionFromEventArgs = {
  input: CreateClientSessionFromEventInput;
};


export type MutationCreateCustomAssessmentArgs = {
  input: CreateCustomAssessmentInput;
};


export type MutationCreateExternalPractitionerFormInviteArgs = {
  input: CreateExternalPractitionerFormInviteInput;
};


export type MutationCreateFollowUpDraftArgs = {
  input: CreateFollowUpDraftInput;
};


export type MutationCreateManualClientSessionArgs = {
  input: CreateManualClientSessionInput;
};


export type MutationCreateMediaFileArgs = {
  input: CreateMediaFileInput;
};


export type MutationCreateMediaFileFromImageUrlArgs = {
  input: CreateMediaFileFromImageUrlInput;
};


export type MutationCreateNylasCalendarEventArgs = {
  input: CreateNylasCalendarEventInput;
};


export type MutationCreateProgramNoteArgs = {
  input: CreateProgramNoteInput;
};


export type MutationCreateProgramNoteShareArgs = {
  input: CreateProgramNoteShareInput;
};


export type MutationCreateProgramTagArgs = {
  input: ProgramTagInput;
};


export type MutationCreateProgramTaskArgs = {
  input: ProgramTaskInput;
  programTemplateId: Scalars['String']['input'];
};


export type MutationCreateProgramTemplateArgs = {
  input: CreateProgramTemplateInput;
};


export type MutationCreateProviderCollectionArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateProviderNoteTemplateArgs = {
  input: CreateProviderNoteTemplateInput;
};


export type MutationCreateProviderServiceArgs = {
  input: CreateProviderServiceInput;
};


export type MutationCreateServiceGroupArgs = {
  input: CreateServiceGroupInput;
};


export type MutationCreateTaskGroupArgs = {
  input: CreateTaskGroupInput;
};


export type MutationDeactivatePatientsArgs = {
  input: DeactivatePatientsInput;
};


export type MutationDeactivateProviderUserArgs = {
  providerUserId: Scalars['String']['input'];
};


export type MutationDeclineCollaboratorInvitationArgs = {
  input: DeclineCollaboratorInvitationInput;
};


export type MutationDeleteAutomationRuleArgs = {
  automationRuleId: Scalars['String']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationDeleteFollowUpDraftArgs = {
  programFollowUpId: Scalars['String']['input'];
};


export type MutationDeleteFollowUpTemplateArgs = {
  input: DeleteFollowUpTemplateInput;
};


export type MutationDeleteNylasCalendarEventArgs = {
  input: DeleteNylasCalendarEventInput;
};


export type MutationDeleteProgramNoteArgs = {
  programNoteId: Scalars['String']['input'];
};


export type MutationDeleteProgramTagArgs = {
  programTagId: Scalars['String']['input'];
};


export type MutationDeleteProviderCollectionArgs = {
  providerCollectionId: Scalars['String']['input'];
};


export type MutationDeleteProviderProgramMediaArgs = {
  providerProgramMediaId: Scalars['String']['input'];
};


export type MutationDeleteProviderUserInviteArgs = {
  providerUserId: Scalars['String']['input'];
};


export type MutationDeleteServiceGroupArgs = {
  serviceGroupId: Scalars['String']['input'];
};


export type MutationDeleteTaskGroupArgs = {
  taskGroupId: Scalars['String']['input'];
};


export type MutationDisableAutomationRuleArgs = {
  automationRuleId: Scalars['String']['input'];
};


export type MutationDismissAssessmentArgs = {
  programAssessmentId: Scalars['String']['input'];
};


export type MutationDismissClientSessionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDismissProgramActivityArgs = {
  input: DismissProgramActivityInput;
};


export type MutationDuplicateActivityArgs = {
  input: DuplicateActivityInput;
};


export type MutationDuplicateFollowUpTemplateArgs = {
  input: DuplicateFollowUpTemplateInput;
};


export type MutationEditActivityFileSettingsArgs = {
  input: EditActivityFileSettingsInput;
};


export type MutationEditActivityPdfCompletionTypeArgs = {
  activityPDFId: Scalars['String']['input'];
  completionType: ActivityFileCompletionType;
};


export type MutationEditActivityTextArgs = {
  input: EditActivityTextInput;
};


export type MutationEditActivityTitleArgs = {
  input: EditActivityTitleInput;
};


export type MutationEditSentMailMessageArgs = {
  input: EditSentMailMessageInput;
};


export type MutationEnableAutomationRuleArgs = {
  automationRuleId: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationInviteExternalCollaboratorArgs = {
  input: InviteExternalCollaboratorInput;
};


export type MutationIsFilePdfEditableArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationLinkInviteeEmailToProgramArgs = {
  inviteeEmail: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type MutationMailSequenceCancelEnrollmentArgs = {
  enrollmentId: Scalars['String']['input'];
};


export type MutationMailSequenceDeleteTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationMailSequenceEnrollArgs = {
  input: MailSequenceEnrollInput;
};


export type MutationMailSequencePreviewDatesArgs = {
  input: MailSequencePreviewDatesInput;
};


export type MutationMailSequenceSaveTemplateArgs = {
  input: MailSequenceSaveTemplateInput;
};


export type MutationMailSequenceSkipScheduledSendArgs = {
  scheduledSendId: Scalars['String']['input'];
};


export type MutationMailSequenceUpdateEnrollmentNameArgs = {
  enrollmentId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMailSequenceUpdateScheduledSendArgs = {
  input: MailSequenceUpdateScheduledSendInput;
};


export type MutationMarkCommentsReadArgs = {
  input: MarkCommentsReadInput;
};


export type MutationMarkInvoicePaidArgs = {
  input: MarkInvoicePaidInput;
};


export type MutationMarkProgramActivitiesSeenArgs = {
  programActivityIds: Array<Scalars['String']['input']>;
};


export type MutationMarkProgramSeenArgs = {
  programId: Scalars['String']['input'];
};


export type MutationMarkProviderUserNotificationReadArgs = {
  archivedNotification: Scalars['Boolean']['input'];
  providerUserNotificationId: Scalars['String']['input'];
};


export type MutationMoveProgramTemplateTaskInGroupArgs = {
  input: MoveProgramTemplateTaskInGroupInput;
};


export type MutationNotifyProgramNoteArgs = {
  input: NotifyProgramNoteInput;
};


export type MutationPatientCreatePatientContactArgs = {
  input: PatientCreatePatientContactInput;
};


export type MutationPatientDeletePatientContactArgs = {
  input: PatientDeletePatientContactInput;
};


export type MutationPatientPortalBookServiceArgs = {
  input: PatientPortalBookServiceInput;
};


export type MutationPatientUpdatePatientContactArgs = {
  input: PatientUpdatePatientContactInput;
};


export type MutationPatientUpdateProfileArgs = {
  input: PatientUpdateProfileInput;
};


export type MutationProviderCompleteFormArgs = {
  input: ProviderCompleteFormInput;
};


export type MutationProviderCreatePatientContactArgs = {
  input: ProviderCreatePatientContactInput;
};


export type MutationProviderDeletePatientContactArgs = {
  input: ProviderDeletePatientContactInput;
};


export type MutationProviderSignMultiSignatureAssessmentArgs = {
  programAssessmentId: Scalars['String']['input'];
  signatureName: Scalars['String']['input'];
  signatureRole: Scalars['String']['input'];
};


export type MutationProviderSignUpArgs = {
  input: ProviderSignUpInput;
};


export type MutationProviderUpdatePatientContactArgs = {
  input: ProviderUpdatePatientContactInput;
};


export type MutationProviderUpdatePatientEmailArgs = {
  input: ProviderUpdatePatientEmailInput;
};


export type MutationProviderUpdatePatientProfileArgs = {
  input: ProviderUpdatePatientProfileInput;
};


export type MutationProviderUserInviteSignupArgs = {
  inviteCode: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationProviderUserLoginArgs = {
  email: Scalars['String']['input'];
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};


export type MutationProvidersCreateApiCredentialArgs = {
  input: ProvidersCreateApiCredentialInput;
};


export type MutationProvidersDeactivateApiCredentialArgs = {
  apiClientId: Scalars['String']['input'];
};


export type MutationPublicServiceSignUpArgs = {
  input: PublicServiceSignUpInput;
};


export type MutationReactivatePatientsArgs = {
  input: ReactivatePatientsInput;
};


export type MutationReactivateProviderUserArgs = {
  providerUserId: Scalars['String']['input'];
};


export type MutationRecordInvoiceDownloadArgs = {
  programInvoiceId: Scalars['String']['input'];
  sourcePage?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordInvoiceListExportArgs = {
  filtered: Scalars['Boolean']['input'];
  invoiceCount: Scalars['Int']['input'];
};


export type MutationRecordProgramActivityPdfDownloadArgs = {
  programActivityId: Scalars['String']['input'];
};


export type MutationRecordProgramActivityResponsesViewedArgs = {
  programActivityId: Scalars['String']['input'];
};


export type MutationRecordProgramNotePdfDownloadArgs = {
  programNoteId: Scalars['String']['input'];
};


export type MutationRefreshProgramInvoiceUrlsArgs = {
  programInvoiceId: Scalars['String']['input'];
};


export type MutationRemoveActivityFromProviderCollectionArgs = {
  input: ProviderCollectionActivityInput;
};


export type MutationRemovePatientsFromProviderUsersArgs = {
  input: ProviderUsersToPatientsInput;
};


export type MutationRemoveProgramTagArgs = {
  input: RemoveProgramTagInput;
};


export type MutationRemoveProviderNoteTemplateArgs = {
  providerNoteTemplateId: Scalars['String']['input'];
};


export type MutationRemoveTaskFromProgramTemplateArgs = {
  programTemplateId: Scalars['String']['input'];
  taskId: Scalars['String']['input'];
};


export type MutationRenameFollowUpTemplateArgs = {
  input: RenameFollowUpTemplateInput;
};


export type MutationRenameTaskGroupArgs = {
  taskGroupId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationReorderProgramTagsArgs = {
  input: Array<ReorderProgramTagInput>;
};


export type MutationReorderServiceGroupsArgs = {
  input: Array<ReorderServiceGroupsInput>;
};


export type MutationReorderServicesArgs = {
  input: Array<ReorderServicesInput>;
};


export type MutationResendPatientInvitesArgs = {
  input: ResendPatientInvitesInput;
};


export type MutationResendProviderUserInviteArgs = {
  providerUserId: Scalars['String']['input'];
};


export type MutationRestoreClientSessionsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRevokeMembershipArgs = {
  input: RevokeMembershipInput;
};


export type MutationRevokeProgramNoteShareArgs = {
  shareId: Scalars['String']['input'];
};


export type MutationSaveAdditionalThoughtsArgs = {
  additionalThoughts: Scalars['String']['input'];
  programAssessmentId: Scalars['String']['input'];
};


export type MutationSaveFollowUpTemplateArgs = {
  input: SaveFollowUpTemplateInput;
};


export type MutationSaveFormDraftArgs = {
  input: SaveFormDraftInput;
};


export type MutationScheduleAssessmentArgs = {
  input: ScheduleAssessmentInput;
};


export type MutationSendFollowUpEmailArgs = {
  programFollowUpId: Scalars['String']['input'];
};


export type MutationSendFollowUpToManyArgs = {
  input: SendFollowUpToManyInput;
};


export type MutationSendInvoiceArgs = {
  input: SendInvoiceInput;
};


export type MutationSendInvoiceReminderArgs = {
  programInvoiceId: Scalars['String']['input'];
};


export type MutationSendPdfFormToEmailArgs = {
  programActivityId: Scalars['String']['input'];
};


export type MutationSendProgramInvitesToPatientsArgs = {
  input: SendProgramInvitesToPatientsInput;
};


export type MutationSendProviderUserInvitesArgs = {
  providerUserInvites?: InputMaybe<Array<ProviderUserInviteInput>>;
};


export type MutationSendTestProviderEmailArgs = {
  isBanner: Scalars['Boolean']['input'];
};


export type MutationSetPatientFirstAppointmentDateArgs = {
  firstAppointmentDate: Scalars['Datetime']['input'];
  programId: Scalars['String']['input'];
};


export type MutationSoftDeletePatientArgs = {
  input: SoftDeletePatientInput;
};


export type MutationStripeCheckoutSuccessArgs = {
  checkoutSessionId: Scalars['String']['input'];
};


export type MutationSubmitClientSessionFormArgs = {
  input: ClientSessionFormSubmitInput;
};


export type MutationSubmitPdfFormArgs = {
  file: Scalars['Upload']['input'];
  pdfSubmissionLinkToken: Scalars['String']['input'];
};


export type MutationSwitchProviderContextArgs = {
  input: SwitchProviderContextInput;
};


export type MutationTestAutomationRuleArgs = {
  input: TestAutomationRuleInput;
};


export type MutationTestAutomationWebhookArgs = {
  input: TestAutomationWebhookInput;
};


export type MutationUnlinkInviteeEmailFromProgramArgs = {
  inviteeEmail: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type MutationUpdateAutomationRuleArgs = {
  input: UpdateAutomationRuleInput;
};


export type MutationUpdateAutomationWebhookConfigArgs = {
  input: UpdateAutomationWebhookConfigInput;
};


export type MutationUpdateClientSessionArgs = {
  input: UpdateClientSessionInput;
};


export type MutationUpdateClientSessionFormArgs = {
  input: ClientSessionFormUpdateInput;
};


export type MutationUpdateCustomAssessmentArgs = {
  input: UpdateCustomAssessmentInput;
};


export type MutationUpdateFollowUpDraftArgs = {
  input: UpdateFollowUpDraftInput;
};


export type MutationUpdateMediaContentArgs = {
  content: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
};


export type MutationUpdateMediaFileArgs = {
  file: Scalars['Upload']['input'];
  mediaId: Scalars['String']['input'];
};


export type MutationUpdateMembershipStatusArgs = {
  input: UpdateMembershipStatusInput;
};


export type MutationUpdateNylasCalendarArgs = {
  input: UpdateNylasCalendarInput;
};


export type MutationUpdateNylasCalendarEventArgs = {
  input: UpdateNylasCalendarEventInput;
};


export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdateProgramNoteArgs = {
  input: UpdateProgramNoteInput;
};


export type MutationUpdateProgramTagArgs = {
  input: UpdateProgramTagInput;
};


export type MutationUpdateProgramTaskArgs = {
  input: TaskInput;
  programTaskId: Scalars['String']['input'];
};


export type MutationUpdateProviderArgs = {
  input: UpdateProviderInput;
};


export type MutationUpdateProviderCalendarSessionSyncSettingsArgs = {
  input: UpdateProviderCalendarSessionSyncSettingsInput;
};


export type MutationUpdateProviderCollectionArgs = {
  input: UpdateProviderCollectionInput;
};


export type MutationUpdateProviderNoteTemplateArgs = {
  input: UpdateProviderNoteTemplateInput;
};


export type MutationUpdateProviderServiceArgs = {
  input: UpdateProviderServiceInput;
};


export type MutationUpdateProviderStorefrontArgs = {
  input: UpdateProviderStorefrontInput;
};


export type MutationUpdateProviderUserArgs = {
  input: UpdateProviderUserInput;
};


export type MutationUpdateProviderUserNotificationControlsArgs = {
  input: UpdateProviderUserNotificationControlsInput;
};


export type MutationUpdateProviderUserRoleArgs = {
  patientDataPermission: PatientDataPermission;
  providerUserId: Scalars['String']['input'];
  role: ProviderUserRole;
};


export type MutationUpdateServiceGroupArgs = {
  input: UpdateServiceGroupInput;
};


export type MutationUploadPatientProfileImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationUploadProviderProgramMediaArgs = {
  input: UploadProviderProgramMediaInput;
};


export type MutationUploadProviderUserProfileImageArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationValidateProviderUserEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationVoidInvoiceArgs = {
  programInvoiceId: Scalars['String']['input'];
};


export type MutationVoidProgramActivityArgs = {
  programActivityId: Scalars['String']['input'];
};

export type MyMembershipsInput = {
  statuses?: InputMaybe<Array<MembershipStatus>>;
};

export type NewPatientLead = {
  email: Scalars['String']['input'];
  firstAppointmentDate?: InputMaybe<Scalars['Datetime']['input']>;
  firstName: Scalars['String']['input'];
  inputId: Scalars['Int']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<ProgramTagInput>>;
};

export enum NotificationFrequency {
  DailyDigest = 'DailyDigest',
  RealTime = 'RealTime'
}

export type NotifyProgramNoteInput = {
  programNoteId: Scalars['String']['input'];
  providerUserIds: Array<Scalars['String']['input']>;
};

export type NylasCalendar = {
  __typename?: 'NylasCalendar';
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  hexColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  readOnly: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type NylasCalendarEvent = {
  __typename?: 'NylasCalendarEvent';
  busy: Scalars['Boolean']['output'];
  calendarId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  htmlLink?: Maybe<Scalars['String']['output']>;
  icalUid?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  organizer?: Maybe<NylasParticipant>;
  participants?: Maybe<Array<NylasParticipant>>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  recurrence?: Maybe<Scalars['String']['output']>;
  resources?: Maybe<Array<NylasEventResource>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  when: CommonWhen;
};

export type NylasCalendarEventsInput = {
  calendarIds: Array<Scalars['String']['input']>;
  endTime: Scalars['Datetime']['input'];
  includeOnlyResources?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['Datetime']['input'];
  titleFilter?: InputMaybe<Scalars['String']['input']>;
};

export type NylasEventResource = {
  __typename?: 'NylasEventResource';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NylasParticipant = {
  __typename?: 'NylasParticipant';
  comment?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type NylasRoomResource = {
  __typename?: 'NylasRoomResource';
  building?: Maybe<Scalars['String']['output']>;
  calendarId: Scalars['String']['output'];
  capacity?: Maybe<Scalars['Int']['output']>;
  email: Scalars['String']['output'];
  floorName?: Maybe<Scalars['String']['output']>;
  floorNumber?: Maybe<Scalars['Int']['output']>;
  floorSection?: Maybe<Scalars['String']['output']>;
  hexColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type OutboundCallLocation = Location & {
  __typename?: 'OutboundCallLocation';
  location?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type Patient = {
  __typename?: 'Patient';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  aggregateUnreadCommentCount: Scalars['Int']['output'];
  assignedProviderUsers?: Maybe<Array<ProviderUserMember>>;
  checkInData?: Maybe<CheckInData>;
  commentCount: Scalars['Int']['output'];
  comments: Array<Comment>;
  completedStorefrontIntakeAt?: Maybe<Scalars['Datetime']['output']>;
  contacts: Array<PatientContact>;
  createdAt: Scalars['Datetime']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  deactivatedAt?: Maybe<Scalars['Datetime']['output']>;
  email: Scalars['String']['output'];
  endTime?: Maybe<Scalars['Datetime']['output']>;
  firstAppointmentAt?: Maybe<Scalars['Datetime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fromStorefront?: Maybe<Scalars['Boolean']['output']>;
  hasCalendlyIntegration?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isTestProgram?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeenAt?: Maybe<Scalars['Datetime']['output']>;
  latestComment?: Maybe<Comment>;
  latestCompletedActivity?: Maybe<ProgramActivity>;
  latestUnreadComment?: Maybe<Comment>;
  latestUnreadCommentAt?: Maybe<Scalars['Datetime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingCompletedAt?: Maybe<Scalars['Datetime']['output']>;
  onboardingLastProgramInviteSentAt?: Maybe<Scalars['Datetime']['output']>;
  /** @deprecated Only correct for V1. Don't use for V2. */
  onboardingStatus: ProgramOnboardingStatus;
  participantId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  profileImageMedia?: Maybe<Media>;
  programEndDate?: Maybe<Scalars['Date']['output']>;
  programInstanceId: Scalars['String']['output'];
  programStartDate?: Maybe<Scalars['Date']['output']>;
  programTemplate?: Maybe<ProgramTemplate>;
  providerAllowsPortalAssessmentTrends: Scalars['Boolean']['output'];
  providerAllowsPortalCalendlyBooking: Scalars['Boolean']['output'];
  providerAllowsPortalServiceBooking: Scalars['Boolean']['output'];
  providerMedia: Array<ProviderProgramMedia>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPrimaryColor?: Maybe<Scalars['String']['output']>;
  providerSecondaryColor?: Maybe<Scalars['String']['output']>;
  providerSquareLogo?: Maybe<Media>;
  providerStorefrontSlug?: Maybe<Scalars['String']['output']>;
  providerTimezone?: Maybe<Scalars['String']['output']>;
  providerWordmarkLogo?: Maybe<Media>;
  referralSource?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['Datetime']['output']>;
  startTime?: Maybe<Scalars['Datetime']['output']>;
  tags: Array<ProgramTag>;
  tasksData?: Maybe<TasksData>;
  timezone?: Maybe<Scalars['String']['output']>;
  unreadCommentCount: Scalars['Int']['output'];
};


export type PatientCommentsArgs = {
  before?: InputMaybe<Scalars['Datetime']['input']>;
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum PatientAccessLevel {
  All = 'All',
  Current = 'Current',
  New = 'New'
}

export type PatientContact = {
  __typename?: 'PatientContact';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactType>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationshipDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type PatientContactAnswerSnapshot = {
  __typename?: 'PatientContactAnswerSnapshot';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressState?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationshipDescription?: Maybe<Scalars['String']['output']>;
};

export type PatientContactAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'PatientContactAssessmentAnswer';
  contactId?: Maybe<Scalars['String']['output']>;
  contactSnapshot?: Maybe<PatientContactAnswerSnapshot>;
  newContactDraftJson?: Maybe<Scalars['String']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type PatientContactAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'PatientContactAssessmentQuestion';
  contactType: ContactType;
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type PatientCreatePatientContactInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactType;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationshipDescription?: InputMaybe<Scalars['String']['input']>;
};

export enum PatientDataPermission {
  All = 'All',
  Assigned = 'Assigned',
  None = 'None'
}

export type PatientDeletePatientContactInput = {
  contactId: Scalars['String']['input'];
};

export enum PatientLifecycleStatus {
  Active = 'Active',
  Archived = 'Archived',
  Invited = 'Invited',
  Onboarding = 'Onboarding'
}

export enum PatientLifecycleStatusV2 {
  Active = 'Active',
  Archived = 'Archived',
  Invited = 'Invited'
}

export type PatientLoginResponse = {
  __typename?: 'PatientLoginResponse';
  authSessionToken: Scalars['String']['output'];
};

export type PatientLoginTokenInput = {
  tokenId: Scalars['String']['input'];
};

export type PatientName = {
  __typename?: 'PatientName';
  createdAt: Scalars['Datetime']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isTestProgram?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  profileImageMedia?: Maybe<Media>;
  programEndDate?: Maybe<Scalars['Date']['output']>;
  programInstanceId: Scalars['String']['output'];
  programStartDate?: Maybe<Scalars['Date']['output']>;
};

export enum PatientPortalBookServiceError {
  NoActiveProgram = 'NoActiveProgram',
  ProviderMismatch = 'ProviderMismatch',
  ServiceNotBookableByExistingClients = 'ServiceNotBookableByExistingClients',
  ServiceNotEnabled = 'ServiceNotEnabled',
  ServiceNotFound = 'ServiceNotFound'
}

export type PatientPortalBookServiceInput = {
  providerServiceId: Scalars['String']['input'];
};

export type PatientPortalBookServiceResult = {
  __typename?: 'PatientPortalBookServiceResult';
  error?: Maybe<PatientPortalBookServiceError>;
  serviceIntakePackageId?: Maybe<Scalars['String']['output']>;
};

export type PatientTask = {
  __typename?: 'PatientTask';
  createdAt: Scalars['Datetime']['output'];
  taskType: TaskType;
  title: Scalars['String']['output'];
};

export type PatientUpdatePatientContactInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['String']['input'];
  contactType?: InputMaybe<ContactType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationshipDescription?: InputMaybe<Scalars['String']['input']>;
};

export type PatientUpdateProfileInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type PatientsCount = {
  __typename?: 'PatientsCount';
  activePatientsCount: Scalars['Int']['output'];
  archivedPatientsCount: Scalars['Int']['output'];
  invitedPatientsCount: Scalars['Int']['output'];
  onboardingPatientsCount: Scalars['Int']['output'];
};

export type PatientsV2Filter = {
  assignedProviderUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assignedProviderUsersMatch?: InputMaybe<ProviderUserMatchOperator>;
  excludedAssignedProviderUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludedProgramTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  filterOperator?: InputMaybe<FilterOperator>;
  no_assigned_practitioners?: InputMaybe<Scalars['Boolean']['input']>;
  no_tags?: InputMaybe<Scalars['Boolean']['input']>;
  programTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsMatch?: InputMaybe<TagMatchOperator>;
};

export type PdfSubmission = {
  __typename?: 'PdfSubmission';
  id: Scalars['String']['output'];
  linkToken?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Media>;
  programActivity: ProgramActivity;
  signatureName?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['Datetime']['output']>;
  submittedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type PerformanceMetricsInput = {
  dateRange: DateRangeInput;
  interval: TimeSeriesInterval;
  metricTypes: Array<MetricType>;
  practitioners: Array<ClientInput>;
};

export type PhysicalLocation = Location & {
  __typename?: 'PhysicalLocation';
  location?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type PractitionerAssignments = {
  __typename?: 'PractitionerAssignments';
  assignedClients: Array<AssignedClient>;
  practitioner: PractitionerBasic;
};

export type PractitionerBasic = {
  __typename?: 'PractitionerBasic';
  id: Scalars['ID']['output'];
  isExternalCollaborator: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  role: ProviderUserRole;
};

export type PractitionerMetrics = {
  __typename?: 'PractitionerMetrics';
  clients: Array<EntityMetrics>;
  practitioner: EntityMetrics;
};

export type ProfileImageUploadLimits = {
  __typename?: 'ProfileImageUploadLimits';
  maxSize: Scalars['Int']['output'];
};

export type ProgramActivity = {
  __typename?: 'ProgramActivity';
  activityAudio?: Maybe<ActivityAudio>;
  activityImage?: Maybe<ActivityImage>;
  activityLink?: Maybe<ActivityLink>;
  activityPDF?: Maybe<ActivityPdf>;
  activityText?: Maybe<ActivityText>;
  activityType: ActivityType;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  dismissedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  isCompletable: Scalars['Boolean']['output'];
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  isVoidable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pdfSubmission?: Maybe<PdfSubmission>;
  programAssessment?: Maybe<ProgramAssessment>;
  programFollowUpId?: Maybe<Scalars['String']['output']>;
  providerNote?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['Datetime']['output']>;
  sentAt: Scalars['Datetime']['output'];
  sentByEmail?: Maybe<Scalars['String']['output']>;
  sentByName: Scalars['String']['output'];
  sentByProfileImageUrl?: Maybe<Scalars['String']['output']>;
  voidedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ProgramAssessment = {
  __typename?: 'ProgramAssessment';
  additionalThoughts?: Maybe<Scalars['String']['output']>;
  answers?: Maybe<Array<AssessmentAnswer>>;
  assessment: Assessment;
  completedAt?: Maybe<Scalars['Datetime']['output']>;
  completedByExternalEmail?: Maybe<Scalars['String']['output']>;
  completedByExternalName?: Maybe<Scalars['String']['output']>;
  completedByProviderUser?: Maybe<ProviderUserMember>;
  completedByType?: Maybe<Scalars['String']['output']>;
  completionCount: Scalars['Int']['output'];
  completionData?: Maybe<AssessmentCompletionData>;
  currentSigner?: Maybe<ProgramAssessmentSignatureUser>;
  dismissedAt?: Maybe<Scalars['Datetime']['output']>;
  draftAnswers?: Maybe<Array<AssessmentAnswer>>;
  draftProviderSignatureName?: Maybe<Scalars['String']['output']>;
  draftProviderSignatureRole?: Maybe<Scalars['String']['output']>;
  draftSignatureTermsAgreed?: Maybe<Scalars['Boolean']['output']>;
  draftUpdatedAt?: Maybe<Scalars['Datetime']['output']>;
  hasExpired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  notifiedAt?: Maybe<Scalars['Datetime']['output']>;
  patientNameData?: Maybe<PatientName>;
  previouslyCompletedProgramAssessmentOfSameType?: Maybe<ProgramAssessment>;
  programAssessmentSignatureUsers?: Maybe<Array<ProgramAssessmentSignatureUser>>;
  startDate: Scalars['Datetime']['output'];
};

export type ProgramAssessmentScheduleResult = {
  __typename?: 'ProgramAssessmentScheduleResult';
  deliveredProgramAssessments?: Maybe<Array<ProgramAssessment>>;
  scheduledProgramAssessments?: Maybe<Array<ProgramAssessment>>;
};

export type ProgramAssessmentSignatureUser = {
  __typename?: 'ProgramAssessmentSignatureUser';
  assessmentSignatureUser?: Maybe<AssessmentSignatureUser>;
  id: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  patientName?: Maybe<Scalars['String']['output']>;
  providerUser?: Maybe<ProviderUserMember>;
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  signatureName?: Maybe<Scalars['String']['output']>;
  signatureRole?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ProgramAssessmentSignatureUserInput = {
  assessmentSignatureUserId: Scalars['String']['input'];
  providerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ProgramEndResponse = {
  __typename?: 'ProgramEndResponse';
  endTimeAfter?: Maybe<Scalars['Datetime']['output']>;
  endTimeBefore?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  programLengthInMonths: Scalars['Int']['output'];
  startTime: Scalars['Datetime']['output'];
};

export type ProgramFollowUp = {
  __typename?: 'ProgramFollowUp';
  activities: Array<AuditLog>;
  activityCount: Scalars['Int']['output'];
  canEditMessage: Scalars['Boolean']['output'];
  commentCount: Scalars['Int']['output'];
  comments: Array<Comment>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  isDraft: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isIntake: Scalars['Boolean']['output'];
  messageEditedAt?: Maybe<Scalars['Datetime']['output']>;
  programActivities: Array<ProgramActivity>;
  programId: Scalars['String']['output'];
  providerNote?: Maybe<Scalars['String']['output']>;
  providerVoiceNote?: Maybe<VoiceNote>;
  sentByEmail: Scalars['String']['output'];
  sentByName: Scalars['String']['output'];
  sentByProfileImageUrl?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  unreadCommentCount: Scalars['Int']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type ProgramFollowUpActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramInvoice = {
  __typename?: 'ProgramInvoice';
  amount: Scalars['Float']['output'];
  archivedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser?: Maybe<ProviderUserMember>;
  currency: Scalars['String']['output'];
  dueAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patient?: Maybe<Patient>;
  status: ProgramInvoiceStatus;
  stripeInvoiceId: Scalars['String']['output'];
  stripeInvoiceNumber: Scalars['String']['output'];
  stripeInvoicePdfUrl: Scalars['String']['output'];
  stripeInvoiceUrl: Scalars['String']['output'];
};

export enum ProgramInvoiceStatus {
  Paid = 'Paid',
  PastDue = 'PastDue',
  Pending = 'Pending',
  Void = 'Void'
}

export type ProgramNote = {
  __typename?: 'ProgramNote';
  activities: Array<AuditLog>;
  canDelete: Scalars['Boolean']['output'];
  canLockUnlock: Scalars['Boolean']['output'];
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser: ProviderUserMember;
  id: Scalars['String']['output'];
  isLocked: Scalars['Boolean']['output'];
  isPinnedNote?: Maybe<Scalars['Boolean']['output']>;
  lockedAt?: Maybe<Scalars['Datetime']['output']>;
  lockedByProviderUser?: Maybe<ProviderUserMember>;
  note: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};


export type ProgramNoteActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramNoteNotificationResult = {
  __typename?: 'ProgramNoteNotificationResult';
  notifiedProviderUsers: Array<ProviderUserMember>;
  success: Scalars['Boolean']['output'];
};

export type ProgramNoteShareInfo = {
  __typename?: 'ProgramNoteShareInfo';
  downloadCount: Scalars['Int']['output'];
  expiresAt: Scalars['Datetime']['output'];
  firstViewedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  noteTitle: Scalars['String']['output'];
  recipientContactType?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['Datetime']['output']>;
  sentAt?: Maybe<Scalars['Datetime']['output']>;
  status: ProgramNoteShareStatus;
  url: Scalars['String']['output'];
};

export type ProgramNoteSharePayload = {
  __typename?: 'ProgramNoteSharePayload';
  expiresAt: Scalars['Datetime']['output'];
  recipientEmail: Scalars['String']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
  shareId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ProgramNoteShareStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED'
}

export enum ProgramOnboardingStatus {
  Archived = 'Archived',
  NeedsActiveProgram = 'NeedsActiveProgram',
  NeedsProgram = 'NeedsProgram',
  NeedsProgramInvite = 'NeedsProgramInvite',
  OnboardingCompleted = 'OnboardingCompleted',
  OnboardingStarted = 'OnboardingStarted',
  ProgramInviteSent = 'ProgramInviteSent'
}

export enum ProgramSortOrder {
  AlphabeticalAsc = 'AlphabeticalAsc',
  AlphabeticalDesc = 'AlphabeticalDesc',
  CreatedAtAsc = 'CreatedAtAsc',
  CreatedAtDesc = 'CreatedAtDesc',
  LatestUnreadCommentAtAsc = 'LatestUnreadCommentAtAsc',
  LatestUnreadCommentAtDesc = 'LatestUnreadCommentAtDesc',
  ProgramEndDateAsc = 'ProgramEndDateAsc',
  ProgramEndDateDesc = 'ProgramEndDateDesc',
  ProgramStartDateAsc = 'ProgramStartDateAsc',
  ProgramStartDateDesc = 'ProgramStartDateDesc'
}

export type ProgramTag = {
  __typename?: 'ProgramTag';
  color: Scalars['String']['output'];
  description: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  programCount: Scalars['Int']['output'];
};

export type ProgramTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProgramTaskInput = {
  audioData?: InputMaybe<TaskAudioData>;
  content: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
  taskGroupId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  weightInGroup?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgramTemplate = {
  __typename?: 'ProgramTemplate';
  activePatientCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  programLengthInMonths?: Maybe<Scalars['Int']['output']>;
  programTemplateAssessments: Array<ProgramTemplateAssessment>;
  status: ProgramTemplateStatus;
  taskGroups?: Maybe<Array<ProgramTemplateTaskGroup>>;
};

export type ProgramTemplateAssessment = {
  __typename?: 'ProgramTemplateAssessment';
  assessment: Assessment;
  scheduleItems: Array<ProgramTemplateAssessmentScheduleItem>;
};

export type ProgramTemplateAssessmentScheduleItem = {
  __typename?: 'ProgramTemplateAssessmentScheduleItem';
  focalEvent: AssessmentFocalEvent;
  recurrenceInterval?: Maybe<Scalars['Duration']['output']>;
  timingOffset?: Maybe<Scalars['Duration']['output']>;
};

export enum ProgramTemplateStatus {
  Active = 'Active',
  InDevelopment = 'InDevelopment'
}

export type ProgramTemplateTaskGroup = {
  __typename?: 'ProgramTemplateTaskGroup';
  id: Scalars['String']['output'];
  isResourceGroup?: Maybe<Scalars['Boolean']['output']>;
  tasks?: Maybe<Array<Task>>;
  title?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Provider = {
  __typename?: 'Provider';
  calendlyIntegration?: Maybe<CalendlyIntegration>;
  clientPortalAssessmentTrendsEnabled: Scalars['Boolean']['output'];
  clientPortalBookCalendlyEnabled: Scalars['Boolean']['output'];
  clientPortalBookServicesEnabled: Scalars['Boolean']['output'];
  emailImageMedia?: Maybe<Media>;
  /** @deprecated Use calendlyIntegration */
  hasCalendlyIntegration: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isOnLegacyV2Pricing: Scalars['Boolean']['output'];
  isTestProvider?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerProfileImageMedia?: Maybe<Media>;
  paymentPlan: ProviderPaymentPlan;
  primaryColor?: Maybe<Scalars['String']['output']>;
  programTags: Array<ProgramTag>;
  seatUsage: SeatUsage;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  squareLogoMedia?: Maybe<Media>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  subscriptionEndsAt?: Maybe<Scalars['Datetime']['output']>;
  subscriptionTier?: Maybe<SubscriptionTier>;
  subscriptionTierV2?: Maybe<SubscriptionTierV2>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  wordmarkLogoMedia?: Maybe<Media>;
};

export type ProviderBillingInfo = {
  __typename?: 'ProviderBillingInfo';
  activePatientCount: Scalars['Int']['output'];
  forecastedActivePatientCount: Scalars['Int']['output'];
  forecastedCost: Scalars['Float']['output'];
  nextBillingDate: Scalars['Datetime']['output'];
};

export type ProviderCollection = {
  __typename?: 'ProviderCollection';
  activities?: Maybe<Array<Activity>>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ProviderCollectionActivityInput = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
  providerCollectionId: Scalars['String']['input'];
};

export type ProviderCompleteFormInput = {
  assessmentAnswers?: InputMaybe<Array<CompleteAssessmentAnswerInput>>;
  programAssessmentId: Scalars['String']['input'];
  signatureName: Scalars['String']['input'];
  signatureRole: Scalars['String']['input'];
  skipEmail?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderCreatePatientContactInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  contactType: ContactType;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  patientId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  relationshipDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderDeletePatientContactInput = {
  contactId: Scalars['String']['input'];
};

export type ProviderMembershipsInput = {
  providerId: Scalars['ID']['input'];
  statuses?: InputMaybe<Array<MembershipStatus>>;
};

export type ProviderNoteTemplate = {
  __typename?: 'ProviderNoteTemplate';
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser: ProviderUserMember;
  id: Scalars['String']['output'];
  isSharedNoteTemplate?: Maybe<Scalars['Boolean']['output']>;
  note: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ProviderPaymentPlan = {
  __typename?: 'ProviderPaymentPlan';
  monthlyFee?: Maybe<Scalars['Float']['output']>;
  pmpmFee?: Maybe<Scalars['Float']['output']>;
  upfrontFee?: Maybe<Scalars['Float']['output']>;
};

export type ProviderProgramMedia = {
  __typename?: 'ProviderProgramMedia';
  createdAt: Scalars['Datetime']['output'];
  createdByProviderUser?: Maybe<ProviderUserMember>;
  id: Scalars['String']['output'];
  media: Media;
  name: Scalars['String']['output'];
};

export type ProviderService = {
  __typename?: 'ProviderService';
  assignedProviderUsers?: Maybe<Array<ProviderUserMember>>;
  calendlyEventColor?: Maybe<Scalars['String']['output']>;
  calendlyEventTypeUri?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  intakeFormAssessment?: Maybe<Assessment>;
  isEnabled: Scalars['Boolean']['output'];
  isPaid: Scalars['Boolean']['output'];
  isPriceLabelShown: Scalars['Boolean']['output'];
  isShownOnStorefront: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  patientAccessLevel: PatientAccessLevel;
  price?: Maybe<Scalars['Int']['output']>;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  serviceIcon: ServiceIcon;
  serviceIconColorUseCalendlyDefault?: Maybe<Scalars['Boolean']['output']>;
  serviceSubmissionBody?: Maybe<Scalars['String']['output']>;
  serviceSubmissionRedirectUrl?: Maybe<Scalars['String']['output']>;
  serviceSubmissionTitle?: Maybe<Scalars['String']['output']>;
  serviceTags?: Maybe<Array<ProgramTag>>;
  slug: Scalars['String']['output'];
};

export type ProviderSettings = {
  __typename?: 'ProviderSettings';
  id: Scalars['String']['output'];
  mobileCopyOverrides?: Maybe<Scalars['Object']['output']>;
  providerId: Scalars['String']['output'];
  shouldSkipInitialIntentionSetting: Scalars['Boolean']['output'];
};

export type ProviderSignUpInput = {
  email: Scalars['String']['input'];
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  signUpConfigSlug?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmParamsInput>;
};

export type ProviderSignatureAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'ProviderSignatureAssessmentAnswer';
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
  signatureName?: Maybe<Scalars['String']['output']>;
  signatureRole?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signingIpAddress?: Maybe<Scalars['String']['output']>;
};

export type ProviderSignatureAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'ProviderSignatureAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type ProviderStorefront = {
  __typename?: 'ProviderStorefront';
  about?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  bannerPosition?: Maybe<Scalars['Int']['output']>;
  calendlyEventTypeUri?: Maybe<Scalars['String']['output']>;
  ctaButtonText?: Maybe<Scalars['String']['output']>;
  ctaFormLabel?: Maybe<Scalars['String']['output']>;
  intakeFormAssessment?: Maybe<Assessment>;
  intakeTags?: Maybe<Array<ProgramTag>>;
  isEnabled: Scalars['Boolean']['output'];
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  roleTitle?: Maybe<Scalars['String']['output']>;
  services?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  tagline?: Maybe<Scalars['String']['output']>;
};

export type ProviderSummary = {
  __typename?: 'ProviderSummary';
  averageResponseTime: MetricComparison;
  averageTimeToFirstResponse: MetricComparison;
  totalClients: MetricComparison;
  totalPractitioners: MetricComparison;
  totalSessions: MetricComparison;
};

export type ProviderSummaryInput = {
  interval: TimeSeriesInterval;
};

export type ProviderUpdatePatientContactInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  contactId: Scalars['String']['input'];
  contactType?: InputMaybe<ContactType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationshipDescription?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUpdatePatientEmailInput = {
  email: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export type ProviderUpdatePatientProfileInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  programEndDate?: InputMaybe<Scalars['Date']['input']>;
  programId: Scalars['String']['input'];
  programStartDate?: InputMaybe<Scalars['Date']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderUserInviteInput = {
  email: Scalars['String']['input'];
  patientDataPermission?: InputMaybe<PatientDataPermission>;
  role?: InputMaybe<ProviderUserRole>;
  seatType: SeatType;
};

export enum ProviderUserMatchOperator {
  All = 'ALL',
  Any = 'ANY'
}

export type ProviderUserMember = {
  __typename?: 'ProviderUserMember';
  assignedPatients?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Datetime']['output']>;
  deactivatedAt?: Maybe<Scalars['Datetime']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invitedAt?: Maybe<Scalars['Datetime']['output']>;
  isExternalCollaborator: Scalars['Boolean']['output'];
  lastInviteSentAt?: Maybe<Scalars['Datetime']['output']>;
  membershipId?: Maybe<Scalars['String']['output']>;
  membershipStatus?: Maybe<MembershipStatus>;
  name?: Maybe<Scalars['String']['output']>;
  patientDataPermission: PatientDataPermission;
  profileImageMedia?: Maybe<Media>;
  registeredAt?: Maybe<Scalars['Datetime']['output']>;
  role: ProviderUserRole;
};

export type ProviderUserMembership = {
  __typename?: 'ProviderUserMembership';
  accessExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  activatedAt?: Maybe<Scalars['Datetime']['output']>;
  createdAt: Scalars['Datetime']['output'];
  deactivatedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['ID']['output'];
  invitationExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  invitedAt?: Maybe<Scalars['Datetime']['output']>;
  invitedBy?: Maybe<ProviderUserMember>;
  isExternalCollaborator: Scalars['Boolean']['output'];
  isPrimaryProvider: Scalars['Boolean']['output'];
  patientDataPermission: PatientDataPermission;
  provider: Provider;
  providerUser: ProviderUserMember;
  role: ProviderUserRole;
  status: MembershipStatus;
  updatedAt: Scalars['Datetime']['output'];
};

export type ProviderUserNotification = {
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationActivation = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationActivation';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationActivityCompleted = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationActivityCompleted';
  activityName: Scalars['String']['output'];
  activityType: ActivityType;
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programActivityId: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationAssessmentCompleted = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationAssessmentCompleted';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  assessmentName: Scalars['String']['output'];
  assessmentSchemaType: AssessmentSchemaType;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programActivityId: Scalars['String']['output'];
  programAssessmentId: Scalars['String']['output'];
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationComment = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationComment';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programFollowUpCreatedAt?: Maybe<Scalars['Datetime']['output']>;
  programFollowUpId?: Maybe<Scalars['String']['output']>;
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationControls = {
  __typename?: 'ProviderUserNotificationControls';
  allClientsFormCompletionEnabled: Scalars['Boolean']['output'];
  careTeamNotificationsEnabled: Scalars['Boolean']['output'];
  patientActivationEmailOption?: Maybe<NotificationFrequency>;
  patientActivationInAppEnabled: Scalars['Boolean']['output'];
  patientActivityCompletionEmailOption?: Maybe<NotificationFrequency>;
  patientActivityCompletionInAppEnabled: Scalars['Boolean']['output'];
  patientAssessmentCompletionEmailOption?: Maybe<NotificationFrequency>;
  patientAssessmentCompletionInAppEnabled: Scalars['Boolean']['output'];
  patientCommentEmailOption?: Maybe<NotificationFrequency>;
  patientCommentInAppEnabled: Scalars['Boolean']['output'];
  patientInvoicePaidEmailOption?: Maybe<NotificationFrequency>;
  patientInvoicePaidInAppEnabled: Scalars['Boolean']['output'];
};

export type ProviderUserNotificationFormNeedsProviderSignature = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationFormNeedsProviderSignature';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  formName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programAssessmentId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationInvoicePaid = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationInvoicePaid';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programId: Scalars['String']['output'];
  programInvoiceAmount: Scalars['Float']['output'];
  programInvoiceCurrency: Scalars['String']['output'];
  programInvoiceId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationPatientAssignment = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationPatientAssignment';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationPendingProviderMembership = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationPendingProviderMembership';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  invitedByName: Scalars['String']['output'];
  invitedByProviderName: Scalars['String']['output'];
  invitedByProviderSquareLogoMedia?: Maybe<Media>;
  membershipId: Scalars['String']['output'];
  membershipStatus: MembershipStatus;
  readAt?: Maybe<Scalars['Datetime']['output']>;
  role: ProviderUserRole;
  seatType: SeatType;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationSessionBooked = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationSessionBooked';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  calendlyEventTypeName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export type ProviderUserNotificationStorefrontSignUp = ProviderUserNotification & {
  __typename?: 'ProviderUserNotificationStorefrontSignUp';
  archivedNotification?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['Datetime']['output'];
  id: Scalars['String']['output'];
  patientName: Scalars['String']['output'];
  patientProfileImageMedia?: Maybe<Media>;
  programId: Scalars['String']['output'];
  readAt?: Maybe<Scalars['Datetime']['output']>;
  type: ProviderUserNotificationType;
};

export enum ProviderUserNotificationType {
  PatientActivation = 'PatientActivation',
  PatientActivityCompleted = 'PatientActivityCompleted',
  PatientAssessmentCompleted = 'PatientAssessmentCompleted',
  PatientAssignment = 'PatientAssignment',
  PatientComment = 'PatientComment',
  PatientFormNeedsProviderSignature = 'PatientFormNeedsProviderSignature',
  PatientInvoicePaid = 'PatientInvoicePaid',
  PatientSessionBooked = 'PatientSessionBooked',
  PatientStorefrontSignUp = 'PatientStorefrontSignUp',
  PendingProviderMembership = 'PendingProviderMembership'
}

export enum ProviderUserRole {
  Administrator = 'Administrator',
  Owner = 'Owner',
  Practitioner = 'Practitioner'
}

export type ProviderUserSearchResults = {
  __typename?: 'ProviderUserSearchResults';
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  providerUsers: Array<ProviderUserMember>;
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ProviderUsersToPatientsInput = {
  programIds: Array<Scalars['String']['input']>;
  providerUserIds: Array<Scalars['String']['input']>;
};

export type ProvidersApiCredential = {
  __typename?: 'ProvidersApiCredential';
  apiClientId: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  deactivatedAt?: Maybe<Scalars['Datetime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['Datetime']['output']>;
  name: Scalars['String']['output'];
  secret?: Maybe<Scalars['String']['output']>;
  status: ProvidersApiCredentialStatus;
};

export enum ProvidersApiCredentialStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ProvidersCreateApiCredentialInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ProvidersCreateApiCredentialResponse = {
  __typename?: 'ProvidersCreateApiCredentialResponse';
  apiCredential?: Maybe<ProvidersApiCredential>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ProvidersDeactivateApiCredentialResponse = {
  __typename?: 'ProvidersDeactivateApiCredentialResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PublicPdfSubmission = {
  __typename?: 'PublicPdfSubmission';
  expiresAt: Scalars['Datetime']['output'];
  pdfUrl: Scalars['String']['output'];
  providerFirstName: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['Datetime']['output']>;
  title: Scalars['String']['output'];
};

export type PublicProviderService = {
  __typename?: 'PublicProviderService';
  calendlyEventColor?: Maybe<Scalars['String']['output']>;
  calendlyEventTypeUri?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  durationMinutes?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  intakeFormAssessment?: Maybe<Assessment>;
  isPaid: Scalars['Boolean']['output'];
  isPriceLabelShown: Scalars['Boolean']['output'];
  isShownOnStorefront: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  patientAccessLevel: PatientAccessLevel;
  price?: Maybe<Scalars['Int']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerPrimaryColor?: Maybe<Scalars['String']['output']>;
  providerRoleTitle?: Maybe<Scalars['String']['output']>;
  providerSecondaryColor?: Maybe<Scalars['String']['output']>;
  serviceGroupId?: Maybe<Scalars['String']['output']>;
  serviceGroupName?: Maybe<Scalars['String']['output']>;
  serviceIcon: ServiceIcon;
  serviceIconColorUseCalendlyDefault?: Maybe<Scalars['Boolean']['output']>;
  serviceSubmissionBody?: Maybe<Scalars['String']['output']>;
  serviceSubmissionRedirectUrl?: Maybe<Scalars['String']['output']>;
  serviceSubmissionTitle?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  storefrontEnabled: Scalars['Boolean']['output'];
};

export enum PublicServiceSignUpError {
  CurrentClientsOnly = 'CurrentClientsOnly',
  EmailAlreadyExistsOtherProvider = 'EmailAlreadyExistsOtherProvider',
  EmailAlreadyExistsThisProvider = 'EmailAlreadyExistsThisProvider',
  InvalidEmail = 'InvalidEmail',
  InvalidName = 'InvalidName',
  InvalidServiceSlug = 'InvalidServiceSlug',
  NewClientsOnly = 'NewClientsOnly'
}

export type PublicServiceSignUpInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  serviceSlug: Scalars['String']['input'];
  storefrontSlug: Scalars['String']['input'];
};

export type PublicServiceSignUpResult = {
  __typename?: 'PublicServiceSignUpResult';
  authToken?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PublicServiceSignUpError>;
  serviceIntakePackageId?: Maybe<Scalars['String']['output']>;
};

export type PublicStorefront = {
  __typename?: 'PublicStorefront';
  about?: Maybe<Scalars['String']['output']>;
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  bannerPosition?: Maybe<Scalars['Int']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  providerCtaButtonText?: Maybe<Scalars['String']['output']>;
  providerCtaFormLabel?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerRoleTitle?: Maybe<Scalars['String']['output']>;
  publicServices?: Maybe<Array<PublicProviderService>>;
  services?: Maybe<Scalars['String']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
};

export enum PushNotificationType {
  AssessmentReminder = 'AssessmentReminder',
  PatientActivation = 'PatientActivation',
  PatientActivityCompletion = 'PatientActivityCompletion',
  PatientAssessmentCompletion = 'PatientAssessmentCompletion',
  PatientComment = 'PatientComment',
  PatientInvoicePaid = 'PatientInvoicePaid',
  ProgramActivityReceived = 'ProgramActivityReceived',
  ProgramFollowUpReceived = 'ProgramFollowUpReceived',
  ProviderCommentReceivedByPatient = 'ProviderCommentReceivedByPatient'
}

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['String']['output']>;
  activeProviderContext?: Maybe<Provider>;
  activities: Array<Activity>;
  activity?: Maybe<Activity>;
  activityAudio: Array<ActivityAudio>;
  activityImages: Array<ActivityImage>;
  activityLinks: Array<ActivityLink>;
  activityPDFs: Array<ActivityPdf>;
  activityTexts: Array<ActivityText>;
  assessment: Assessment;
  /**
   * Get audit logs for a specific entity.
   * Requires entityType (e.g., "app.api.models.program_note.ProgramNote") and entityId.
   * Supports limit and offset for pagination.
   */
  auditLogs: Array<AuditLog>;
  auth0GetUserByEmail?: Maybe<MeProvider>;
  authenticationCodeVerification: AuthenticationCodeVerificationResponse;
  authenticationSession?: Maybe<AuthenticationSession>;
  automationExecutions: Array<AutomationExecution>;
  automationRule?: Maybe<AutomationRule>;
  automationRules: Array<AutomationRule>;
  automationWebhookConfig?: Maybe<AutomationWebhookConfig>;
  availableProviderContexts: Array<Provider>;
  brandingBrandSettings?: Maybe<BrandingBrandSettings>;
  calendlyEventTypes: Array<CalendlyEventType>;
  calendlyImportStatus?: Maybe<CalendlyImportStatus>;
  calendlyPractitionerEventTypes: Array<CalendlyPractitionerEventTypes>;
  calendlyProviderEventTypes: Array<CalendlyProfile>;
  /** @deprecated No longer using general scheduling url */
  calendlySchedulingUrl: Scalars['String']['output'];
  calendlyTeamProviderUsers: Array<CalendlyTeamProviderUser>;
  clientFiles: Array<ClientFile>;
  clientFilesForProgram: Array<ClientFile>;
  clientSession?: Maybe<ClientSession>;
  clientSessions: ClientSessionConnection;
  clientSessionsCount: Scalars['Int']['output'];
  clientsPerformanceSummary: ClientsPerformanceSummaryResponse;
  completedPdfSubmissions: Array<PdfSubmission>;
  completedProgramAssessmentsByAssessment: Array<ProgramAssessment>;
  contactDeletionImpact: ContactDeletionImpact;
  contactHasActiveExternalLinks: Scalars['Boolean']['output'];
  contactsForProgram: Array<PatientContact>;
  countries: Array<Scalars['String']['output']>;
  curatedProviderCollections: Array<CuratedProviderCollection>;
  enabledFeatures: Array<Feature>;
  /** @deprecated Use `enabledFeatures` */
  enabledPatientFeatures: Array<Feature>;
  externalPartyFilesForProgram: Array<ClientFile>;
  externalPractitionerFormInvitesForContact: Array<ExternalPractitionerFormInviteInfo>;
  fileUploadConstants: FileUploadConstants;
  findClientSessionFormByType?: Maybe<ClientSessionForm>;
  followUpTemplate: FollowUpTemplate;
  followUpTemplates: Array<FollowUpTemplate>;
  handPickedCountries: Array<Scalars['String']['output']>;
  handPickedLanguages: Array<Scalars['String']['output']>;
  handPickedTimezones: Array<Timezone>;
  /** @deprecated Use serviceIntakePackage instead. */
  intakePackage: IntakePackage;
  invitedProviderUser: InvitedProviderUser;
  languages: Array<Scalars['String']['output']>;
  latestCompletedProgramAssessments: Array<ProgramAssessment>;
  linkPreview: LinkPreview;
  mailSequenceEnrollment?: Maybe<MailSequenceEnrollment>;
  mailSequenceEnrollmentsForProgram: Array<MailSequenceEnrollment>;
  mailSequenceTemplates: Array<MailSequenceTemplate>;
  mePatient?: Maybe<Patient>;
  meProvider?: Maybe<MeProvider>;
  myMemberships: Array<ProviderUserMembership>;
  nylasAuthUrl: Scalars['String']['output'];
  nylasCalendarEvents: Array<NylasCalendarEvent>;
  nylasCalendars: Array<NylasCalendar>;
  nylasPrimaryCalendar: NylasCalendar;
  nylasRoomResources: Array<NylasRoomResource>;
  nylasSupportedProviders: Array<CalendarProvider>;
  patient: Patient;
  patientCompletedProgramAssessmentsByAssessment: Array<ProgramAssessment>;
  patientFeed: ActivityFeedResult;
  patientNames: Array<PatientName>;
  patientNamesForRecipients: Array<PatientName>;
  patientProfileImageMedia?: Maybe<Media>;
  patientsCount: PatientsCount;
  patientsCountV2: Scalars['Int']['output'];
  patientsV2: Array<Patient>;
  performanceMetrics: Array<PractitionerMetrics>;
  practitionerAssignments: Array<PractitionerAssignments>;
  programActivities: Array<ProgramActivity>;
  programActivity?: Maybe<ProgramActivity>;
  programActivityJourney: Array<ProgramActivity>;
  programAssessment?: Maybe<ProgramAssessment>;
  programAssessmentSchedule: ProgramAssessmentScheduleResult;
  programFollowUp: ProgramFollowUp;
  programFollowUps: Array<ProgramFollowUp>;
  programHasDefaultPaymentMethod: Scalars['Boolean']['output'];
  programInvoices: Array<ProgramInvoice>;
  programNote: ProgramNote;
  programNoteShares: Array<ProgramNoteShareInfo>;
  programNoteSharesForContact: Array<ProgramNoteShareInfo>;
  programNotes: Array<ProgramNote>;
  programTask: Task;
  programTemplate: ProgramTemplate;
  /** @deprecated Use `assessment.programTemplateAssessment */
  programTemplateAssessments?: Maybe<Array<ProgramTemplateAssessment>>;
  programTemplates: Array<ProgramTemplate>;
  providerActivities: Array<Activity>;
  providerAssessments: Array<Assessment>;
  providerBookableServices: Array<BookableProviderService>;
  providerCalendarSessionSyncSettings?: Maybe<ClientCalendarSessionSyncSettings>;
  providerCollections: Array<ProviderCollection>;
  /**
   * Paginated activity feed for everything that happens in the provider Library
   * (resources, custom forms, folders). Scoped to the authenticated user's active provider.
   */
  providerLibraryActivities: Array<AuditLog>;
  providerMemberships: Array<ProviderUserMembership>;
  providerNoteTemplate: ProviderNoteTemplate;
  providerNoteTemplates: Array<ProviderNoteTemplate>;
  /** Paginated payment activity feed for the authenticated provider. Owner/Admin only. */
  providerPaymentActivities: Array<AuditLog>;
  providerPerformanceSummary: ProviderSummary;
  /**
   * Paginated void/unvoid activity feed for sent program activities.
   * Scoped to the authenticated user's active provider. Owner/Admin only.
   */
  providerProgramActivityActivities: Array<AuditLog>;
  providerService: ProviderService;
  providerServiceSlugExists: Scalars['Boolean']['output'];
  providerServices?: Maybe<Array<ProviderService>>;
  providerSettings?: Maybe<ProviderSettings>;
  providerStorefront: ProviderStorefront;
  providerStripeCardProcessingFeeSchedule?: Maybe<StripeCardProcessingFeeSchedule>;
  providerUserMembers: Array<ProviderUserMember>;
  providerUserPatients: Array<PatientName>;
  providerUserSignableForms: Array<ProgramAssessment>;
  providerUserSignableFormsCount: Scalars['Int']['output'];
  providersApiCredentials: Array<ProvidersApiCredential>;
  publicPdfSubmission: PublicPdfSubmission;
  publicProviderService: PublicProviderService;
  publicStorefront: PublicStorefront;
  referralSources: Array<Scalars['String']['output']>;
  releaseInfo?: Maybe<ReleaseInfo>;
  scheduledEvent: ScheduledEvent;
  scheduledEvents: Array<ScheduledEvent>;
  searchProviderUsers: ProviderUserSearchResults;
  searchStripeProducts: Array<StripeProduct>;
  serviceGroups: Array<ServiceGroup>;
  serviceIntakePackage: ServiceIntakePackage;
  signUpConfig?: Maybe<SignUpConfig>;
  signUpDeepLink: Scalars['String']['output'];
  standardAssessments: Array<Activity>;
  stripeCheckoutPortal: StripeCheckoutPortal;
  stripeCustomerPortal: StripeCustomerPortal;
  teamPerformanceInsightsMetrics: TeamPerformanceInsightsMetrics;
  timezones: Array<Timezone>;
  todoProgramActivities: Array<ProgramActivity>;
  todoProgramAssessments: Array<ProgramAssessment>;
  uninvitedEventInvitees: Array<EventInvitee>;
  validateRecoveryCode: Scalars['Boolean']['output'];
};


export type QueryActivitiesArgs = {
  programId: Scalars['String']['input'];
};


export type QueryActivityArgs = {
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
};


export type QueryActivityAudioArgs = {
  mediaCategory: MediaCategory;
};


export type QueryAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuditLogsArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuth0GetUserByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryAuthenticationCodeVerificationArgs = {
  verificationId: Scalars['ID']['input'];
};


export type QueryAutomationExecutionsArgs = {
  automationRuleId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<AutomationExecutionStatus>;
};


export type QueryAutomationRuleArgs = {
  automationRuleId: Scalars['String']['input'];
};


export type QueryAutomationRulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableProviderContextsArgs = {
  input?: InputMaybe<AvailableProviderContextsInput>;
};


export type QueryClientFilesForProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryClientSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientSessionsArgs = {
  input?: InputMaybe<ClientSessionListInput>;
};


export type QueryClientSessionsCountArgs = {
  input?: InputMaybe<ClientSessionFilterInput>;
};


export type QueryClientsPerformanceSummaryArgs = {
  input: ClientsPerformanceSummaryInput;
};


export type QueryCompletedPdfSubmissionsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryCompletedProgramAssessmentsByAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};


export type QueryContactDeletionImpactArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryContactHasActiveExternalLinksArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryContactsForProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryCountriesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExternalPartyFilesForProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryExternalPractitionerFormInvitesForContactArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryFindClientSessionFormByTypeArgs = {
  clientSessionId: Scalars['ID']['input'];
  formType: ClientSessionFormType;
};


export type QueryFollowUpTemplateArgs = {
  followUpTemplateId: Scalars['String']['input'];
};


export type QueryFollowUpTemplatesArgs = {
  input: FollowUpTemplatesInput;
};


export type QueryInvitedProviderUserArgs = {
  inviteCode: Scalars['String']['input'];
};


export type QueryLanguagesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestCompletedProgramAssessmentsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryLinkPreviewArgs = {
  linkURL: Scalars['String']['input'];
};


export type QueryMailSequenceEnrollmentArgs = {
  enrollmentId: Scalars['String']['input'];
};


export type QueryMailSequenceEnrollmentsForProgramArgs = {
  programId: Scalars['String']['input'];
};


export type QueryMyMembershipsArgs = {
  input?: InputMaybe<MyMembershipsInput>;
};


export type QueryNylasAuthUrlArgs = {
  provider: CalendarProvider;
};


export type QueryNylasCalendarEventsArgs = {
  input: NylasCalendarEventsInput;
};


export type QueryPatientArgs = {
  programId: Scalars['String']['input'];
};


export type QueryPatientCompletedProgramAssessmentsByAssessmentArgs = {
  assessmentId: Scalars['String']['input'];
};


export type QueryPatientFeedArgs = {
  feedType: FeedType;
  paginationIndex?: InputMaybe<Scalars['Int']['input']>;
  programId: Scalars['String']['input'];
};


export type QueryPatientNamesArgs = {
  assignedPatients?: InputMaybe<Scalars['Boolean']['input']>;
  patientLifecycleStatuses?: InputMaybe<Array<PatientLifecycleStatusV2>>;
};


export type QueryPatientNamesForRecipientsArgs = {
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  programTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPatientsCountArgs = {
  providerId: Scalars['String']['input'];
};


export type QueryPatientsCountV2Args = {
  filter?: InputMaybe<PatientsV2Filter>;
  patientLifecycleStatuses?: InputMaybe<Array<PatientLifecycleStatusV2>>;
};


export type QueryPatientsV2Args = {
  filter?: InputMaybe<PatientsV2Filter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  patientLifecycleStatuses?: InputMaybe<Array<PatientLifecycleStatusV2>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<ProgramSortOrder>;
};


export type QueryPerformanceMetricsArgs = {
  input: PerformanceMetricsInput;
  providerId: Scalars['ID']['input'];
};


export type QueryPractitionerAssignmentsArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryProgramActivitiesArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramActivityArgs = {
  programActivityId: Scalars['String']['input'];
};


export type QueryProgramActivityJourneyArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramAssessmentArgs = {
  programAssessmentId: Scalars['String']['input'];
};


export type QueryProgramAssessmentScheduleArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramFollowUpArgs = {
  programFollowUpId: Scalars['String']['input'];
};


export type QueryProgramFollowUpsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramHasDefaultPaymentMethodArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramInvoicesArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProgramNoteArgs = {
  programNoteId: Scalars['String']['input'];
};


export type QueryProgramNoteSharesArgs = {
  programNoteId: Scalars['String']['input'];
};


export type QueryProgramNoteSharesForContactArgs = {
  contactId: Scalars['String']['input'];
};


export type QueryProgramNotesArgs = {
  programId: Scalars['String']['input'];
};


export type QueryProgramTaskArgs = {
  programTaskId: Scalars['String']['input'];
};


export type QueryProgramTemplateArgs = {
  programTemplateId: Scalars['String']['input'];
};


export type QueryProgramTemplateAssessmentsArgs = {
  programTemplateId: Scalars['String']['input'];
};


export type QueryProviderAssessmentsArgs = {
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProviderLibraryActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderMembershipsArgs = {
  input: ProviderMembershipsInput;
};


export type QueryProviderNoteTemplateArgs = {
  providerNoteTemplateId: Scalars['String']['input'];
};


export type QueryProviderPaymentActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderPerformanceSummaryArgs = {
  input: ProviderSummaryInput;
  providerId: Scalars['ID']['input'];
};


export type QueryProviderProgramActivityActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProviderServiceArgs = {
  providerServiceId: Scalars['String']['input'];
};


export type QueryProviderServiceSlugExistsArgs = {
  serviceSlug: Scalars['String']['input'];
};


export type QueryProviderSettingsArgs = {
  providerId: Scalars['String']['input'];
};


export type QueryProviderUserMembersArgs = {
  activeProviderUsersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProviderUserPatientsArgs = {
  providerUserId: Scalars['String']['input'];
};


export type QueryPublicPdfSubmissionArgs = {
  pdfSubmissionLinkToken: Scalars['String']['input'];
};


export type QueryPublicProviderServiceArgs = {
  serviceSlug: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryPublicStorefrontArgs = {
  slug: Scalars['String']['input'];
};


export type QueryReferralSourcesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReleaseInfoArgs = {
  version: Scalars['String']['input'];
};


export type QueryScheduledEventArgs = {
  calendlyEventUri: Scalars['String']['input'];
};


export type QueryScheduledEventsArgs = {
  input: ScheduledEventsInput;
};


export type QuerySearchProviderUsersArgs = {
  input?: InputMaybe<SearchProviderUsersInput>;
};


export type QuerySearchStripeProductsArgs = {
  query: Scalars['String']['input'];
};


export type QueryServiceIntakePackageArgs = {
  serviceIntakePackageId: Scalars['String']['input'];
};


export type QuerySignUpConfigArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStripeCheckoutPortalArgs = {
  choseAnnual?: InputMaybe<Scalars['Boolean']['input']>;
  extraSeatCount?: InputMaybe<Scalars['Int']['input']>;
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  tierSelection?: InputMaybe<SubscriptionTierV2>;
  webRedirectPath?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTeamPerformanceInsightsMetricsArgs = {
  input: TeamPerformanceInsightsMetricsInput;
  providerId: Scalars['ID']['input'];
};


export type QueryTimezonesArgs = {
  filterQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTodoProgramActivitiesArgs = {
  programId: Scalars['String']['input'];
};


export type QueryTodoProgramAssessmentsArgs = {
  programId: Scalars['String']['input'];
};


export type QueryValidateRecoveryCodeArgs = {
  recoveryCode: Scalars['String']['input'];
};

export type ReactivatePatientsInput = {
  programIds: Array<Scalars['String']['input']>;
};

export type ReactivatePatientsResult = {
  __typename?: 'ReactivatePatientsResult';
  reactivatedPatients?: Maybe<Array<Patient>>;
};

export type ReleaseInfo = {
  __typename?: 'ReleaseInfo';
  isRecommended: Scalars['Boolean']['output'];
  isSupported: Scalars['Boolean']['output'];
};

export type RemoveProgramTagInput = {
  programId: Scalars['String']['input'];
  programTagId: Scalars['String']['input'];
};

export type RemoveProgramTagResult = {
  __typename?: 'RemoveProgramTagResult';
  updatedProgramTags: Array<ProgramTag>;
};

export type RenameFollowUpTemplateInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type ReorderProgramTagInput = {
  displayOrder: Scalars['Int']['input'];
  programTagId: Scalars['String']['input'];
};

export type ReorderServiceGroupsInput = {
  displayOrder: Scalars['Int']['input'];
  serviceGroupId: Scalars['String']['input'];
};

export type ReorderServicesInput = {
  displayOrder: Scalars['Int']['input'];
  serviceGroupId?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
};

export type RequestPatientLoginTokenInput = {
  email: Scalars['String']['input'];
};

export type ResendPatientInvitesInput = {
  programIds: Array<Scalars['String']['input']>;
};

export type ResendPatientInvitesResult = {
  __typename?: 'ResendPatientInvitesResult';
  updatedPatients: Array<Patient>;
};

export type RestoreClientSessionError = {
  __typename?: 'RestoreClientSessionError';
  message: Scalars['String']['output'];
  sessionId: Scalars['ID']['output'];
};

export type RestoreClientSessionsResponse = {
  __typename?: 'RestoreClientSessionsResponse';
  errors: Array<RestoreClientSessionError>;
  /** Indicates if the operation was at least partially successful */
  success: Scalars['Boolean']['output'];
  summary: CommonBatchOperationSummary;
};

export type RevokeMembershipInput = {
  membershipId: Scalars['ID']['input'];
};

export type RichTextAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'RichTextAssessmentAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type RichTextAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'RichTextAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type SaveActivityTemplateInput = {
  activityAudioId?: InputMaybe<Scalars['String']['input']>;
  activityImageId?: InputMaybe<Scalars['String']['input']>;
  activityLinkId?: InputMaybe<Scalars['String']['input']>;
  activityPDFId?: InputMaybe<Scalars['String']['input']>;
  activityTextId?: InputMaybe<Scalars['String']['input']>;
  activityType: ActivityType;
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  providerNote: Scalars['String']['input'];
};

export type SaveFollowUpTemplateInput = {
  activityTemplates?: InputMaybe<Array<SaveActivityTemplateInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  programTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  providerNote: Scalars['String']['input'];
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};

export type SaveFormDraftInput = {
  draftAnswers: Array<CompleteAssessmentAnswerInput>;
  programAssessmentId: Scalars['String']['input'];
  providerSignatureName?: InputMaybe<Scalars['String']['input']>;
  providerSignatureRole?: InputMaybe<Scalars['String']['input']>;
  signatureTermsAgreed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveFormDraftPayload = {
  __typename?: 'SaveFormDraftPayload';
  programAssessment?: Maybe<ProgramAssessment>;
  success: Scalars['Boolean']['output'];
};

export type ScheduleAssessmentInput = {
  assessmentId: Scalars['String']['input'];
  assessmentScheduleItems: Array<AssessmentScheduleItemInput>;
  programTemplateId: Scalars['String']['input'];
};

export type ScheduleAssessmentResult = {
  __typename?: 'ScheduleAssessmentResult';
  updatedProgramTemplateAssessment: ProgramTemplateAssessment;
};

export type ScheduledEvent = {
  __typename?: 'ScheduledEvent';
  calendlyEventTypeUri: Scalars['String']['output'];
  calendlyEventUri: Scalars['String']['output'];
  createdAt: Scalars['Datetime']['output'];
  endTime: Scalars['Datetime']['output'];
  hostName: Scalars['String']['output'];
  hostProfileImageUrl?: Maybe<Scalars['String']['output']>;
  invitees?: Maybe<Array<EventInvitee>>;
  isCanceled: Scalars['Boolean']['output'];
  location: Location;
  name: Scalars['String']['output'];
  startTime: Scalars['Datetime']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ScheduledEventsInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
  isCanceled?: InputMaybe<Scalars['Boolean']['input']>;
  maxStartTime?: InputMaybe<Scalars['Datetime']['input']>;
  minStartTime?: InputMaybe<Scalars['Datetime']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
};

export type ScoreRange = {
  __typename?: 'ScoreRange';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type SearchProviderUsersInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum SeatType {
  Client = 'CLIENT',
  Collaborator = 'COLLABORATOR',
  Staff = 'STAFF'
}

/** GraphQL schema for seat management feature. */
export type SeatUsage = {
  __typename?: 'SeatUsage';
  clientSeats?: Maybe<Scalars['Int']['output']>;
  collaboratorSeats?: Maybe<Scalars['Int']['output']>;
  remainingClientSeats?: Maybe<Scalars['Int']['output']>;
  remainingCollaboratorSeats?: Maybe<Scalars['Int']['output']>;
  remainingStaffSeats?: Maybe<Scalars['Int']['output']>;
  staffSeats?: Maybe<Scalars['Int']['output']>;
  usedClientSeats: Scalars['Int']['output'];
  usedCollaboratorSeats: Scalars['Int']['output'];
  usedStaffSeats: Scalars['Int']['output'];
};

export type SendFollowUpActivityInput = {
  activityAudioId?: InputMaybe<Scalars['String']['input']>;
  activityImageId?: InputMaybe<Scalars['String']['input']>;
  activityLinkId?: InputMaybe<Scalars['String']['input']>;
  activityPDFId?: InputMaybe<Scalars['String']['input']>;
  activityTextId?: InputMaybe<Scalars['String']['input']>;
  activityType: ActivityType;
  assessmentId?: InputMaybe<Scalars['String']['input']>;
  isCompletable?: InputMaybe<Scalars['Boolean']['input']>;
  programAssessmentSignatureUsers?: InputMaybe<Array<ProgramAssessmentSignatureUserInput>>;
  providerNote?: InputMaybe<Scalars['String']['input']>;
};

export type SendFollowUpInput = {
  activities?: InputMaybe<Array<SendFollowUpActivityInput>>;
  programFollowUpId?: InputMaybe<Scalars['String']['input']>;
  programId: Scalars['String']['input'];
  providerNote?: InputMaybe<Scalars['String']['input']>;
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendFollowUpToManyInput = {
  activities?: InputMaybe<Array<SendFollowUpActivityInput>>;
  isIntake?: InputMaybe<Scalars['Boolean']['input']>;
  programFollowUpId?: InputMaybe<Scalars['String']['input']>;
  programIds?: InputMaybe<Array<Scalars['String']['input']>>;
  programTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  providerNote?: InputMaybe<Scalars['String']['input']>;
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  sourceDraftFollowUpTemplateId?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SendInvoiceInput = {
  chargeAutomatically?: Scalars['Boolean']['input'];
  dueDate: Scalars['Datetime']['input'];
  lineItems?: InputMaybe<Array<LineItemInput>>;
  note?: InputMaybe<Scalars['String']['input']>;
  passProcessingFeesToClient?: Scalars['Boolean']['input'];
  programId: Scalars['String']['input'];
};

export type SendProgramInvitesToPatientsClientSeatLimitError = {
  __typename?: 'SendProgramInvitesToPatientsClientSeatLimitError';
  seatsRemaining: Scalars['Int']['output'];
};

export type SendProgramInvitesToPatientsInput = {
  programInstanceIds: Array<Scalars['String']['input']>;
};

export type SendProgramInvitesToPatientsResult = {
  __typename?: 'SendProgramInvitesToPatientsResult';
  clientSeatLimitError?: Maybe<SendProgramInvitesToPatientsClientSeatLimitError>;
  updatedPatients?: Maybe<Array<Patient>>;
};

export type ServiceGroup = {
  __typename?: 'ServiceGroup';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  services: Array<ProviderService>;
};

export enum ServiceIcon {
  Circles = 'Circles',
  Energy = 'Energy',
  Faces = 'Faces',
  Grapes = 'Grapes',
  Leaf = 'Leaf',
  Notepad = 'Notepad',
  Path = 'Path',
  Pencil = 'Pencil',
  Stones = 'Stones',
  Swirls = 'Swirls',
  Vine = 'Vine'
}

export type ServiceIntakePackage = {
  __typename?: 'ServiceIntakePackage';
  calendlyEventType?: Maybe<CalendlyEventType>;
  completedCalendlyBookingAt?: Maybe<Scalars['Datetime']['output']>;
  completedIntakeAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  intakeFormProgramActivity?: Maybe<ProgramActivity>;
  serviceSlug: Scalars['String']['output'];
  serviceSubmissionRedirectUrl?: Maybe<Scalars['String']['output']>;
  storefrontSlug: Scalars['String']['output'];
};

export type SignUpConfig = {
  __typename?: 'SignUpConfig';
  additionalLogoMedia?: Maybe<Media>;
  circleDefaultSpaceSlug?: Maybe<Scalars['String']['output']>;
  headerText?: Maybe<Scalars['String']['output']>;
  hideLoginLink: Scalars['Boolean']['output'];
  isCommunityHub: Scalars['Boolean']['output'];
  logoLinkUrl?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  postSignUpSplashBgMedia?: Maybe<Media>;
  sidepanelBgMedia?: Maybe<Media>;
  sidepanelCommunityMedia?: Maybe<Media>;
  skipIntroCarousel: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  subheaderText?: Maybe<Scalars['String']['output']>;
  testimonialAvatarMedia?: Maybe<Media>;
  testimonialName?: Maybe<Scalars['String']['output']>;
  testimonialQuote?: Maybe<Scalars['String']['output']>;
  testimonialTitle?: Maybe<Scalars['String']['output']>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmContent?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
  utmSource?: Maybe<Scalars['String']['output']>;
  utmTerm?: Maybe<Scalars['String']['output']>;
};

export type SignatureAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'SignatureAssessmentAnswer';
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
  signatureName?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signingIpAddress?: Maybe<Scalars['String']['output']>;
};

export type SignatureAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'SignatureAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type SignatureDetail = {
  __typename?: 'SignatureDetail';
  signatureName: Scalars['String']['output'];
  signatureRole?: Maybe<Scalars['String']['output']>;
  signedAt: Scalars['String']['output'];
  signingIpAddress: Scalars['String']['output'];
};

export type SignatureInput = {
  signature: Scalars['String']['input'];
  signatureDate: Scalars['Datetime']['input'];
  signatureTosAgreement: Scalars['Boolean']['input'];
};

export enum SignatureUser {
  AssignedProviderUser = 'AssignedProviderUser',
  PatientUser = 'PatientUser',
  SendingProviderUser = 'SendingProviderUser'
}

export enum SignupChannel {
  Email = 'Email',
  Phone = 'Phone'
}

export type SoftDeletePatientInput = {
  patientId: Scalars['String']['input'];
};

export type StatementAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'StatementAssessmentAnswer';
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type StatementAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'StatementAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  question: Scalars['String']['output'];
  questionType: AssessmentQuestionType;
};

export type StorefrontImageUploadLimits = {
  __typename?: 'StorefrontImageUploadLimits';
  maxBannerImageSize: Scalars['Int']['output'];
  maxProfileImageSize: Scalars['Int']['output'];
};

export type StripeCardProcessingFeeSchedule = {
  __typename?: 'StripeCardProcessingFeeSchedule';
  country: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  fixedFee: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  percentFee: Scalars['Float']['output'];
};

export type StripeCheckoutPortal = {
  __typename?: 'StripeCheckoutPortal';
  url: Scalars['String']['output'];
};

export type StripeCustomerPortal = {
  __typename?: 'StripeCustomerPortal';
  url: Scalars['String']['output'];
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  stripePriceId: Scalars['String']['output'];
};

export enum SubscriptionTier {
  Lite = 'Lite',
  Premium = 'Premium',
  Standard = 'Standard'
}

export enum SubscriptionTierV2 {
  Free = 'Free',
  Premium = 'Premium',
  Team = 'Team'
}

export type SwitchProviderContextInput = {
  providerId: Scalars['ID']['input'];
};

export type SwitchProviderContextResponse = {
  __typename?: 'SwitchProviderContextResponse';
  message: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  success: Scalars['Boolean']['output'];
};

export enum TagMatchOperator {
  All = 'ALL',
  Any = 'ANY'
}

export type Task = {
  __typename?: 'Task';
  author?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Content>;
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  media?: Maybe<Content>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weightInGroup?: Maybe<Scalars['Float']['output']>;
};

export type TaskAudioData = {
  duration: Scalars['Int']['input'];
  fileName: Scalars['String']['input'];
  label: Scalars['String']['input'];
  mediaId: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type TaskInput = {
  audioData?: InputMaybe<TaskAudioData>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum TaskType {
  CheckIn = 'CheckIn',
  Educational = 'Educational',
  Emotional = 'Emotional',
  Intention = 'Intention',
  Journal = 'Journal',
  Mental = 'Mental',
  Physical = 'Physical',
  Spiritual = 'Spiritual'
}

export type TasksData = {
  __typename?: 'TasksData';
  activitiesCount: Scalars['Int']['output'];
  availableContentCount: Scalars['Int']['output'];
  completedContentCount: Scalars['Int']['output'];
  /** @deprecated Using `contentCompletedPercentage` instead. Remove when web repo fully removes references. */
  completedContentPercentage?: Maybe<Scalars['Float']['output']>;
  contentCompletedPercentage?: Maybe<Scalars['Int']['output']>;
  journalEntriesCount: Scalars['Int']['output'];
  recent3Tasks?: Maybe<Array<PatientTask>>;
};

export type TeamPerformanceInsightsMetricValue = {
  __typename?: 'TeamPerformanceInsightsMetricValue';
  value: Scalars['Int']['output'];
};

export type TeamPerformanceInsightsMetrics = {
  __typename?: 'TeamPerformanceInsightsMetrics';
  newClients: TeamPerformanceInsightsMetricValue;
  /** Resolved window end (UTC, exclusive). Now for ALL_TIME. */
  rangeEnd: Scalars['Datetime']['output'];
  /** Resolved window start (UTC). Null for ALL_TIME. */
  rangeStart?: Maybe<Scalars['Datetime']['output']>;
  sessionsBooked: TeamPerformanceInsightsMetricValue;
  timezone: Scalars['String']['output'];
};

export type TeamPerformanceInsightsMetricsInput = {
  /** Custom range end (inclusive), provider-local date. Required for CUSTOM. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  excludeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeTagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  preset: TeamPerformanceInsightsRangePreset;
  providerServiceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Custom range start (inclusive), provider-local date. Required for CUSTOM. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Browser IANA time zone; used only when the provider has none. */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum TeamPerformanceInsightsRangePreset {
  AllTime = 'ALL_TIME',
  CalendarMonth = 'CALENDAR_MONTH',
  CalendarWeek = 'CALENDAR_WEEK',
  CalendarYear = 'CALENDAR_YEAR',
  Custom = 'CUSTOM'
}

export type TestAutomationRuleInput = {
  automationRuleId: Scalars['String']['input'];
  testData?: InputMaybe<Scalars['String']['input']>;
};

export type TestAutomationRuleResult = {
  __typename?: 'TestAutomationRuleResult';
  result?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  triggeredAt: Scalars['String']['output'];
};

export type TestAutomationWebhookInput = {
  eventType: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['String']['input']>;
};

export type TestAutomationWebhookResult = {
  __typename?: 'TestAutomationWebhookResult';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TimeSeriesInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type Timezone = {
  __typename?: 'Timezone';
  offset: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TokenPayload = {
  __typename?: 'TokenPayload';
  authToken?: Maybe<Scalars['String']['output']>;
  isV2: Scalars['Boolean']['output'];
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  role: AuthSessionRole;
};

export type UnsupportedAssessmentAnswer = AssessmentAnswer & {
  __typename?: 'UnsupportedAssessmentAnswer';
  questionType: AssessmentQuestionType;
  unsupportedAnswer: Scalars['String']['output'];
  unsupportedQuestion: Scalars['String']['output'];
};

export type UnsupportedAssessmentQuestion = AssessmentQuestion & {
  __typename?: 'UnsupportedAssessmentQuestion';
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  questionType: AssessmentQuestionType;
  unsupportedAnswerOptions: Array<UnsupportedQuestionAnswerOption>;
  unsupportedQuestion: Scalars['String']['output'];
};

export type UnsupportedCompletionData = AssessmentCompletionData & {
  __typename?: 'UnsupportedCompletionData';
  schemaType: AssessmentSchemaType;
  unsupportedResult: Scalars['String']['output'];
};

export type UnsupportedQuestionAnswerOption = {
  __typename?: 'UnsupportedQuestionAnswerOption';
  unsupportedAnswerOption: Scalars['String']['output'];
};

export type UpdateAutomationRuleInput = {
  actions?: InputMaybe<Array<InputMaybe<AutomationRuleAction>>>;
  automationRuleId: Scalars['String']['input'];
  conditions?: InputMaybe<AutomationRuleConditions>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  triggerConfig?: InputMaybe<Scalars['String']['input']>;
  triggerEvent?: InputMaybe<AutomationRuleTriggerEvent>;
};

export type UpdateAutomationWebhookConfigInput = {
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientSessionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  participantId?: InputMaybe<Scalars['ID']['input']>;
  practitionerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  when?: InputMaybe<CommonWhenInput>;
};

export type UpdateClientSessionResponse = {
  __typename?: 'UpdateClientSessionResponse';
  clientSession?: Maybe<ClientSession>;
  errors?: Maybe<Array<CommonFormValidationError>>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCustomAssessmentInput = {
  assessmentId: Scalars['String']['input'];
  assessmentSignatureUsers?: InputMaybe<Array<AssessmentSignatureUserInput>>;
  completableByProviderOnly?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<CustomAssessmentQuestionInput>>;
};

export type UpdateFollowUpDraftInput = {
  activities?: InputMaybe<Array<SendFollowUpActivityInput>>;
  isIntake?: InputMaybe<Scalars['Boolean']['input']>;
  programFollowUpId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
  providerNote?: InputMaybe<Scalars['String']['input']>;
  providerVoiceNoteId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMembershipStatusInput = {
  membershipId: Scalars['ID']['input'];
  status: MembershipStatus;
};

export type UpdateMembershipStatusResponse = {
  __typename?: 'UpdateMembershipStatusResponse';
  membership?: Maybe<ProviderUserMembership>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateNylasCalendarEventInput = {
  calendarId: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
  eventId: Scalars['String']['input'];
};

export type UpdateNylasCalendarEventResponse = {
  __typename?: 'UpdateNylasCalendarEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Scalars['JSON']['output']>;
  event?: Maybe<NylasCalendarEvent>;
  success: Scalars['Boolean']['output'];
};

export type UpdateNylasCalendarInput = {
  calendarId: Scalars['String']['input'];
  hexColor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePatientInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressState?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participantId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  programEndDate?: InputMaybe<Scalars['Date']['input']>;
  programId?: InputMaybe<Scalars['String']['input']>;
  programStartDate?: InputMaybe<Scalars['Date']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramNoteInput = {
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPinnedNote?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  programNoteId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProgramTagInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  programTagId: Scalars['String']['input'];
};

export type UpdateProviderCalendarSessionSyncSettingsInput = {
  enableCalendarSyncForSessions?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchivedPatients?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeactivatedStaff?: InputMaybe<Scalars['Boolean']['input']>;
  syncCalendarSessionsForCollaborators?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProviderCalendarSessionSyncSettingsResponse = {
  __typename?: 'UpdateProviderCalendarSessionSyncSettingsResponse';
  error?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ClientCalendarSessionSyncSettings>;
  success: Scalars['Boolean']['output'];
};

export type UpdateProviderCollectionInput = {
  name: Scalars['String']['input'];
  providerCollectionId: Scalars['String']['input'];
};

export type UpdateProviderInput = {
  clientPortalAssessmentTrendsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientPortalBookCalendlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  clientPortalBookServicesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  deleteEmailImageMedia?: InputMaybe<Scalars['Boolean']['input']>;
  deleteSquareLogoMedia?: InputMaybe<Scalars['Boolean']['input']>;
  deleteWordmarkLogoMedia?: InputMaybe<Scalars['Boolean']['input']>;
  emailImageMedia?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  squareLogoMedia?: InputMaybe<Scalars['Upload']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  wordmarkLogoMedia?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateProviderNoteTemplateInput = {
  isSharedNoteTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  providerNoteTemplateId: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderServiceInput = {
  assignedProviderUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  calendlyEventColor?: InputMaybe<Scalars['String']['input']>;
  calendlyEventTypeUri?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  intakeFormAssessmentId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  isPriceLabelShown?: InputMaybe<Scalars['Boolean']['input']>;
  isShownOnStorefront?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  patientAccessLevel?: InputMaybe<PatientAccessLevel>;
  price?: InputMaybe<Scalars['Int']['input']>;
  providerServiceId: Scalars['String']['input'];
  serviceIcon?: InputMaybe<ServiceIcon>;
  serviceIconColorUseCalendlyDefault?: InputMaybe<Scalars['Boolean']['input']>;
  serviceSubmissionBody?: InputMaybe<Scalars['String']['input']>;
  serviceSubmissionRedirectUrl?: InputMaybe<Scalars['String']['input']>;
  serviceSubmissionTitle?: InputMaybe<Scalars['String']['input']>;
  serviceTags?: InputMaybe<Array<ProgramTagInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderStorefrontInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  bannerImageFile?: InputMaybe<Scalars['Upload']['input']>;
  bannerPosition?: InputMaybe<Scalars['Int']['input']>;
  calendlyEventTypeUri?: InputMaybe<Scalars['String']['input']>;
  ctaButtonText?: InputMaybe<Scalars['String']['input']>;
  ctaFormLabel?: InputMaybe<Scalars['String']['input']>;
  intakeFormAssessmentId?: InputMaybe<Scalars['String']['input']>;
  intakeTags?: InputMaybe<Array<ProgramTagInput>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  profileImageFile?: InputMaybe<Scalars['Upload']['input']>;
  roleTitle?: InputMaybe<Scalars['String']['input']>;
  services?: InputMaybe<Scalars['String']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderUserInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProviderUserNotificationControlsInput = {
  allClientsFormCompletionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  careTeamNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientActivationEmailOption?: InputMaybe<NotificationFrequency>;
  patientActivationInAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientActivityCompletionEmailOption?: InputMaybe<NotificationFrequency>;
  patientActivityCompletionInAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientAssessmentCompletionEmailOption?: InputMaybe<NotificationFrequency>;
  patientAssessmentCompletionInAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientCommentEmailOption?: InputMaybe<NotificationFrequency>;
  patientCommentInAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientInvoicePaidEmailOption?: InputMaybe<NotificationFrequency>;
  patientInvoicePaidInAppEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateServiceGroupInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UploadProviderProgramMediaInput = {
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  programId: Scalars['String']['input'];
};

export enum UserType {
  ExternalParty = 'ExternalParty',
  Patient = 'Patient',
  ProviderUser = 'ProviderUser'
}

export type UtmParamsInput = {
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceNote = {
  __typename?: 'VoiceNote';
  duration: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  media: Media;
};

export type VoiceNoteInput = {
  duration: Scalars['Int']['input'];
  file: Scalars['Upload']['input'];
};

export type WebexConferenceLocation = Location & {
  __typename?: 'WebexConferenceLocation';
  joinUrl?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type ZoomConferenceLocation = Location & {
  __typename?: 'ZoomConferenceLocation';
  joinUrl?: Maybe<Scalars['String']['output']>;
  type: LocationType;
};

export type BasicProgramActivityDataFragment = { __typename?: 'ProgramActivity', id: string };

export type ProgramActivityDataFragment = { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null };

type ActivityData_ActivityAction_Fragment = { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> };

type ActivityData_ActivityAssessment_Fragment = { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
      | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
      | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
      | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
    > } };

type ActivityData_ActivityAudio_Fragment = { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityData_ActivityImage_Fragment = { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityData_ActivityLink_Fragment = { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null };

type ActivityData_ActivityPdf_Fragment = { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityData_ActivityText_Fragment = { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> };

export type ActivityDataFragment =
  | ActivityData_ActivityAction_Fragment
  | ActivityData_ActivityAssessment_Fragment
  | ActivityData_ActivityAudio_Fragment
  | ActivityData_ActivityImage_Fragment
  | ActivityData_ActivityLink_Fragment
  | ActivityData_ActivityPdf_Fragment
  | ActivityData_ActivityText_Fragment
;

type ActivityListData_ActivityAction_Fragment = { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> };

type ActivityListData_ActivityAssessment_Fragment = { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, completableByProviderOnly: boolean, description: string, estimatedLengthInMinutes?: number | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null } };

type ActivityListData_ActivityAudio_Fragment = { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityListData_ActivityImage_Fragment = { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityListData_ActivityLink_Fragment = { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null };

type ActivityListData_ActivityPdf_Fragment = { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } };

type ActivityListData_ActivityText_Fragment = { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> };

export type ActivityListDataFragment =
  | ActivityListData_ActivityAction_Fragment
  | ActivityListData_ActivityAssessment_Fragment
  | ActivityListData_ActivityAudio_Fragment
  | ActivityListData_ActivityImage_Fragment
  | ActivityListData_ActivityLink_Fragment
  | ActivityListData_ActivityPdf_Fragment
  | ActivityListData_ActivityText_Fragment
;

export type ProviderActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderActivitiesQuery = { __typename?: 'Query', providerActivities: Array<
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, completableByProviderOnly: boolean, description: string, estimatedLengthInMinutes?: number | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
  > };

export type StandardAssessmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardAssessmentsQuery = { __typename?: 'Query', standardAssessments: Array<
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, completableByProviderOnly: boolean, description: string, estimatedLengthInMinutes?: number | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
  > };

export type ProgramActivitiesQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProgramActivitiesQuery = { __typename?: 'Query', programActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> };

export type ProgramActivityQueryVariables = Exact<{
  programActivityId: Scalars['String']['input'];
}>;


export type ProgramActivityQuery = { __typename?: 'Query', programActivity?: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } | null };

export type CompletedPdfSubmissionsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type CompletedPdfSubmissionsQuery = { __typename?: 'Query', completedPdfSubmissions: Array<{ __typename?: 'PdfSubmission', id: string, signedAt?: any | null, programActivity: { __typename?: 'ProgramActivity', id: string, activityType: ActivityType, name: string, completedAt?: any | null }, media?: { __typename?: 'Media', id: string, url: string } | null }> };

export type AssessmentActivitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssessmentActivitiesQuery = { __typename?: 'Query', providerAssessments: Array<{ __typename?: 'Assessment', description: string, category: AssessmentCategory, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string }> };

export type LinkPreviewQueryVariables = Exact<{
  linkURL: Scalars['String']['input'];
}>;


export type LinkPreviewQuery = { __typename?: 'Query', linkPreview: { __typename?: 'LinkPreview', title?: string | null, imageURL?: string | null } };

export type ActivityQueryVariables = Exact<{
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
}>;


export type ActivityQuery = { __typename?: 'Query', activity?:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   | null };

export type ActivityAudioQueryVariables = Exact<{
  mediaCategory: MediaCategory;
}>;


export type ActivityAudioQuery = { __typename?: 'Query', activityAudio: Array<{ __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }> };

export type ActivityImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityImagesQuery = { __typename?: 'Query', activityImages: Array<{ __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }> };

export type ActivityLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityLinksQuery = { __typename?: 'Query', activityLinks: Array<{ __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }> };

export type ActivityPdFsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityPdFsQuery = { __typename?: 'Query', activityPDFs: Array<{ __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }> };

export type ActivityTextsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityTextsQuery = { __typename?: 'Query', activityTexts: Array<{ __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }> };

export type DuplicateActivityMutationVariables = Exact<{
  input: DuplicateActivityInput;
}>;


export type DuplicateActivityMutation = { __typename?: 'Mutation', duplicateActivity:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   };

export type AddActivityAudioMutationVariables = Exact<{
  input: ActivityAudioInput;
}>;


export type AddActivityAudioMutation = { __typename?: 'Mutation', addActivityAudio: { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } };

export type AddActivityImageMutationVariables = Exact<{
  input: ActivityImageInput;
}>;


export type AddActivityImageMutation = { __typename?: 'Mutation', addActivityImage: { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } };

export type AddActivityLinkMutationVariables = Exact<{
  input: ActivityLinkInput;
}>;


export type AddActivityLinkMutation = { __typename?: 'Mutation', addActivityLink: { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } };

export type AddActivityPdfMutationVariables = Exact<{
  input: ActivityPdfInput;
}>;


export type AddActivityPdfMutation = { __typename?: 'Mutation', addActivityPDF: { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } };

export type AddActivityTextMutationVariables = Exact<{
  input: ActivityTextInput;
}>;


export type AddActivityTextMutation = { __typename?: 'Mutation', addActivityText: { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> } };

export type EditActivityTitleMutationVariables = Exact<{
  input: EditActivityTitleInput;
}>;


export type EditActivityTitleMutation = { __typename?: 'Mutation', editActivityTitle:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   };

export type EditActivityTextMutationVariables = Exact<{
  input: EditActivityTextInput;
}>;


export type EditActivityTextMutation = { __typename?: 'Mutation', editActivityText: { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> } };

export type EditActivityFileSettingsMutationVariables = Exact<{
  input: EditActivityFileSettingsInput;
}>;


export type EditActivityFileSettingsMutation = { __typename?: 'Mutation', editActivityFileSettings:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   };

export type ArchiveActivityMutationVariables = Exact<{
  activityId: Scalars['String']['input'];
  activityType: ActivityType;
}>;


export type ArchiveActivityMutation = { __typename?: 'Mutation', archiveActivity:
    | { __typename?: 'ActivityAction', id: string }
    | { __typename?: 'ActivityAssessment', id: string }
    | { __typename?: 'ActivityAudio', id: string }
    | { __typename?: 'ActivityImage', id: string }
    | { __typename?: 'ActivityLink', id: string }
    | { __typename?: 'ActivityPDF', id: string }
    | { __typename?: 'ActivityText', id: string }
   };

export type ArchiveActivitiesMutationVariables = Exact<{
  input: ArchiveActivitiesInput;
}>;


export type ArchiveActivitiesMutation = { __typename?: 'Mutation', archiveActivities: Array<
    | { __typename?: 'ActivityAction', id: string }
    | { __typename?: 'ActivityAssessment', id: string }
    | { __typename?: 'ActivityAudio', id: string }
    | { __typename?: 'ActivityImage', id: string }
    | { __typename?: 'ActivityLink', id: string }
    | { __typename?: 'ActivityPDF', id: string }
    | { __typename?: 'ActivityText', id: string }
  > };

export type VoidProgramActivityMutationVariables = Exact<{
  programActivityId: Scalars['String']['input'];
}>;


export type VoidProgramActivityMutation = { __typename?: 'Mutation', voidProgramActivity: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } };

export type RecordProgramActivityPdfDownloadMutationVariables = Exact<{
  programActivityId: Scalars['String']['input'];
}>;


export type RecordProgramActivityPdfDownloadMutation = { __typename?: 'Mutation', recordProgramActivityPdfDownload: boolean };

export type RecordProgramActivityResponsesViewedMutationVariables = Exact<{
  programActivityId: Scalars['String']['input'];
}>;


export type RecordProgramActivityResponsesViewedMutation = { __typename?: 'Mutation', recordProgramActivityResponsesViewed: boolean };

export type PublicPdfSubmissionQueryVariables = Exact<{
  pdfSubmissionLinkToken: Scalars['String']['input'];
}>;


export type PublicPdfSubmissionQuery = { __typename?: 'Query', publicPdfSubmission: { __typename?: 'PublicPdfSubmission', title: string, pdfUrl: string, expiresAt: any, submittedAt?: any | null, providerFirstName: string } };

export type SubmitPdfFormMutationVariables = Exact<{
  pdfSubmissionLinkToken: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}>;


export type SubmitPdfFormMutation = { __typename?: 'Mutation', submitPdfForm: boolean };

export type CompleteProgramActivityMutationVariables = Exact<{
  input: CompleteProgramActivityInput;
}>;


export type CompleteProgramActivityMutation = { __typename?: 'Mutation', completeProgramActivity: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } };

export type DismissProgramActivityMutationVariables = Exact<{
  input: DismissProgramActivityInput;
}>;


export type DismissProgramActivityMutation = { __typename?: 'Mutation', dismissProgramActivity: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } };

export type MarkProgramActivitiesSeenMutationVariables = Exact<{
  programActivityIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type MarkProgramActivitiesSeenMutation = { __typename?: 'Mutation', markProgramActivitiesSeen: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> };

export type TodoProgramActivitiesQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type TodoProgramActivitiesQuery = { __typename?: 'Query', todoProgramActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> };

export type EssentialAssessmentDataFragment = { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string };

export type BasicAssessmentDataFragment = { __typename?: 'Assessment', description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null };

export type AssessmentDataFragment = { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null };

type AssessmentQuestionData_AutofillAssessmentQuestion_Fragment = { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType };

type AssessmentQuestionData_ConditionalMultipleChoiceAssessmentQuestion_Fragment = { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } };

type AssessmentQuestionData_DatePickerAssessmentQuestion_Fragment = { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType };

type AssessmentQuestionData_FileUploadAssessmentQuestion_Fragment = { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType };

type AssessmentQuestionData_FreeTextAssessmentQuestion_Fragment = { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_InitialsAssessmentQuestion_Fragment = { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_MultiSelectAssessmentQuestion_Fragment = { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> };

type AssessmentQuestionData_MultiSignatureAssessmentQuestion_Fragment = { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null };

type AssessmentQuestionData_MultipleChoiceAssessmentQuestion_Fragment = { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> };

type AssessmentQuestionData_MultipleChoiceScoredAssessmentQuestion_Fragment = { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> };

type AssessmentQuestionData_PatientContactAssessmentQuestion_Fragment = { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType };

type AssessmentQuestionData_ProviderSignatureAssessmentQuestion_Fragment = { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_RichTextAssessmentQuestion_Fragment = { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_SignatureAssessmentQuestion_Fragment = { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_StatementAssessmentQuestion_Fragment = { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType };

type AssessmentQuestionData_UnsupportedAssessmentQuestion_Fragment = { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType };

export type AssessmentQuestionDataFragment =
  | AssessmentQuestionData_AutofillAssessmentQuestion_Fragment
  | AssessmentQuestionData_ConditionalMultipleChoiceAssessmentQuestion_Fragment
  | AssessmentQuestionData_DatePickerAssessmentQuestion_Fragment
  | AssessmentQuestionData_FileUploadAssessmentQuestion_Fragment
  | AssessmentQuestionData_FreeTextAssessmentQuestion_Fragment
  | AssessmentQuestionData_InitialsAssessmentQuestion_Fragment
  | AssessmentQuestionData_MultiSelectAssessmentQuestion_Fragment
  | AssessmentQuestionData_MultiSignatureAssessmentQuestion_Fragment
  | AssessmentQuestionData_MultipleChoiceAssessmentQuestion_Fragment
  | AssessmentQuestionData_MultipleChoiceScoredAssessmentQuestion_Fragment
  | AssessmentQuestionData_PatientContactAssessmentQuestion_Fragment
  | AssessmentQuestionData_ProviderSignatureAssessmentQuestion_Fragment
  | AssessmentQuestionData_RichTextAssessmentQuestion_Fragment
  | AssessmentQuestionData_SignatureAssessmentQuestion_Fragment
  | AssessmentQuestionData_StatementAssessmentQuestion_Fragment
  | AssessmentQuestionData_UnsupportedAssessmentQuestion_Fragment
;

export type ProviderAssessmentsQueryVariables = Exact<{
  programTemplateId: Scalars['String']['input'];
}>;


export type ProviderAssessmentsQuery = { __typename?: 'Query', providerAssessments: Array<{ __typename?: 'Assessment', estimatedLengthInMinutes?: number | null, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, programTemplateAssessment?: { __typename?: 'ProgramTemplateAssessment', scheduleItems: Array<{ __typename?: 'ProgramTemplateAssessmentScheduleItem', focalEvent: AssessmentFocalEvent, timingOffset?: any | null, recurrenceInterval?: any | null }> } | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }> };

export type ProviderAssessmentsWithoutScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderAssessmentsWithoutScheduleQuery = { __typename?: 'Query', assessments: Array<{ __typename?: 'Assessment', estimatedLengthInMinutes?: number | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
      | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
      | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
      | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
    >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }>, forms: Array<{ __typename?: 'Assessment', estimatedLengthInMinutes?: number | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
      | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
      | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
      | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
    >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }> };

export type AssignAssessmentModalDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignAssessmentModalDataQuery = { __typename?: 'Query', providerAssessments: Array<{ __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string }> };

export type ScheduleAssessmentDataQueryVariables = Exact<{
  programTemplateId: Scalars['String']['input'];
  assessmentId: Scalars['String']['input'];
}>;


export type ScheduleAssessmentDataQuery = { __typename?: 'Query', assessment: { __typename?: 'Assessment', estimatedLengthInMinutes?: number | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion' }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion' }
      | { __typename?: 'DatePickerAssessmentQuestion' }
      | { __typename?: 'FileUploadAssessmentQuestion' }
      | { __typename?: 'FreeTextAssessmentQuestion' }
      | { __typename?: 'InitialsAssessmentQuestion' }
      | { __typename?: 'MultiSelectAssessmentQuestion' }
      | { __typename?: 'MultiSignatureAssessmentQuestion' }
      | { __typename?: 'MultipleChoiceAssessmentQuestion' }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', question: string, subscale?: string | null, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion' }
      | { __typename?: 'ProviderSignatureAssessmentQuestion' }
      | { __typename?: 'RichTextAssessmentQuestion' }
      | { __typename?: 'SignatureAssessmentQuestion' }
      | { __typename?: 'StatementAssessmentQuestion' }
      | { __typename?: 'UnsupportedAssessmentQuestion' }
    >, programTemplateAssessment?: { __typename?: 'ProgramTemplateAssessment', scheduleItems: Array<{ __typename?: 'ProgramTemplateAssessmentScheduleItem', focalEvent: AssessmentFocalEvent, timingOffset?: any | null, recurrenceInterval?: any | null }> } | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null } };

export type ScheduleAssessmentMutationVariables = Exact<{
  input: ScheduleAssessmentInput;
}>;


export type ScheduleAssessmentMutation = { __typename?: 'Mutation', scheduleAssessment: { __typename?: 'ScheduleAssessmentResult', updatedProgramTemplateAssessment: { __typename?: 'ProgramTemplateAssessment', scheduleItems: Array<{ __typename?: 'ProgramTemplateAssessmentScheduleItem', focalEvent: AssessmentFocalEvent, timingOffset?: any | null, recurrenceInterval?: any | null }> } } };

export type AssignAssessmentMutationVariables = Exact<{
  programId: Scalars['String']['input'];
  assessmentId: Scalars['String']['input'];
}>;


export type AssignAssessmentMutation = { __typename?: 'Mutation', assignAssessment: { __typename?: 'ProgramAssessment', id: string } };

export type LatestCompletedProgramAssessmentsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type LatestCompletedProgramAssessmentsQuery = { __typename?: 'Query', latestCompletedProgramAssessments: Array<{ __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, completedByType?: string | null, completedByExternalName?: string | null, completedByExternalEmail?: string | null, completionCount: number, completedByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', completableByProviderOnly: boolean, increasingScoreTowardsHealth?: boolean | null, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', patientName?: string | null, signedAt?: any | null, providerUser?: { __typename?: 'ProviderUserMember', name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, completionData?:
      | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, categorization: string, color: string }> }
      | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, categorization: string, color: string }> }
      | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
      | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, categorization: string, color: string }> }
      | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
      | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
     | null, previouslyCompletedProgramAssessmentOfSameType?: { __typename?: 'ProgramAssessment', completionData?:
        | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType }
        | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType }
        | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
        | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number }> }
        | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, schemaType: AssessmentSchemaType }
        | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
       | null } | null }> };

export type CompletedProgramAssessmentsDataQueryVariables = Exact<{
  programId: Scalars['String']['input'];
  assessmentId: Scalars['String']['input'];
}>;


export type CompletedProgramAssessmentsDataQuery = { __typename?: 'Query', assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, completedProgramAssessmentsByAssessment: Array<{ __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, completedByType?: string | null, completedByExternalName?: string | null, additionalThoughts?: string | null, draftProviderSignatureName?: string | null, draftProviderSignatureRole?: string | null, draftSignatureTermsAgreed?: boolean | null, completedByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', signedAt?: any | null, providerUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null }> | null, completionData?:
      | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, color: string, categorization: string }> }
      | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
      | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
      | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
     | null, answers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
        | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
        | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
        | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
        | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
        | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
        | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
      >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, draftAnswers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null }> };

type AssessmentAnswerData_AutofillAssessmentAnswer_Fragment = { __typename?: 'AutofillAssessmentAnswer', questionType: AssessmentQuestionType };

type AssessmentAnswerData_DatePickerAssessmentAnswer_Fragment = { __typename?: 'DatePickerAssessmentAnswer', questionType: AssessmentQuestionType };

type AssessmentAnswerData_FileUploadAssessmentAnswer_Fragment = { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType };

type AssessmentAnswerData_FreeTextAssessmentAnswer_Fragment = { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType };

type AssessmentAnswerData_InitialsAssessmentAnswer_Fragment = { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType };

type AssessmentAnswerData_MultiSelectAssessmentAnswer_Fragment = { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType };

type AssessmentAnswerData_MultiSignatureAssessmentAnswer_Fragment = { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> };

type AssessmentAnswerData_MultipleChoiceAssessmentAnswer_Fragment = { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType };

type AssessmentAnswerData_MultipleChoiceScoredAssessmentAnswer_Fragment = { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType };

type AssessmentAnswerData_PatientContactAssessmentAnswer_Fragment = { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null };

type AssessmentAnswerData_ProviderSignatureAssessmentAnswer_Fragment = { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType };

type AssessmentAnswerData_RichTextAssessmentAnswer_Fragment = { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType };

type AssessmentAnswerData_SignatureAssessmentAnswer_Fragment = { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType };

type AssessmentAnswerData_StatementAssessmentAnswer_Fragment = { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType };

type AssessmentAnswerData_UnsupportedAssessmentAnswer_Fragment = { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType };

export type AssessmentAnswerDataFragment =
  | AssessmentAnswerData_AutofillAssessmentAnswer_Fragment
  | AssessmentAnswerData_DatePickerAssessmentAnswer_Fragment
  | AssessmentAnswerData_FileUploadAssessmentAnswer_Fragment
  | AssessmentAnswerData_FreeTextAssessmentAnswer_Fragment
  | AssessmentAnswerData_InitialsAssessmentAnswer_Fragment
  | AssessmentAnswerData_MultiSelectAssessmentAnswer_Fragment
  | AssessmentAnswerData_MultiSignatureAssessmentAnswer_Fragment
  | AssessmentAnswerData_MultipleChoiceAssessmentAnswer_Fragment
  | AssessmentAnswerData_MultipleChoiceScoredAssessmentAnswer_Fragment
  | AssessmentAnswerData_PatientContactAssessmentAnswer_Fragment
  | AssessmentAnswerData_ProviderSignatureAssessmentAnswer_Fragment
  | AssessmentAnswerData_RichTextAssessmentAnswer_Fragment
  | AssessmentAnswerData_SignatureAssessmentAnswer_Fragment
  | AssessmentAnswerData_StatementAssessmentAnswer_Fragment
  | AssessmentAnswerData_UnsupportedAssessmentAnswer_Fragment
;

export type AssessmentOnProgramAssessmentDataFragment = { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
    | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
    | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
    | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
    | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
    | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
    | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
    | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
    | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
    | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
    | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
  >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null };

export type ProgramAssessmentDataFragment = { __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, additionalThoughts?: string | null, draftProviderSignatureName?: string | null, draftProviderSignatureRole?: string | null, draftSignatureTermsAgreed?: boolean | null, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
      | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
      | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
      | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
    >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, completionData?:
    | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, color: string, categorization: string }> }
    | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, color: string, categorization: string }> }
    | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
    | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, color: string, categorization: string }> }
    | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
    | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
   | null, answers?: Array<
    | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
    | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
    | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
    | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
    | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
    | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
    | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
  > | null, draftAnswers?: Array<
    | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
    | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
    | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
    | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
    | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
    | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
    | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
    | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
    | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
  > | null };

export type ProgramAssessmentQueryVariables = Exact<{
  programAssessmentId: Scalars['String']['input'];
}>;


export type ProgramAssessmentQuery = { __typename?: 'Query', programAssessment?: { __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, additionalThoughts?: string | null, draftProviderSignatureName?: string | null, draftProviderSignatureRole?: string | null, draftSignatureTermsAgreed?: boolean | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
        | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
        | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
        | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
        | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
        | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
        | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
      >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, completionData?:
      | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, color: string, categorization: string }> }
      | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
      | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
      | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
     | null, answers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null, draftAnswers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null } | null };

export type ProgramAssessmentSignatureUserDataFragment = { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null };

export type ProviderSignMultiSignatureAssessmentMutationVariables = Exact<{
  programAssessmentId: Scalars['String']['input'];
  signatureName: Scalars['String']['input'];
  signatureRole: Scalars['String']['input'];
}>;


export type ProviderSignMultiSignatureAssessmentMutation = { __typename?: 'Mutation', providerSignMultiSignatureAssessment: { __typename?: 'ProgramAssessment', id: string, assessment: { __typename?: 'Assessment', id: string, name: string }, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null } };

export type ProviderCompleteFormMutationVariables = Exact<{
  input: ProviderCompleteFormInput;
}>;


export type ProviderCompleteFormMutation = { __typename?: 'Mutation', providerCompleteForm: { __typename?: 'ProgramAssessment', id: string, assessment: { __typename?: 'Assessment', id: string, name: string }, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null } };

export type ProviderProgramAssessmentQueryVariables = Exact<{
  programAssessmentId: Scalars['String']['input'];
}>;


export type ProviderProgramAssessmentQuery = { __typename?: 'Query', programAssessment?: { __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, additionalThoughts?: string | null, draftProviderSignatureName?: string | null, draftProviderSignatureRole?: string | null, draftSignatureTermsAgreed?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, answers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
        | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
        | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
        | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
        | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
        | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
        | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
      >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, completionData?:
      | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, color: string, categorization: string }> }
      | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
      | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
      | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
     | null, draftAnswers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null } | null };

export type ProgramAssessmentScheduleQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProgramAssessmentScheduleQuery = { __typename?: 'Query', programAssessmentSchedule: { __typename?: 'ProgramAssessmentScheduleResult', scheduledProgramAssessments?: Array<{ __typename?: 'ProgramAssessment', id: string, startDate: any, assessment: { __typename?: 'Assessment', shortName: string } }> | null, deliveredProgramAssessments?: Array<{ __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, dismissedAt?: any | null, notifiedAt?: any | null, hasExpired?: boolean | null, assessment: { __typename?: 'Assessment', shortName: string } }> | null } };

export type CustomAssessmentQueryVariables = Exact<{
  assessmentId: Scalars['String']['input'];
  programId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CustomAssessmentQuery = { __typename?: 'Query', assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
      | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
      | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
      | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
      | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
      | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
      | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
    >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null } };

export type ProviderUserSignableFormsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserSignableFormsCountQuery = { __typename?: 'Query', providerUserSignableFormsCount: number };

export type UnsignedFormDataFragment = { __typename?: 'ProgramAssessment', id: string, assessment: { __typename?: 'Assessment', name: string }, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null };

export type ProviderUserSignableFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserSignableFormsQuery = { __typename?: 'Query', providerUserSignableForms: Array<{ __typename?: 'ProgramAssessment', id: string, assessment: { __typename?: 'Assessment', name: string }, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type CreateCustomAssessmentMutationVariables = Exact<{
  input: CreateCustomAssessmentInput;
}>;


export type CreateCustomAssessmentMutation = { __typename?: 'Mutation', createCustomAssessment: { __typename?: 'Assessment', id: string, name: string } };

export type UpdateCustomAssessmentMutationVariables = Exact<{
  input: UpdateCustomAssessmentInput;
}>;


export type UpdateCustomAssessmentMutation = { __typename?: 'Mutation', updateCustomAssessment: { __typename?: 'Assessment', id: string, name: string } };

export type ArchiveCustomAssessmentMutationVariables = Exact<{
  assessmentId: Scalars['String']['input'];
}>;


export type ArchiveCustomAssessmentMutation = { __typename?: 'Mutation', archiveCustomAssessment: { __typename?: 'Assessment', id: string } };

export type SaveFormDraftMutationVariables = Exact<{
  input: SaveFormDraftInput;
}>;


export type SaveFormDraftMutation = { __typename?: 'Mutation', saveFormDraft: { __typename?: 'SaveFormDraftPayload', success: boolean } };

export type CompleteProviderOnlyFormMutationVariables = Exact<{
  input: CompleteProviderOnlyFormInput;
}>;


export type CompleteProviderOnlyFormMutation = { __typename?: 'Mutation', completeProviderOnlyForm: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, assessment: { __typename?: 'Assessment', id: string, name: string } } };

export type ExternalPractitionerFormInvitesForContactQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type ExternalPractitionerFormInvitesForContactQuery = { __typename?: 'Query', externalPractitionerFormInvitesForContact: Array<{ __typename?: 'ExternalPractitionerFormInviteInfo', id: string, url: string, formName: string, sentAt?: any | null, expiresAt: any, status: ExternalPractitionerFormInviteStatus }> };

export type CreateExternalPractitionerFormInviteMutationVariables = Exact<{
  input: CreateExternalPractitionerFormInviteInput;
}>;


export type CreateExternalPractitionerFormInviteMutation = { __typename?: 'Mutation', createExternalPractitionerFormInvite: { __typename?: 'CreateExternalPractitionerFormInvitePayload', inviteId: string, url: string, expiresAt: any, programAssessmentId: string } };

export type PatientCompletedProgramAssessmentsDataQueryVariables = Exact<{
  assessmentId: Scalars['String']['input'];
}>;


export type PatientCompletedProgramAssessmentsDataQuery = { __typename?: 'Query', patientCompletedProgramAssessmentsByAssessment: Array<{ __typename?: 'ProgramAssessment', id: string, startDate: any, completedAt?: any | null, completedByType?: string | null, completedByExternalName?: string | null, additionalThoughts?: string | null, draftProviderSignatureName?: string | null, draftProviderSignatureRole?: string | null, draftSignatureTermsAgreed?: boolean | null, completedByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', signedAt?: any | null, providerUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null }> | null, completionData?:
      | { __typename?: 'ASRS19AssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'ASRS19SubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'CBIAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'CBISubscoreCompletionData', subscale: CbiSubscale, score: number, color: string, categorization: string }> }
      | { __typename?: 'CustomAssessmentCompletionData', schemaType: AssessmentSchemaType }
      | { __typename?: 'HADSAssessmentCompletionData', schemaType: AssessmentSchemaType, subscores: Array<{ __typename?: 'HADSSubscoreCompletionData', score: number, color: string, categorization: string }> }
      | { __typename?: 'MultipleChoiceSumScoredAssessmentCompletionData', score: number, categorization?: string | null, color?: string | null, schemaType: AssessmentSchemaType }
      | { __typename?: 'UnsupportedCompletionData', schemaType: AssessmentSchemaType }
     | null, patientNameData?: { __typename?: 'PatientName', programInstanceId: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, assessment: { __typename?: 'Assessment', moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, completableByProviderOnly: boolean, description: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string, questions: Array<
        | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
        | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
        | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
        | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
        | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
        | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
        | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
        | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
        | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
      >, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', signatureUserType: SignatureUser, orderIndex: number }> | null, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null }, answers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null, draftAnswers?: Array<
      | { __typename?: 'AutofillAssessmentAnswer', question: string, questionType: AssessmentQuestionType, autofillAnswer?: string | null }
      | { __typename?: 'DatePickerAssessmentAnswer', question: string, questionType: AssessmentQuestionType, datePickerAnswer?: any | null }
      | { __typename?: 'FileUploadAssessmentAnswer', question: string, fileName?: string | null, mediaId?: string | null, mediaUrl?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'FreeTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'InitialsAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSelectAssessmentAnswer', question: string, answers: Array<string>, questionType: AssessmentQuestionType }
      | { __typename?: 'MultiSignatureAssessmentAnswer', question: string, questionType: AssessmentQuestionType, signatures: Array<{ __typename?: 'SignatureDetail', signingIpAddress: string, signedAt: string, signatureName: string, signatureRole?: string | null }> }
      | { __typename?: 'MultipleChoiceAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'MultipleChoiceScoredAssessmentAnswer', question: string, subscale?: string | null, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'PatientContactAssessmentAnswer', question: string, contactId?: string | null, newContactDraftJson?: string | null, questionType: AssessmentQuestionType, contactSnapshot?: { __typename?: 'PatientContactAnswerSnapshot', firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null } | null }
      | { __typename?: 'ProviderSignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, signatureRole?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'RichTextAssessmentAnswer', question: string, answer: string, questionType: AssessmentQuestionType }
      | { __typename?: 'SignatureAssessmentAnswer', question: string, signatureName?: string | null, signedAt?: string | null, signingIpAddress?: string | null, questionType: AssessmentQuestionType }
      | { __typename?: 'StatementAssessmentAnswer', questionType: AssessmentQuestionType }
      | { __typename?: 'UnsupportedAssessmentAnswer', questionType: AssessmentQuestionType }
    > | null }> };

export type AuditLogsQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
  entityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs: Array<{ __typename?: 'AuditLog', id: string, activityType: string, actorType: AuditLogActorType, performedAt: any, extraMetadata?: any | null, performedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type AuthenticationRequestVerificationCodeMutationVariables = Exact<{
  input: AuthenticationRequestCodeInput;
}>;


export type AuthenticationRequestVerificationCodeMutation = { __typename?: 'Mutation', authenticationRequestCode: { __typename?: 'AuthenticationRequestCodeResponse', success: boolean, verificationId?: string | null, maskedEmail?: string | null, codeSent: boolean, nextResendAllowedAt?: any | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type AuthenticationResendCodeMutationVariables = Exact<{
  input: AuthenticationResendCodeInput;
}>;


export type AuthenticationResendCodeMutation = { __typename?: 'Mutation', authenticationResendCode: { __typename?: 'AuthenticationRequestCodeResponse', success: boolean, verificationId?: string | null, maskedEmail?: string | null, codeSent: boolean, nextResendAllowedAt?: any | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type AuthenticationVerifyCodeMutationVariables = Exact<{
  input: AuthenticationVerifyCodeInput;
}>;


export type AuthenticationVerifyCodeMutation = { __typename?: 'Mutation', authenticationVerifyCode: { __typename?: 'AuthenticationVerifyCodeResponse', success: boolean, sessionToken?: string | null, userId?: string | null, userType?: string | null, createdAt?: any | null, expiresAt?: any | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type AuthenticationCodeVerificationQueryVariables = Exact<{
  verificationId: Scalars['ID']['input'];
}>;


export type AuthenticationCodeVerificationQuery = { __typename?: 'Query', authenticationCodeVerification: { __typename?: 'AuthenticationCodeVerificationResponse', success: boolean, verificationId?: string | null, maskedEmail?: string | null, nextResendAllowedAt?: any | null, providerWordmarkLogoUrl?: string | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type AuthenticationLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthenticationLogoutMutation = { __typename?: 'Mutation', authenticationLogout: { __typename?: 'AuthenticationLogoutResponse', success: boolean, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type AutomationRuleDataFragment = { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> };

export type AutomationRulesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationRulesQuery = { __typename?: 'Query', automationRules: Array<{ __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> }> };

export type AutomationRuleQueryVariables = Exact<{
  automationRuleId: Scalars['String']['input'];
}>;


export type AutomationRuleQuery = { __typename?: 'Query', automationRule?: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } | null };

export type CreateAutomationRuleMutationVariables = Exact<{
  input: CreateAutomationRuleInput;
}>;


export type CreateAutomationRuleMutation = { __typename?: 'Mutation', createAutomationRule: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } };

export type UpdateAutomationRuleMutationVariables = Exact<{
  input: UpdateAutomationRuleInput;
}>;


export type UpdateAutomationRuleMutation = { __typename?: 'Mutation', updateAutomationRule: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } };

export type DeleteAutomationRuleMutationVariables = Exact<{
  automationRuleId: Scalars['String']['input'];
}>;


export type DeleteAutomationRuleMutation = { __typename?: 'Mutation', deleteAutomationRule: boolean };

export type EnableAutomationRuleMutationVariables = Exact<{
  automationRuleId: Scalars['String']['input'];
}>;


export type EnableAutomationRuleMutation = { __typename?: 'Mutation', enableAutomationRule: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } };

export type DisableAutomationRuleMutationVariables = Exact<{
  automationRuleId: Scalars['String']['input'];
}>;


export type DisableAutomationRuleMutation = { __typename?: 'Mutation', disableAutomationRule: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } };

export type CopyAutomationRuleMutationVariables = Exact<{
  automationRuleId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CopyAutomationRuleMutation = { __typename?: 'Mutation', copyAutomationRule: { __typename?: 'CopyAutomationRuleResult', automationRule: { __typename?: 'AutomationRule', id: string, automationRuleId: string, name: string, description?: string | null, enabled: boolean, triggerEvent: AutomationRuleTriggerEvent, triggerConfig?: string | null, priority: number, createdBy?: string | null, createdAt: string, updatedAt: string, lastTriggeredAt?: string | null, triggerCount: number, successCount: number, failureCount: number, conditions: { __typename?: 'AutomationRuleConditionsOutput', logic: string, rules: Array<{ __typename?: 'AutomationRuleConditionOutput', field: string, operator: string, value: string }> }, actions: Array<{ __typename?: 'AutomationRuleActionOutput', type: string, params: Array<{ __typename?: 'AutomationRuleActionParamOutput', key: string, value: string }> }> } } };

export type TestAutomationRuleMutationVariables = Exact<{
  input: TestAutomationRuleInput;
}>;


export type TestAutomationRuleMutation = { __typename?: 'Mutation', testAutomationRule: { __typename?: 'TestAutomationRuleResult', success: boolean, triggeredAt: string, result?: string | null } };

export type AutomationExecutionsQueryVariables = Exact<{
  automationRuleId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AutomationExecutionStatus>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationExecutionsQuery = { __typename?: 'Query', automationExecutions: Array<{ __typename?: 'AutomationExecution', id: string, automationExecutionId: string, automationRuleId: string, providerId: string, status: AutomationExecutionStatus, triggerEventType: string, eventId?: string | null, eventData?: string | null, conditionsMet: boolean, actionsExecuted: number, actionsSucceeded: number, actionsFailed: number, errorMessage?: string | null, executionResults?: string | null, startedAt: string, completedAt?: string | null, createdAt: string }> };

export type AutomationWebhookConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationWebhookConfigQuery = { __typename?: 'Query', automationWebhookConfig?: { __typename?: 'AutomationWebhookConfig', webhookUrl?: string | null } | null };

export type UpdateAutomationWebhookConfigMutationVariables = Exact<{
  input: UpdateAutomationWebhookConfigInput;
}>;


export type UpdateAutomationWebhookConfigMutation = { __typename?: 'Mutation', updateAutomationWebhookConfig: { __typename?: 'AutomationWebhookConfig', webhookUrl?: string | null } };

export type TestAutomationWebhookMutationVariables = Exact<{
  input: TestAutomationWebhookInput;
}>;


export type TestAutomationWebhookMutation = { __typename?: 'Mutation', testAutomationWebhook: { __typename?: 'TestAutomationWebhookResult', success: boolean, statusCode?: number | null, message?: string | null } };

export type BrandingBrandSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BrandingBrandSettingsQuery = { __typename?: 'Query', brandingBrandSettings?: { __typename?: 'BrandingBrandSettings', id: string, primaryColor?: string | null, secondaryColor?: string | null, verifiedEmailSender?: { __typename?: 'BrandingVerifiedEmailSender', id: string, status: BrandingVerifiedEmailSenderStatus, fromEmail: string, fromName: string } | null } | null };

export type BrandingCreateVerifiedEmailSenderMutationVariables = Exact<{
  input: BrandingCreateVerifiedEmailSenderInput;
}>;


export type BrandingCreateVerifiedEmailSenderMutation = { __typename?: 'Mutation', brandingCreateVerifiedEmailSender: { __typename?: 'BrandingCreateVerifiedEmailSenderResponse', success: boolean, verificationId?: string | null, verificationStatus?: string | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type BrandingDeleteVerifiedEmailSenderMutationVariables = Exact<{ [key: string]: never; }>;


export type BrandingDeleteVerifiedEmailSenderMutation = { __typename?: 'Mutation', brandingDeleteVerifiedEmailSender: { __typename?: 'BrandingDeleteVerifiedEmailSenderResponse', success: boolean, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type BrandingVerifyEmailSenderMutationVariables = Exact<{ [key: string]: never; }>;


export type BrandingVerifyEmailSenderMutation = { __typename?: 'Mutation', brandingVerifyEmailSender: { __typename?: 'BrandingVerifyEmailSenderResponse', success: boolean, verificationStatus?: string | null, verified?: boolean | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type NylasCalendarDataFragment = { __typename?: 'NylasCalendar', id: string, name: string, email: string, description?: string | null, hexColor?: string | null, isPrimary: boolean, readOnly: boolean, timezone?: string | null };

export type NylasRoomResourceDataFragment = { __typename?: 'NylasRoomResource', id: string, name: string, email: string, calendarId: string, building?: string | null, capacity?: number | null, floorName?: string | null, floorNumber?: number | null, floorSection?: string | null, hexColor?: string | null };

export type NylasCalendarEventDataFragment = { __typename?: 'NylasCalendarEvent', id: string, calendarId: string, busy: boolean, readOnly?: boolean | null, title?: string | null, description?: string | null, location?: string | null, htmlLink?: string | null, status?: string | null, recurrence?: string | null, visibility?: string | null, when:
    | { __typename?: 'CommonWhenDate', type: CommonWhenType, date: string }
    | { __typename?: 'CommonWhenDatespan', type: CommonWhenType, startDate: string, endDate: string }
    | { __typename?: 'CommonWhenTime', type: CommonWhenType, time: string, timezone: string }
    | { __typename?: 'CommonWhenTimespan', type: CommonWhenType, startTime: string, endTime: string, startTimezone: string, endTimezone: string }
  , organizer?: { __typename?: 'NylasParticipant', email: string, name?: string | null } | null, participants?: Array<{ __typename?: 'NylasParticipant', email: string, name?: string | null, status?: string | null, phoneNumber?: string | null, comment?: string | null }> | null, resources?: Array<{ __typename?: 'NylasEventResource', email: string, name: string }> | null };

export type NylasAuthUrlQueryVariables = Exact<{
  provider: CalendarProvider;
}>;


export type NylasAuthUrlQuery = { __typename?: 'Query', nylasAuthUrl: string };

export type NylasSupportedProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type NylasSupportedProvidersQuery = { __typename?: 'Query', nylasSupportedProviders: Array<CalendarProvider> };

export type NylasPrimaryCalendarQueryVariables = Exact<{ [key: string]: never; }>;


export type NylasPrimaryCalendarQuery = { __typename?: 'Query', nylasPrimaryCalendar: { __typename?: 'NylasCalendar', id: string, name: string, email: string, description?: string | null, hexColor?: string | null, isPrimary: boolean, readOnly: boolean, timezone?: string | null } };

export type NylasCalendarsQueryVariables = Exact<{ [key: string]: never; }>;


export type NylasCalendarsQuery = { __typename?: 'Query', nylasCalendars: Array<{ __typename?: 'NylasCalendar', id: string, name: string, email: string, description?: string | null, hexColor?: string | null, isPrimary: boolean, readOnly: boolean, timezone?: string | null }> };

export type NylasRoomResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type NylasRoomResourcesQuery = { __typename?: 'Query', nylasRoomResources: Array<{ __typename?: 'NylasRoomResource', id: string, name: string, email: string, calendarId: string, building?: string | null, capacity?: number | null, floorName?: string | null, floorNumber?: number | null, floorSection?: string | null, hexColor?: string | null }> };

export type NylasCalendarEventsQueryVariables = Exact<{
  input: NylasCalendarEventsInput;
}>;


export type NylasCalendarEventsQuery = { __typename?: 'Query', nylasCalendarEvents: Array<{ __typename?: 'NylasCalendarEvent', id: string, calendarId: string, busy: boolean, readOnly?: boolean | null, title?: string | null, description?: string | null, location?: string | null, htmlLink?: string | null, status?: string | null, recurrence?: string | null, visibility?: string | null, when:
      | { __typename?: 'CommonWhenDate', type: CommonWhenType, date: string }
      | { __typename?: 'CommonWhenDatespan', type: CommonWhenType, startDate: string, endDate: string }
      | { __typename?: 'CommonWhenTime', type: CommonWhenType, time: string, timezone: string }
      | { __typename?: 'CommonWhenTimespan', type: CommonWhenType, startTime: string, endTime: string, startTimezone: string, endTimezone: string }
    , organizer?: { __typename?: 'NylasParticipant', email: string, name?: string | null } | null, participants?: Array<{ __typename?: 'NylasParticipant', email: string, name?: string | null, status?: string | null, phoneNumber?: string | null, comment?: string | null }> | null, resources?: Array<{ __typename?: 'NylasEventResource', email: string, name: string }> | null }> };

export type AddNylasIntegrationMutationVariables = Exact<{
  code: Scalars['String']['input'];
  provider: CalendarProvider;
}>;


export type AddNylasIntegrationMutation = { __typename?: 'Mutation', addNylasIntegration: boolean };

export type RevokeNylasIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeNylasIntegrationMutation = { __typename?: 'Mutation', revokeNylasIntegration: boolean };

export type UpdateNylasCalendarMutationVariables = Exact<{
  input: UpdateNylasCalendarInput;
}>;


export type UpdateNylasCalendarMutation = { __typename?: 'Mutation', updateNylasCalendar: { __typename?: 'NylasCalendar', id: string, name: string, email: string, description?: string | null, hexColor?: string | null, isPrimary: boolean, readOnly: boolean, timezone?: string | null } };

export type DeleteNylasCalendarEventMutationVariables = Exact<{
  input: DeleteNylasCalendarEventInput;
}>;


export type DeleteNylasCalendarEventMutation = { __typename?: 'Mutation', deleteNylasCalendarEvent: boolean };

export type CreateNylasCalendarEventMutationVariables = Exact<{
  input: CreateNylasCalendarEventInput;
}>;


export type CreateNylasCalendarEventMutation = { __typename?: 'Mutation', createNylasCalendarEvent: { __typename?: 'CreateNylasCalendarEventResponse', success: boolean, error?: string | null, errors?: any | null, event?: { __typename?: 'NylasCalendarEvent', id: string, calendarId: string, busy: boolean, readOnly?: boolean | null, title?: string | null, description?: string | null, location?: string | null, htmlLink?: string | null, status?: string | null, recurrence?: string | null, visibility?: string | null, when:
        | { __typename?: 'CommonWhenDate', type: CommonWhenType, date: string }
        | { __typename?: 'CommonWhenDatespan', type: CommonWhenType, startDate: string, endDate: string }
        | { __typename?: 'CommonWhenTime', type: CommonWhenType, time: string, timezone: string }
        | { __typename?: 'CommonWhenTimespan', type: CommonWhenType, startTime: string, endTime: string, startTimezone: string, endTimezone: string }
      , organizer?: { __typename?: 'NylasParticipant', email: string, name?: string | null } | null, participants?: Array<{ __typename?: 'NylasParticipant', email: string, name?: string | null, status?: string | null, phoneNumber?: string | null, comment?: string | null }> | null, resources?: Array<{ __typename?: 'NylasEventResource', email: string, name: string }> | null } | null } };

export type UpdateNylasCalendarEventMutationVariables = Exact<{
  input: UpdateNylasCalendarEventInput;
}>;


export type UpdateNylasCalendarEventMutation = { __typename?: 'Mutation', updateNylasCalendarEvent: { __typename?: 'UpdateNylasCalendarEventResponse', success: boolean, error?: string | null, errors?: any | null, event?: { __typename?: 'NylasCalendarEvent', id: string, calendarId: string, busy: boolean, readOnly?: boolean | null, title?: string | null, description?: string | null, location?: string | null, htmlLink?: string | null, status?: string | null, recurrence?: string | null, visibility?: string | null, when:
        | { __typename?: 'CommonWhenDate', type: CommonWhenType, date: string }
        | { __typename?: 'CommonWhenDatespan', type: CommonWhenType, startDate: string, endDate: string }
        | { __typename?: 'CommonWhenTime', type: CommonWhenType, time: string, timezone: string }
        | { __typename?: 'CommonWhenTimespan', type: CommonWhenType, startTime: string, endTime: string, startTimezone: string, endTimezone: string }
      , organizer?: { __typename?: 'NylasParticipant', email: string, name?: string | null } | null, participants?: Array<{ __typename?: 'NylasParticipant', email: string, name?: string | null, status?: string | null, phoneNumber?: string | null, comment?: string | null }> | null, resources?: Array<{ __typename?: 'NylasEventResource', email: string, name: string }> | null } | null } };

export type CreateClientSessionFromEventMutationVariables = Exact<{
  input: CreateClientSessionFromEventInput;
}>;


export type CreateClientSessionFromEventMutation = { __typename?: 'Mutation', createClientSessionFromEvent: { __typename?: 'CreateClientSessionFromEventResponse', success: boolean, error?: string | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null, clientSession?:
      | { __typename?: 'ClientSessionGroup', id: string }
      | { __typename?: 'ClientSessionIndividual', id: string }
     | null } };

export type SearchCalendarParticipantsQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCalendarParticipantsQuery = { __typename?: 'Query', patientsV2: Array<{ __typename?: 'Patient', name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type ClientFileDataFragment = { __typename?: 'ClientFile', id: string, name: string, createdAt: any, externalCompleterName?: string | null, media: { __typename?: 'Media', id: string, url: string, fileName: string, isPdf?: boolean | null, isDocument?: boolean | null } };

export type ClientFilesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientFilesQuery = { __typename?: 'Query', clientFiles: Array<{ __typename?: 'ClientFile', id: string, name: string, createdAt: any, externalCompleterName?: string | null, media: { __typename?: 'Media', id: string, url: string, fileName: string, isPdf?: boolean | null, isDocument?: boolean | null } }> };

export type ClientFilesForProgramQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ClientFilesForProgramQuery = { __typename?: 'Query', clientFilesForProgram: Array<{ __typename?: 'ClientFile', id: string, name: string, createdAt: any, externalCompleterName?: string | null, media: { __typename?: 'Media', id: string, url: string, fileName: string, isPdf?: boolean | null, isDocument?: boolean | null } }> };

export type ExternalPartyFilesForProgramQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ExternalPartyFilesForProgramQuery = { __typename?: 'Query', externalPartyFilesForProgram: Array<{ __typename?: 'ClientFile', id: string, name: string, createdAt: any, externalCompleterName?: string | null, media: { __typename?: 'Media', id: string, url: string, fileName: string, isPdf?: boolean | null, isDocument?: boolean | null } }> };

export type UploadClientFileMutationVariables = Exact<{
  input: ClientFilesUploadFileInput;
}>;


export type UploadClientFileMutation = { __typename?: 'Mutation', clientFilesUploadFile: { __typename?: 'ClientFile', id: string, name: string, createdAt: any, externalCompleterName?: string | null, media: { __typename?: 'Media', id: string, url: string, fileName: string, isPdf?: boolean | null, isDocument?: boolean | null } } };

export type DeleteClientFileMutationVariables = Exact<{
  clientFileId: Scalars['String']['input'];
}>;


export type DeleteClientFileMutation = { __typename?: 'Mutation', clientFilesDeleteFile: { __typename?: 'ClientFilesDeleteFileResponse', success: boolean } };

type ClientSessionBaseFields_ClientSessionGroup_Fragment = { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

type ClientSessionBaseFields_ClientSessionIndividual_Fragment = { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

export type ClientSessionBaseFieldsFragment =
  | ClientSessionBaseFields_ClientSessionGroup_Fragment
  | ClientSessionBaseFields_ClientSessionIndividual_Fragment
;

export type ClientSessionIndividualFieldsFragment = { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

export type ClientSessionGroupFieldsFragment = { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

type ClientSessionFields_ClientSessionGroup_Fragment = { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

type ClientSessionFields_ClientSessionIndividual_Fragment = { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } };

export type ClientSessionFieldsFragment =
  | ClientSessionFields_ClientSessionGroup_Fragment
  | ClientSessionFields_ClientSessionIndividual_Fragment
;

export type DismissClientSessionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DismissClientSessionsMutation = { __typename?: 'Mutation', dismissClientSessions: { __typename?: 'DismissClientSessionsResponse', success: boolean, errors: Array<{ __typename?: 'DismissClientSessionError', sessionId: string, message: string }>, summary: { __typename?: 'CommonBatchOperationSummary', requestedCount: number, processedCount: number, skippedCount: number, errorCount: number } } };

export type RestoreClientSessionsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreClientSessionsMutation = { __typename?: 'Mutation', restoreClientSessions: { __typename?: 'RestoreClientSessionsResponse', success: boolean, errors: Array<{ __typename?: 'RestoreClientSessionError', sessionId: string, message: string }>, summary: { __typename?: 'CommonBatchOperationSummary', requestedCount: number, processedCount: number, skippedCount: number, errorCount: number } } };

export type GetClientSessionsQueryVariables = Exact<{
  input?: InputMaybe<ClientSessionListInput>;
}>;


export type GetClientSessionsQuery = { __typename?: 'Query', clientSessions: { __typename?: 'ClientSessionConnection', totalCount: number, edges: Array<
      | { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
      | { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
    >, pageInfo: { __typename?: 'CommonPageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } };

export type GetClientSessionsCountQueryVariables = Exact<{
  input?: InputMaybe<ClientSessionFilterInput>;
}>;


export type GetClientSessionsCountQuery = { __typename?: 'Query', clientSessionsCount: number };

export type GetClientSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientSessionQuery = { __typename?: 'Query', clientSession?:
    | { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
    | { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
   | null };

export type FindClientSessionFormByTypeQueryVariables = Exact<{
  clientSessionId: Scalars['ID']['input'];
  formType: ClientSessionFormType;
}>;


export type FindClientSessionFormByTypeQuery = { __typename?: 'Query', findClientSessionFormByType?: { __typename?: 'ClientSessionForm', id: string, clientSessionId: string, formType: ClientSessionFormType, data: any, createdAt: any, updatedAt: any } | null };

export type SubmitClientSessionFormMutationVariables = Exact<{
  input: ClientSessionFormSubmitInput;
}>;


export type SubmitClientSessionFormMutation = { __typename?: 'Mutation', submitClientSessionForm: { __typename?: 'ClientSessionFormSubmitResponse', success: boolean, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null, form?: { __typename?: 'ClientSessionForm', id: string, formType: ClientSessionFormType, data: any, createdAt: any, updatedAt: any } | null } };

export type UpdateClientSessionFormMutationVariables = Exact<{
  input: ClientSessionFormUpdateInput;
}>;


export type UpdateClientSessionFormMutation = { __typename?: 'Mutation', updateClientSessionForm: { __typename?: 'ClientSessionFormSubmitResponse', success: boolean, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null, form?: { __typename?: 'ClientSessionForm', id: string, formType: ClientSessionFormType, data: any, createdAt: any, updatedAt: any } | null } };

export type UpdateClientSessionMutationVariables = Exact<{
  input: UpdateClientSessionInput;
}>;


export type UpdateClientSessionMutation = { __typename?: 'Mutation', updateClientSession: { __typename?: 'UpdateClientSessionResponse', success: boolean, clientSession?:
      | { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
      | { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
     | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type CreateManualClientSessionMutationVariables = Exact<{
  input: CreateManualClientSessionInput;
}>;


export type CreateManualClientSessionMutation = { __typename?: 'Mutation', createManualClientSession: { __typename?: 'CreateManualClientSessionResponse', success: boolean, error?: string | null, clientSession?:
      | { __typename?: 'ClientSessionGroup', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participants: Array<{ __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
      | { __typename?: 'ClientSessionIndividual', id: string, title: string, description?: string | null, startTime: any, endTime: any, reviewStatus: ClientSessionReviewStatus, source: ClientSessionSource, createdAt: any, updatedAt: any, participant: { __typename?: 'ClientSessionParticipant', id: string, email?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }, practitioners: Array<{ __typename?: 'ClientSessionPractitioner', id: string, name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, provider: { __typename?: 'Provider', id: string, name: string }, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, email: string, name?: string | null } }
     | null, errors?: Array<{ __typename?: 'CommonFormValidationError', field: string, message: string }> | null } };

export type GetProviderCalendarSessionSyncSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderCalendarSessionSyncSettingsQuery = { __typename?: 'Query', providerCalendarSessionSyncSettings?: { __typename?: 'ClientCalendarSessionSyncSettings', id: string, providerId: string, enableCalendarSyncForSessions: boolean, includeArchivedPatients: boolean, syncCalendarSessionsForCollaborators: boolean, includeDeactivatedStaff: boolean } | null };

export type UpdateProviderCalendarSessionSyncSettingsMutationVariables = Exact<{
  input: UpdateProviderCalendarSessionSyncSettingsInput;
}>;


export type UpdateProviderCalendarSessionSyncSettingsMutation = { __typename?: 'Mutation', updateProviderCalendarSessionSyncSettings: { __typename?: 'UpdateProviderCalendarSessionSyncSettingsResponse', success: boolean, error?: string | null, settings?: { __typename?: 'ClientCalendarSessionSyncSettings', id: string, providerId: string, enableCalendarSyncForSessions: boolean, includeArchivedPatients: boolean, syncCalendarSessionsForCollaborators: boolean, includeDeactivatedStaff: boolean } | null } };

export type ProviderCollectionDataFragment = { __typename?: 'ProviderCollection', id: string, name: string, createdAt: any, updatedAt: any };

export type ProviderCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderCollectionsQuery = { __typename?: 'Query', providerCollections: Array<{ __typename?: 'ProviderCollection', id: string, name: string, createdAt: any, updatedAt: any }> };

export type CreateProviderCollectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateProviderCollectionMutation = { __typename?: 'Mutation', createProviderCollection: { __typename?: 'ProviderCollection', id: string, name: string, createdAt: any, updatedAt: any } };

export type UpdateProviderCollectionMutationVariables = Exact<{
  input: UpdateProviderCollectionInput;
}>;


export type UpdateProviderCollectionMutation = { __typename?: 'Mutation', updateProviderCollection: { __typename?: 'ProviderCollection', id: string, name: string, createdAt: any, updatedAt: any } };

export type DeleteProviderCollectionMutationVariables = Exact<{
  providerCollectionId: Scalars['String']['input'];
}>;


export type DeleteProviderCollectionMutation = { __typename?: 'Mutation', deleteProviderCollection: boolean };

export type AddActivityToProviderCollectionMutationVariables = Exact<{
  input: ProviderCollectionActivityInput;
}>;


export type AddActivityToProviderCollectionMutation = { __typename?: 'Mutation', addActivityToProviderCollection:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   };

export type RemoveActivityFromProviderCollectionMutationVariables = Exact<{
  input: ProviderCollectionActivityInput;
}>;


export type RemoveActivityFromProviderCollectionMutation = { __typename?: 'Mutation', removeActivityFromProviderCollection:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   };

export type CopyCollectionToLibraryMutationVariables = Exact<{
  input: CopyCollectionToLibraryInput;
}>;


export type CopyCollectionToLibraryMutation = { __typename?: 'Mutation', copyCollectionToLibrary: { __typename?: 'ProviderCollection', id: string } };

export type CuratedProviderCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CuratedProviderCollectionsQuery = { __typename?: 'Query', curatedProviderCollections: Array<{ __typename?: 'CuratedProviderCollection', id: string, description: string, curatorName: string, createdAt: any, updatedAt: any, headerMedia: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any }, curatorAvatarMedia: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any }, providerCollection: { __typename?: 'ProviderCollection', id: string, name: string, createdAt: any, updatedAt: any, activities?: Array<
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
      > | null } }> };

export type CommentDataFragment = { __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null };

export type ProgramCommentsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['Datetime']['input']>;
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProgramCommentsQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', unreadCommentCount: number, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }> } };

export type AddCommentMutationVariables = Exact<{
  input: CommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null } };

export type DeleteCommentMutationVariables = Exact<{
  commentId: Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type MarkCommentsReadMutationVariables = Exact<{
  input: MarkCommentsReadInput;
}>;


export type MarkCommentsReadMutation = { __typename?: 'Mutation', markCommentsRead: boolean };

export type MePatientCommentsQueryVariables = Exact<{
  before?: InputMaybe<Scalars['Datetime']['input']>;
  chunkSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MePatientCommentsQuery = { __typename?: 'Query', mePatient?: { __typename?: 'Patient', programInstanceId: string, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }> } | null };

export type ProviderUserMembershipFieldsFragment = { __typename?: 'ProviderUserMembership', id: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, isExternalCollaborator: boolean, isPrimaryProvider: boolean, status: MembershipStatus, accessExpiresAt?: any | null, invitedAt?: any | null, invitationExpiresAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, createdAt: any, updatedAt: any, provider: { __typename?: 'Provider', id: string, name: string }, providerUser: { __typename?: 'ProviderUserMember', id: string, email: string }, invitedBy?: { __typename?: 'ProviderUserMember', id: string, email: string } | null };

export type ProviderFieldsFragment = { __typename?: 'Provider', id: string, name: string, squareLogoMedia?: { __typename?: 'Media', url: string } | null };

export type GetMyMembershipsQueryVariables = Exact<{
  input: MyMembershipsInput;
}>;


export type GetMyMembershipsQuery = { __typename?: 'Query', myMemberships: Array<{ __typename?: 'ProviderUserMembership', id: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, isExternalCollaborator: boolean, isPrimaryProvider: boolean, status: MembershipStatus, accessExpiresAt?: any | null, invitedAt?: any | null, invitationExpiresAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, createdAt: any, updatedAt: any, provider: { __typename?: 'Provider', id: string, name: string }, providerUser: { __typename?: 'ProviderUserMember', id: string, email: string }, invitedBy?: { __typename?: 'ProviderUserMember', id: string, email: string } | null }> };

export type GetProviderMembershipsQueryVariables = Exact<{
  input: ProviderMembershipsInput;
}>;


export type GetProviderMembershipsQuery = { __typename?: 'Query', providerMemberships: Array<{ __typename?: 'ProviderUserMembership', id: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, isExternalCollaborator: boolean, isPrimaryProvider: boolean, status: MembershipStatus, accessExpiresAt?: any | null, invitedAt?: any | null, invitationExpiresAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, createdAt: any, updatedAt: any, provider: { __typename?: 'Provider', id: string, name: string }, providerUser: { __typename?: 'ProviderUserMember', id: string, email: string }, invitedBy?: { __typename?: 'ProviderUserMember', id: string, email: string } | null }> };

export type GetAvailableProviderContextsQueryVariables = Exact<{
  input?: InputMaybe<AvailableProviderContextsInput>;
}>;


export type GetAvailableProviderContextsQuery = { __typename?: 'Query', availableProviderContexts: Array<{ __typename?: 'Provider', id: string, name: string, squareLogoMedia?: { __typename?: 'Media', url: string } | null }> };

export type GetActiveProviderContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveProviderContextQuery = { __typename?: 'Query', activeProviderContext?: { __typename?: 'Provider', id: string, name: string, squareLogoMedia?: { __typename?: 'Media', url: string } | null } | null };

export type MyPendingInvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPendingInvitationsQuery = { __typename?: 'Query', myMemberships: Array<{ __typename?: 'ProviderUserMembership', id: string, role: ProviderUserRole, invitedAt?: any | null, invitationExpiresAt?: any | null, provider: { __typename?: 'Provider', id: string, name: string, squareLogoMedia?: { __typename?: 'Media', url: string } | null } }> };

export type InviteExternalCollaboratorMutationVariables = Exact<{
  input: InviteExternalCollaboratorInput;
}>;


export type InviteExternalCollaboratorMutation = { __typename?: 'Mutation', inviteExternalCollaborator: { __typename?: 'InviteExternalCollaboratorResponse', success: boolean, message: string, membership?: { __typename?: 'ProviderUserMembership', id: string, status: MembershipStatus } | null } };

export type SwitchProviderContextMutationVariables = Exact<{
  input: SwitchProviderContextInput;
}>;


export type SwitchProviderContextMutation = { __typename?: 'Mutation', switchProviderContext: { __typename?: 'SwitchProviderContextResponse', success: boolean, message: string, provider?: { __typename?: 'Provider', id: string, name: string, squareLogoMedia?: { __typename?: 'Media', url: string } | null } | null } };

export type AcceptInvitationMutationVariables = Exact<{
  input: AcceptCollaboratorInvitationInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptCollaboratorInvitation: { __typename?: 'AcceptCollaboratorInvitationResponse', success: boolean, message: string, membership?: { __typename?: 'ProviderUserMembership', id: string, status: MembershipStatus } | null } };

export type DeclineCollaboratorInvitationMutationVariables = Exact<{
  input: DeclineCollaboratorInvitationInput;
}>;


export type DeclineCollaboratorInvitationMutation = { __typename?: 'Mutation', declineCollaboratorInvitation: { __typename?: 'DeclineCollaboratorInvitationResponse', success: boolean, message: string, membership?: { __typename?: 'ProviderUserMembership', id: string, status: MembershipStatus, provider: { __typename?: 'Provider', id: string, name: string } } | null } };

export type EnabledFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledFeaturesQuery = { __typename?: 'Query', enabledFeatures: Array<Feature> };

export type BasicFollowUpDataFragment = { __typename?: 'ProgramFollowUp', id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean };

export type PatientCardFollowUpDataFragment = { __typename?: 'ProgramFollowUp', commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number } | null, programActivities: Array<{ __typename?: 'ProgramActivity', id: string }> };

export type VoiceNoteDataFragment = { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } };

export type FollowUpDataFragment = { __typename?: 'ProgramFollowUp', sentByName: string, sentByEmail: string, sentByProfileImageUrl?: string | null, commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }>, programActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> };

export type ProgramFollowUpsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProgramFollowUpsQuery = { __typename?: 'Query', programFollowUps: Array<{ __typename?: 'ProgramFollowUp', id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean }> };

export type PatientProgramFollowUpsQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type PatientProgramFollowUpsQuery = { __typename?: 'Query', programFollowUps: Array<{ __typename?: 'ProgramFollowUp', commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number } | null, programActivities: Array<{ __typename?: 'ProgramActivity', id: string }> }> };

export type ProgramFollowUpQueryVariables = Exact<{
  programFollowUpId: Scalars['String']['input'];
}>;


export type ProgramFollowUpQuery = { __typename?: 'Query', programFollowUp: { __typename?: 'ProgramFollowUp', sentByName: string, sentByEmail: string, sentByProfileImageUrl?: string | null, commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }>, programActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> } };

export type PatientNamesForRecipientsQueryVariables = Exact<{
  programIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  programTagIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type PatientNamesForRecipientsQuery = { __typename?: 'Query', patientNamesForRecipients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type AddVoiceNoteMutationVariables = Exact<{
  input: VoiceNoteInput;
}>;


export type AddVoiceNoteMutation = { __typename?: 'Mutation', addVoiceNote: { __typename?: 'VoiceNote', id: string } };

export type SendFollowUpToManyMutationVariables = Exact<{
  input: SendFollowUpToManyInput;
}>;


export type SendFollowUpToManyMutation = { __typename?: 'Mutation', sendFollowUpToMany: Array<{ __typename?: 'ProgramFollowUp', sentByName: string, sentByEmail: string, sentByProfileImageUrl?: string | null, commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }>, programActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> } | null> };

export type SendFollowUpEmailMutationVariables = Exact<{
  programFollowUpId: Scalars['String']['input'];
}>;


export type SendFollowUpEmailMutation = { __typename?: 'Mutation', sendFollowUpEmail: boolean };

export type EditSentMailMessageMutationVariables = Exact<{
  input: EditSentMailMessageInput;
}>;


export type EditSentMailMessageMutation = { __typename?: 'Mutation', editSentMailMessage: { __typename?: 'ProgramFollowUp', sentByName: string, sentByEmail: string, sentByProfileImageUrl?: string | null, commentCount: number, id: string, programId: string, isDraft: boolean, subject?: string | null, providerNote?: string | null, createdAt: any, unreadCommentCount: number, isIntake: boolean, isEdited: boolean, messageEditedAt?: any | null, canEditMessage: boolean, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, comments: Array<{ __typename?: 'Comment', id: string, authorUserType: UserType, authorPatientId?: string | null, authorProviderUserId?: string | null, sentByName: string, sentByProfileImageUrl?: string | null, createdAt: any, text?: string | null, voiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, imageMedia?: { __typename?: 'Media', url: string } | null }>, programActivities: Array<{ __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null }> } };

export type FollowUpTemplatePickerItemFragment = { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, providerVoiceNote?: { __typename?: 'VoiceNote', duration: number } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType }> };

export type FollowUpTemplatesForPickerQueryVariables = Exact<{
  input: FollowUpTemplatesInput;
}>;


export type FollowUpTemplatesForPickerQuery = { __typename?: 'Query', followUpTemplates: Array<{ __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, providerVoiceNote?: { __typename?: 'VoiceNote', duration: number } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType }> }> };

export type FollowUpTemplateDataFragment = { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
      | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
      | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
            | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
            | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
            | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
            | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
            | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
            | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
            | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
            | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
            | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
            | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
            | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
          > } }
      | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
      | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
      | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
      | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
      | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
     | null }> };

export type ActivityTemplateDataFragment = { __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
    | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
    | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
          | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
          | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
          | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
          | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
          | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
          | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
          | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
          | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
          | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
        > } }
    | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
    | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
    | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
   | null };

export type FollowUpTemplatesQueryVariables = Exact<{
  input: FollowUpTemplatesInput;
}>;


export type FollowUpTemplatesQuery = { __typename?: 'Query', followUpTemplates: Array<{ __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
       | null }> }> };

export type FollowUpTemplateQueryVariables = Exact<{
  followUpTemplateId: Scalars['String']['input'];
}>;


export type FollowUpTemplateQuery = { __typename?: 'Query', followUpTemplate: { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
       | null }> } };

export type SaveFollowUpTemplateMutationVariables = Exact<{
  input: SaveFollowUpTemplateInput;
}>;


export type SaveFollowUpTemplateMutation = { __typename?: 'Mutation', saveFollowUpTemplate: { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
       | null }> } };

export type RenameFollowUpTemplateMutationVariables = Exact<{
  input: RenameFollowUpTemplateInput;
}>;


export type RenameFollowUpTemplateMutation = { __typename?: 'Mutation', renameFollowUpTemplate: { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
       | null }> } };

export type DuplicateFollowUpTemplateMutationVariables = Exact<{
  input: DuplicateFollowUpTemplateInput;
}>;


export type DuplicateFollowUpTemplateMutation = { __typename?: 'Mutation', duplicateFollowUpTemplate: { __typename?: 'FollowUpTemplate', id: string, name?: string | null, subject: string, isDraft: boolean, providerNote: string, createdAt: any, updatedAt: any, patients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }>, programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }>, providerVoiceNote?: { __typename?: 'VoiceNote', id: string, duration: number, media: { __typename?: 'Media', url: string } } | null, activityTemplates: Array<{ __typename?: 'ActivityTemplate', activityType: ActivityType, name: string, providerNote: string, activity?:
        | { __typename?: 'ActivityAction', id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
        | { __typename?: 'ActivityAssessment', id: string, activityType: ActivityType, providerCollectionIds: Array<string>, assessment: { __typename?: 'Assessment', id: string, createdAt: any, schemaType: AssessmentSchemaType, description: string, type: AssessmentType, shortName: string, name: string, category: AssessmentCategory, oneTimeAssessment?: boolean | null, moreInfoLink?: string | null, providerInterpretation?: string | null, questionFrame?: string | null, instructions?: string | null, estimatedLengthInMinutes?: number | null, completableByProviderOnly: boolean, scoreRange?: { __typename?: 'ScoreRange', min: number, max: number } | null, scoreRanges?: Array<{ __typename?: 'AssessmentScoreRange', min: number, max: number, categorization: string, color: string }> | null, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, questions: Array<
              | { __typename?: 'AutofillAssessmentQuestion', isRequired?: boolean | null, question: string, autofillSource: AutofillSource, autofillValue?: string | null, questionType: AssessmentQuestionType }
              | { __typename?: 'ConditionalMultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, followUpWhen: Array<string>, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }>, followUp: { __typename?: 'ConditionalMultipleChoiceFollowUp', question: string, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> } }
              | { __typename?: 'DatePickerAssessmentQuestion', isRequired?: boolean | null, question: string, defaultToToday?: boolean | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FileUploadAssessmentQuestion', isRequired?: boolean | null, question: string, allowedExtensions?: Array<string> | null, questionType: AssessmentQuestionType }
              | { __typename?: 'FreeTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'InitialsAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'MultiSelectAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultiSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, assessmentSignatureOrderIndices: Array<number | null>, questionType: AssessmentQuestionType, assessmentSignatureUsers?: Array<{ __typename?: 'AssessmentSignatureUser', id: string, signatureUserType: SignatureUser, orderIndex: number }> | null, existingSignatures?: Array<{ __typename?: 'SignatureDetail', signatureName: string, signedAt: string, signingIpAddress: string, signatureRole?: string | null }> | null }
              | { __typename?: 'MultipleChoiceAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceAssessmentQuestionAnswerOption', answerOption: string }> }
              | { __typename?: 'MultipleChoiceScoredAssessmentQuestion', isRequired?: boolean | null, question: string, subscale?: string | null, questionType: AssessmentQuestionType, answerOptions: Array<{ __typename?: 'MultipleChoiceScoredAssessmentQuestionAnswerOption', answerOption: string, score?: number | null }> }
              | { __typename?: 'PatientContactAssessmentQuestion', isRequired?: boolean | null, question: string, contactType: ContactType, questionType: AssessmentQuestionType }
              | { __typename?: 'ProviderSignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'RichTextAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'SignatureAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'StatementAssessmentQuestion', isRequired?: boolean | null, question: string, questionType: AssessmentQuestionType }
              | { __typename?: 'UnsupportedAssessmentQuestion', questionType: AssessmentQuestionType }
            > } }
        | { __typename?: 'ActivityAudio', createdAt: any, title: string, duration?: number | null, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityImage', createdAt: any, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityLink', createdAt: any, url: string, title: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null }
        | { __typename?: 'ActivityPDF', createdAt: any, title: string, completionType: ActivityFileCompletionType, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string>, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } }
        | { __typename?: 'ActivityText', createdAt: any, title: string, text: string, activityUseType: ActivityUseType, id: string, activityType: ActivityType, providerCollectionIds: Array<string> }
       | null }> } };

export type DeleteFollowUpTemplateMutationVariables = Exact<{
  input: DeleteFollowUpTemplateInput;
}>;


export type DeleteFollowUpTemplateMutation = { __typename?: 'Mutation', deleteFollowUpTemplate: boolean };

export type AddCalendlyIntegrationMutationVariables = Exact<{
  authorizationCode: Scalars['String']['input'];
}>;


export type AddCalendlyIntegrationMutation = { __typename?: 'Mutation', addCalendlyIntegration: { __typename?: 'CalendlyIntegration', id: string } };

export type RemoveCalendlyIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveCalendlyIntegrationMutation = { __typename?: 'Mutation', removeCalendlyIntegration: { __typename?: 'CalendlyIntegration', id: string } };

export type AddStripeIntegrationMutationVariables = Exact<{
  authorizationCode: Scalars['String']['input'];
}>;


export type AddStripeIntegrationMutation = { __typename?: 'Mutation', addStripeIntegration: boolean };

export type RemoveStripeIntegrationMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveStripeIntegrationMutation = { __typename?: 'Mutation', removeStripeIntegration: boolean };

export type ProgramInvoiceDataFragment = { __typename?: 'ProgramInvoice', id: string, createdAt: any, dueAt: any, status: ProgramInvoiceStatus, amount: number, currency: string, stripeInvoiceId: string, stripeInvoiceUrl: string, stripeInvoicePdfUrl: string, stripeInvoiceNumber: string, archivedAt?: any | null, createdByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, patient?: { __typename?: 'Patient', name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null };

export type ProgramInvoicesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProgramInvoicesQuery = { __typename?: 'Query', programInvoices: Array<{ __typename?: 'ProgramInvoice', id: string, createdAt: any, dueAt: any, status: ProgramInvoiceStatus, amount: number, currency: string, stripeInvoiceId: string, stripeInvoiceUrl: string, stripeInvoicePdfUrl: string, stripeInvoiceNumber: string, archivedAt?: any | null, createdByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, patient?: { __typename?: 'Patient', name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type ProgramInvoicesForProgramQueryVariables = Exact<{
  programId?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProgramInvoicesForProgramQuery = { __typename?: 'Query', programInvoices: Array<{ __typename?: 'ProgramInvoice', id: string, createdAt: any, dueAt: any, status: ProgramInvoiceStatus, amount: number, currency: string, stripeInvoiceId: string, stripeInvoiceUrl: string, stripeInvoicePdfUrl: string, stripeInvoiceNumber: string, archivedAt?: any | null, createdByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null, patient?: { __typename?: 'Patient', name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type SearchStripeProductsQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchStripeProductsQuery = { __typename?: 'Query', searchStripeProducts: Array<{ __typename?: 'StripeProduct', name: string, price: number, stripePriceId: string }> };

export type ProgramHasDefaultPaymentMethodQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProgramHasDefaultPaymentMethodQuery = { __typename?: 'Query', programHasDefaultPaymentMethod: boolean };

export type ProviderStripeCardProcessingFeeScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderStripeCardProcessingFeeScheduleQuery = { __typename?: 'Query', providerStripeCardProcessingFeeSchedule?: { __typename?: 'StripeCardProcessingFeeSchedule', country: string, currency: string, percentFee: number, fixedFee: number, label: string } | null };

export type SendInvoiceMutationVariables = Exact<{
  input: SendInvoiceInput;
}>;


export type SendInvoiceMutation = { __typename?: 'Mutation', sendInvoice: { __typename?: 'ProgramInvoice', id: string } };

export type SendInvoiceReminderMutationVariables = Exact<{
  programInvoiceId: Scalars['String']['input'];
}>;


export type SendInvoiceReminderMutation = { __typename?: 'Mutation', sendInvoiceReminder: boolean };

export type VoidInvoiceMutationVariables = Exact<{
  programInvoiceId: Scalars['String']['input'];
}>;


export type VoidInvoiceMutation = { __typename?: 'Mutation', voidInvoice: boolean };

export type RecordInvoiceDownloadMutationVariables = Exact<{
  programInvoiceId: Scalars['String']['input'];
  sourcePage?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordInvoiceDownloadMutation = { __typename?: 'Mutation', recordInvoiceDownload: boolean };

export type RecordInvoiceListExportMutationVariables = Exact<{
  invoiceCount: Scalars['Int']['input'];
  filtered: Scalars['Boolean']['input'];
}>;


export type RecordInvoiceListExportMutation = { __typename?: 'Mutation', recordInvoiceListExport: boolean };

export type RefreshProgramInvoiceUrlsMutationVariables = Exact<{
  programInvoiceId: Scalars['String']['input'];
}>;


export type RefreshProgramInvoiceUrlsMutation = { __typename?: 'Mutation', refreshProgramInvoiceUrls: { __typename?: 'ProgramInvoice', id: string, stripeInvoiceUrl: string, stripeInvoicePdfUrl: string, status: ProgramInvoiceStatus } };

export type MarkInvoicePaidMutationVariables = Exact<{
  input: MarkInvoicePaidInput;
}>;


export type MarkInvoicePaidMutation = { __typename?: 'Mutation', markInvoicePaid: { __typename?: 'ProgramInvoice', id: string, status: ProgramInvoiceStatus } };

export type ProviderLibraryActivitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProviderLibraryActivitiesQuery = { __typename?: 'Query', providerLibraryActivities: Array<{ __typename?: 'AuditLog', id: string, entityType: string, entityId: string, activityType: string, actorType: AuditLogActorType, performedAt: any, extraMetadata?: any | null, performedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type MailSequenceScheduledSendDataFragment = { __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> };

export type MailSequenceEnrollmentActivityDataFragment = { __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number };

export type MailSequenceEnrollmentDataFragment = { __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> };

export type MailSequenceSnapshotActivityDataFragment = { __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null };

export type MailSequenceTemplateStepDataFragment = { __typename?: 'MailSequenceTemplateStep', id: string, sortOrder: number, offsetDays: number, subject: string, providerNote: string, hasActivityOverride: boolean, sourceFollowUpTemplateId?: string | null, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, activityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }> };

export type MailSequenceTemplateDataFragment = { __typename?: 'MailSequenceTemplate', id: string, providerId: string, name: string, referenceDateType?: MailSequenceReferenceDateType | null, defaultSendTime?: string | null, createdByProviderUserId: string, createdAt: any, updatedAt: any, hasDefaultActivities: boolean, defaultActivities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, defaultActivityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }>, steps: Array<{ __typename?: 'MailSequenceTemplateStep', id: string, sortOrder: number, offsetDays: number, subject: string, providerNote: string, hasActivityOverride: boolean, sourceFollowUpTemplateId?: string | null, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, activityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }> }> };

export type MailSequenceClientPreviewDataFragment = { __typename?: 'MailSequenceClientPreview', programId: string, referenceDate?: any | null, error?: string | null, steps: Array<{ __typename?: 'MailSequenceClientPreviewStep', stepIndex: number, offsetDays: number, scheduledDate: any, willBeSkippedAtEnroll: boolean, skipReason?: MailSequenceSkipReason | null }> };

export type MailSequenceTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type MailSequenceTemplatesQuery = { __typename?: 'Query', mailSequenceTemplates: Array<{ __typename?: 'MailSequenceTemplate', id: string, providerId: string, name: string, referenceDateType?: MailSequenceReferenceDateType | null, defaultSendTime?: string | null, createdByProviderUserId: string, createdAt: any, updatedAt: any, hasDefaultActivities: boolean, defaultActivities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, defaultActivityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }>, steps: Array<{ __typename?: 'MailSequenceTemplateStep', id: string, sortOrder: number, offsetDays: number, subject: string, providerNote: string, hasActivityOverride: boolean, sourceFollowUpTemplateId?: string | null, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, activityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }> }> }> };

export type MailSequenceEnrollmentsForProgramQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type MailSequenceEnrollmentsForProgramQuery = { __typename?: 'Query', mailSequenceEnrollmentsForProgram: Array<{ __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }> };

export type MailSequenceEnrollmentQueryVariables = Exact<{
  enrollmentId: Scalars['String']['input'];
}>;


export type MailSequenceEnrollmentQuery = { __typename?: 'Query', mailSequenceEnrollment?: { __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> } | null };

export type MailSequenceEnrollMutationVariables = Exact<{
  input: MailSequenceEnrollInput;
}>;


export type MailSequenceEnrollMutation = { __typename?: 'Mutation', mailSequenceEnroll: { __typename?: 'MailSequenceEnrollResponse', success: boolean, error?: string | null, enrollments: Array<{ __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }> } };

export type MailSequencePreviewDatesMutationVariables = Exact<{
  input: MailSequencePreviewDatesInput;
}>;


export type MailSequencePreviewDatesMutation = { __typename?: 'Mutation', mailSequencePreviewDates: { __typename?: 'MailSequencePreviewDatesResponse', success: boolean, error?: string | null, previews: Array<{ __typename?: 'MailSequenceClientPreview', programId: string, referenceDate?: any | null, error?: string | null, steps: Array<{ __typename?: 'MailSequenceClientPreviewStep', stepIndex: number, offsetDays: number, scheduledDate: any, willBeSkippedAtEnroll: boolean, skipReason?: MailSequenceSkipReason | null }> }> } };

export type MailSequenceCancelEnrollmentMutationVariables = Exact<{
  enrollmentId: Scalars['String']['input'];
}>;


export type MailSequenceCancelEnrollmentMutation = { __typename?: 'Mutation', mailSequenceCancelEnrollment: { __typename?: 'MailSequenceCancelEnrollmentResponse', success: boolean, error?: string | null, enrollment?: { __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> } | null } };

export type MailSequenceUpdateEnrollmentNameMutationVariables = Exact<{
  enrollmentId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type MailSequenceUpdateEnrollmentNameMutation = { __typename?: 'Mutation', mailSequenceUpdateEnrollmentName: { __typename?: 'MailSequenceUpdateEnrollmentNameResponse', success: boolean, error?: string | null, enrollment?: { __typename?: 'MailSequenceEnrollment', id: string, providerId: string, programId: string, templateId?: string | null, name?: string | null, enrolledByProviderUserId: string, referenceDateType: MailSequenceReferenceDateType, referenceDate: any, snapshotVersion: number, providerVoiceNoteId?: string | null, defaultSendTime: string, sendEmail: boolean, sendSms: boolean, status: MailSequenceEnrollmentStatus, sourceFollowUpTemplateId?: string | null, isIntake: boolean, cancelledAt?: any | null, cancelledByProviderUserId?: string | null, createdAt: any, updatedAt: any, scheduledSends: Array<{ __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> }>, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> } | null } };

export type MailSequenceSkipScheduledSendMutationVariables = Exact<{
  scheduledSendId: Scalars['String']['input'];
}>;


export type MailSequenceSkipScheduledSendMutation = { __typename?: 'Mutation', mailSequenceSkipScheduledSend: { __typename?: 'MailSequenceSkipScheduledSendResponse', success: boolean, error?: string | null, scheduledSend?: { __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> } | null } };

export type MailSequenceUpdateScheduledSendMutationVariables = Exact<{
  input: MailSequenceUpdateScheduledSendInput;
}>;


export type MailSequenceUpdateScheduledSendMutation = { __typename?: 'Mutation', mailSequenceUpdateScheduledSend: { __typename?: 'MailSequenceUpdateScheduledSendResponse', success: boolean, error?: string | null, scheduledSend?: { __typename?: 'MailSequenceScheduledSend', id: string, enrollmentId: string, stepIndex: number, scheduledDate: any, subject: string, providerNote: string, status: MailSequenceScheduledSendStatus, programFollowUpId?: string | null, sentAt?: any | null, failureReason?: string | null, skipReason?: MailSequenceSkipReason | null, attemptCount: number, hasActivityOverride: boolean, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }> } | null } };

export type MailSequenceSaveTemplateMutationVariables = Exact<{
  input: MailSequenceSaveTemplateInput;
}>;


export type MailSequenceSaveTemplateMutation = { __typename?: 'Mutation', mailSequenceSaveTemplate: { __typename?: 'MailSequenceSaveTemplateResponse', success: boolean, error?: string | null, template?: { __typename?: 'MailSequenceTemplate', id: string, providerId: string, name: string, referenceDateType?: MailSequenceReferenceDateType | null, defaultSendTime?: string | null, createdByProviderUserId: string, createdAt: any, updatedAt: any, hasDefaultActivities: boolean, defaultActivities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, defaultActivityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }>, steps: Array<{ __typename?: 'MailSequenceTemplateStep', id: string, sortOrder: number, offsetDays: number, subject: string, providerNote: string, hasActivityOverride: boolean, sourceFollowUpTemplateId?: string | null, activities: Array<{ __typename?: 'MailSequenceEnrollmentActivity', activityType: string, title: string, subtitle?: string | null, providerNote?: string | null, isCompletable: boolean, isAvailable: boolean, unavailableReason?: string | null, signerCount: number }>, activityInputs: Array<{ __typename?: 'MailSequenceSnapshotActivity', activityType: string, providerNote?: string | null, assessmentId?: string | null, activityAudioId?: string | null, activityImageId?: string | null, activityLinkId?: string | null, activityPdfId?: string | null, activityTextId?: string | null, isCompletable?: boolean | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'MailSequenceSnapshotSignatureUser', assessmentSignatureUserId: string, providerUserId?: string | null }> | null }> }> } | null } };

export type MailSequenceDeleteTemplateMutationVariables = Exact<{
  templateId: Scalars['String']['input'];
}>;


export type MailSequenceDeleteTemplateMutation = { __typename?: 'Mutation', mailSequenceDeleteTemplate: { __typename?: 'MailSequenceDeleteTemplateResponse', success: boolean, error?: string | null } };

export type MediaDataFragment = { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any };

export type UpdateMediaContentMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  content: Scalars['String']['input'];
}>;


export type UpdateMediaContentMutation = { __typename?: 'Mutation', updateMediaContent: boolean };

export type UpdateMediaFileMutationVariables = Exact<{
  mediaId: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UpdateMediaFileMutation = { __typename?: 'Mutation', updateMediaFile: boolean };

export type CreateMediaFileMutationVariables = Exact<{
  input: CreateMediaFileInput;
}>;


export type CreateMediaFileMutation = { __typename?: 'Mutation', createMediaFile: { __typename?: 'Media', id: string, url: string } };

export type IsFilePdfEditableMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type IsFilePdfEditableMutation = { __typename?: 'Mutation', isFilePdfEditable: boolean };

export type ProgramNoteDataFragment = { __typename?: 'ProgramNote', id: string, createdAt: any, updatedAt: any, title: string, note: string, isPinnedNote?: boolean | null, isLocked: boolean, lockedAt?: any | null, canLockUnlock: boolean, canDelete: boolean, lockedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string } | null, createdByProviderUser: { __typename?: 'ProviderUserMember', name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type ProgramNotesQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProgramNotesQuery = { __typename?: 'Query', programNotes: Array<{ __typename?: 'ProgramNote', id: string, createdAt: any, updatedAt: any, title: string, note: string, isPinnedNote?: boolean | null, isLocked: boolean, lockedAt?: any | null, canLockUnlock: boolean, canDelete: boolean, lockedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string } | null, createdByProviderUser: { __typename?: 'ProviderUserMember', name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } }> };

export type ProgramNoteQueryVariables = Exact<{
  programNoteId: Scalars['String']['input'];
}>;


export type ProgramNoteQuery = { __typename?: 'Query', programNote: { __typename?: 'ProgramNote', id: string, createdAt: any, updatedAt: any, title: string, note: string, isPinnedNote?: boolean | null, isLocked: boolean, lockedAt?: any | null, canLockUnlock: boolean, canDelete: boolean, lockedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string } | null, createdByProviderUser: { __typename?: 'ProviderUserMember', name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } } };

export type CreateProgramNoteMutationVariables = Exact<{
  input: CreateProgramNoteInput;
}>;


export type CreateProgramNoteMutation = { __typename?: 'Mutation', createProgramNote: { __typename?: 'ProgramNote', id: string } };

export type UpdateProgramNoteMutationVariables = Exact<{
  input: UpdateProgramNoteInput;
}>;


export type UpdateProgramNoteMutation = { __typename?: 'Mutation', updateProgramNote: { __typename?: 'ProgramNote', id: string } };

export type DeleteProgramNoteMutationVariables = Exact<{
  programNoteId: Scalars['String']['input'];
}>;


export type DeleteProgramNoteMutation = { __typename?: 'Mutation', deleteProgramNote: boolean };

export type RecordProgramNotePdfDownloadMutationVariables = Exact<{
  programNoteId: Scalars['String']['input'];
}>;


export type RecordProgramNotePdfDownloadMutation = { __typename?: 'Mutation', recordProgramNotePdfDownload: boolean };

export type NotifyProgramNoteMutationVariables = Exact<{
  input: NotifyProgramNoteInput;
}>;


export type NotifyProgramNoteMutation = { __typename?: 'Mutation', notifyProgramNote: { __typename?: 'ProgramNoteNotificationResult', success: boolean, notifiedProviderUsers: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> } };

export type CreateProgramNoteShareMutationVariables = Exact<{
  input: CreateProgramNoteShareInput;
}>;


export type CreateProgramNoteShareMutation = { __typename?: 'Mutation', createProgramNoteShare: { __typename?: 'ProgramNoteSharePayload', shareId: string, url: string, expiresAt: any, recipientEmail: string, recipientName?: string | null } };

export type RevokeProgramNoteShareMutationVariables = Exact<{
  shareId: Scalars['String']['input'];
}>;


export type RevokeProgramNoteShareMutation = { __typename?: 'Mutation', revokeProgramNoteShare: boolean };

export type ProgramNoteSharesQueryVariables = Exact<{
  programNoteId: Scalars['String']['input'];
}>;


export type ProgramNoteSharesQuery = { __typename?: 'Query', programNoteShares: Array<{ __typename?: 'ProgramNoteShareInfo', id: string, status: ProgramNoteShareStatus, noteTitle: string, recipientName?: string | null, recipientEmail?: string | null, recipientContactType?: string | null, sentAt?: any | null, expiresAt: any, firstViewedAt?: any | null, downloadCount: number, url: string, revokedAt?: any | null }> };

export type ProgramNoteSharesForContactQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type ProgramNoteSharesForContactQuery = { __typename?: 'Query', programNoteSharesForContact: Array<{ __typename?: 'ProgramNoteShareInfo', id: string, status: ProgramNoteShareStatus, noteTitle: string, recipientName?: string | null, recipientEmail?: string | null, recipientContactType?: string | null, sentAt?: any | null, expiresAt: any, firstViewedAt?: any | null, downloadCount: number, url: string, revokedAt?: any | null }> };

export type BasicProviderNoteTemplateDataFragment = { __typename?: 'ProviderNoteTemplate', id: string, title: string, isSharedNoteTemplate?: boolean | null, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type ProviderNoteTemplateDataFragment = { __typename?: 'ProviderNoteTemplate', id: string, title: string, note: string, isSharedNoteTemplate?: boolean | null, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type ProviderNoteTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderNoteTemplatesQuery = { __typename?: 'Query', providerNoteTemplates: Array<{ __typename?: 'ProviderNoteTemplate', id: string, title: string, isSharedNoteTemplate?: boolean | null, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } }> };

export type ProviderNoteTemplateQueryVariables = Exact<{
  providerNoteTemplateId: Scalars['String']['input'];
}>;


export type ProviderNoteTemplateQuery = { __typename?: 'Query', providerNoteTemplate: { __typename?: 'ProviderNoteTemplate', id: string, title: string, note: string, isSharedNoteTemplate?: boolean | null, createdByProviderUser: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } } };

export type CreateProviderNoteTemplateMutationVariables = Exact<{
  input: CreateProviderNoteTemplateInput;
}>;


export type CreateProviderNoteTemplateMutation = { __typename?: 'Mutation', createProviderNoteTemplate: { __typename?: 'ProviderNoteTemplate', id: string, title: string, note: string } };

export type UpdateProviderNoteTemplateMutationVariables = Exact<{
  input: UpdateProviderNoteTemplateInput;
}>;


export type UpdateProviderNoteTemplateMutation = { __typename?: 'Mutation', updateProviderNoteTemplate: { __typename?: 'ProviderNoteTemplate', id: string, title: string, note: string } };

export type RemoveProviderNoteTemplateMutationVariables = Exact<{
  providerNoteTemplateId: Scalars['String']['input'];
}>;


export type RemoveProviderNoteTemplateMutation = { __typename?: 'Mutation', removeProviderNoteTemplate: boolean };

export type MarkProviderUserNotificationReadMutationVariables = Exact<{
  providerUserNotificationId: Scalars['String']['input'];
  archivedNotification: Scalars['Boolean']['input'];
}>;


export type MarkProviderUserNotificationReadMutation = { __typename?: 'Mutation', markProviderUserNotificationRead: boolean };

export type MarkAllProviderUserNotificationsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllProviderUserNotificationsReadMutation = { __typename?: 'Mutation', markAllProviderUserNotificationsRead: boolean };

export type UpdateProviderUserNotificationControlsMutationVariables = Exact<{
  input: UpdateProviderUserNotificationControlsInput;
}>;


export type UpdateProviderUserNotificationControlsMutation = { __typename?: 'Mutation', updateProviderUserNotificationControls: { __typename?: 'ProviderUserNotificationControls', patientActivationEmailOption?: NotificationFrequency | null, patientActivityCompletionEmailOption?: NotificationFrequency | null, patientAssessmentCompletionEmailOption?: NotificationFrequency | null, patientCommentEmailOption?: NotificationFrequency | null, careTeamNotificationsEnabled: boolean, allClientsFormCompletionEnabled: boolean } };

export type MePatientDataFragment = { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, createdAt: any, registeredAt?: any | null, fromStorefront?: boolean | null, completedStorefrontIntakeAt?: any | null, hasCalendlyIntegration?: boolean | null, providerAllowsPortalServiceBooking: boolean, providerAllowsPortalCalendlyBooking: boolean, providerAllowsPortalAssessmentTrends: boolean, providerName?: string | null, providerTimezone?: string | null, providerStorefrontSlug?: string | null, providerPrimaryColor?: string | null, providerSecondaryColor?: string | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, providerSquareLogo?: { __typename?: 'Media', url: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type PatientTableDataFragment = { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, name?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, createdAt: any, registeredAt?: any | null, lastSeenAt?: any | null, fromStorefront?: boolean | null, onboardingLastProgramInviteSentAt?: any | null, completedStorefrontIntakeAt?: any | null, aggregateUnreadCommentCount: number, latestUnreadCommentAt?: any | null, participantId?: string | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> };

export type UpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { __typename?: 'Mutation', updatePatient: { __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> } };

export type PatientUpdateProfileMutationVariables = Exact<{
  input: PatientUpdateProfileInput;
}>;


export type PatientUpdateProfileMutation = { __typename?: 'Mutation', patientUpdateProfile: { __typename?: 'Patient', id?: string | null, name?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null } };

export type ProviderUpdatePatientProfileMutationVariables = Exact<{
  input: ProviderUpdatePatientProfileInput;
}>;


export type ProviderUpdatePatientProfileMutation = { __typename?: 'Mutation', providerUpdatePatientProfile: { __typename?: 'Patient', id?: string | null, programInstanceId: string, name?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, email: string, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, programStartDate?: any | null, programEndDate?: any | null, referralSource?: string | null } };

export type ProviderUpdatePatientEmailMutationVariables = Exact<{
  input: ProviderUpdatePatientEmailInput;
}>;


export type ProviderUpdatePatientEmailMutation = { __typename?: 'Mutation', providerUpdatePatientEmail: { __typename?: 'Patient', id?: string | null, email: string } };

export type PublicServiceSignUpMutationVariables = Exact<{
  input: PublicServiceSignUpInput;
}>;


export type PublicServiceSignUpMutation = { __typename?: 'Mutation', publicServiceSignUp: { __typename?: 'PublicServiceSignUpResult', authToken?: string | null, serviceIntakePackageId?: string | null, error?: PublicServiceSignUpError | null } };

export type SignUpDeepLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type SignUpDeepLinkQuery = { __typename?: 'Query', signUpDeepLink: string };

export type MePatientQueryVariables = Exact<{ [key: string]: never; }>;


export type MePatientQuery = { __typename?: 'Query', mePatient?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, createdAt: any, registeredAt?: any | null, fromStorefront?: boolean | null, completedStorefrontIntakeAt?: any | null, hasCalendlyIntegration?: boolean | null, providerAllowsPortalServiceBooking: boolean, providerAllowsPortalCalendlyBooking: boolean, providerAllowsPortalAssessmentTrends: boolean, providerName?: string | null, providerTimezone?: string | null, providerStorefrontSlug?: string | null, providerPrimaryColor?: string | null, providerSecondaryColor?: string | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, providerSquareLogo?: { __typename?: 'Media', url: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> } | null };

export type ReactivatePatientsMutationVariables = Exact<{
  input: ReactivatePatientsInput;
}>;


export type ReactivatePatientsMutation = { __typename?: 'Mutation', reactivatePatients: { __typename?: 'ReactivatePatientsResult', reactivatedPatients?: Array<{ __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> }> | null } };

export type UploadPatientProfileImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadPatientProfileImageMutation = { __typename?: 'Mutation', uploadPatientProfileImage: { __typename?: 'Media', id: string, url: string } };

export type PatientContactDataFragment = { __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null };

export type ProviderCreatePatientContactMutationVariables = Exact<{
  input: ProviderCreatePatientContactInput;
}>;


export type ProviderCreatePatientContactMutation = { __typename?: 'Mutation', providerCreatePatientContact: { __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type ProviderUpdatePatientContactMutationVariables = Exact<{
  input: ProviderUpdatePatientContactInput;
}>;


export type ProviderUpdatePatientContactMutation = { __typename?: 'Mutation', providerUpdatePatientContact: { __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type ProviderDeletePatientContactMutationVariables = Exact<{
  input: ProviderDeletePatientContactInput;
}>;


export type ProviderDeletePatientContactMutation = { __typename?: 'Mutation', providerDeletePatientContact: boolean };

export type PatientCreatePatientContactMutationVariables = Exact<{
  input: PatientCreatePatientContactInput;
}>;


export type PatientCreatePatientContactMutation = { __typename?: 'Mutation', patientCreatePatientContact: { __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type PatientUpdatePatientContactMutationVariables = Exact<{
  input: PatientUpdatePatientContactInput;
}>;


export type PatientUpdatePatientContactMutation = { __typename?: 'Mutation', patientUpdatePatientContact: { __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null } };

export type PatientDeletePatientContactMutationVariables = Exact<{
  input: PatientDeletePatientContactInput;
}>;


export type PatientDeletePatientContactMutation = { __typename?: 'Mutation', patientDeletePatientContact: boolean };

export type ContactDeletionImpactQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type ContactDeletionImpactQuery = { __typename?: 'Query', contactDeletionImpact: { __typename?: 'ContactDeletionImpact', hasActiveLinks: boolean, activeNoteShares: Array<{ __typename?: 'ContactDeletionImpactNoteShare', id: string, noteTitle: string, expiresAt: any }>, activeFormInvites: Array<{ __typename?: 'ContactDeletionImpactFormInvite', id: string, formName: string, expiresAt: any }> } };

export type ContactHasActiveExternalLinksQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type ContactHasActiveExternalLinksQuery = { __typename?: 'Query', contactHasActiveExternalLinks: boolean };

export type BookableProviderServiceDataFragment = { __typename?: 'BookableProviderService', id: string, slug: string, name: string, description: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, hasCalendlyEvent: boolean, hasIntakeForm: boolean, displayOrder: number, serviceGroupId?: string | null, serviceGroupName?: string | null };

export type ProviderBookableServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderBookableServicesQuery = { __typename?: 'Query', providerBookableServices: Array<{ __typename?: 'BookableProviderService', id: string, slug: string, name: string, description: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, hasCalendlyEvent: boolean, hasIntakeForm: boolean, displayOrder: number, serviceGroupId?: string | null, serviceGroupName?: string | null }> };

export type PatientPortalBookServiceMutationVariables = Exact<{
  input: PatientPortalBookServiceInput;
}>;


export type PatientPortalBookServiceMutation = { __typename?: 'Mutation', patientPortalBookService: { __typename?: 'PatientPortalBookServiceResult', serviceIntakePackageId?: string | null, error?: PatientPortalBookServiceError | null } };

export type ProviderPaymentActivitiesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProviderPaymentActivitiesQuery = { __typename?: 'Query', providerPaymentActivities: Array<{ __typename?: 'AuditLog', id: string, entityType: string, entityId: string, activityType: string, actorType: AuditLogActorType, performedAt: any, extraMetadata?: any | null, performedByProviderUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> };

export type ProviderProgramMediaDataFragment = { __typename?: 'ProviderProgramMedia', id: string, name: string, createdAt: any, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any }, createdByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null };

export type ProviderProgramMediaQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ProviderProgramMediaQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', providerMedia: Array<{ __typename?: 'ProviderProgramMedia', id: string, name: string, createdAt: any, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any }, createdByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null }> } };

export type MarkProgramSeenMutationVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type MarkProgramSeenMutation = { __typename?: 'Mutation', markProgramSeen: { __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> } };

export type UploadProviderProgramMediaMutationVariables = Exact<{
  input: UploadProviderProgramMediaInput;
}>;


export type UploadProviderProgramMediaMutation = { __typename?: 'Mutation', uploadProviderProgramMedia: { __typename?: 'ProviderProgramMedia', id: string, name: string, createdAt: any, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any }, createdByProviderUser?: { __typename?: 'ProviderUserMember', name?: string | null } | null } };

export type DeleteProviderProgramMediaMutationVariables = Exact<{
  providerProgramMediaId: Scalars['String']['input'];
}>;


export type DeleteProviderProgramMediaMutation = { __typename?: 'Mutation', deleteProviderProgramMedia: boolean };

export type ProgramTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProgramTemplatesQuery = { __typename?: 'Query', programTemplates: Array<{ __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, activePatientCount?: number | null }> };

export type ProgramTemplateQueryVariables = Exact<{
  programTemplateId: Scalars['String']['input'];
}>;


export type ProgramTemplateQuery = { __typename?: 'Query', programTemplate: { __typename?: 'ProgramTemplate', id: string, name?: string | null, taskGroups?: Array<{ __typename?: 'ProgramTemplateTaskGroup', id: string, title?: string | null, weight?: number | null, isResourceGroup?: boolean | null, tasks?: Array<{ __typename?: 'Task', id?: string | null, title?: string | null, type?: string | null, author?: string | null, weightInGroup?: number | null, contentType?: string | null, media?: { __typename?: 'Content', imageUrl?: string | null } | null }> | null }> | null } };

export type ProgramTemplateNameQueryVariables = Exact<{
  programTemplateId: Scalars['String']['input'];
}>;


export type ProgramTemplateNameQuery = { __typename?: 'Query', programTemplate: { __typename?: 'ProgramTemplate', name?: string | null } };

export type ProgramTaskQueryVariables = Exact<{
  programTaskId: Scalars['String']['input'];
}>;


export type ProgramTaskQuery = { __typename?: 'Query', programTask: { __typename?: 'Task', id?: string | null, title?: string | null, type?: string | null, author?: string | null, content?: { __typename?: 'Content', title?: string | null, audioDuration?: number | null, audioFileName?: string | null } | null, media?: { __typename?: 'Content', htmlUrl?: string | null, htmlMediaId?: string | null, imageUrl?: string | null, imageMediaId?: string | null, audioUrl?: string | null, audioMediaId?: string | null } | null } };

export type CreateProgramTemplateMutationVariables = Exact<{
  input: CreateProgramTemplateInput;
}>;


export type CreateProgramTemplateMutation = { __typename?: 'Mutation', createProgramTemplate: { __typename?: 'ProgramTemplate', id: string } };

export type CreateProgramTaskMutationVariables = Exact<{
  programTemplateId: Scalars['String']['input'];
  input: ProgramTaskInput;
}>;


export type CreateProgramTaskMutation = { __typename?: 'Mutation', createProgramTask: string };

export type UpdateProgramTaskMutationVariables = Exact<{
  programTaskId: Scalars['String']['input'];
  input: TaskInput;
}>;


export type UpdateProgramTaskMutation = { __typename?: 'Mutation', updateProgramTask: boolean };

export type RemoveTaskFromProgramTemplateMutationVariables = Exact<{
  taskId: Scalars['String']['input'];
  programTemplateId: Scalars['String']['input'];
}>;


export type RemoveTaskFromProgramTemplateMutation = { __typename?: 'Mutation', removeTaskFromProgramTemplate: boolean };

export type MoveProgramTemplateTaskInGroupMutationVariables = Exact<{
  input: MoveProgramTemplateTaskInGroupInput;
}>;


export type MoveProgramTemplateTaskInGroupMutation = { __typename?: 'Mutation', moveProgramTemplateTaskInGroup: Array<{ __typename?: 'ProgramTemplateTaskGroup', id: string, title?: string | null, weight?: number | null, isResourceGroup?: boolean | null, tasks?: Array<{ __typename?: 'Task', id?: string | null, title?: string | null, type?: string | null, author?: string | null, weightInGroup?: number | null, contentType?: string | null, media?: { __typename?: 'Content', imageUrl?: string | null } | null }> | null }> };

export type RenameTaskGroupMutationVariables = Exact<{
  taskGroupId: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type RenameTaskGroupMutation = { __typename?: 'Mutation', renameTaskGroup: boolean };

export type CreateTaskGroupMutationVariables = Exact<{
  input: CreateTaskGroupInput;
}>;


export type CreateTaskGroupMutation = { __typename?: 'Mutation', createTaskGroup: { __typename?: 'ProgramTemplateTaskGroup', id: string } };

export type DeleteTaskGroupMutationVariables = Exact<{
  taskGroupId: Scalars['String']['input'];
}>;


export type DeleteTaskGroupMutation = { __typename?: 'Mutation', deleteTaskGroup: boolean };

export type PatientLeadDataFragment = { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }>, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type PatientDataFragment = { __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> };

export type PatientQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type PatientQuery = { __typename?: 'Query', patient: { __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> } };

export type ContactsForProgramQueryVariables = Exact<{
  programId: Scalars['String']['input'];
}>;


export type ContactsForProgramQuery = { __typename?: 'Query', contactsForProgram: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> };

export type AssignPatientsToProgramMutationVariables = Exact<{
  input: AssignPatientsToProgramInput;
}>;


export type AssignPatientsToProgramMutation = { __typename?: 'Mutation', assignPatientsToProgram: { __typename?: 'AssignPatientsToProgramResult', updatedPatients: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }>, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> }> } };

export type SendProgramInvitesToPatientsMutationVariables = Exact<{
  input: SendProgramInvitesToPatientsInput;
}>;


export type SendProgramInvitesToPatientsMutation = { __typename?: 'Mutation', sendProgramInvitesToPatients: { __typename?: 'SendProgramInvitesToPatientsResult', updatedPatients?: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }>, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> }> | null, clientSeatLimitError?: { __typename?: 'SendProgramInvitesToPatientsClientSeatLimitError', seatsRemaining: number } | null } };

export type DeactivatePatientsMutationVariables = Exact<{
  input: DeactivatePatientsInput;
}>;


export type DeactivatePatientsMutation = { __typename?: 'Mutation', deactivatePatients: { __typename?: 'DeactivatePatientsResult', deactivatedPatients?: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string }> | null } };

export type SetPatientFirstAppointmentDateMutationVariables = Exact<{
  programId: Scalars['String']['input'];
  firstAppointmentDate: Scalars['Datetime']['input'];
}>;


export type SetPatientFirstAppointmentDateMutation = { __typename?: 'Mutation', setPatientFirstAppointmentDate: { __typename?: 'Patient', deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, programStartDate?: any | null, programEndDate?: any | null, participantId?: string | null, dateOfBirth?: any | null, age?: number | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, preferredLanguage?: string | null, timezone?: string | null, referralSource?: string | null, id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, checkInData?: { __typename?: 'CheckInData', last7DaysAverage: number, last7DaysAverageDifference: number, last7DaysCheckInsCount: number, last7DaysCheckInsCountDifference: number, totalCheckIns: number, lastCheckIn?: { __typename?: 'CheckIn', score: number, createdAt: any } | null, recent3CheckIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } | null, tasksData?: { __typename?: 'TasksData', completedContentCount: number, availableContentCount: number, journalEntriesCount: number, activitiesCount: number, contentCompletedPercentage?: number | null, completedContentPercentage?: number | null, recent3Tasks?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null } | null, providerWordmarkLogo?: { __typename?: 'Media', url: string } | null, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }>, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> } };

export type PatientFeedQueryVariables = Exact<{
  programId: Scalars['String']['input'];
  feedType: FeedType;
  paginationIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientFeedQuery = { __typename?: 'Query', patientFeed: { __typename?: 'ActivityFeedResult', activities?: Array<{ __typename?: 'PatientTask', taskType: TaskType, title: string, createdAt: any }> | null, checkIns?: Array<{ __typename?: 'CheckIn', score: number, createdAt: any }> | null } };

export type PatientsV2QueryVariables = Exact<{
  patientLifecycleStatuses?: InputMaybe<Array<PatientLifecycleStatusV2> | PatientLifecycleStatusV2>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<ProgramSortOrder>;
  filter?: InputMaybe<PatientsV2Filter>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PatientsV2Query = { __typename?: 'Query', patientsV2: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, name?: string | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, deactivatedAt?: any | null, startTime?: any | null, endTime?: any | null, createdAt: any, registeredAt?: any | null, lastSeenAt?: any | null, fromStorefront?: boolean | null, onboardingLastProgramInviteSentAt?: any | null, completedStorefrontIntakeAt?: any | null, aggregateUnreadCommentCount: number, latestUnreadCommentAt?: any | null, participantId?: string | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> }> };

export type PatientNameDataFragment = { __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null };

export type PatientsCountV2QueryVariables = Exact<{
  filter?: InputMaybe<PatientsV2Filter>;
}>;


export type PatientsCountV2Query = { __typename?: 'Query', activePatientsCount: number, archivedPatientsCount: number };

export type PatientsV2NamesQueryVariables = Exact<{
  patientLifecycleStatuses?: InputMaybe<Array<PatientLifecycleStatusV2> | PatientLifecycleStatusV2>;
  assignedPatients?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PatientsV2NamesQuery = { __typename?: 'Query', patientNames: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type UpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;


export type UpdateProviderMutation = { __typename?: 'Mutation', updateProvider: { __typename?: 'Provider', name: string, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, timezone?: string | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null } };

export type AddPatientsV2MutationVariables = Exact<{
  input: AddPatientsV2Input;
}>;


export type AddPatientsV2Mutation = { __typename?: 'Mutation', addPatientsV2: { __typename?: 'AddPatientsV2Result', newPatients?: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }>, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> }> | null, validationErrors?: Array<{ __typename?: 'AddPatientsV2ValidationError', inputId: number, isDuplicate?: boolean | null, nameInvalid?: boolean | null, emailInvalid?: boolean | null, phoneNumberInvalid?: boolean | null, tagsInvalid?: boolean | null }> | null } };

export type ResendPatientInvitesMutationVariables = Exact<{
  input: ResendPatientInvitesInput;
}>;


export type ResendPatientInvitesMutation = { __typename?: 'Mutation', resendPatientInvites: { __typename?: 'ResendPatientInvitesResult', updatedPatients: Array<{ __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, name?: string | null, phoneNumber?: string | null, isTestProgram?: boolean | null, aggregateUnreadCommentCount: number, unreadCommentCount: number, onboardingStatus: ProgramOnboardingStatus, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, firstAppointmentAt?: any | null, createdAt: any, fromStorefront?: boolean | null, lastSeenAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, latestCompletedActivity?: { __typename?: 'ProgramActivity', activityType: ActivityType, name: string, completedAt?: any | null, programAssessment?: { __typename?: 'ProgramAssessment', assessment: { __typename?: 'Assessment', schemaType: AssessmentSchemaType } } | null } | null, latestUnreadComment?: { __typename?: 'Comment', createdAt: any } | null, programTemplate?: { __typename?: 'ProgramTemplate', id: string, name?: string | null, status: ProgramTemplateStatus, programLengthInMonths?: number | null, programTemplateAssessments: Array<{ __typename?: 'ProgramTemplateAssessment', assessment: { __typename?: 'Assessment', type: AssessmentType, shortName: string } }> } | null, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }>, contacts: Array<{ __typename?: 'PatientContact', id?: string | null, patientId?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, contactType?: ContactType | null, relationshipDescription?: string | null, addressStreet?: string | null, addressCity?: string | null, addressState?: string | null, addressPostalCode?: string | null, addressCountry?: string | null, createdAt?: any | null, updatedAt?: any | null }> }> } };

export type SendTestProviderEmailMutationVariables = Exact<{
  isBanner: Scalars['Boolean']['input'];
}>;


export type SendTestProviderEmailMutation = { __typename?: 'Mutation', sendTestProviderEmail: boolean };

export type ServiceTagsDataFragment = { __typename?: 'ProgramTag', id: string, name: string, description: string, color: string };

export type ProviderServiceDataFragment = { __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null };

export type PublicProviderServiceDataFragment = { __typename?: 'PublicProviderService', id: string, providerName: string, profileImageUrl?: string | null, providerRoleTitle?: string | null, storefrontEnabled: boolean, isShownOnStorefront: boolean, slug: string, name: string, serviceIcon: ServiceIcon, providerPrimaryColor?: string | null, providerSecondaryColor?: string | null, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, patientAccessLevel: PatientAccessLevel, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, serviceGroupId?: string | null, serviceGroupName?: string | null };

export type PublicProviderServiceQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  serviceSlug: Scalars['String']['input'];
}>;


export type PublicProviderServiceQuery = { __typename?: 'Query', publicProviderService: { __typename?: 'PublicProviderService', id: string, providerName: string, profileImageUrl?: string | null, providerRoleTitle?: string | null, storefrontEnabled: boolean, isShownOnStorefront: boolean, slug: string, name: string, serviceIcon: ServiceIcon, providerPrimaryColor?: string | null, providerSecondaryColor?: string | null, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, patientAccessLevel: PatientAccessLevel, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, serviceGroupId?: string | null, serviceGroupName?: string | null } };

export type ProviderServiceQueryVariables = Exact<{
  providerServiceId: Scalars['String']['input'];
}>;


export type ProviderServiceQuery = { __typename?: 'Query', providerService: { __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null } };

export type ProviderServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderServicesQuery = { __typename?: 'Query', providerServices?: Array<{ __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null }> | null };

export type CreateProviderServiceMutationVariables = Exact<{
  input: CreateProviderServiceInput;
}>;


export type CreateProviderServiceMutation = { __typename?: 'Mutation', createProviderService: { __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null } };

export type UpdateProviderServiceMutationVariables = Exact<{
  input: UpdateProviderServiceInput;
}>;


export type UpdateProviderServiceMutation = { __typename?: 'Mutation', updateProviderService: { __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null } };

export type ArchiveProviderServiceMutationVariables = Exact<{
  providerServiceId: Scalars['String']['input'];
}>;


export type ArchiveProviderServiceMutation = { __typename?: 'Mutation', archiveProviderService: boolean };

export type __ProviderUserNotificationTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type __ProviderUserNotificationTypeQuery = { __typename: 'Query' };

type NotificationData_ProviderUserNotificationActivation_Fragment = { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationActivityCompleted_Fragment = { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationAssessmentCompleted_Fragment = { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationComment_Fragment = { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationFormNeedsProviderSignature_Fragment = { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationInvoicePaid_Fragment = { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationPatientAssignment_Fragment = { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationPendingProviderMembership_Fragment = { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null };

type NotificationData_ProviderUserNotificationSessionBooked_Fragment = { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

type NotificationData_ProviderUserNotificationStorefrontSignUp_Fragment = { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null };

export type NotificationDataFragment =
  | NotificationData_ProviderUserNotificationActivation_Fragment
  | NotificationData_ProviderUserNotificationActivityCompleted_Fragment
  | NotificationData_ProviderUserNotificationAssessmentCompleted_Fragment
  | NotificationData_ProviderUserNotificationComment_Fragment
  | NotificationData_ProviderUserNotificationFormNeedsProviderSignature_Fragment
  | NotificationData_ProviderUserNotificationInvoicePaid_Fragment
  | NotificationData_ProviderUserNotificationPatientAssignment_Fragment
  | NotificationData_ProviderUserNotificationPendingProviderMembership_Fragment
  | NotificationData_ProviderUserNotificationSessionBooked_Fragment
  | NotificationData_ProviderUserNotificationStorefrontSignUp_Fragment
;

export type MeProviderDataFragment = { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
    | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
    | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
  >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null };

export type MeProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
      | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
      | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null } | null };

export type MeProviderUserNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderUserNotificationsQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', notifications: Array<
      | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
      | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    > } | null };

export type MeProviderUserNotificationControlsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderUserNotificationControlsQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', hasMultipleTeamMembers: boolean, patientDataPermission: PatientDataPermission, notificationControls?: { __typename?: 'ProviderUserNotificationControls', patientActivationEmailOption?: NotificationFrequency | null, patientActivityCompletionEmailOption?: NotificationFrequency | null, patientAssessmentCompletionEmailOption?: NotificationFrequency | null, patientCommentEmailOption?: NotificationFrequency | null, careTeamNotificationsEnabled: boolean, allClientsFormCompletionEnabled: boolean } | null } | null };

export type CalendlyTeamProviderUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlyTeamProviderUsersQuery = { __typename?: 'Query', calendlyTeamProviderUsers: Array<{ __typename?: 'CalendlyTeamProviderUser', id: string, email: string, name?: string | null, profileImageUrl?: string | null }> };

export type MeProviderUserProfileImageUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderUserProfileImageUrlQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null } } | null };

export type MeProviderProgramTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderProgramTagsQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', provider: { __typename?: 'Provider', programTags: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> } } | null };

export type MeProviderProgramTagsWithCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderProgramTagsWithCountQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', provider: { __typename?: 'Provider', programTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }> } } | null };

export type MeProviderSubscriptionStateQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderSubscriptionStateQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, isTrialing: boolean, trialEndsAt: any, provider: { __typename?: 'Provider', subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, usedClientSeats: number, usedStaffSeats: number } } } | null };

export type MeProviderSignUpConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type MeProviderSignUpConfigQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', signUpConfig?: { __typename?: 'SignUpConfig', isCommunityHub: boolean } | null } | null };

export type InvitedProviderUserQueryVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type InvitedProviderUserQuery = { __typename?: 'Query', invitedProviderUser: { __typename?: 'InvitedProviderUser', providerName: string, email: string, role: ProviderUserRole, inviterProviderUserName?: string | null, providerSquareLogoUrl?: string | null } };

export type BasicProviderUserMemberDataFragment = { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, isExternalCollaborator: boolean, patientDataPermission: PatientDataPermission, role: ProviderUserRole, profileImageMedia?: { __typename?: 'Media', url: string } | null };

export type ProviderUserMemberDataFragment = { __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null };

export type ProviderUserMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserMembersQuery = { __typename?: 'Query', providerUserMembers: Array<{ __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type ProviderUserMembersV2QueryVariables = Exact<{
  activeProviderUsersOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProviderUserMembersV2Query = { __typename?: 'Query', providerUserMembers: Array<{ __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type BillingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingInfoQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', billingInfo?: { __typename?: 'ProviderBillingInfo', nextBillingDate: any, activePatientCount: number, forecastedActivePatientCount: number, forecastedCost: number } | null, provider: { __typename?: 'Provider', subscriptionTier?: SubscriptionTier | null, subscriptionTierV2?: SubscriptionTierV2 | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, usedClientSeats: number }, paymentPlan: { __typename?: 'ProviderPaymentPlan', upfrontFee?: number | null, pmpmFee?: number | null, monthlyFee?: number | null } } } | null };

export type ProviderUserLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  isMobile?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProviderUserLoginMutation = { __typename?: 'Mutation', providerUserLogin: { __typename?: 'AuthResponse', tokenPayload: { __typename?: 'TokenPayload', authToken?: string | null, providerUserId: string, providerId: string, role: AuthSessionRole, isV2: boolean }, meProvider: { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
        | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
        | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null }, signUpConfig?: { __typename?: 'SignUpConfig', isCommunityHub: boolean } | null } };

export type ProviderUserLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type ProviderUserLogoutMutation = { __typename?: 'Mutation', providerUserLogout: boolean };

export type CompleteOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteOnboardingMutation = { __typename?: 'Mutation', completeOnboarding: boolean };

export type ValidateProviderUserEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ValidateProviderUserEmailMutation = { __typename?: 'Mutation', validateProviderUserEmail: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type ValidateRecoveryCodeQueryVariables = Exact<{
  recoveryCode: Scalars['String']['input'];
}>;


export type ValidateRecoveryCodeQuery = { __typename?: 'Query', validateRecoveryCode: boolean };

export type SignUpConfigQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type SignUpConfigQuery = { __typename?: 'Query', signUpConfig?: { __typename?: 'SignUpConfig', skipIntroCarousel: boolean, isCommunityHub: boolean, hideLoginLink: boolean, headerText?: string | null, subheaderText?: string | null, partnerName?: string | null, logoLinkUrl?: string | null, testimonialQuote?: string | null, testimonialName?: string | null, testimonialTitle?: string | null, testimonialAvatarMedia?: { __typename?: 'Media', url: string } | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, sidepanelBgMedia?: { __typename?: 'Media', url: string } | null, sidepanelCommunityMedia?: { __typename?: 'Media', url: string } | null } | null };

export type ChangePasswordWithRecoveryCodeMutationVariables = Exact<{
  recoveryCode: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordWithRecoveryCodeMutation = { __typename?: 'Mutation', changePasswordWithRecoveryCode: boolean };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: boolean };

export type UploadProviderUserProfileImageMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadProviderUserProfileImageMutation = { __typename?: 'Mutation', uploadProviderUserProfileImage: boolean };

export type ResetOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetOnboardingMutation = { __typename?: 'Mutation', resetOnboarding: boolean };

export type ProviderSignUpMutationVariables = Exact<{
  input: ProviderSignUpInput;
}>;


export type ProviderSignUpMutation = { __typename?: 'Mutation', providerSignUp: { __typename?: 'AuthResponse', tokenPayload: { __typename?: 'TokenPayload', authToken?: string | null, providerUserId: string, providerId: string, role: AuthSessionRole, isV2: boolean }, meProvider: { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
        | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
        | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null }, signUpConfig?: { __typename?: 'SignUpConfig', skipIntroCarousel: boolean, hideLoginLink: boolean } | null } };

export type ProviderUserInviteSignupMutationVariables = Exact<{
  inviteCode: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ProviderUserInviteSignupMutation = { __typename?: 'Mutation', providerUserInviteSignup: { __typename?: 'AuthResponse', tokenPayload: { __typename?: 'TokenPayload', authToken?: string | null, providerUserId: string, providerId: string, role: AuthSessionRole, isV2: boolean }, meProvider: { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
        | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
        | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
        | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null } } };

export type UpdateProviderUserMutationVariables = Exact<{
  input: UpdateProviderUserInput;
}>;


export type UpdateProviderUserMutation = { __typename?: 'Mutation', updateProviderUser: { __typename?: 'MeProvider', id: string, isExternalCollaborator: boolean, primaryColor?: string | null, secondaryColor?: string | null, supportEmail?: string | null, email: string, name: string, role: ProviderUserRole, patientDataPermission: PatientDataPermission, jobTitle?: string | null, hasSentFollowUps: boolean, hasPremiumAccess: boolean, isProviderSubscribed: boolean, hasBeenSubscribed: boolean, hasCreatedAProviderService: boolean, isTrialing: boolean, trialEndsAt: any, onboardingCompletedAt?: any | null, isV2: boolean, storefrontSlug?: string | null, hasNylasIntegration: boolean, nylasCalendarProvider?: string | null, createdAt?: any | null, intercomUserJwt?: string | null, squareLogoMedia?: { __typename?: 'Media', url: string } | null, wordmarkLogoMedia?: { __typename?: 'Media', url: string } | null, emailImageMedia?: { __typename?: 'Media', url: string } | null, profileImageMedia?: { __typename?: 'Media', url: string } | null, provider: { __typename?: 'Provider', id: string, name: string, timezone?: string | null, logo?: string | null, isTestProvider?: boolean | null, subscriptionTierV2?: SubscriptionTierV2 | null, subscriptionEndsAt?: any | null, clientPortalBookServicesEnabled: boolean, clientPortalBookCalendlyEnabled: boolean, clientPortalAssessmentTrendsEnabled: boolean, stripeAccountId?: string | null, calendlyIntegration?: { __typename?: 'CalendlyIntegration', id: string, lookBackUntil: any, isEnabled: boolean, connectedByProviderUser?: { __typename?: 'CalendlyConnectedByProviderUser', name: string, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null } | null, ownerProfileImageMedia?: { __typename?: 'Media', url: string } | null, seatUsage: { __typename?: 'SeatUsage', clientSeats?: number | null, staffSeats?: number | null, collaboratorSeats?: number | null, usedClientSeats: number, usedStaffSeats: number, usedCollaboratorSeats: number, remainingClientSeats?: number | null, remainingStaffSeats?: number | null, remainingCollaboratorSeats?: number | null } }, notifications: Array<
      | { __typename?: 'ProviderUserNotificationActivation', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationActivityCompleted', programId: string, patientName: string, programActivityId: string, activityType: ActivityType, activityName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationAssessmentCompleted', programId: string, patientName: string, programActivityId: string, assessmentSchemaType: AssessmentSchemaType, assessmentName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationComment', programId: string, patientName: string, programFollowUpId?: string | null, programFollowUpCreatedAt?: any | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationFormNeedsProviderSignature', formName: string, programAssessmentId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationInvoicePaid', programId: string, patientName: string, programInvoiceId: string, programInvoiceAmount: number, programInvoiceCurrency: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPatientAssignment', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationPendingProviderMembership', invitedByProviderName: string, invitedByName: string, role: ProviderUserRole, seatType: SeatType, membershipId: string, membershipStatus: MembershipStatus, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, invitedByProviderSquareLogoMedia?: { __typename?: 'Media', url: string } | null }
      | { __typename?: 'ProviderUserNotificationSessionBooked', programId: string, patientName: string, calendlyEventTypeName?: string | null, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
      | { __typename?: 'ProviderUserNotificationStorefrontSignUp', programId: string, patientName: string, id: string, type: ProviderUserNotificationType, createdAt: any, readAt?: any | null, archivedNotification?: boolean | null, patientProfileImageMedia?: { __typename?: 'Media', id: string, url: string } | null }
    >, signUpConfig?: { __typename?: 'SignUpConfig', slug: string, isCommunityHub: boolean, partnerName?: string | null, circleDefaultSpaceSlug?: string | null, additionalLogoMedia?: { __typename?: 'Media', url: string } | null, postSignUpSplashBgMedia?: { __typename?: 'Media', url: string } | null } | null } };

export type SendProviderUserInvitesMutationVariables = Exact<{
  providerUserInvites: Array<ProviderUserInviteInput> | ProviderUserInviteInput;
}>;


export type SendProviderUserInvitesMutation = { __typename?: 'Mutation', sendProviderUserInvites: boolean };

export type ResendProviderUserInviteMutationVariables = Exact<{
  providerUserId: Scalars['String']['input'];
}>;


export type ResendProviderUserInviteMutation = { __typename?: 'Mutation', resendProviderUserInvite: boolean };

export type DeleteProviderUserInviteMutationVariables = Exact<{
  providerUserId: Scalars['String']['input'];
}>;


export type DeleteProviderUserInviteMutation = { __typename?: 'Mutation', deleteProviderUserInvite: boolean };

export type DeactivateProviderUserMutationVariables = Exact<{
  providerUserId: Scalars['String']['input'];
}>;


export type DeactivateProviderUserMutation = { __typename?: 'Mutation', deactivateProviderUser: { __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type ReactivateProviderUserMutationVariables = Exact<{
  providerUserId: Scalars['String']['input'];
}>;


export type ReactivateProviderUserMutation = { __typename?: 'Mutation', reactivateProviderUser: { __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type UpdateProviderUserRoleMutationVariables = Exact<{
  providerUserId: Scalars['String']['input'];
  role: ProviderUserRole;
  patientDataPermission: PatientDataPermission;
}>;


export type UpdateProviderUserRoleMutation = { __typename?: 'Mutation', updateProviderUserRole: { __typename?: 'ProviderUserMember', role: ProviderUserRole, assignedPatients?: number | null, isExternalCollaborator: boolean, lastInviteSentAt?: any | null, registeredAt?: any | null, membershipStatus?: MembershipStatus | null, id: string, name?: string | null, email: string, patientDataPermission: PatientDataPermission, profileImageMedia?: { __typename?: 'Media', url: string } | null } };

export type ProviderUserPatientsQueryVariables = Exact<{
  providerUserId: Scalars['String']['input'];
}>;


export type ProviderUserPatientsQuery = { __typename?: 'Query', providerUserPatients: Array<{ __typename?: 'PatientName', id?: string | null, firstName?: string | null, lastName?: string | null, name?: string | null, email: string, programInstanceId: string, createdAt: any, isTestProgram?: boolean | null, programStartDate?: any | null, programEndDate?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null }> };

export type AddPatientsToProviderUsersMutationVariables = Exact<{
  input: ProviderUsersToPatientsInput;
}>;


export type AddPatientsToProviderUsersMutation = { __typename?: 'Mutation', addPatientsToProviderUsers: boolean };

export type RemovePatientsFromProviderUsersMutationVariables = Exact<{
  input: ProviderUsersToPatientsInput;
}>;


export type RemovePatientsFromProviderUsersMutation = { __typename?: 'Mutation', removePatientsFromProviderUsers: boolean };

export type BasicProviderUserDataFragment = { __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null };

export type SearchProviderUsersQueryVariables = Exact<{
  input?: InputMaybe<SearchProviderUsersInput>;
}>;


export type SearchProviderUsersQuery = { __typename?: 'Query', searchProviderUsers: { __typename?: 'ProviderUserSearchResults', totalCount: number, page: number, pageSize: number, totalPages: number, providerUsers: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> } };

export type ProviderApiCredentialDataFragment = { __typename?: 'ProvidersApiCredential', id: string, apiClientId: string, name: string, description?: string | null, createdAt: any, status: ProvidersApiCredentialStatus, lastUsedAt?: any | null, deactivatedAt?: any | null };

export type GetProviderApiCredentialsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProviderApiCredentialsQuery = { __typename?: 'Query', providersApiCredentials: Array<{ __typename?: 'ProvidersApiCredential', id: string, apiClientId: string, name: string, description?: string | null, createdAt: any, status: ProvidersApiCredentialStatus, lastUsedAt?: any | null, deactivatedAt?: any | null }> };

export type CreateApiCredentialMutationVariables = Exact<{
  input: ProvidersCreateApiCredentialInput;
}>;


export type CreateApiCredentialMutation = { __typename?: 'Mutation', providersCreateApiCredential: { __typename?: 'ProvidersCreateApiCredentialResponse', success: boolean, error?: string | null, apiCredential?: { __typename?: 'ProvidersApiCredential', secret?: string | null, id: string, apiClientId: string, name: string, description?: string | null, createdAt: any, status: ProvidersApiCredentialStatus, lastUsedAt?: any | null, deactivatedAt?: any | null } | null } };

export type DeactivateApiCredentialMutationVariables = Exact<{
  apiClientId: Scalars['String']['input'];
}>;


export type DeactivateApiCredentialMutation = { __typename?: 'Mutation', providersDeactivateApiCredential: { __typename?: 'ProvidersDeactivateApiCredentialResponse', success: boolean, error?: string | null } };

export type ScheduledEventLocationFragment = { __typename?: 'ScheduledEvent', location:
    | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
    | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
    | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
    | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
   };

export type BasicScheduledEventFragment = { __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null };

export type UpcomingScheduledEventFragment = { __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
    | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
    | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
    | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
    | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
   };

export type PatientScheduledEventFragment = { __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
    | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
    | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
    | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
    | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
   };

export type CalendarScheduledEventFragment = { __typename?: 'ScheduledEvent', calendlyEventTypeUri: string, name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null };

export type CompleteScheduledEventFragment = { __typename?: 'ScheduledEvent', createdAt: any, updatedAt: any, name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', email: string, firstName: string, lastName: string, calendlyInviteeUri: string, calendlyRescheduleUrl?: string | null, calendlyCancelUrl?: string | null, calendlyEventUri: string, createdAt: any, updatedAt: any, questionsAndAnswers?: Array<{ __typename?: 'EventInviteeQuestionAndAnswer', question: string, answer: string, position: number }> | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
    | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
    | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
    | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
    | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
    | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
    | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
   };

export type CalendlyEventDataFragment = { __typename?: 'CalendlyEventType', name?: string | null, description?: string | null, duration?: number | null, color: string, calendlyEventTypeUri: string, schedulingUrl?: string | null, isVisible: boolean };

export type UpcomingScheduledEventsQueryVariables = Exact<{
  input: ScheduledEventsInput;
}>;


export type UpcomingScheduledEventsQuery = { __typename?: 'Query', scheduledEvents: Array<{ __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
      | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
      | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
      | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
      | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
     }> };

export type PatientScheduledEventsQueryVariables = Exact<{
  input: ScheduledEventsInput;
}>;


export type PatientScheduledEventsQuery = { __typename?: 'Query', scheduledEvents: Array<{ __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
      | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
      | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
      | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
      | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
     }> };

export type CalendarScheduledEventsQueryVariables = Exact<{
  input: ScheduledEventsInput;
}>;


export type CalendarScheduledEventsQuery = { __typename?: 'Query', scheduledEvents: Array<{ __typename?: 'ScheduledEvent', calendlyEventTypeUri: string, name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null }> };

export type ScheduledEventsQueryVariables = Exact<{
  input: ScheduledEventsInput;
}>;


export type ScheduledEventsQuery = { __typename?: 'Query', scheduledEvents: Array<{ __typename?: 'ScheduledEvent', name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', firstName: string, lastName: string, email: string, calendlyCancelUrl?: string | null, calendlyRescheduleUrl?: string | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null }> };

export type ScheduledEventQueryVariables = Exact<{
  calendlyEventUri: Scalars['String']['input'];
}>;


export type ScheduledEventQuery = { __typename?: 'Query', scheduledEvent: { __typename?: 'ScheduledEvent', createdAt: any, updatedAt: any, name: string, isCanceled: boolean, startTime: any, hostProfileImageUrl?: string | null, calendlyEventUri: string, hostName: string, endTime: any, invitees?: Array<{ __typename?: 'EventInvitee', email: string, firstName: string, lastName: string, calendlyInviteeUri: string, calendlyRescheduleUrl?: string | null, calendlyCancelUrl?: string | null, calendlyEventUri: string, createdAt: any, updatedAt: any, questionsAndAnswers?: Array<{ __typename?: 'EventInviteeQuestionAndAnswer', question: string, answer: string, position: number }> | null, program?: { __typename?: 'Patient', id?: string | null, programInstanceId: string, email: string, firstName?: string | null, lastName?: string | null, onboardingLastProgramInviteSentAt?: any | null, onboardingCompletedAt?: any | null, profileImageMedia?: { __typename?: 'Media', url: string } | null } | null }> | null, location:
      | { __typename?: 'AskInviteeLocation', location?: string | null, type: LocationType }
      | { __typename?: 'CustomLocation', location?: string | null, type: LocationType }
      | { __typename?: 'GoToMeetingLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'GoogleConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'InboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'MicrosoftTeamsConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'OutboundCallLocation', location?: string | null, type: LocationType }
      | { __typename?: 'PhysicalLocation', location?: string | null, type: LocationType }
      | { __typename?: 'WebexConferenceLocation', joinUrl?: string | null, type: LocationType }
      | { __typename?: 'ZoomConferenceLocation', joinUrl?: string | null, type: LocationType }
     } };

export type CalendlySchedulingUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlySchedulingUrlQuery = { __typename?: 'Query', calendlySchedulingUrl: string };

export type CalendlyEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlyEventTypesQuery = { __typename?: 'Query', calendlyEventTypes: Array<{ __typename?: 'CalendlyEventType', name?: string | null, description?: string | null, duration?: number | null, color: string, calendlyEventTypeUri: string, schedulingUrl?: string | null, isVisible: boolean }> };

export type CalendlyImportStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlyImportStatusQuery = { __typename?: 'Query', calendlyImportStatus?: CalendlyImportStatus | null };

export type ChangeCalendlyEventTypeVisibilityMutationVariables = Exact<{
  calendlyEventTypeUri: Scalars['String']['input'];
  shouldBeVisible: Scalars['Boolean']['input'];
}>;


export type ChangeCalendlyEventTypeVisibilityMutation = { __typename?: 'Mutation', changeCalendlyEventTypeVisibility: boolean };

export type CancelCalendlyEventMutationVariables = Exact<{
  calendlyEventUri: Scalars['String']['input'];
  reasonForCancellation?: InputMaybe<Scalars['String']['input']>;
}>;


export type CancelCalendlyEventMutation = { __typename?: 'Mutation', cancelCalendlyEvent: boolean };

export type ImportCalendlyDataMutationVariables = Exact<{ [key: string]: never; }>;


export type ImportCalendlyDataMutation = { __typename?: 'Mutation', importCalendlyData: boolean };

export type LinkInviteeEmailToProgramMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  programId: Scalars['String']['input'];
}>;


export type LinkInviteeEmailToProgramMutation = { __typename?: 'Mutation', linkInviteeEmailToProgram: boolean };

export type UnlinkInviteeEmailFromProgramMutationVariables = Exact<{
  inviteeEmail: Scalars['String']['input'];
  programId: Scalars['String']['input'];
}>;


export type UnlinkInviteeEmailFromProgramMutation = { __typename?: 'Mutation', unlinkInviteeEmailFromProgram: boolean };

export type UninvitedEventInviteesQueryVariables = Exact<{ [key: string]: never; }>;


export type UninvitedEventInviteesQuery = { __typename?: 'Query', uninvitedEventInvitees: Array<{ __typename?: 'EventInvitee', email: string, firstName: string, lastName: string }> };

export type CalendlyPractitionerEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlyPractitionerEventTypesQuery = { __typename?: 'Query', calendlyPractitionerEventTypes: Array<{ __typename?: 'CalendlyPractitionerEventTypes', practitioner: { __typename?: 'PractitionerBasic', id: string, name: string, profileImageUrl?: string | null, role: ProviderUserRole }, eventTypes: Array<{ __typename?: 'CalendlyEventType', name?: string | null, color: string, calendlyEventTypeUri: string, isVisible: boolean, description?: string | null, duration?: number | null, schedulingUrl?: string | null, createdAt: any, updatedAt: any }> }> };

export type CalendlyProviderEventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendlyProviderEventTypesQuery = { __typename?: 'Query', calendlyProviderEventTypes: Array<{ __typename?: 'CalendlyProfile', name: string, ownerUri: string, eventTypes: Array<{ __typename?: 'CalendlyEventType', name?: string | null, color: string, calendlyEventTypeUri: string, isVisible: boolean, description?: string | null, duration?: number | null, schedulingUrl?: string | null, createdAt: any, updatedAt: any }> }> };

export type ServiceGroupDataFragment = { __typename?: 'ServiceGroup', id: string, name: string, displayOrder: number, services: Array<{ __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null }> };

export type ServiceGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceGroupsQuery = { __typename?: 'Query', serviceGroups: Array<{ __typename?: 'ServiceGroup', id: string, name: string, displayOrder: number, services: Array<{ __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null }> }> };

export type CreateServiceGroupMutationVariables = Exact<{
  input: CreateServiceGroupInput;
}>;


export type CreateServiceGroupMutation = { __typename?: 'Mutation', createServiceGroup: { __typename?: 'ServiceGroup', id: string, name: string, displayOrder: number, services: Array<{ __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null }> } };

export type UpdateServiceGroupMutationVariables = Exact<{
  input: UpdateServiceGroupInput;
}>;


export type UpdateServiceGroupMutation = { __typename?: 'Mutation', updateServiceGroup: { __typename?: 'ServiceGroup', id: string, name: string, displayOrder: number, services: Array<{ __typename?: 'ProviderService', id: string, isEnabled: boolean, isShownOnStorefront: boolean, patientAccessLevel: PatientAccessLevel, slug: string, name: string, serviceIcon: ServiceIcon, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, calendlyEventTypeUri?: string | null, serviceGroupId?: string | null, displayOrder: number, serviceTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, shortName: string, name: string } | null, assignedProviderUsers?: Array<{ __typename?: 'ProviderUserMember', id: string, name?: string | null, email: string, profileImageMedia?: { __typename?: 'Media', url: string } | null }> | null }> } };

export type DeleteServiceGroupMutationVariables = Exact<{
  serviceGroupId: Scalars['String']['input'];
}>;


export type DeleteServiceGroupMutation = { __typename?: 'Mutation', deleteServiceGroup: boolean };

export type ReorderServicesMutationVariables = Exact<{
  input: Array<ReorderServicesInput> | ReorderServicesInput;
}>;


export type ReorderServicesMutation = { __typename?: 'Mutation', reorderServices: boolean };

export type ReorderServiceGroupsMutationVariables = Exact<{
  input: Array<ReorderServiceGroupsInput> | ReorderServiceGroupsInput;
}>;


export type ReorderServiceGroupsMutation = { __typename?: 'Mutation', reorderServiceGroups: boolean };

export type ServiceIntakePackageQueryVariables = Exact<{
  serviceIntakePackageId: Scalars['String']['input'];
}>;


export type ServiceIntakePackageQuery = { __typename?: 'Query', serviceIntakePackage: { __typename?: 'ServiceIntakePackage', id: string, storefrontSlug: string, serviceSlug: string, serviceSubmissionRedirectUrl?: string | null, completedCalendlyBookingAt?: any | null, intakeFormProgramActivity?: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } | null, calendlyEventType?: { __typename?: 'CalendlyEventType', name?: string | null, description?: string | null, calendlyEventTypeUri: string, schedulingUrl?: string | null } | null } };

export type CompleteServiceCalendlyBookingMutationVariables = Exact<{
  serviceIntakePackageId: Scalars['String']['input'];
}>;


export type CompleteServiceCalendlyBookingMutation = { __typename?: 'Mutation', completeServiceCalendlyBooking: boolean };

export type CompleteServiceIntakeMutationVariables = Exact<{
  serviceIntakePackageId: Scalars['String']['input'];
}>;


export type CompleteServiceIntakeMutation = { __typename?: 'Mutation', completeServiceIntake: boolean };

export type ProviderStorefrontDataFragment = { __typename?: 'ProviderStorefront', slug: string, isEnabled: boolean, bannerImageUrl?: string | null, bannerPosition?: number | null, profileImageUrl?: string | null, roleTitle?: string | null, ctaFormLabel?: string | null, ctaButtonText?: string | null, tagline?: string | null, about?: string | null, services?: string | null, calendlyEventTypeUri?: string | null, intakeTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, type: AssessmentType, schemaType: AssessmentSchemaType, name: string, shortName: string } | null };

export type ProviderStorefrontQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderStorefrontQuery = { __typename?: 'Query', providerStorefront: { __typename?: 'ProviderStorefront', slug: string, isEnabled: boolean, bannerImageUrl?: string | null, bannerPosition?: number | null, profileImageUrl?: string | null, roleTitle?: string | null, ctaFormLabel?: string | null, ctaButtonText?: string | null, tagline?: string | null, about?: string | null, services?: string | null, calendlyEventTypeUri?: string | null, intakeTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, type: AssessmentType, schemaType: AssessmentSchemaType, name: string, shortName: string } | null } };

export type IntakePackageQueryVariables = Exact<{ [key: string]: never; }>;


export type IntakePackageQuery = { __typename?: 'Query', intakePackage: { __typename?: 'IntakePackage', storefrontSlug: string, completedStorefrontCalendlyBookingAt?: any | null, intakeFormProgramActivity?: { __typename?: 'ProgramActivity', id: string, name: string, activityType: ActivityType, sentAt: any, sentByName: string, sentByEmail?: string | null, completedAt?: any | null, dismissedAt?: any | null, seenAt?: any | null, providerNote?: string | null, isCompletable: boolean, isDraft?: boolean | null, isVoidable: boolean, voidedAt?: any | null, activityLink?: { __typename?: 'ActivityLink', id: string, url: string, title: string, activityUseType: ActivityUseType, thumbnailMedia?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null, activityAudio?: { __typename?: 'ActivityAudio', id: string, title: string, duration?: number | null, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityImage?: { __typename?: 'ActivityImage', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityPDF?: { __typename?: 'ActivityPDF', id: string, title: string, createdAt: any, activityUseType: ActivityUseType, media: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } } | null, activityText?: { __typename?: 'ActivityText', id: string, title: string, text: string, createdAt: any, activityUseType: ActivityUseType } | null, programAssessment?: { __typename?: 'ProgramAssessment', id: string, completedAt?: any | null, programAssessmentSignatureUsers?: Array<{ __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null }> | null, currentSigner?: { __typename?: 'ProgramAssessmentSignatureUser', id: string, orderIndex: number, patientName?: string | null, sentAt?: any | null, signedAt?: any | null, signatureName?: string | null, signatureRole?: string | null, providerUser?: { __typename?: 'ProviderUserMember', id: string, name?: string | null } | null, assessmentSignatureUser?: { __typename?: 'AssessmentSignatureUser', id: string, orderIndex: number, signatureUserType: SignatureUser } | null } | null, assessment: { __typename?: 'Assessment', id: string, schemaType: AssessmentSchemaType, type: AssessmentType, name: string, description: string, shortName: string } } | null, pdfSubmission?: { __typename?: 'PdfSubmission', id: string, linkToken?: string | null, media?: { __typename?: 'Media', id: string, url: string, fileName: string, category: string, isPdf?: boolean | null, isPdfEditable?: boolean | null, isDocument?: boolean | null, createdAt: any } | null } | null } | null, calendlyEventType?: { __typename?: 'CalendlyEventType', name?: string | null, description?: string | null, calendlyEventTypeUri: string, schedulingUrl?: string | null } | null } };

export type PublicStorefrontQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type PublicStorefrontQuery = { __typename?: 'Query', publicStorefront: { __typename?: 'PublicStorefront', providerName: string, profileImageUrl?: string | null, providerRoleTitle?: string | null, providerCtaFormLabel?: string | null, providerCtaButtonText?: string | null, bannerImageUrl?: string | null, bannerPosition?: number | null, tagline?: string | null, about?: string | null, services?: string | null, publicServices?: Array<{ __typename?: 'PublicProviderService', id: string, providerName: string, profileImageUrl?: string | null, providerRoleTitle?: string | null, storefrontEnabled: boolean, isShownOnStorefront: boolean, slug: string, name: string, serviceIcon: ServiceIcon, providerPrimaryColor?: string | null, providerSecondaryColor?: string | null, serviceIconColorUseCalendlyDefault?: boolean | null, calendlyEventColor?: string | null, description: string, patientAccessLevel: PatientAccessLevel, isPaid: boolean, price?: number | null, isPriceLabelShown: boolean, durationMinutes?: number | null, serviceSubmissionTitle?: string | null, serviceSubmissionBody?: string | null, serviceSubmissionRedirectUrl?: string | null, serviceGroupId?: string | null, serviceGroupName?: string | null }> | null } };

export type UpdateProviderStorefrontMutationVariables = Exact<{
  input: UpdateProviderStorefrontInput;
}>;


export type UpdateProviderStorefrontMutation = { __typename?: 'Mutation', updateProviderStorefront: { __typename?: 'ProviderStorefront', slug: string, isEnabled: boolean, bannerImageUrl?: string | null, bannerPosition?: number | null, profileImageUrl?: string | null, roleTitle?: string | null, ctaFormLabel?: string | null, ctaButtonText?: string | null, tagline?: string | null, about?: string | null, services?: string | null, calendlyEventTypeUri?: string | null, intakeTags?: Array<{ __typename?: 'ProgramTag', id: string, name: string, description: string, color: string }> | null, intakeFormAssessment?: { __typename?: 'Assessment', id: string, type: AssessmentType, schemaType: AssessmentSchemaType, name: string, shortName: string } | null } };

export type CompleteStorefrontCalendlyBookingMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteStorefrontCalendlyBookingMutation = { __typename?: 'Mutation', completeStorefrontCalendlyBooking: boolean };

export type CompleteStorefrontIntakeMutationVariables = Exact<{ [key: string]: never; }>;


export type CompleteStorefrontIntakeMutation = { __typename?: 'Mutation', completeStorefrontIntake: boolean };

export type StripeCheckoutPortalQueryVariables = Exact<{
  isOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  webRedirectPath?: InputMaybe<Scalars['String']['input']>;
  choseAnnual?: InputMaybe<Scalars['Boolean']['input']>;
  tierSelection?: InputMaybe<SubscriptionTierV2>;
  extraSeatCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StripeCheckoutPortalQuery = { __typename?: 'Query', stripeCheckoutPortal: { __typename?: 'StripeCheckoutPortal', url: string } };

export type StripeCustomerPortalQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeCustomerPortalQuery = { __typename?: 'Query', stripeCustomerPortal: { __typename?: 'StripeCustomerPortal', url: string } };

export type ProviderIsOnLegacyV2PricingQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderIsOnLegacyV2PricingQuery = { __typename?: 'Query', meProvider?: { __typename?: 'MeProvider', provider: { __typename?: 'Provider', isOnLegacyV2Pricing: boolean } } | null };

export type StripeCheckoutSuccessMutationVariables = Exact<{
  checkoutSessionId: Scalars['String']['input'];
}>;


export type StripeCheckoutSuccessMutation = { __typename?: 'Mutation', stripeCheckoutSuccess?: boolean | null };

export type UpdateStripeSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateStripeSubscriptionMutation = { __typename?: 'Mutation', updateStripeSubscription?: boolean | null };

export type ProgramTagDataFragment = { __typename?: 'ProgramTag', id: string, name: string, description: string, color: string };

export type ProgramTagWithCountDataFragment = { __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string };

export type AddProgramTagMutationVariables = Exact<{
  input: AddProgramTagInput;
}>;


export type AddProgramTagMutation = { __typename?: 'Mutation', addProgramTag: { __typename?: 'AddProgramTagResult', updatedProgramTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }> } };

export type RemoveProgramTagMutationVariables = Exact<{
  input: RemoveProgramTagInput;
}>;


export type RemoveProgramTagMutation = { __typename?: 'Mutation', removeProgramTag: { __typename?: 'RemoveProgramTagResult', updatedProgramTags: Array<{ __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string }> } };

export type CreateProgramTagMutationVariables = Exact<{
  input: ProgramTagInput;
}>;


export type CreateProgramTagMutation = { __typename?: 'Mutation', createProgramTag: { __typename?: 'ProgramTag', displayOrder: number, programCount: number, id: string, name: string, description: string, color: string } };

export type UpdateProgramTagMutationVariables = Exact<{
  input: UpdateProgramTagInput;
}>;


export type UpdateProgramTagMutation = { __typename?: 'Mutation', updateProgramTag: { __typename?: 'ProgramTag', id: string, name: string, description: string, color: string } };

export type DeleteProgramTagMutationVariables = Exact<{
  programTagId: Scalars['String']['input'];
}>;


export type DeleteProgramTagMutation = { __typename?: 'Mutation', deleteProgramTag: { __typename?: 'ProgramTag', id: string, name: string, description: string, color: string } };

export type ReorderProgramTagsMutationVariables = Exact<{
  input: Array<ReorderProgramTagInput> | ReorderProgramTagInput;
}>;


export type ReorderProgramTagsMutation = { __typename?: 'Mutation', reorderProgramTags: boolean };

export type ProviderSummaryQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
  input: ProviderSummaryInput;
}>;


export type ProviderSummaryQuery = { __typename?: 'Query', providerPerformanceSummary: { __typename?: 'ProviderSummary', totalSessions: { __typename?: 'MetricComparison', current: number, previous: number, changeInPercentage: number, changeInValue: number, direction: Direction, impact: Impact }, totalPractitioners: { __typename?: 'MetricComparison', current: number, previous: number, changeInPercentage: number, changeInValue: number, direction: Direction, impact: Impact }, totalClients: { __typename?: 'MetricComparison', current: number, previous: number, changeInPercentage: number, changeInValue: number, direction: Direction, impact: Impact }, averageResponseTime: { __typename?: 'MetricComparison', current: number, previous: number, changeInPercentage: number, changeInValue: number, direction: Direction, impact: Impact }, averageTimeToFirstResponse: { __typename?: 'MetricComparison', current: number, previous: number, changeInPercentage: number, changeInValue: number, direction: Direction, impact: Impact } } };

export type PractitionerAssignmentsQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type PractitionerAssignmentsQuery = { __typename?: 'Query', practitionerAssignments: Array<{ __typename?: 'PractitionerAssignments', practitioner: { __typename?: 'PractitionerBasic', id: string, name: string, role: ProviderUserRole, profileImageUrl?: string | null }, assignedClients: Array<{ __typename?: 'AssignedClient', id: string, name: string, profileImageUrl?: string | null, latestProgramId: string, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string }> }> }> };

export type ClientsPerformanceSummaryQueryVariables = Exact<{
  input: ClientsPerformanceSummaryInput;
}>;


export type ClientsPerformanceSummaryQuery = { __typename?: 'Query', clientsPerformanceSummary: { __typename?: 'ClientsPerformanceSummaryResponse', totals: { __typename?: 'ClientPerformanceMetrics', totalAlerts?: number | null, totalSessions?: number | null, averageResponseTime?: number | null, averageTimeToFirstResponse?: number | null }, clients: Array<{ __typename?: 'ClientPerformanceSummary', id: string, name: string, startedAt: any, tags: Array<{ __typename?: 'ProgramTag', id: string, name: string, color: string }>, metrics: { __typename?: 'ClientPerformanceMetrics', totalAlerts?: number | null, totalSessions?: number | null, averageResponseTime?: number | null, averageTimeToFirstResponse?: number | null } }> } };

export type TeamPerformanceInsightsMetricsQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
  input: TeamPerformanceInsightsMetricsInput;
}>;


export type TeamPerformanceInsightsMetricsQuery = { __typename?: 'Query', teamPerformanceInsightsMetrics: { __typename?: 'TeamPerformanceInsightsMetrics', rangeStart?: any | null, rangeEnd: any, timezone: string, sessionsBooked: { __typename?: 'TeamPerformanceInsightsMetricValue', value: number }, newClients: { __typename?: 'TeamPerformanceInsightsMetricValue', value: number } } };

export type GetHandPickedLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHandPickedLanguagesQuery = { __typename?: 'Query', handPickedLanguages: Array<string> };

export type GetLanguagesQueryVariables = Exact<{
  filterQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLanguagesQuery = { __typename?: 'Query', languages: Array<string> };

export type GetHandPickedTimezonesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHandPickedTimezonesQuery = { __typename?: 'Query', handPickedTimezones: Array<{ __typename?: 'Timezone', value: string, offset: string }> };

export type GetTimezonesQueryVariables = Exact<{
  filterQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTimezonesQuery = { __typename?: 'Query', timezones: Array<{ __typename?: 'Timezone', value: string, offset: string }> };

export type GetReferralSourcesQueryVariables = Exact<{
  filterQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReferralSourcesQuery = { __typename?: 'Query', referralSources: Array<string> };

export type GetHandPickedCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHandPickedCountriesQuery = { __typename?: 'Query', handPickedCountries: Array<string> };

export type GetCountriesQueryVariables = Exact<{
  filterQuery?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCountriesQuery = { __typename?: 'Query', countries: Array<string> };

export const MediaDataFragmentDoc = gql`
    fragment mediaData on Media {
  id
  url
  fileName
  category
  isPdf
  isPdfEditable
  isDocument
  createdAt
}
    `;
export const ActivityListDataFragmentDoc = gql`
    fragment activityListData on Activity {
  id
  activityType
  providerCollectionIds
  ... on ActivityLink {
    createdAt
    url
    title
    thumbnailMedia {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityAudio {
    createdAt
    title
    duration
    media {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityImage {
    createdAt
    title
    media {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityPDF {
    createdAt
    title
    media {
      ...mediaData
    }
    completionType
    activityUseType
  }
  ... on ActivityText {
    createdAt
    title
    text
    activityUseType
  }
  ... on ActivityAssessment {
    id
    activityType
    providerCollectionIds
    assessment {
      id
      createdAt
      schemaType
      type
      shortName
      name
      category
      oneTimeAssessment
      completableByProviderOnly
      description
      estimatedLengthInMinutes
      scoreRange {
        min
        max
      }
      scoreRanges {
        min
        max
        categorization
        color
      }
      assessmentSignatureUsers {
        id
        signatureUserType
        orderIndex
      }
    }
  }
}
    ${MediaDataFragmentDoc}`;
export const EssentialAssessmentDataFragmentDoc = gql`
    fragment essentialAssessmentData on Assessment {
  id
  schemaType
  type
  shortName
  name
}
    `;
export const BasicAssessmentDataFragmentDoc = gql`
    fragment basicAssessmentData on Assessment {
  ...essentialAssessmentData
  description
  category
  oneTimeAssessment
  scoreRange {
    min
    max
  }
  scoreRanges {
    min
    max
    categorization
    color
  }
}
    ${EssentialAssessmentDataFragmentDoc}`;
export const AssessmentDataFragmentDoc = gql`
    fragment assessmentData on Assessment {
  ...basicAssessmentData
  moreInfoLink
  providerInterpretation
  questionFrame
  instructions
  completableByProviderOnly
  assessmentSignatureUsers {
    signatureUserType
    orderIndex
  }
}
    ${BasicAssessmentDataFragmentDoc}`;
export const AssessmentQuestionDataFragmentDoc = gql`
    fragment assessmentQuestionData on AssessmentQuestion {
  questionType
  ... on MultipleChoiceScoredAssessmentQuestion {
    isRequired
    question
    subscale
    answerOptions {
      answerOption
      score
    }
  }
  ... on MultipleChoiceAssessmentQuestion {
    isRequired
    question
    answerOptions {
      answerOption
    }
  }
  ... on MultiSelectAssessmentQuestion {
    isRequired
    question
    answerOptions {
      answerOption
    }
  }
  ... on ConditionalMultipleChoiceAssessmentQuestion {
    isRequired
    question
    answerOptions {
      answerOption
    }
    followUpWhen
    followUp {
      question
      answerOptions {
        answerOption
      }
    }
  }
  ... on FreeTextAssessmentQuestion {
    isRequired
    question
  }
  ... on RichTextAssessmentQuestion {
    isRequired
    question
  }
  ... on StatementAssessmentQuestion {
    isRequired
    question
  }
  ... on InitialsAssessmentQuestion {
    isRequired
    question
  }
  ... on SignatureAssessmentQuestion {
    isRequired
    question
  }
  ... on MultiSignatureAssessmentQuestion {
    isRequired
    question
    assessmentSignatureOrderIndices
    assessmentSignatureUsers {
      id
      signatureUserType
      orderIndex
    }
    existingSignatures {
      signatureName
      signedAt
      signingIpAddress
      signatureRole
    }
  }
  ... on ProviderSignatureAssessmentQuestion {
    isRequired
    question
  }
  ... on FileUploadAssessmentQuestion {
    isRequired
    question
    allowedExtensions
  }
  ... on AutofillAssessmentQuestion {
    isRequired
    question
    autofillSource
    autofillValue
  }
  ... on DatePickerAssessmentQuestion {
    isRequired
    question
    defaultToToday
  }
  ... on PatientContactAssessmentQuestion {
    isRequired
    question
    contactType
  }
}
    `;
export const AssessmentOnProgramAssessmentDataFragmentDoc = gql`
    fragment assessmentOnProgramAssessmentData on Assessment {
  ...assessmentData
  questions {
    ...assessmentQuestionData
  }
}
    ${AssessmentDataFragmentDoc}
${AssessmentQuestionDataFragmentDoc}`;
export const AssessmentAnswerDataFragmentDoc = gql`
    fragment assessmentAnswerData on AssessmentAnswer {
  questionType
  ... on MultipleChoiceScoredAssessmentAnswer {
    question
    subscale
    answer
  }
  ... on MultipleChoiceAssessmentAnswer {
    question
    answer
  }
  ... on MultiSelectAssessmentAnswer {
    question
    answers
  }
  ... on FreeTextAssessmentAnswer {
    question
    answer
  }
  ... on RichTextAssessmentAnswer {
    question
    answer
  }
  ... on InitialsAssessmentAnswer {
    question
    signatureName
    signedAt
    signingIpAddress
  }
  ... on SignatureAssessmentAnswer {
    question
    signatureName
    signedAt
    signingIpAddress
  }
  ... on ProviderSignatureAssessmentAnswer {
    question
    signatureName
    signedAt
    signingIpAddress
    signatureRole
  }
  ... on MultiSignatureAssessmentAnswer {
    question
    signatures {
      signingIpAddress
      signedAt
      signatureName
      signatureRole
    }
  }
  ... on FileUploadAssessmentAnswer {
    question
    fileName
    mediaId
    mediaUrl
  }
  ... on PatientContactAssessmentAnswer {
    question
    contactId
    newContactDraftJson
    contactSnapshot {
      firstName
      lastName
      email
      phoneNumber
      contactType
      relationshipDescription
      addressStreet
      addressCity
      addressState
      addressPostalCode
      addressCountry
    }
  }
}
    `;
export const ProgramAssessmentDataFragmentDoc = gql`
    fragment programAssessmentData on ProgramAssessment {
  id
  startDate
  completedAt
  additionalThoughts
  patientNameData {
    programInstanceId
    name
    profileImageMedia {
      url
    }
  }
  assessment {
    ...assessmentOnProgramAssessmentData
  }
  completionData {
    schemaType
    ... on MultipleChoiceSumScoredAssessmentCompletionData {
      score
      categorization
      color
    }
    ... on HADSAssessmentCompletionData {
      subscores {
        score
        color
        categorization
      }
    }
    ... on ASRS19AssessmentCompletionData {
      subscores {
        score
        color
        categorization
      }
    }
    ... on CBIAssessmentCompletionData {
      subscores {
        subscale
        score
        color
        categorization
      }
    }
  }
  answers {
    ...assessmentAnswerData
    ... on AutofillAssessmentAnswer {
      question
      autofillAnswer: answer
    }
    ... on DatePickerAssessmentAnswer {
      question
      datePickerAnswer: answer
    }
  }
  draftAnswers {
    ...assessmentAnswerData
    ... on AutofillAssessmentAnswer {
      question
      autofillAnswer: answer
    }
    ... on DatePickerAssessmentAnswer {
      question
      datePickerAnswer: answer
    }
  }
  draftProviderSignatureName
  draftProviderSignatureRole
  draftSignatureTermsAgreed
}
    ${AssessmentOnProgramAssessmentDataFragmentDoc}
${AssessmentAnswerDataFragmentDoc}`;
export const UnsignedFormDataFragmentDoc = gql`
    fragment unsignedFormData on ProgramAssessment {
  id
  assessment {
    name
  }
  patientNameData {
    programInstanceId
    name
    profileImageMedia {
      url
    }
  }
}
    `;
export const AutomationRuleDataFragmentDoc = gql`
    fragment automationRuleData on AutomationRule {
  id
  automationRuleId
  name
  description
  enabled
  triggerEvent
  triggerConfig
  conditions {
    logic
    rules {
      field
      operator
      value
    }
  }
  actions {
    type
    params {
      key
      value
    }
  }
  priority
  createdBy
  createdAt
  updatedAt
  lastTriggeredAt
  triggerCount
  successCount
  failureCount
}
    `;
export const NylasCalendarDataFragmentDoc = gql`
    fragment nylasCalendarData on NylasCalendar {
  id
  name
  email
  description
  hexColor
  isPrimary
  readOnly
  timezone
}
    `;
export const NylasRoomResourceDataFragmentDoc = gql`
    fragment nylasRoomResourceData on NylasRoomResource {
  id
  name
  email
  calendarId
  building
  capacity
  floorName
  floorNumber
  floorSection
  hexColor
}
    `;
export const NylasCalendarEventDataFragmentDoc = gql`
    fragment nylasCalendarEventData on NylasCalendarEvent {
  id
  calendarId
  busy
  readOnly
  when {
    ... on CommonWhenTime {
      type
      time
      timezone
    }
    ... on CommonWhenTimespan {
      type
      startTime
      endTime
      startTimezone
      endTimezone
    }
    ... on CommonWhenDate {
      type
      date
    }
    ... on CommonWhenDatespan {
      type
      startDate
      endDate
    }
  }
  title
  description
  location
  htmlLink
  status
  recurrence
  visibility
  organizer {
    email
    name
  }
  participants {
    email
    name
    status
    phoneNumber
    comment
  }
  resources {
    email
    name
  }
}
    `;
export const ClientFileDataFragmentDoc = gql`
    fragment clientFileData on ClientFile {
  id
  name
  createdAt
  externalCompleterName
  media {
    id
    url
    fileName
    isPdf
    isDocument
  }
}
    `;
export const ClientSessionBaseFieldsFragmentDoc = gql`
    fragment clientSessionBaseFields on ClientSessionBase {
  id
  title
  description
  startTime
  endTime
  reviewStatus
  source
  practitioners {
    id
    name
    profileImageMedia {
      url
    }
  }
  provider {
    id
    name
  }
  createdByProviderUser {
    id
    email
    name
  }
  createdAt
  updatedAt
}
    `;
export const ClientSessionIndividualFieldsFragmentDoc = gql`
    fragment clientSessionIndividualFields on ClientSessionIndividual {
  ...clientSessionBaseFields
  participant {
    id
    email
    name
    firstName
    lastName
    profileImageMedia {
      url
    }
  }
}
    ${ClientSessionBaseFieldsFragmentDoc}`;
export const ClientSessionGroupFieldsFragmentDoc = gql`
    fragment clientSessionGroupFields on ClientSessionGroup {
  ...clientSessionBaseFields
  participants {
    id
    email
    name
    firstName
    lastName
    profileImageMedia {
      url
    }
  }
}
    ${ClientSessionBaseFieldsFragmentDoc}`;
export const ClientSessionFieldsFragmentDoc = gql`
    fragment clientSessionFields on ClientSession {
  ... on ClientSessionIndividual {
    ...clientSessionIndividualFields
  }
  ... on ClientSessionGroup {
    ...clientSessionGroupFields
  }
}
    ${ClientSessionIndividualFieldsFragmentDoc}
${ClientSessionGroupFieldsFragmentDoc}`;
export const ProviderCollectionDataFragmentDoc = gql`
    fragment providerCollectionData on ProviderCollection {
  id
  name
  createdAt
  updatedAt
}
    `;
export const ProviderUserMembershipFieldsFragmentDoc = gql`
    fragment ProviderUserMembershipFields on ProviderUserMembership {
  id
  provider {
    id
    name
  }
  providerUser {
    id
    email
  }
  role
  patientDataPermission
  isExternalCollaborator
  isPrimaryProvider
  status
  accessExpiresAt
  invitedAt
  invitationExpiresAt
  activatedAt
  deactivatedAt
  createdAt
  updatedAt
  invitedBy {
    id
    email
  }
}
    `;
export const ProviderFieldsFragmentDoc = gql`
    fragment ProviderFields on Provider {
  id
  name
  squareLogoMedia {
    url
  }
}
    `;
export const BasicFollowUpDataFragmentDoc = gql`
    fragment basicFollowUpData on ProgramFollowUp {
  id
  programId
  isDraft
  subject
  providerNote
  createdAt
  unreadCommentCount
  isIntake
  isEdited
  messageEditedAt
  canEditMessage
}
    `;
export const BasicProgramActivityDataFragmentDoc = gql`
    fragment basicProgramActivityData on ProgramActivity {
  id
}
    `;
export const PatientCardFollowUpDataFragmentDoc = gql`
    fragment patientCardFollowUpData on ProgramFollowUp {
  ...basicFollowUpData
  providerVoiceNote {
    id
    duration
  }
  commentCount
  programActivities {
    ...basicProgramActivityData
  }
}
    ${BasicFollowUpDataFragmentDoc}
${BasicProgramActivityDataFragmentDoc}`;
export const VoiceNoteDataFragmentDoc = gql`
    fragment voiceNoteData on VoiceNote {
  id
  duration
  media {
    url
  }
}
    `;
export const CommentDataFragmentDoc = gql`
    fragment commentData on Comment {
  id
  authorUserType
  authorPatientId
  authorProviderUserId
  sentByName
  sentByProfileImageUrl
  createdAt
  text
  voiceNote {
    ...voiceNoteData
  }
  imageMedia {
    url
  }
}
    ${VoiceNoteDataFragmentDoc}`;
export const ProgramAssessmentSignatureUserDataFragmentDoc = gql`
    fragment programAssessmentSignatureUserData on ProgramAssessmentSignatureUser {
  id
  orderIndex
  providerUser {
    id
    name
  }
  patientName
  sentAt
  signedAt
  signatureName
  signatureRole
  assessmentSignatureUser {
    id
    orderIndex
    signatureUserType
  }
}
    `;
export const ProgramActivityDataFragmentDoc = gql`
    fragment programActivityData on ProgramActivity {
  id
  name
  activityType
  sentAt
  sentByName
  sentByEmail
  completedAt
  dismissedAt
  seenAt
  providerNote
  isCompletable
  isDraft
  isVoidable
  voidedAt
  activityLink {
    id
    url
    title
    thumbnailMedia {
      ...mediaData
    }
    activityUseType
  }
  activityAudio {
    id
    title
    duration
    media {
      ...mediaData
    }
    activityUseType
  }
  activityImage {
    id
    title
    media {
      ...mediaData
    }
    createdAt
    activityUseType
  }
  activityPDF {
    id
    title
    media {
      ...mediaData
    }
    createdAt
    activityUseType
  }
  activityText {
    id
    title
    text
    createdAt
    activityUseType
  }
  programAssessment {
    id
    completedAt
    programAssessmentSignatureUsers {
      ...programAssessmentSignatureUserData
    }
    currentSigner {
      ...programAssessmentSignatureUserData
    }
    assessment {
      id
      schemaType
      type
      name
      description
      shortName
    }
  }
  pdfSubmission {
    id
    media {
      ...mediaData
    }
    linkToken
  }
}
    ${MediaDataFragmentDoc}
${ProgramAssessmentSignatureUserDataFragmentDoc}`;
export const FollowUpDataFragmentDoc = gql`
    fragment followUpData on ProgramFollowUp {
  ...basicFollowUpData
  providerVoiceNote {
    ...voiceNoteData
  }
  sentByName
  sentByEmail
  sentByProfileImageUrl
  commentCount
  comments {
    ...commentData
  }
  programActivities {
    ...programActivityData
  }
}
    ${BasicFollowUpDataFragmentDoc}
${VoiceNoteDataFragmentDoc}
${CommentDataFragmentDoc}
${ProgramActivityDataFragmentDoc}`;
export const FollowUpTemplatePickerItemFragmentDoc = gql`
    fragment followUpTemplatePickerItem on FollowUpTemplate {
  id
  name
  subject
  isDraft
  providerNote
  createdAt
  updatedAt
  providerVoiceNote {
    duration
  }
  activityTemplates {
    activityType
  }
}
    `;
export const PatientNameDataFragmentDoc = gql`
    fragment patientNameData on PatientName {
  id
  firstName
  lastName
  name
  email
  programInstanceId
  createdAt
  isTestProgram
  programStartDate
  programEndDate
  profileImageMedia {
    url
  }
}
    `;
export const ProgramTagDataFragmentDoc = gql`
    fragment programTagData on ProgramTag {
  id
  name
  description
  color
}
    `;
export const ProgramTagWithCountDataFragmentDoc = gql`
    fragment programTagWithCountData on ProgramTag {
  ...programTagData
  displayOrder
  programCount
}
    ${ProgramTagDataFragmentDoc}`;
export const ActivityDataFragmentDoc = gql`
    fragment activityData on Activity {
  id
  activityType
  providerCollectionIds
  ... on ActivityLink {
    createdAt
    url
    title
    thumbnailMedia {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityAudio {
    createdAt
    title
    duration
    media {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityImage {
    createdAt
    title
    media {
      ...mediaData
    }
    activityUseType
  }
  ... on ActivityPDF {
    createdAt
    title
    media {
      ...mediaData
    }
    completionType
    activityUseType
  }
  ... on ActivityText {
    createdAt
    title
    text
    activityUseType
  }
  ... on ActivityAssessment {
    id
    activityType
    providerCollectionIds
    assessment {
      id
      createdAt
      schemaType
      description
      type
      shortName
      name
      category
      oneTimeAssessment
      scoreRange {
        min
        max
      }
      scoreRanges {
        min
        max
        categorization
        color
      }
      moreInfoLink
      providerInterpretation
      questionFrame
      instructions
      estimatedLengthInMinutes
      assessmentSignatureUsers {
        id
        signatureUserType
        orderIndex
      }
      completableByProviderOnly
      questions {
        ...assessmentQuestionData
      }
    }
  }
}
    ${MediaDataFragmentDoc}
${AssessmentQuestionDataFragmentDoc}`;
export const ActivityTemplateDataFragmentDoc = gql`
    fragment activityTemplateData on ActivityTemplate {
  activityType
  name
  providerNote
  activity {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export const FollowUpTemplateDataFragmentDoc = gql`
    fragment followUpTemplateData on FollowUpTemplate {
  id
  name
  subject
  isDraft
  patients {
    ...patientNameData
  }
  programTags {
    ...programTagWithCountData
  }
  providerNote
  providerVoiceNote {
    ...voiceNoteData
  }
  activityTemplates {
    ...activityTemplateData
  }
  createdAt
  updatedAt
}
    ${PatientNameDataFragmentDoc}
${ProgramTagWithCountDataFragmentDoc}
${VoiceNoteDataFragmentDoc}
${ActivityTemplateDataFragmentDoc}`;
export const ProgramInvoiceDataFragmentDoc = gql`
    fragment programInvoiceData on ProgramInvoice {
  id
  createdAt
  dueAt
  status
  amount
  currency
  stripeInvoiceId
  stripeInvoiceUrl
  stripeInvoicePdfUrl
  stripeInvoiceNumber
  archivedAt
  createdByProviderUser {
    id
    name
    email
    profileImageMedia {
      url
    }
  }
  patient {
    name
    email
    profileImageMedia {
      url
    }
  }
}
    `;
export const MailSequenceEnrollmentActivityDataFragmentDoc = gql`
    fragment mailSequenceEnrollmentActivityData on MailSequenceEnrollmentActivity {
  activityType
  title
  subtitle
  providerNote
  isCompletable
  isAvailable
  unavailableReason
  signerCount
}
    `;
export const MailSequenceScheduledSendDataFragmentDoc = gql`
    fragment mailSequenceScheduledSendData on MailSequenceScheduledSend {
  id
  enrollmentId
  stepIndex
  scheduledDate
  subject
  providerNote
  status
  programFollowUpId
  sentAt
  failureReason
  skipReason
  attemptCount
  hasActivityOverride
  activities {
    ...mailSequenceEnrollmentActivityData
  }
}
    ${MailSequenceEnrollmentActivityDataFragmentDoc}`;
export const MailSequenceEnrollmentDataFragmentDoc = gql`
    fragment mailSequenceEnrollmentData on MailSequenceEnrollment {
  id
  providerId
  programId
  templateId
  name
  enrolledByProviderUserId
  referenceDateType
  referenceDate
  snapshotVersion
  providerVoiceNoteId
  defaultSendTime
  sendEmail
  sendSms
  status
  sourceFollowUpTemplateId
  isIntake
  cancelledAt
  cancelledByProviderUserId
  createdAt
  updatedAt
  scheduledSends {
    ...mailSequenceScheduledSendData
  }
  activities {
    ...mailSequenceEnrollmentActivityData
  }
}
    ${MailSequenceScheduledSendDataFragmentDoc}
${MailSequenceEnrollmentActivityDataFragmentDoc}`;
export const MailSequenceSnapshotActivityDataFragmentDoc = gql`
    fragment mailSequenceSnapshotActivityData on MailSequenceSnapshotActivity {
  activityType
  providerNote
  assessmentId
  activityAudioId
  activityImageId
  activityLinkId
  activityPdfId
  activityTextId
  isCompletable
  programAssessmentSignatureUsers {
    assessmentSignatureUserId
    providerUserId
  }
}
    `;
export const MailSequenceTemplateStepDataFragmentDoc = gql`
    fragment mailSequenceTemplateStepData on MailSequenceTemplateStep {
  id
  sortOrder
  offsetDays
  subject
  providerNote
  hasActivityOverride
  sourceFollowUpTemplateId
  activities {
    ...mailSequenceEnrollmentActivityData
  }
  activityInputs {
    ...mailSequenceSnapshotActivityData
  }
}
    ${MailSequenceEnrollmentActivityDataFragmentDoc}
${MailSequenceSnapshotActivityDataFragmentDoc}`;
export const MailSequenceTemplateDataFragmentDoc = gql`
    fragment mailSequenceTemplateData on MailSequenceTemplate {
  id
  providerId
  name
  referenceDateType
  defaultSendTime
  createdByProviderUserId
  createdAt
  updatedAt
  hasDefaultActivities
  defaultActivities {
    ...mailSequenceEnrollmentActivityData
  }
  defaultActivityInputs {
    ...mailSequenceSnapshotActivityData
  }
  steps {
    ...mailSequenceTemplateStepData
  }
}
    ${MailSequenceEnrollmentActivityDataFragmentDoc}
${MailSequenceSnapshotActivityDataFragmentDoc}
${MailSequenceTemplateStepDataFragmentDoc}`;
export const MailSequenceClientPreviewDataFragmentDoc = gql`
    fragment mailSequenceClientPreviewData on MailSequenceClientPreview {
  programId
  referenceDate
  error
  steps {
    stepIndex
    offsetDays
    scheduledDate
    willBeSkippedAtEnroll
    skipReason
  }
}
    `;
export const ProgramNoteDataFragmentDoc = gql`
    fragment programNoteData on ProgramNote {
  id
  createdAt
  updatedAt
  title
  note
  isPinnedNote
  isLocked
  lockedAt
  lockedByProviderUser {
    id
    name
    email
  }
  canLockUnlock
  canDelete
  createdByProviderUser {
    name
    profileImageMedia {
      url
    }
  }
}
    `;
export const BasicProviderNoteTemplateDataFragmentDoc = gql`
    fragment basicProviderNoteTemplateData on ProviderNoteTemplate {
  id
  title
  isSharedNoteTemplate
  createdByProviderUser {
    id
    name
    profileImageMedia {
      url
    }
  }
}
    `;
export const ProviderNoteTemplateDataFragmentDoc = gql`
    fragment providerNoteTemplateData on ProviderNoteTemplate {
  id
  title
  note
  isSharedNoteTemplate
  createdByProviderUser {
    id
    name
    profileImageMedia {
      url
    }
  }
}
    `;
export const MePatientDataFragmentDoc = gql`
    fragment mePatientData on Patient {
  id
  programInstanceId
  email
  firstName
  lastName
  name
  phoneNumber
  isTestProgram
  profileImageMedia {
    url
  }
  createdAt
  registeredAt
  fromStorefront
  completedStorefrontIntakeAt
  hasCalendlyIntegration
  providerAllowsPortalServiceBooking
  providerAllowsPortalCalendlyBooking
  providerAllowsPortalAssessmentTrends
  providerName
  providerTimezone
  providerStorefrontSlug
  providerPrimaryColor
  providerSecondaryColor
  providerSquareLogo {
    url
  }
  assignedProviderUsers {
    id
    name
    email
    isExternalCollaborator
    patientDataPermission
    role
    profileImageMedia {
      url
    }
  }
  participantId
  dateOfBirth
  age
  addressStreet
  addressCity
  addressState
  addressPostalCode
  addressCountry
  preferredLanguage
  timezone
  referralSource
  contacts {
    id
    patientId
    firstName
    lastName
    email
    phoneNumber
    contactType
    relationshipDescription
    addressStreet
    addressCity
    addressState
    addressPostalCode
    addressCountry
    createdAt
    updatedAt
  }
}
    `;
export const PatientTableDataFragmentDoc = gql`
    fragment patientTableData on Patient {
  id
  programInstanceId
  email
  name
  firstName
  lastName
  phoneNumber
  isTestProgram
  profileImageMedia {
    url
  }
  deactivatedAt
  startTime
  endTime
  createdAt
  registeredAt
  lastSeenAt
  fromStorefront
  onboardingLastProgramInviteSentAt
  completedStorefrontIntakeAt
  assignedProviderUsers {
    id
    name
    email
    isExternalCollaborator
    patientDataPermission
    role
    profileImageMedia {
      url
    }
  }
  tags {
    ...programTagData
  }
  aggregateUnreadCommentCount
  latestUnreadCommentAt
  participantId
  programStartDate
  programEndDate
}
    ${ProgramTagDataFragmentDoc}`;
export const PatientContactDataFragmentDoc = gql`
    fragment patientContactData on PatientContact {
  id
  patientId
  firstName
  lastName
  email
  phoneNumber
  contactType
  relationshipDescription
  addressStreet
  addressCity
  addressState
  addressPostalCode
  addressCountry
  createdAt
  updatedAt
}
    `;
export const BookableProviderServiceDataFragmentDoc = gql`
    fragment bookableProviderServiceData on BookableProviderService {
  id
  slug
  name
  description
  serviceIcon
  serviceIconColorUseCalendlyDefault
  calendlyEventColor
  isPaid
  price
  isPriceLabelShown
  durationMinutes
  hasCalendlyEvent
  hasIntakeForm
  displayOrder
  serviceGroupId
  serviceGroupName
}
    `;
export const ProviderProgramMediaDataFragmentDoc = gql`
    fragment providerProgramMediaData on ProviderProgramMedia {
  id
  name
  media {
    ...mediaData
  }
  createdAt
  createdByProviderUser {
    name
  }
}
    ${MediaDataFragmentDoc}`;
export const PatientLeadDataFragmentDoc = gql`
    fragment patientLeadData on Patient {
  id
  programInstanceId
  email
  firstName
  lastName
  name
  phoneNumber
  isTestProgram
  profileImageMedia {
    url
  }
  aggregateUnreadCommentCount
  unreadCommentCount
  latestCompletedActivity {
    activityType
    name
    completedAt
    programAssessment {
      assessment {
        schemaType
      }
    }
  }
  latestUnreadComment {
    createdAt
  }
  onboardingStatus
  onboardingLastProgramInviteSentAt
  onboardingCompletedAt
  firstAppointmentAt
  createdAt
  programTemplate {
    id
    name
    status
    programLengthInMonths
    programTemplateAssessments {
      assessment {
        type
        shortName
      }
    }
  }
  tags {
    ...programTagData
  }
  fromStorefront
  lastSeenAt
  contacts {
    id
    patientId
    firstName
    lastName
    email
    phoneNumber
    contactType
    relationshipDescription
    addressStreet
    addressCity
    addressState
    addressPostalCode
    addressCountry
    createdAt
    updatedAt
  }
}
    ${ProgramTagDataFragmentDoc}`;
export const BasicProviderUserMemberDataFragmentDoc = gql`
    fragment basicProviderUserMemberData on ProviderUserMember {
  id
  name
  email
  isExternalCollaborator
  patientDataPermission
  role
  profileImageMedia {
    url
  }
}
    `;
export const PatientDataFragmentDoc = gql`
    fragment patientData on Patient {
  ...patientLeadData
  deactivatedAt
  startTime
  endTime
  programStartDate
  programEndDate
  assignedProviderUsers {
    ...basicProviderUserMemberData
  }
  checkInData {
    last7DaysAverage
    last7DaysAverageDifference
    last7DaysCheckInsCount
    last7DaysCheckInsCountDifference
    totalCheckIns
    lastCheckIn {
      score
      createdAt
    }
    recent3CheckIns {
      score
      createdAt
    }
  }
  tasksData {
    completedContentCount
    availableContentCount
    journalEntriesCount
    activitiesCount
    contentCompletedPercentage
    completedContentPercentage
    recent3Tasks {
      taskType
      title
      createdAt
    }
  }
  participantId
  dateOfBirth
  age
  addressStreet
  addressCity
  addressState
  addressPostalCode
  addressCountry
  preferredLanguage
  timezone
  referralSource
  providerWordmarkLogo {
    url
  }
  contacts {
    id
    patientId
    firstName
    lastName
    email
    phoneNumber
    contactType
    relationshipDescription
    addressStreet
    addressCity
    addressState
    addressPostalCode
    addressCountry
    createdAt
    updatedAt
  }
}
    ${PatientLeadDataFragmentDoc}
${BasicProviderUserMemberDataFragmentDoc}`;
export const PublicProviderServiceDataFragmentDoc = gql`
    fragment publicProviderServiceData on PublicProviderService {
  id
  providerName
  profileImageUrl
  providerRoleTitle
  storefrontEnabled
  isShownOnStorefront
  slug
  name
  serviceIcon
  providerPrimaryColor
  providerSecondaryColor
  serviceIconColorUseCalendlyDefault
  calendlyEventColor
  description
  patientAccessLevel
  isPaid
  price
  isPriceLabelShown
  durationMinutes
  serviceSubmissionTitle
  serviceSubmissionBody
  serviceSubmissionRedirectUrl
  serviceGroupId
  serviceGroupName
}
    `;
export const NotificationDataFragmentDoc = gql`
    fragment notificationData on ProviderUserNotification {
  id
  type
  createdAt
  readAt
  archivedNotification
  ... on ProviderUserNotificationFormNeedsProviderSignature {
    formName
    programAssessmentId
    patientName
    patientProfileImageMedia {
      id
      url
    }
  }
  ... on ProviderUserNotificationPatientAssignment {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
  }
  ... on ProviderUserNotificationStorefrontSignUp {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
  }
  ... on ProviderUserNotificationActivation {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
  }
  ... on ProviderUserNotificationActivityCompleted {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
    programActivityId
    activityType
    activityName
  }
  ... on ProviderUserNotificationAssessmentCompleted {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
    programActivityId
    assessmentSchemaType
    assessmentName
  }
  ... on ProviderUserNotificationComment {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
    programFollowUpId
    programFollowUpCreatedAt
  }
  ... on ProviderUserNotificationInvoicePaid {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
    programInvoiceId
    programInvoiceAmount
    programInvoiceCurrency
  }
  ... on ProviderUserNotificationSessionBooked {
    programId
    patientName
    patientProfileImageMedia {
      id
      url
    }
    calendlyEventTypeName
  }
  ... on ProviderUserNotificationPendingProviderMembership {
    invitedByProviderName
    invitedByProviderSquareLogoMedia {
      url
    }
    invitedByName
    role
    seatType
    membershipId
    membershipStatus
  }
}
    `;
export const MeProviderDataFragmentDoc = gql`
    fragment meProviderData on MeProvider {
  id
  isExternalCollaborator
  primaryColor
  secondaryColor
  supportEmail
  squareLogoMedia {
    url
  }
  wordmarkLogoMedia {
    url
  }
  emailImageMedia {
    url
  }
  email
  name
  role
  patientDataPermission
  jobTitle
  hasSentFollowUps
  profileImageMedia {
    url
  }
  hasPremiumAccess
  isProviderSubscribed
  hasBeenSubscribed
  hasCreatedAProviderService
  isTrialing
  trialEndsAt
  onboardingCompletedAt
  provider {
    id
    name
    timezone
    logo
    isTestProvider
    subscriptionTierV2
    subscriptionEndsAt
    clientPortalBookServicesEnabled
    clientPortalBookCalendlyEnabled
    clientPortalAssessmentTrendsEnabled
    calendlyIntegration {
      id
      lookBackUntil
      isEnabled
      connectedByProviderUser {
        name
        profileImageMedia {
          url
        }
      }
    }
    stripeAccountId
    ownerProfileImageMedia {
      url
    }
    seatUsage {
      clientSeats
      staffSeats
      collaboratorSeats
      usedClientSeats
      usedStaffSeats
      usedCollaboratorSeats
      remainingClientSeats
      remainingStaffSeats
      remainingCollaboratorSeats
    }
  }
  notifications {
    ...notificationData
  }
  isV2
  signUpConfig {
    slug
    isCommunityHub
    partnerName
    additionalLogoMedia {
      url
    }
    postSignUpSplashBgMedia {
      url
    }
    circleDefaultSpaceSlug
  }
  storefrontSlug
  hasNylasIntegration
  nylasCalendarProvider
  createdAt
  intercomUserJwt
}
    ${NotificationDataFragmentDoc}`;
export const ProviderUserMemberDataFragmentDoc = gql`
    fragment providerUserMemberData on ProviderUserMember {
  ...basicProviderUserMemberData
  role
  assignedPatients
  isExternalCollaborator
  lastInviteSentAt
  registeredAt
  membershipStatus
}
    ${BasicProviderUserMemberDataFragmentDoc}`;
export const ProviderApiCredentialDataFragmentDoc = gql`
    fragment providerApiCredentialData on ProvidersApiCredential {
  id
  apiClientId
  name
  description
  createdAt
  status
  lastUsedAt
  deactivatedAt
}
    `;
export const BasicScheduledEventFragmentDoc = gql`
    fragment BasicScheduledEvent on ScheduledEvent {
  name
  isCanceled
  startTime
  hostProfileImageUrl
  calendlyEventUri
  hostName
  endTime
  invitees {
    firstName
    lastName
    email
    calendlyCancelUrl
    calendlyRescheduleUrl
    program {
      id
      programInstanceId
      email
      firstName
      lastName
      profileImageMedia {
        url
      }
      onboardingLastProgramInviteSentAt
      onboardingCompletedAt
    }
  }
}
    `;
export const ScheduledEventLocationFragmentDoc = gql`
    fragment ScheduledEventLocation on ScheduledEvent {
  location {
    type
    ... on PhysicalLocation {
      location
    }
    ... on OutboundCallLocation {
      location
    }
    ... on InboundCallLocation {
      location
    }
    ... on GoogleConferenceLocation {
      joinUrl
    }
    ... on ZoomConferenceLocation {
      joinUrl
    }
    ... on GoToMeetingLocation {
      joinUrl
    }
    ... on MicrosoftTeamsConferenceLocation {
      joinUrl
    }
    ... on CustomLocation {
      location
    }
    ... on AskInviteeLocation {
      location
    }
    ... on WebexConferenceLocation {
      joinUrl
    }
  }
}
    `;
export const UpcomingScheduledEventFragmentDoc = gql`
    fragment UpcomingScheduledEvent on ScheduledEvent {
  ...BasicScheduledEvent
  ...ScheduledEventLocation
}
    ${BasicScheduledEventFragmentDoc}
${ScheduledEventLocationFragmentDoc}`;
export const PatientScheduledEventFragmentDoc = gql`
    fragment PatientScheduledEvent on ScheduledEvent {
  ...UpcomingScheduledEvent
}
    ${UpcomingScheduledEventFragmentDoc}`;
export const CalendarScheduledEventFragmentDoc = gql`
    fragment CalendarScheduledEvent on ScheduledEvent {
  ...BasicScheduledEvent
  calendlyEventTypeUri
}
    ${BasicScheduledEventFragmentDoc}`;
export const CompleteScheduledEventFragmentDoc = gql`
    fragment CompleteScheduledEvent on ScheduledEvent {
  ...BasicScheduledEvent
  ...ScheduledEventLocation
  createdAt
  updatedAt
  invitees {
    email
    firstName
    lastName
    questionsAndAnswers {
      question
      answer
      position
    }
    calendlyInviteeUri
    calendlyRescheduleUrl
    calendlyCancelUrl
    calendlyEventUri
    createdAt
    updatedAt
  }
}
    ${BasicScheduledEventFragmentDoc}
${ScheduledEventLocationFragmentDoc}`;
export const CalendlyEventDataFragmentDoc = gql`
    fragment CalendlyEventData on CalendlyEventType {
  name
  description
  duration
  color
  calendlyEventTypeUri
  schedulingUrl
  isVisible
}
    `;
export const ServiceTagsDataFragmentDoc = gql`
    fragment serviceTagsData on ProgramTag {
  id
  name
  description
  color
}
    `;
export const BasicProviderUserDataFragmentDoc = gql`
    fragment basicProviderUserData on ProviderUserMember {
  id
  name
  email
  profileImageMedia {
    url
  }
}
    `;
export const ProviderServiceDataFragmentDoc = gql`
    fragment providerServiceData on ProviderService {
  id
  isEnabled
  isShownOnStorefront
  patientAccessLevel
  slug
  name
  serviceIcon
  serviceIconColorUseCalendlyDefault
  calendlyEventColor
  description
  isPaid
  price
  isPriceLabelShown
  durationMinutes
  serviceSubmissionTitle
  serviceSubmissionBody
  serviceSubmissionRedirectUrl
  serviceTags {
    ...serviceTagsData
  }
  intakeFormAssessment {
    ...essentialAssessmentData
  }
  calendlyEventTypeUri
  assignedProviderUsers {
    ...basicProviderUserData
  }
  serviceGroupId
  displayOrder
}
    ${ServiceTagsDataFragmentDoc}
${EssentialAssessmentDataFragmentDoc}
${BasicProviderUserDataFragmentDoc}`;
export const ServiceGroupDataFragmentDoc = gql`
    fragment serviceGroupData on ServiceGroup {
  id
  name
  displayOrder
  services {
    ...providerServiceData
  }
}
    ${ProviderServiceDataFragmentDoc}`;
export const ProviderStorefrontDataFragmentDoc = gql`
    fragment providerStorefrontData on ProviderStorefront {
  slug
  isEnabled
  bannerImageUrl
  bannerPosition
  profileImageUrl
  roleTitle
  ctaFormLabel
  ctaButtonText
  tagline
  about
  services
  intakeTags {
    ...programTagData
  }
  intakeFormAssessment {
    id
    type
    schemaType
    name
    shortName
  }
  calendlyEventTypeUri
}
    ${ProgramTagDataFragmentDoc}`;
export const ProviderActivitiesDocument = gql`
    query ProviderActivities {
  providerActivities {
    ...activityListData
  }
}
    ${ActivityListDataFragmentDoc}`;

/**
 * __useProviderActivitiesQuery__
 *
 * To run a query within a React component, call `useProviderActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderActivitiesQuery, ProviderActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderActivitiesQuery, ProviderActivitiesQueryVariables>(ProviderActivitiesDocument, options);
      }
export function useProviderActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderActivitiesQuery, ProviderActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderActivitiesQuery, ProviderActivitiesQueryVariables>(ProviderActivitiesDocument, options);
        }
export type ProviderActivitiesQueryHookResult = ReturnType<typeof useProviderActivitiesQuery>;
export type ProviderActivitiesLazyQueryHookResult = ReturnType<typeof useProviderActivitiesLazyQuery>;
export type ProviderActivitiesQueryResult = Apollo.QueryResult<ProviderActivitiesQuery, ProviderActivitiesQueryVariables>;
export const StandardAssessmentsDocument = gql`
    query StandardAssessments {
  standardAssessments {
    ...activityListData
  }
}
    ${ActivityListDataFragmentDoc}`;

/**
 * __useStandardAssessmentsQuery__
 *
 * To run a query within a React component, call `useStandardAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStandardAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useStandardAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<StandardAssessmentsQuery, StandardAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardAssessmentsQuery, StandardAssessmentsQueryVariables>(StandardAssessmentsDocument, options);
      }
export function useStandardAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StandardAssessmentsQuery, StandardAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardAssessmentsQuery, StandardAssessmentsQueryVariables>(StandardAssessmentsDocument, options);
        }
export type StandardAssessmentsQueryHookResult = ReturnType<typeof useStandardAssessmentsQuery>;
export type StandardAssessmentsLazyQueryHookResult = ReturnType<typeof useStandardAssessmentsLazyQuery>;
export type StandardAssessmentsQueryResult = Apollo.QueryResult<StandardAssessmentsQuery, StandardAssessmentsQueryVariables>;
export const ProgramActivitiesDocument = gql`
    query ProgramActivities($programId: String!) {
  programActivities(programId: $programId) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;

/**
 * __useProgramActivitiesQuery__
 *
 * To run a query within a React component, call `useProgramActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramActivitiesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramActivitiesQuery(baseOptions: Apollo.QueryHookOptions<ProgramActivitiesQuery, ProgramActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramActivitiesQuery, ProgramActivitiesQueryVariables>(ProgramActivitiesDocument, options);
      }
export function useProgramActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramActivitiesQuery, ProgramActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramActivitiesQuery, ProgramActivitiesQueryVariables>(ProgramActivitiesDocument, options);
        }
export type ProgramActivitiesQueryHookResult = ReturnType<typeof useProgramActivitiesQuery>;
export type ProgramActivitiesLazyQueryHookResult = ReturnType<typeof useProgramActivitiesLazyQuery>;
export type ProgramActivitiesQueryResult = Apollo.QueryResult<ProgramActivitiesQuery, ProgramActivitiesQueryVariables>;
export const ProgramActivityDocument = gql`
    query ProgramActivity($programActivityId: String!) {
  programActivity(programActivityId: $programActivityId) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;

/**
 * __useProgramActivityQuery__
 *
 * To run a query within a React component, call `useProgramActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramActivityQuery({
 *   variables: {
 *      programActivityId: // value for 'programActivityId'
 *   },
 * });
 */
export function useProgramActivityQuery(baseOptions: Apollo.QueryHookOptions<ProgramActivityQuery, ProgramActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramActivityQuery, ProgramActivityQueryVariables>(ProgramActivityDocument, options);
      }
export function useProgramActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramActivityQuery, ProgramActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramActivityQuery, ProgramActivityQueryVariables>(ProgramActivityDocument, options);
        }
export type ProgramActivityQueryHookResult = ReturnType<typeof useProgramActivityQuery>;
export type ProgramActivityLazyQueryHookResult = ReturnType<typeof useProgramActivityLazyQuery>;
export type ProgramActivityQueryResult = Apollo.QueryResult<ProgramActivityQuery, ProgramActivityQueryVariables>;
export const CompletedPdfSubmissionsDocument = gql`
    query CompletedPdfSubmissions($programId: String!) {
  completedPdfSubmissions(programId: $programId) {
    id
    programActivity {
      id
      activityType
      name
      completedAt
    }
    media {
      id
      url
    }
    signedAt
  }
}
    `;

/**
 * __useCompletedPdfSubmissionsQuery__
 *
 * To run a query within a React component, call `useCompletedPdfSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedPdfSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedPdfSubmissionsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useCompletedPdfSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<CompletedPdfSubmissionsQuery, CompletedPdfSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedPdfSubmissionsQuery, CompletedPdfSubmissionsQueryVariables>(CompletedPdfSubmissionsDocument, options);
      }
export function useCompletedPdfSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedPdfSubmissionsQuery, CompletedPdfSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedPdfSubmissionsQuery, CompletedPdfSubmissionsQueryVariables>(CompletedPdfSubmissionsDocument, options);
        }
export type CompletedPdfSubmissionsQueryHookResult = ReturnType<typeof useCompletedPdfSubmissionsQuery>;
export type CompletedPdfSubmissionsLazyQueryHookResult = ReturnType<typeof useCompletedPdfSubmissionsLazyQuery>;
export type CompletedPdfSubmissionsQueryResult = Apollo.QueryResult<CompletedPdfSubmissionsQuery, CompletedPdfSubmissionsQueryVariables>;
export const AssessmentActivitiesDocument = gql`
    query AssessmentActivities {
  providerAssessments {
    ...essentialAssessmentData
    description
    category
  }
}
    ${EssentialAssessmentDataFragmentDoc}`;

/**
 * __useAssessmentActivitiesQuery__
 *
 * To run a query within a React component, call `useAssessmentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentActivitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssessmentActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<AssessmentActivitiesQuery, AssessmentActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentActivitiesQuery, AssessmentActivitiesQueryVariables>(AssessmentActivitiesDocument, options);
      }
export function useAssessmentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentActivitiesQuery, AssessmentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentActivitiesQuery, AssessmentActivitiesQueryVariables>(AssessmentActivitiesDocument, options);
        }
export type AssessmentActivitiesQueryHookResult = ReturnType<typeof useAssessmentActivitiesQuery>;
export type AssessmentActivitiesLazyQueryHookResult = ReturnType<typeof useAssessmentActivitiesLazyQuery>;
export type AssessmentActivitiesQueryResult = Apollo.QueryResult<AssessmentActivitiesQuery, AssessmentActivitiesQueryVariables>;
export const LinkPreviewDocument = gql`
    query LinkPreview($linkURL: String!) {
  linkPreview(linkURL: $linkURL) {
    title
    imageURL
  }
}
    `;

/**
 * __useLinkPreviewQuery__
 *
 * To run a query within a React component, call `useLinkPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkPreviewQuery({
 *   variables: {
 *      linkURL: // value for 'linkURL'
 *   },
 * });
 */
export function useLinkPreviewQuery(baseOptions: Apollo.QueryHookOptions<LinkPreviewQuery, LinkPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkPreviewQuery, LinkPreviewQueryVariables>(LinkPreviewDocument, options);
      }
export function useLinkPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkPreviewQuery, LinkPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkPreviewQuery, LinkPreviewQueryVariables>(LinkPreviewDocument, options);
        }
export type LinkPreviewQueryHookResult = ReturnType<typeof useLinkPreviewQuery>;
export type LinkPreviewLazyQueryHookResult = ReturnType<typeof useLinkPreviewLazyQuery>;
export type LinkPreviewQueryResult = Apollo.QueryResult<LinkPreviewQuery, LinkPreviewQueryVariables>;
export const ActivityDocument = gql`
    query Activity($activityId: String!, $activityType: ActivityType!) {
  activity(activityId: $activityId, activityType: $activityType) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityQuery__
 *
 * To run a query within a React component, call `useActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityQuery({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityType: // value for 'activityType'
 *   },
 * });
 */
export function useActivityQuery(baseOptions: Apollo.QueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
      }
export function useActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityQuery, ActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityQuery, ActivityQueryVariables>(ActivityDocument, options);
        }
export type ActivityQueryHookResult = ReturnType<typeof useActivityQuery>;
export type ActivityLazyQueryHookResult = ReturnType<typeof useActivityLazyQuery>;
export type ActivityQueryResult = Apollo.QueryResult<ActivityQuery, ActivityQueryVariables>;
export const ActivityAudioDocument = gql`
    query ActivityAudio($mediaCategory: MediaCategory!) {
  activityAudio(mediaCategory: $mediaCategory) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityAudioQuery__
 *
 * To run a query within a React component, call `useActivityAudioQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityAudioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityAudioQuery({
 *   variables: {
 *      mediaCategory: // value for 'mediaCategory'
 *   },
 * });
 */
export function useActivityAudioQuery(baseOptions: Apollo.QueryHookOptions<ActivityAudioQuery, ActivityAudioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityAudioQuery, ActivityAudioQueryVariables>(ActivityAudioDocument, options);
      }
export function useActivityAudioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityAudioQuery, ActivityAudioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityAudioQuery, ActivityAudioQueryVariables>(ActivityAudioDocument, options);
        }
export type ActivityAudioQueryHookResult = ReturnType<typeof useActivityAudioQuery>;
export type ActivityAudioLazyQueryHookResult = ReturnType<typeof useActivityAudioLazyQuery>;
export type ActivityAudioQueryResult = Apollo.QueryResult<ActivityAudioQuery, ActivityAudioQueryVariables>;
export const ActivityImagesDocument = gql`
    query ActivityImages {
  activityImages {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityImagesQuery__
 *
 * To run a query within a React component, call `useActivityImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityImagesQuery(baseOptions?: Apollo.QueryHookOptions<ActivityImagesQuery, ActivityImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityImagesQuery, ActivityImagesQueryVariables>(ActivityImagesDocument, options);
      }
export function useActivityImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityImagesQuery, ActivityImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityImagesQuery, ActivityImagesQueryVariables>(ActivityImagesDocument, options);
        }
export type ActivityImagesQueryHookResult = ReturnType<typeof useActivityImagesQuery>;
export type ActivityImagesLazyQueryHookResult = ReturnType<typeof useActivityImagesLazyQuery>;
export type ActivityImagesQueryResult = Apollo.QueryResult<ActivityImagesQuery, ActivityImagesQueryVariables>;
export const ActivityLinksDocument = gql`
    query ActivityLinks {
  activityLinks {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityLinksQuery__
 *
 * To run a query within a React component, call `useActivityLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityLinksQuery(baseOptions?: Apollo.QueryHookOptions<ActivityLinksQuery, ActivityLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityLinksQuery, ActivityLinksQueryVariables>(ActivityLinksDocument, options);
      }
export function useActivityLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityLinksQuery, ActivityLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityLinksQuery, ActivityLinksQueryVariables>(ActivityLinksDocument, options);
        }
export type ActivityLinksQueryHookResult = ReturnType<typeof useActivityLinksQuery>;
export type ActivityLinksLazyQueryHookResult = ReturnType<typeof useActivityLinksLazyQuery>;
export type ActivityLinksQueryResult = Apollo.QueryResult<ActivityLinksQuery, ActivityLinksQueryVariables>;
export const ActivityPdFsDocument = gql`
    query ActivityPDFs {
  activityPDFs {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityPdFsQuery__
 *
 * To run a query within a React component, call `useActivityPdFsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityPdFsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityPdFsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityPdFsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityPdFsQuery, ActivityPdFsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityPdFsQuery, ActivityPdFsQueryVariables>(ActivityPdFsDocument, options);
      }
export function useActivityPdFsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityPdFsQuery, ActivityPdFsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityPdFsQuery, ActivityPdFsQueryVariables>(ActivityPdFsDocument, options);
        }
export type ActivityPdFsQueryHookResult = ReturnType<typeof useActivityPdFsQuery>;
export type ActivityPdFsLazyQueryHookResult = ReturnType<typeof useActivityPdFsLazyQuery>;
export type ActivityPdFsQueryResult = Apollo.QueryResult<ActivityPdFsQuery, ActivityPdFsQueryVariables>;
export const ActivityTextsDocument = gql`
    query ActivityTexts {
  activityTexts {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;

/**
 * __useActivityTextsQuery__
 *
 * To run a query within a React component, call `useActivityTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityTextsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityTextsQuery(baseOptions?: Apollo.QueryHookOptions<ActivityTextsQuery, ActivityTextsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityTextsQuery, ActivityTextsQueryVariables>(ActivityTextsDocument, options);
      }
export function useActivityTextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityTextsQuery, ActivityTextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityTextsQuery, ActivityTextsQueryVariables>(ActivityTextsDocument, options);
        }
export type ActivityTextsQueryHookResult = ReturnType<typeof useActivityTextsQuery>;
export type ActivityTextsLazyQueryHookResult = ReturnType<typeof useActivityTextsLazyQuery>;
export type ActivityTextsQueryResult = Apollo.QueryResult<ActivityTextsQuery, ActivityTextsQueryVariables>;
export const DuplicateActivityDocument = gql`
    mutation DuplicateActivity($input: DuplicateActivityInput!) {
  duplicateActivity(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type DuplicateActivityMutationFn = Apollo.MutationFunction<DuplicateActivityMutation, DuplicateActivityMutationVariables>;

/**
 * __useDuplicateActivityMutation__
 *
 * To run a mutation, you first call `useDuplicateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateActivityMutation, { data, loading, error }] = useDuplicateActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateActivityMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateActivityMutation, DuplicateActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateActivityMutation, DuplicateActivityMutationVariables>(DuplicateActivityDocument, options);
      }
export type DuplicateActivityMutationHookResult = ReturnType<typeof useDuplicateActivityMutation>;
export type DuplicateActivityMutationResult = Apollo.MutationResult<DuplicateActivityMutation>;
export type DuplicateActivityMutationOptions = Apollo.BaseMutationOptions<DuplicateActivityMutation, DuplicateActivityMutationVariables>;
export const AddActivityAudioDocument = gql`
    mutation AddActivityAudio($input: ActivityAudioInput!) {
  addActivityAudio(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityAudioMutationFn = Apollo.MutationFunction<AddActivityAudioMutation, AddActivityAudioMutationVariables>;

/**
 * __useAddActivityAudioMutation__
 *
 * To run a mutation, you first call `useAddActivityAudioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityAudioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityAudioMutation, { data, loading, error }] = useAddActivityAudioMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityAudioMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityAudioMutation, AddActivityAudioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityAudioMutation, AddActivityAudioMutationVariables>(AddActivityAudioDocument, options);
      }
export type AddActivityAudioMutationHookResult = ReturnType<typeof useAddActivityAudioMutation>;
export type AddActivityAudioMutationResult = Apollo.MutationResult<AddActivityAudioMutation>;
export type AddActivityAudioMutationOptions = Apollo.BaseMutationOptions<AddActivityAudioMutation, AddActivityAudioMutationVariables>;
export const AddActivityImageDocument = gql`
    mutation AddActivityImage($input: ActivityImageInput!) {
  addActivityImage(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityImageMutationFn = Apollo.MutationFunction<AddActivityImageMutation, AddActivityImageMutationVariables>;

/**
 * __useAddActivityImageMutation__
 *
 * To run a mutation, you first call `useAddActivityImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityImageMutation, { data, loading, error }] = useAddActivityImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityImageMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityImageMutation, AddActivityImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityImageMutation, AddActivityImageMutationVariables>(AddActivityImageDocument, options);
      }
export type AddActivityImageMutationHookResult = ReturnType<typeof useAddActivityImageMutation>;
export type AddActivityImageMutationResult = Apollo.MutationResult<AddActivityImageMutation>;
export type AddActivityImageMutationOptions = Apollo.BaseMutationOptions<AddActivityImageMutation, AddActivityImageMutationVariables>;
export const AddActivityLinkDocument = gql`
    mutation AddActivityLink($input: ActivityLinkInput!) {
  addActivityLink(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityLinkMutationFn = Apollo.MutationFunction<AddActivityLinkMutation, AddActivityLinkMutationVariables>;

/**
 * __useAddActivityLinkMutation__
 *
 * To run a mutation, you first call `useAddActivityLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityLinkMutation, { data, loading, error }] = useAddActivityLinkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityLinkMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityLinkMutation, AddActivityLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityLinkMutation, AddActivityLinkMutationVariables>(AddActivityLinkDocument, options);
      }
export type AddActivityLinkMutationHookResult = ReturnType<typeof useAddActivityLinkMutation>;
export type AddActivityLinkMutationResult = Apollo.MutationResult<AddActivityLinkMutation>;
export type AddActivityLinkMutationOptions = Apollo.BaseMutationOptions<AddActivityLinkMutation, AddActivityLinkMutationVariables>;
export const AddActivityPdfDocument = gql`
    mutation AddActivityPDF($input: ActivityPDFInput!) {
  addActivityPDF(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityPdfMutationFn = Apollo.MutationFunction<AddActivityPdfMutation, AddActivityPdfMutationVariables>;

/**
 * __useAddActivityPdfMutation__
 *
 * To run a mutation, you first call `useAddActivityPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityPdfMutation, { data, loading, error }] = useAddActivityPdfMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityPdfMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityPdfMutation, AddActivityPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityPdfMutation, AddActivityPdfMutationVariables>(AddActivityPdfDocument, options);
      }
export type AddActivityPdfMutationHookResult = ReturnType<typeof useAddActivityPdfMutation>;
export type AddActivityPdfMutationResult = Apollo.MutationResult<AddActivityPdfMutation>;
export type AddActivityPdfMutationOptions = Apollo.BaseMutationOptions<AddActivityPdfMutation, AddActivityPdfMutationVariables>;
export const AddActivityTextDocument = gql`
    mutation AddActivityText($input: ActivityTextInput!) {
  addActivityText(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityTextMutationFn = Apollo.MutationFunction<AddActivityTextMutation, AddActivityTextMutationVariables>;

/**
 * __useAddActivityTextMutation__
 *
 * To run a mutation, you first call `useAddActivityTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityTextMutation, { data, loading, error }] = useAddActivityTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityTextMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityTextMutation, AddActivityTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityTextMutation, AddActivityTextMutationVariables>(AddActivityTextDocument, options);
      }
export type AddActivityTextMutationHookResult = ReturnType<typeof useAddActivityTextMutation>;
export type AddActivityTextMutationResult = Apollo.MutationResult<AddActivityTextMutation>;
export type AddActivityTextMutationOptions = Apollo.BaseMutationOptions<AddActivityTextMutation, AddActivityTextMutationVariables>;
export const EditActivityTitleDocument = gql`
    mutation EditActivityTitle($input: EditActivityTitleInput!) {
  editActivityTitle(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type EditActivityTitleMutationFn = Apollo.MutationFunction<EditActivityTitleMutation, EditActivityTitleMutationVariables>;

/**
 * __useEditActivityTitleMutation__
 *
 * To run a mutation, you first call `useEditActivityTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditActivityTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editActivityTitleMutation, { data, loading, error }] = useEditActivityTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditActivityTitleMutation(baseOptions?: Apollo.MutationHookOptions<EditActivityTitleMutation, EditActivityTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditActivityTitleMutation, EditActivityTitleMutationVariables>(EditActivityTitleDocument, options);
      }
export type EditActivityTitleMutationHookResult = ReturnType<typeof useEditActivityTitleMutation>;
export type EditActivityTitleMutationResult = Apollo.MutationResult<EditActivityTitleMutation>;
export type EditActivityTitleMutationOptions = Apollo.BaseMutationOptions<EditActivityTitleMutation, EditActivityTitleMutationVariables>;
export const EditActivityTextDocument = gql`
    mutation EditActivityText($input: EditActivityTextInput!) {
  editActivityText(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type EditActivityTextMutationFn = Apollo.MutationFunction<EditActivityTextMutation, EditActivityTextMutationVariables>;

/**
 * __useEditActivityTextMutation__
 *
 * To run a mutation, you first call `useEditActivityTextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditActivityTextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editActivityTextMutation, { data, loading, error }] = useEditActivityTextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditActivityTextMutation(baseOptions?: Apollo.MutationHookOptions<EditActivityTextMutation, EditActivityTextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditActivityTextMutation, EditActivityTextMutationVariables>(EditActivityTextDocument, options);
      }
export type EditActivityTextMutationHookResult = ReturnType<typeof useEditActivityTextMutation>;
export type EditActivityTextMutationResult = Apollo.MutationResult<EditActivityTextMutation>;
export type EditActivityTextMutationOptions = Apollo.BaseMutationOptions<EditActivityTextMutation, EditActivityTextMutationVariables>;
export const EditActivityFileSettingsDocument = gql`
    mutation EditActivityFileSettings($input: EditActivityFileSettingsInput!) {
  editActivityFileSettings(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type EditActivityFileSettingsMutationFn = Apollo.MutationFunction<EditActivityFileSettingsMutation, EditActivityFileSettingsMutationVariables>;

/**
 * __useEditActivityFileSettingsMutation__
 *
 * To run a mutation, you first call `useEditActivityFileSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditActivityFileSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editActivityFileSettingsMutation, { data, loading, error }] = useEditActivityFileSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditActivityFileSettingsMutation(baseOptions?: Apollo.MutationHookOptions<EditActivityFileSettingsMutation, EditActivityFileSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditActivityFileSettingsMutation, EditActivityFileSettingsMutationVariables>(EditActivityFileSettingsDocument, options);
      }
export type EditActivityFileSettingsMutationHookResult = ReturnType<typeof useEditActivityFileSettingsMutation>;
export type EditActivityFileSettingsMutationResult = Apollo.MutationResult<EditActivityFileSettingsMutation>;
export type EditActivityFileSettingsMutationOptions = Apollo.BaseMutationOptions<EditActivityFileSettingsMutation, EditActivityFileSettingsMutationVariables>;
export const ArchiveActivityDocument = gql`
    mutation ArchiveActivity($activityId: String!, $activityType: ActivityType!) {
  archiveActivity(activityId: $activityId, activityType: $activityType) {
    id
  }
}
    `;
export type ArchiveActivityMutationFn = Apollo.MutationFunction<ArchiveActivityMutation, ArchiveActivityMutationVariables>;

/**
 * __useArchiveActivityMutation__
 *
 * To run a mutation, you first call `useArchiveActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveActivityMutation, { data, loading, error }] = useArchiveActivityMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      activityType: // value for 'activityType'
 *   },
 * });
 */
export function useArchiveActivityMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveActivityMutation, ArchiveActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveActivityMutation, ArchiveActivityMutationVariables>(ArchiveActivityDocument, options);
      }
export type ArchiveActivityMutationHookResult = ReturnType<typeof useArchiveActivityMutation>;
export type ArchiveActivityMutationResult = Apollo.MutationResult<ArchiveActivityMutation>;
export type ArchiveActivityMutationOptions = Apollo.BaseMutationOptions<ArchiveActivityMutation, ArchiveActivityMutationVariables>;
export const ArchiveActivitiesDocument = gql`
    mutation ArchiveActivities($input: ArchiveActivitiesInput!) {
  archiveActivities(input: $input) {
    id
  }
}
    `;
export type ArchiveActivitiesMutationFn = Apollo.MutationFunction<ArchiveActivitiesMutation, ArchiveActivitiesMutationVariables>;

/**
 * __useArchiveActivitiesMutation__
 *
 * To run a mutation, you first call `useArchiveActivitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveActivitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveActivitiesMutation, { data, loading, error }] = useArchiveActivitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveActivitiesMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveActivitiesMutation, ArchiveActivitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveActivitiesMutation, ArchiveActivitiesMutationVariables>(ArchiveActivitiesDocument, options);
      }
export type ArchiveActivitiesMutationHookResult = ReturnType<typeof useArchiveActivitiesMutation>;
export type ArchiveActivitiesMutationResult = Apollo.MutationResult<ArchiveActivitiesMutation>;
export type ArchiveActivitiesMutationOptions = Apollo.BaseMutationOptions<ArchiveActivitiesMutation, ArchiveActivitiesMutationVariables>;
export const VoidProgramActivityDocument = gql`
    mutation VoidProgramActivity($programActivityId: String!) {
  voidProgramActivity(programActivityId: $programActivityId) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;
export type VoidProgramActivityMutationFn = Apollo.MutationFunction<VoidProgramActivityMutation, VoidProgramActivityMutationVariables>;

/**
 * __useVoidProgramActivityMutation__
 *
 * To run a mutation, you first call `useVoidProgramActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidProgramActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidProgramActivityMutation, { data, loading, error }] = useVoidProgramActivityMutation({
 *   variables: {
 *      programActivityId: // value for 'programActivityId'
 *   },
 * });
 */
export function useVoidProgramActivityMutation(baseOptions?: Apollo.MutationHookOptions<VoidProgramActivityMutation, VoidProgramActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidProgramActivityMutation, VoidProgramActivityMutationVariables>(VoidProgramActivityDocument, options);
      }
export type VoidProgramActivityMutationHookResult = ReturnType<typeof useVoidProgramActivityMutation>;
export type VoidProgramActivityMutationResult = Apollo.MutationResult<VoidProgramActivityMutation>;
export type VoidProgramActivityMutationOptions = Apollo.BaseMutationOptions<VoidProgramActivityMutation, VoidProgramActivityMutationVariables>;
export const RecordProgramActivityPdfDownloadDocument = gql`
    mutation RecordProgramActivityPdfDownload($programActivityId: String!) {
  recordProgramActivityPdfDownload(programActivityId: $programActivityId)
}
    `;
export type RecordProgramActivityPdfDownloadMutationFn = Apollo.MutationFunction<RecordProgramActivityPdfDownloadMutation, RecordProgramActivityPdfDownloadMutationVariables>;

/**
 * __useRecordProgramActivityPdfDownloadMutation__
 *
 * To run a mutation, you first call `useRecordProgramActivityPdfDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProgramActivityPdfDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProgramActivityPdfDownloadMutation, { data, loading, error }] = useRecordProgramActivityPdfDownloadMutation({
 *   variables: {
 *      programActivityId: // value for 'programActivityId'
 *   },
 * });
 */
export function useRecordProgramActivityPdfDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RecordProgramActivityPdfDownloadMutation, RecordProgramActivityPdfDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProgramActivityPdfDownloadMutation, RecordProgramActivityPdfDownloadMutationVariables>(RecordProgramActivityPdfDownloadDocument, options);
      }
export type RecordProgramActivityPdfDownloadMutationHookResult = ReturnType<typeof useRecordProgramActivityPdfDownloadMutation>;
export type RecordProgramActivityPdfDownloadMutationResult = Apollo.MutationResult<RecordProgramActivityPdfDownloadMutation>;
export type RecordProgramActivityPdfDownloadMutationOptions = Apollo.BaseMutationOptions<RecordProgramActivityPdfDownloadMutation, RecordProgramActivityPdfDownloadMutationVariables>;
export const RecordProgramActivityResponsesViewedDocument = gql`
    mutation RecordProgramActivityResponsesViewed($programActivityId: String!) {
  recordProgramActivityResponsesViewed(programActivityId: $programActivityId)
}
    `;
export type RecordProgramActivityResponsesViewedMutationFn = Apollo.MutationFunction<RecordProgramActivityResponsesViewedMutation, RecordProgramActivityResponsesViewedMutationVariables>;

/**
 * __useRecordProgramActivityResponsesViewedMutation__
 *
 * To run a mutation, you first call `useRecordProgramActivityResponsesViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProgramActivityResponsesViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProgramActivityResponsesViewedMutation, { data, loading, error }] = useRecordProgramActivityResponsesViewedMutation({
 *   variables: {
 *      programActivityId: // value for 'programActivityId'
 *   },
 * });
 */
export function useRecordProgramActivityResponsesViewedMutation(baseOptions?: Apollo.MutationHookOptions<RecordProgramActivityResponsesViewedMutation, RecordProgramActivityResponsesViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProgramActivityResponsesViewedMutation, RecordProgramActivityResponsesViewedMutationVariables>(RecordProgramActivityResponsesViewedDocument, options);
      }
export type RecordProgramActivityResponsesViewedMutationHookResult = ReturnType<typeof useRecordProgramActivityResponsesViewedMutation>;
export type RecordProgramActivityResponsesViewedMutationResult = Apollo.MutationResult<RecordProgramActivityResponsesViewedMutation>;
export type RecordProgramActivityResponsesViewedMutationOptions = Apollo.BaseMutationOptions<RecordProgramActivityResponsesViewedMutation, RecordProgramActivityResponsesViewedMutationVariables>;
export const PublicPdfSubmissionDocument = gql`
    query PublicPdfSubmission($pdfSubmissionLinkToken: String!) {
  publicPdfSubmission(pdfSubmissionLinkToken: $pdfSubmissionLinkToken) {
    title
    pdfUrl
    expiresAt
    submittedAt
    providerFirstName
  }
}
    `;

/**
 * __usePublicPdfSubmissionQuery__
 *
 * To run a query within a React component, call `usePublicPdfSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicPdfSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicPdfSubmissionQuery({
 *   variables: {
 *      pdfSubmissionLinkToken: // value for 'pdfSubmissionLinkToken'
 *   },
 * });
 */
export function usePublicPdfSubmissionQuery(baseOptions: Apollo.QueryHookOptions<PublicPdfSubmissionQuery, PublicPdfSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicPdfSubmissionQuery, PublicPdfSubmissionQueryVariables>(PublicPdfSubmissionDocument, options);
      }
export function usePublicPdfSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicPdfSubmissionQuery, PublicPdfSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicPdfSubmissionQuery, PublicPdfSubmissionQueryVariables>(PublicPdfSubmissionDocument, options);
        }
export type PublicPdfSubmissionQueryHookResult = ReturnType<typeof usePublicPdfSubmissionQuery>;
export type PublicPdfSubmissionLazyQueryHookResult = ReturnType<typeof usePublicPdfSubmissionLazyQuery>;
export type PublicPdfSubmissionQueryResult = Apollo.QueryResult<PublicPdfSubmissionQuery, PublicPdfSubmissionQueryVariables>;
export const SubmitPdfFormDocument = gql`
    mutation SubmitPdfForm($pdfSubmissionLinkToken: String!, $file: Upload!) {
  submitPdfForm(pdfSubmissionLinkToken: $pdfSubmissionLinkToken, file: $file)
}
    `;
export type SubmitPdfFormMutationFn = Apollo.MutationFunction<SubmitPdfFormMutation, SubmitPdfFormMutationVariables>;

/**
 * __useSubmitPdfFormMutation__
 *
 * To run a mutation, you first call `useSubmitPdfFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPdfFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPdfFormMutation, { data, loading, error }] = useSubmitPdfFormMutation({
 *   variables: {
 *      pdfSubmissionLinkToken: // value for 'pdfSubmissionLinkToken'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useSubmitPdfFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPdfFormMutation, SubmitPdfFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPdfFormMutation, SubmitPdfFormMutationVariables>(SubmitPdfFormDocument, options);
      }
export type SubmitPdfFormMutationHookResult = ReturnType<typeof useSubmitPdfFormMutation>;
export type SubmitPdfFormMutationResult = Apollo.MutationResult<SubmitPdfFormMutation>;
export type SubmitPdfFormMutationOptions = Apollo.BaseMutationOptions<SubmitPdfFormMutation, SubmitPdfFormMutationVariables>;
export const CompleteProgramActivityDocument = gql`
    mutation CompleteProgramActivity($input: CompleteProgramActivityInput!) {
  completeProgramActivity(input: $input) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;
export type CompleteProgramActivityMutationFn = Apollo.MutationFunction<CompleteProgramActivityMutation, CompleteProgramActivityMutationVariables>;

/**
 * __useCompleteProgramActivityMutation__
 *
 * To run a mutation, you first call `useCompleteProgramActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProgramActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProgramActivityMutation, { data, loading, error }] = useCompleteProgramActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteProgramActivityMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProgramActivityMutation, CompleteProgramActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProgramActivityMutation, CompleteProgramActivityMutationVariables>(CompleteProgramActivityDocument, options);
      }
export type CompleteProgramActivityMutationHookResult = ReturnType<typeof useCompleteProgramActivityMutation>;
export type CompleteProgramActivityMutationResult = Apollo.MutationResult<CompleteProgramActivityMutation>;
export type CompleteProgramActivityMutationOptions = Apollo.BaseMutationOptions<CompleteProgramActivityMutation, CompleteProgramActivityMutationVariables>;
export const DismissProgramActivityDocument = gql`
    mutation DismissProgramActivity($input: DismissProgramActivityInput!) {
  dismissProgramActivity(input: $input) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;
export type DismissProgramActivityMutationFn = Apollo.MutationFunction<DismissProgramActivityMutation, DismissProgramActivityMutationVariables>;

/**
 * __useDismissProgramActivityMutation__
 *
 * To run a mutation, you first call `useDismissProgramActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissProgramActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissProgramActivityMutation, { data, loading, error }] = useDismissProgramActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissProgramActivityMutation(baseOptions?: Apollo.MutationHookOptions<DismissProgramActivityMutation, DismissProgramActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissProgramActivityMutation, DismissProgramActivityMutationVariables>(DismissProgramActivityDocument, options);
      }
export type DismissProgramActivityMutationHookResult = ReturnType<typeof useDismissProgramActivityMutation>;
export type DismissProgramActivityMutationResult = Apollo.MutationResult<DismissProgramActivityMutation>;
export type DismissProgramActivityMutationOptions = Apollo.BaseMutationOptions<DismissProgramActivityMutation, DismissProgramActivityMutationVariables>;
export const MarkProgramActivitiesSeenDocument = gql`
    mutation MarkProgramActivitiesSeen($programActivityIds: [String!]!) {
  markProgramActivitiesSeen(programActivityIds: $programActivityIds) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;
export type MarkProgramActivitiesSeenMutationFn = Apollo.MutationFunction<MarkProgramActivitiesSeenMutation, MarkProgramActivitiesSeenMutationVariables>;

/**
 * __useMarkProgramActivitiesSeenMutation__
 *
 * To run a mutation, you first call `useMarkProgramActivitiesSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProgramActivitiesSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProgramActivitiesSeenMutation, { data, loading, error }] = useMarkProgramActivitiesSeenMutation({
 *   variables: {
 *      programActivityIds: // value for 'programActivityIds'
 *   },
 * });
 */
export function useMarkProgramActivitiesSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkProgramActivitiesSeenMutation, MarkProgramActivitiesSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProgramActivitiesSeenMutation, MarkProgramActivitiesSeenMutationVariables>(MarkProgramActivitiesSeenDocument, options);
      }
export type MarkProgramActivitiesSeenMutationHookResult = ReturnType<typeof useMarkProgramActivitiesSeenMutation>;
export type MarkProgramActivitiesSeenMutationResult = Apollo.MutationResult<MarkProgramActivitiesSeenMutation>;
export type MarkProgramActivitiesSeenMutationOptions = Apollo.BaseMutationOptions<MarkProgramActivitiesSeenMutation, MarkProgramActivitiesSeenMutationVariables>;
export const TodoProgramActivitiesDocument = gql`
    query TodoProgramActivities($programId: String!) {
  todoProgramActivities(programId: $programId) {
    ...programActivityData
  }
}
    ${ProgramActivityDataFragmentDoc}`;

/**
 * __useTodoProgramActivitiesQuery__
 *
 * To run a query within a React component, call `useTodoProgramActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodoProgramActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodoProgramActivitiesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useTodoProgramActivitiesQuery(baseOptions: Apollo.QueryHookOptions<TodoProgramActivitiesQuery, TodoProgramActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodoProgramActivitiesQuery, TodoProgramActivitiesQueryVariables>(TodoProgramActivitiesDocument, options);
      }
export function useTodoProgramActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodoProgramActivitiesQuery, TodoProgramActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodoProgramActivitiesQuery, TodoProgramActivitiesQueryVariables>(TodoProgramActivitiesDocument, options);
        }
export type TodoProgramActivitiesQueryHookResult = ReturnType<typeof useTodoProgramActivitiesQuery>;
export type TodoProgramActivitiesLazyQueryHookResult = ReturnType<typeof useTodoProgramActivitiesLazyQuery>;
export type TodoProgramActivitiesQueryResult = Apollo.QueryResult<TodoProgramActivitiesQuery, TodoProgramActivitiesQueryVariables>;
export const ProviderAssessmentsDocument = gql`
    query ProviderAssessments($programTemplateId: String!) {
  providerAssessments {
    ...basicAssessmentData
    estimatedLengthInMinutes
    programTemplateAssessment(programTemplateId: $programTemplateId) {
      scheduleItems {
        focalEvent
        timingOffset
        recurrenceInterval
      }
    }
  }
}
    ${BasicAssessmentDataFragmentDoc}`;

/**
 * __useProviderAssessmentsQuery__
 *
 * To run a query within a React component, call `useProviderAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderAssessmentsQuery({
 *   variables: {
 *      programTemplateId: // value for 'programTemplateId'
 *   },
 * });
 */
export function useProviderAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<ProviderAssessmentsQuery, ProviderAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderAssessmentsQuery, ProviderAssessmentsQueryVariables>(ProviderAssessmentsDocument, options);
      }
export function useProviderAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderAssessmentsQuery, ProviderAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderAssessmentsQuery, ProviderAssessmentsQueryVariables>(ProviderAssessmentsDocument, options);
        }
export type ProviderAssessmentsQueryHookResult = ReturnType<typeof useProviderAssessmentsQuery>;
export type ProviderAssessmentsLazyQueryHookResult = ReturnType<typeof useProviderAssessmentsLazyQuery>;
export type ProviderAssessmentsQueryResult = Apollo.QueryResult<ProviderAssessmentsQuery, ProviderAssessmentsQueryVariables>;
export const ProviderAssessmentsWithoutScheduleDocument = gql`
    query ProviderAssessmentsWithoutSchedule {
  assessments: providerAssessments(isCustom: false) {
    ...assessmentData
    estimatedLengthInMinutes
    questions {
      ...assessmentQuestionData
    }
  }
  forms: providerAssessments(isCustom: true) {
    ...assessmentData
    estimatedLengthInMinutes
    questions {
      ...assessmentQuestionData
    }
  }
}
    ${AssessmentDataFragmentDoc}
${AssessmentQuestionDataFragmentDoc}`;

/**
 * __useProviderAssessmentsWithoutScheduleQuery__
 *
 * To run a query within a React component, call `useProviderAssessmentsWithoutScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderAssessmentsWithoutScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderAssessmentsWithoutScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderAssessmentsWithoutScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ProviderAssessmentsWithoutScheduleQuery, ProviderAssessmentsWithoutScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderAssessmentsWithoutScheduleQuery, ProviderAssessmentsWithoutScheduleQueryVariables>(ProviderAssessmentsWithoutScheduleDocument, options);
      }
export function useProviderAssessmentsWithoutScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderAssessmentsWithoutScheduleQuery, ProviderAssessmentsWithoutScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderAssessmentsWithoutScheduleQuery, ProviderAssessmentsWithoutScheduleQueryVariables>(ProviderAssessmentsWithoutScheduleDocument, options);
        }
export type ProviderAssessmentsWithoutScheduleQueryHookResult = ReturnType<typeof useProviderAssessmentsWithoutScheduleQuery>;
export type ProviderAssessmentsWithoutScheduleLazyQueryHookResult = ReturnType<typeof useProviderAssessmentsWithoutScheduleLazyQuery>;
export type ProviderAssessmentsWithoutScheduleQueryResult = Apollo.QueryResult<ProviderAssessmentsWithoutScheduleQuery, ProviderAssessmentsWithoutScheduleQueryVariables>;
export const AssignAssessmentModalDataDocument = gql`
    query AssignAssessmentModalData {
  providerAssessments {
    ...essentialAssessmentData
  }
}
    ${EssentialAssessmentDataFragmentDoc}`;

/**
 * __useAssignAssessmentModalDataQuery__
 *
 * To run a query within a React component, call `useAssignAssessmentModalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignAssessmentModalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignAssessmentModalDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignAssessmentModalDataQuery(baseOptions?: Apollo.QueryHookOptions<AssignAssessmentModalDataQuery, AssignAssessmentModalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignAssessmentModalDataQuery, AssignAssessmentModalDataQueryVariables>(AssignAssessmentModalDataDocument, options);
      }
export function useAssignAssessmentModalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignAssessmentModalDataQuery, AssignAssessmentModalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignAssessmentModalDataQuery, AssignAssessmentModalDataQueryVariables>(AssignAssessmentModalDataDocument, options);
        }
export type AssignAssessmentModalDataQueryHookResult = ReturnType<typeof useAssignAssessmentModalDataQuery>;
export type AssignAssessmentModalDataLazyQueryHookResult = ReturnType<typeof useAssignAssessmentModalDataLazyQuery>;
export type AssignAssessmentModalDataQueryResult = Apollo.QueryResult<AssignAssessmentModalDataQuery, AssignAssessmentModalDataQueryVariables>;
export const ScheduleAssessmentDataDocument = gql`
    query ScheduleAssessmentData($programTemplateId: String!, $assessmentId: String!) {
  assessment(assessmentId: $assessmentId) {
    ...assessmentData
    estimatedLengthInMinutes
    questions {
      ... on MultipleChoiceScoredAssessmentQuestion {
        question
        subscale
        answerOptions {
          answerOption
          score
        }
      }
    }
    programTemplateAssessment(programTemplateId: $programTemplateId) {
      scheduleItems {
        focalEvent
        timingOffset
        recurrenceInterval
      }
    }
  }
}
    ${AssessmentDataFragmentDoc}`;

/**
 * __useScheduleAssessmentDataQuery__
 *
 * To run a query within a React component, call `useScheduleAssessmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleAssessmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleAssessmentDataQuery({
 *   variables: {
 *      programTemplateId: // value for 'programTemplateId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useScheduleAssessmentDataQuery(baseOptions: Apollo.QueryHookOptions<ScheduleAssessmentDataQuery, ScheduleAssessmentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleAssessmentDataQuery, ScheduleAssessmentDataQueryVariables>(ScheduleAssessmentDataDocument, options);
      }
export function useScheduleAssessmentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleAssessmentDataQuery, ScheduleAssessmentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleAssessmentDataQuery, ScheduleAssessmentDataQueryVariables>(ScheduleAssessmentDataDocument, options);
        }
export type ScheduleAssessmentDataQueryHookResult = ReturnType<typeof useScheduleAssessmentDataQuery>;
export type ScheduleAssessmentDataLazyQueryHookResult = ReturnType<typeof useScheduleAssessmentDataLazyQuery>;
export type ScheduleAssessmentDataQueryResult = Apollo.QueryResult<ScheduleAssessmentDataQuery, ScheduleAssessmentDataQueryVariables>;
export const ScheduleAssessmentDocument = gql`
    mutation ScheduleAssessment($input: ScheduleAssessmentInput!) {
  scheduleAssessment(input: $input) {
    updatedProgramTemplateAssessment {
      scheduleItems {
        focalEvent
        timingOffset
        recurrenceInterval
      }
    }
  }
}
    `;
export type ScheduleAssessmentMutationFn = Apollo.MutationFunction<ScheduleAssessmentMutation, ScheduleAssessmentMutationVariables>;

/**
 * __useScheduleAssessmentMutation__
 *
 * To run a mutation, you first call `useScheduleAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleAssessmentMutation, { data, loading, error }] = useScheduleAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleAssessmentMutation, ScheduleAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleAssessmentMutation, ScheduleAssessmentMutationVariables>(ScheduleAssessmentDocument, options);
      }
export type ScheduleAssessmentMutationHookResult = ReturnType<typeof useScheduleAssessmentMutation>;
export type ScheduleAssessmentMutationResult = Apollo.MutationResult<ScheduleAssessmentMutation>;
export type ScheduleAssessmentMutationOptions = Apollo.BaseMutationOptions<ScheduleAssessmentMutation, ScheduleAssessmentMutationVariables>;
export const AssignAssessmentDocument = gql`
    mutation AssignAssessment($programId: String!, $assessmentId: String!) {
  assignAssessment(programId: $programId, assessmentId: $assessmentId) {
    id
  }
}
    `;
export type AssignAssessmentMutationFn = Apollo.MutationFunction<AssignAssessmentMutation, AssignAssessmentMutationVariables>;

/**
 * __useAssignAssessmentMutation__
 *
 * To run a mutation, you first call `useAssignAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAssessmentMutation, { data, loading, error }] = useAssignAssessmentMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useAssignAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<AssignAssessmentMutation, AssignAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignAssessmentMutation, AssignAssessmentMutationVariables>(AssignAssessmentDocument, options);
      }
export type AssignAssessmentMutationHookResult = ReturnType<typeof useAssignAssessmentMutation>;
export type AssignAssessmentMutationResult = Apollo.MutationResult<AssignAssessmentMutation>;
export type AssignAssessmentMutationOptions = Apollo.BaseMutationOptions<AssignAssessmentMutation, AssignAssessmentMutationVariables>;
export const LatestCompletedProgramAssessmentsDocument = gql`
    query LatestCompletedProgramAssessments($programId: String!) {
  latestCompletedProgramAssessments(programId: $programId) {
    id
    completedAt
    completedByType
    completedByProviderUser {
      name
      profileImageMedia {
        url
      }
    }
    completedByExternalName
    completedByExternalEmail
    completionCount
    assessment {
      ...basicAssessmentData
      completableByProviderOnly
      increasingScoreTowardsHealth
    }
    programAssessmentSignatureUsers {
      providerUser {
        name
        profileImageMedia {
          url
        }
      }
      patientName
      signedAt
    }
    completionData {
      schemaType
      ... on MultipleChoiceSumScoredAssessmentCompletionData {
        score
        categorization
        color
      }
      ... on HADSAssessmentCompletionData {
        subscores {
          score
          categorization
          color
        }
      }
      ... on ASRS19AssessmentCompletionData {
        subscores {
          score
          categorization
          color
        }
      }
      ... on CBIAssessmentCompletionData {
        subscores {
          subscale
          score
          categorization
          color
        }
      }
    }
    previouslyCompletedProgramAssessmentOfSameType {
      completionData {
        schemaType
        ... on MultipleChoiceSumScoredAssessmentCompletionData {
          score
        }
        ... on HADSAssessmentCompletionData {
          subscores {
            score
          }
        }
      }
    }
  }
}
    ${BasicAssessmentDataFragmentDoc}`;

/**
 * __useLatestCompletedProgramAssessmentsQuery__
 *
 * To run a query within a React component, call `useLatestCompletedProgramAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLatestCompletedProgramAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestCompletedProgramAssessmentsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useLatestCompletedProgramAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<LatestCompletedProgramAssessmentsQuery, LatestCompletedProgramAssessmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LatestCompletedProgramAssessmentsQuery, LatestCompletedProgramAssessmentsQueryVariables>(LatestCompletedProgramAssessmentsDocument, options);
      }
export function useLatestCompletedProgramAssessmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LatestCompletedProgramAssessmentsQuery, LatestCompletedProgramAssessmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LatestCompletedProgramAssessmentsQuery, LatestCompletedProgramAssessmentsQueryVariables>(LatestCompletedProgramAssessmentsDocument, options);
        }
export type LatestCompletedProgramAssessmentsQueryHookResult = ReturnType<typeof useLatestCompletedProgramAssessmentsQuery>;
export type LatestCompletedProgramAssessmentsLazyQueryHookResult = ReturnType<typeof useLatestCompletedProgramAssessmentsLazyQuery>;
export type LatestCompletedProgramAssessmentsQueryResult = Apollo.QueryResult<LatestCompletedProgramAssessmentsQuery, LatestCompletedProgramAssessmentsQueryVariables>;
export const CompletedProgramAssessmentsDataDocument = gql`
    query CompletedProgramAssessmentsData($programId: String!, $assessmentId: String!) {
  assessment(assessmentId: $assessmentId) {
    ...assessmentData
  }
  completedProgramAssessmentsByAssessment(
    assessmentId: $assessmentId
    programId: $programId
  ) {
    ...programAssessmentData
    id
    startDate
    completedAt
    completedByType
    completedByExternalName
    completedByProviderUser {
      name
    }
    programAssessmentSignatureUsers {
      providerUser {
        name
      }
      signedAt
    }
    additionalThoughts
    completionData {
      schemaType
      ... on MultipleChoiceSumScoredAssessmentCompletionData {
        score
        categorization
        color
      }
      ... on HADSAssessmentCompletionData {
        subscores {
          score
          color
          categorization
        }
      }
      ... on ASRS19AssessmentCompletionData {
        subscores {
          score
          color
          categorization
        }
      }
      ... on CBIAssessmentCompletionData {
        subscores {
          subscale
          score
          color
          categorization
        }
      }
    }
    answers {
      ...assessmentAnswerData
      ... on AutofillAssessmentAnswer {
        question
        autofillAnswer: answer
      }
      ... on DatePickerAssessmentAnswer {
        question
        datePickerAnswer: answer
      }
    }
  }
}
    ${AssessmentDataFragmentDoc}
${ProgramAssessmentDataFragmentDoc}
${AssessmentAnswerDataFragmentDoc}`;

/**
 * __useCompletedProgramAssessmentsDataQuery__
 *
 * To run a query within a React component, call `useCompletedProgramAssessmentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompletedProgramAssessmentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompletedProgramAssessmentsDataQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useCompletedProgramAssessmentsDataQuery(baseOptions: Apollo.QueryHookOptions<CompletedProgramAssessmentsDataQuery, CompletedProgramAssessmentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompletedProgramAssessmentsDataQuery, CompletedProgramAssessmentsDataQueryVariables>(CompletedProgramAssessmentsDataDocument, options);
      }
export function useCompletedProgramAssessmentsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompletedProgramAssessmentsDataQuery, CompletedProgramAssessmentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompletedProgramAssessmentsDataQuery, CompletedProgramAssessmentsDataQueryVariables>(CompletedProgramAssessmentsDataDocument, options);
        }
export type CompletedProgramAssessmentsDataQueryHookResult = ReturnType<typeof useCompletedProgramAssessmentsDataQuery>;
export type CompletedProgramAssessmentsDataLazyQueryHookResult = ReturnType<typeof useCompletedProgramAssessmentsDataLazyQuery>;
export type CompletedProgramAssessmentsDataQueryResult = Apollo.QueryResult<CompletedProgramAssessmentsDataQuery, CompletedProgramAssessmentsDataQueryVariables>;
export const ProgramAssessmentDocument = gql`
    query ProgramAssessment($programAssessmentId: String!) {
  programAssessment(programAssessmentId: $programAssessmentId) {
    ...programAssessmentData
    currentSigner {
      ...programAssessmentSignatureUserData
    }
    programAssessmentSignatureUsers {
      ...programAssessmentSignatureUserData
    }
  }
}
    ${ProgramAssessmentDataFragmentDoc}
${ProgramAssessmentSignatureUserDataFragmentDoc}`;

/**
 * __useProgramAssessmentQuery__
 *
 * To run a query within a React component, call `useProgramAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAssessmentQuery({
 *   variables: {
 *      programAssessmentId: // value for 'programAssessmentId'
 *   },
 * });
 */
export function useProgramAssessmentQuery(baseOptions: Apollo.QueryHookOptions<ProgramAssessmentQuery, ProgramAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramAssessmentQuery, ProgramAssessmentQueryVariables>(ProgramAssessmentDocument, options);
      }
export function useProgramAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramAssessmentQuery, ProgramAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramAssessmentQuery, ProgramAssessmentQueryVariables>(ProgramAssessmentDocument, options);
        }
export type ProgramAssessmentQueryHookResult = ReturnType<typeof useProgramAssessmentQuery>;
export type ProgramAssessmentLazyQueryHookResult = ReturnType<typeof useProgramAssessmentLazyQuery>;
export type ProgramAssessmentQueryResult = Apollo.QueryResult<ProgramAssessmentQuery, ProgramAssessmentQueryVariables>;
export const ProviderSignMultiSignatureAssessmentDocument = gql`
    mutation ProviderSignMultiSignatureAssessment($programAssessmentId: String!, $signatureName: String!, $signatureRole: String!) {
  providerSignMultiSignatureAssessment(
    programAssessmentId: $programAssessmentId
    signatureName: $signatureName
    signatureRole: $signatureRole
  ) {
    id
    assessment {
      id
      name
    }
    programAssessmentSignatureUsers {
      ...programAssessmentSignatureUserData
    }
  }
}
    ${ProgramAssessmentSignatureUserDataFragmentDoc}`;
export type ProviderSignMultiSignatureAssessmentMutationFn = Apollo.MutationFunction<ProviderSignMultiSignatureAssessmentMutation, ProviderSignMultiSignatureAssessmentMutationVariables>;

/**
 * __useProviderSignMultiSignatureAssessmentMutation__
 *
 * To run a mutation, you first call `useProviderSignMultiSignatureAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderSignMultiSignatureAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerSignMultiSignatureAssessmentMutation, { data, loading, error }] = useProviderSignMultiSignatureAssessmentMutation({
 *   variables: {
 *      programAssessmentId: // value for 'programAssessmentId'
 *      signatureName: // value for 'signatureName'
 *      signatureRole: // value for 'signatureRole'
 *   },
 * });
 */
export function useProviderSignMultiSignatureAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ProviderSignMultiSignatureAssessmentMutation, ProviderSignMultiSignatureAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderSignMultiSignatureAssessmentMutation, ProviderSignMultiSignatureAssessmentMutationVariables>(ProviderSignMultiSignatureAssessmentDocument, options);
      }
export type ProviderSignMultiSignatureAssessmentMutationHookResult = ReturnType<typeof useProviderSignMultiSignatureAssessmentMutation>;
export type ProviderSignMultiSignatureAssessmentMutationResult = Apollo.MutationResult<ProviderSignMultiSignatureAssessmentMutation>;
export type ProviderSignMultiSignatureAssessmentMutationOptions = Apollo.BaseMutationOptions<ProviderSignMultiSignatureAssessmentMutation, ProviderSignMultiSignatureAssessmentMutationVariables>;
export const ProviderCompleteFormDocument = gql`
    mutation providerCompleteForm($input: ProviderCompleteFormInput!) {
  providerCompleteForm(input: $input) {
    id
    assessment {
      id
      name
    }
    programAssessmentSignatureUsers {
      ...programAssessmentSignatureUserData
    }
  }
}
    ${ProgramAssessmentSignatureUserDataFragmentDoc}`;
export type ProviderCompleteFormMutationFn = Apollo.MutationFunction<ProviderCompleteFormMutation, ProviderCompleteFormMutationVariables>;

/**
 * __useProviderCompleteFormMutation__
 *
 * To run a mutation, you first call `useProviderCompleteFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderCompleteFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerCompleteFormMutation, { data, loading, error }] = useProviderCompleteFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderCompleteFormMutation(baseOptions?: Apollo.MutationHookOptions<ProviderCompleteFormMutation, ProviderCompleteFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderCompleteFormMutation, ProviderCompleteFormMutationVariables>(ProviderCompleteFormDocument, options);
      }
export type ProviderCompleteFormMutationHookResult = ReturnType<typeof useProviderCompleteFormMutation>;
export type ProviderCompleteFormMutationResult = Apollo.MutationResult<ProviderCompleteFormMutation>;
export type ProviderCompleteFormMutationOptions = Apollo.BaseMutationOptions<ProviderCompleteFormMutation, ProviderCompleteFormMutationVariables>;
export const ProviderProgramAssessmentDocument = gql`
    query ProviderProgramAssessment($programAssessmentId: String!) {
  programAssessment(programAssessmentId: $programAssessmentId) {
    ...programAssessmentData
    programAssessmentSignatureUsers {
      ...programAssessmentSignatureUserData
    }
    currentSigner {
      ...programAssessmentSignatureUserData
    }
    answers {
      ...assessmentAnswerData
      ... on AutofillAssessmentAnswer {
        question
        autofillAnswer: answer
      }
      ... on DatePickerAssessmentAnswer {
        question
        datePickerAnswer: answer
      }
    }
  }
}
    ${ProgramAssessmentDataFragmentDoc}
${ProgramAssessmentSignatureUserDataFragmentDoc}
${AssessmentAnswerDataFragmentDoc}`;

/**
 * __useProviderProgramAssessmentQuery__
 *
 * To run a query within a React component, call `useProviderProgramAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderProgramAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderProgramAssessmentQuery({
 *   variables: {
 *      programAssessmentId: // value for 'programAssessmentId'
 *   },
 * });
 */
export function useProviderProgramAssessmentQuery(baseOptions: Apollo.QueryHookOptions<ProviderProgramAssessmentQuery, ProviderProgramAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderProgramAssessmentQuery, ProviderProgramAssessmentQueryVariables>(ProviderProgramAssessmentDocument, options);
      }
export function useProviderProgramAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderProgramAssessmentQuery, ProviderProgramAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderProgramAssessmentQuery, ProviderProgramAssessmentQueryVariables>(ProviderProgramAssessmentDocument, options);
        }
export type ProviderProgramAssessmentQueryHookResult = ReturnType<typeof useProviderProgramAssessmentQuery>;
export type ProviderProgramAssessmentLazyQueryHookResult = ReturnType<typeof useProviderProgramAssessmentLazyQuery>;
export type ProviderProgramAssessmentQueryResult = Apollo.QueryResult<ProviderProgramAssessmentQuery, ProviderProgramAssessmentQueryVariables>;
export const ProgramAssessmentScheduleDocument = gql`
    query ProgramAssessmentSchedule($programId: String!) {
  programAssessmentSchedule(programId: $programId) {
    scheduledProgramAssessments {
      id
      startDate
      assessment {
        shortName
      }
    }
    deliveredProgramAssessments {
      id
      startDate
      assessment {
        shortName
      }
      completedAt
      dismissedAt
      notifiedAt
      hasExpired
    }
  }
}
    `;

/**
 * __useProgramAssessmentScheduleQuery__
 *
 * To run a query within a React component, call `useProgramAssessmentScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramAssessmentScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramAssessmentScheduleQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramAssessmentScheduleQuery(baseOptions: Apollo.QueryHookOptions<ProgramAssessmentScheduleQuery, ProgramAssessmentScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramAssessmentScheduleQuery, ProgramAssessmentScheduleQueryVariables>(ProgramAssessmentScheduleDocument, options);
      }
export function useProgramAssessmentScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramAssessmentScheduleQuery, ProgramAssessmentScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramAssessmentScheduleQuery, ProgramAssessmentScheduleQueryVariables>(ProgramAssessmentScheduleDocument, options);
        }
export type ProgramAssessmentScheduleQueryHookResult = ReturnType<typeof useProgramAssessmentScheduleQuery>;
export type ProgramAssessmentScheduleLazyQueryHookResult = ReturnType<typeof useProgramAssessmentScheduleLazyQuery>;
export type ProgramAssessmentScheduleQueryResult = Apollo.QueryResult<ProgramAssessmentScheduleQuery, ProgramAssessmentScheduleQueryVariables>;
export const CustomAssessmentDocument = gql`
    query CustomAssessment($assessmentId: String!, $programId: String) {
  assessment(assessmentId: $assessmentId, programId: $programId) {
    ...assessmentData
    questions {
      ...assessmentQuestionData
    }
  }
}
    ${AssessmentDataFragmentDoc}
${AssessmentQuestionDataFragmentDoc}`;

/**
 * __useCustomAssessmentQuery__
 *
 * To run a query within a React component, call `useCustomAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useCustomAssessmentQuery(baseOptions: Apollo.QueryHookOptions<CustomAssessmentQuery, CustomAssessmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomAssessmentQuery, CustomAssessmentQueryVariables>(CustomAssessmentDocument, options);
      }
export function useCustomAssessmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomAssessmentQuery, CustomAssessmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomAssessmentQuery, CustomAssessmentQueryVariables>(CustomAssessmentDocument, options);
        }
export type CustomAssessmentQueryHookResult = ReturnType<typeof useCustomAssessmentQuery>;
export type CustomAssessmentLazyQueryHookResult = ReturnType<typeof useCustomAssessmentLazyQuery>;
export type CustomAssessmentQueryResult = Apollo.QueryResult<CustomAssessmentQuery, CustomAssessmentQueryVariables>;
export const ProviderUserSignableFormsCountDocument = gql`
    query providerUserSignableFormsCount {
  providerUserSignableFormsCount
}
    `;

/**
 * __useProviderUserSignableFormsCountQuery__
 *
 * To run a query within a React component, call `useProviderUserSignableFormsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserSignableFormsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserSignableFormsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderUserSignableFormsCountQuery(baseOptions?: Apollo.QueryHookOptions<ProviderUserSignableFormsCountQuery, ProviderUserSignableFormsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserSignableFormsCountQuery, ProviderUserSignableFormsCountQueryVariables>(ProviderUserSignableFormsCountDocument, options);
      }
export function useProviderUserSignableFormsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserSignableFormsCountQuery, ProviderUserSignableFormsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserSignableFormsCountQuery, ProviderUserSignableFormsCountQueryVariables>(ProviderUserSignableFormsCountDocument, options);
        }
export type ProviderUserSignableFormsCountQueryHookResult = ReturnType<typeof useProviderUserSignableFormsCountQuery>;
export type ProviderUserSignableFormsCountLazyQueryHookResult = ReturnType<typeof useProviderUserSignableFormsCountLazyQuery>;
export type ProviderUserSignableFormsCountQueryResult = Apollo.QueryResult<ProviderUserSignableFormsCountQuery, ProviderUserSignableFormsCountQueryVariables>;
export const ProviderUserSignableFormsDocument = gql`
    query ProviderUserSignableForms {
  providerUserSignableForms {
    ...unsignedFormData
  }
}
    ${UnsignedFormDataFragmentDoc}`;

/**
 * __useProviderUserSignableFormsQuery__
 *
 * To run a query within a React component, call `useProviderUserSignableFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserSignableFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserSignableFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderUserSignableFormsQuery(baseOptions?: Apollo.QueryHookOptions<ProviderUserSignableFormsQuery, ProviderUserSignableFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserSignableFormsQuery, ProviderUserSignableFormsQueryVariables>(ProviderUserSignableFormsDocument, options);
      }
export function useProviderUserSignableFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserSignableFormsQuery, ProviderUserSignableFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserSignableFormsQuery, ProviderUserSignableFormsQueryVariables>(ProviderUserSignableFormsDocument, options);
        }
export type ProviderUserSignableFormsQueryHookResult = ReturnType<typeof useProviderUserSignableFormsQuery>;
export type ProviderUserSignableFormsLazyQueryHookResult = ReturnType<typeof useProviderUserSignableFormsLazyQuery>;
export type ProviderUserSignableFormsQueryResult = Apollo.QueryResult<ProviderUserSignableFormsQuery, ProviderUserSignableFormsQueryVariables>;
export const CreateCustomAssessmentDocument = gql`
    mutation CreateCustomAssessment($input: CreateCustomAssessmentInput!) {
  createCustomAssessment(input: $input) {
    id
    name
  }
}
    `;
export type CreateCustomAssessmentMutationFn = Apollo.MutationFunction<CreateCustomAssessmentMutation, CreateCustomAssessmentMutationVariables>;

/**
 * __useCreateCustomAssessmentMutation__
 *
 * To run a mutation, you first call `useCreateCustomAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomAssessmentMutation, { data, loading, error }] = useCreateCustomAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomAssessmentMutation, CreateCustomAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomAssessmentMutation, CreateCustomAssessmentMutationVariables>(CreateCustomAssessmentDocument, options);
      }
export type CreateCustomAssessmentMutationHookResult = ReturnType<typeof useCreateCustomAssessmentMutation>;
export type CreateCustomAssessmentMutationResult = Apollo.MutationResult<CreateCustomAssessmentMutation>;
export type CreateCustomAssessmentMutationOptions = Apollo.BaseMutationOptions<CreateCustomAssessmentMutation, CreateCustomAssessmentMutationVariables>;
export const UpdateCustomAssessmentDocument = gql`
    mutation UpdateCustomAssessment($input: UpdateCustomAssessmentInput!) {
  updateCustomAssessment(input: $input) {
    id
    name
  }
}
    `;
export type UpdateCustomAssessmentMutationFn = Apollo.MutationFunction<UpdateCustomAssessmentMutation, UpdateCustomAssessmentMutationVariables>;

/**
 * __useUpdateCustomAssessmentMutation__
 *
 * To run a mutation, you first call `useUpdateCustomAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomAssessmentMutation, { data, loading, error }] = useUpdateCustomAssessmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomAssessmentMutation, UpdateCustomAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomAssessmentMutation, UpdateCustomAssessmentMutationVariables>(UpdateCustomAssessmentDocument, options);
      }
export type UpdateCustomAssessmentMutationHookResult = ReturnType<typeof useUpdateCustomAssessmentMutation>;
export type UpdateCustomAssessmentMutationResult = Apollo.MutationResult<UpdateCustomAssessmentMutation>;
export type UpdateCustomAssessmentMutationOptions = Apollo.BaseMutationOptions<UpdateCustomAssessmentMutation, UpdateCustomAssessmentMutationVariables>;
export const ArchiveCustomAssessmentDocument = gql`
    mutation ArchiveCustomAssessment($assessmentId: String!) {
  archiveCustomAssessment(assessmentId: $assessmentId) {
    id
  }
}
    `;
export type ArchiveCustomAssessmentMutationFn = Apollo.MutationFunction<ArchiveCustomAssessmentMutation, ArchiveCustomAssessmentMutationVariables>;

/**
 * __useArchiveCustomAssessmentMutation__
 *
 * To run a mutation, you first call `useArchiveCustomAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCustomAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCustomAssessmentMutation, { data, loading, error }] = useArchiveCustomAssessmentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useArchiveCustomAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCustomAssessmentMutation, ArchiveCustomAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCustomAssessmentMutation, ArchiveCustomAssessmentMutationVariables>(ArchiveCustomAssessmentDocument, options);
      }
export type ArchiveCustomAssessmentMutationHookResult = ReturnType<typeof useArchiveCustomAssessmentMutation>;
export type ArchiveCustomAssessmentMutationResult = Apollo.MutationResult<ArchiveCustomAssessmentMutation>;
export type ArchiveCustomAssessmentMutationOptions = Apollo.BaseMutationOptions<ArchiveCustomAssessmentMutation, ArchiveCustomAssessmentMutationVariables>;
export const SaveFormDraftDocument = gql`
    mutation SaveFormDraft($input: SaveFormDraftInput!) {
  saveFormDraft(input: $input) {
    success
  }
}
    `;
export type SaveFormDraftMutationFn = Apollo.MutationFunction<SaveFormDraftMutation, SaveFormDraftMutationVariables>;

/**
 * __useSaveFormDraftMutation__
 *
 * To run a mutation, you first call `useSaveFormDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFormDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFormDraftMutation, { data, loading, error }] = useSaveFormDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFormDraftMutation(baseOptions?: Apollo.MutationHookOptions<SaveFormDraftMutation, SaveFormDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFormDraftMutation, SaveFormDraftMutationVariables>(SaveFormDraftDocument, options);
      }
export type SaveFormDraftMutationHookResult = ReturnType<typeof useSaveFormDraftMutation>;
export type SaveFormDraftMutationResult = Apollo.MutationResult<SaveFormDraftMutation>;
export type SaveFormDraftMutationOptions = Apollo.BaseMutationOptions<SaveFormDraftMutation, SaveFormDraftMutationVariables>;
export const CompleteProviderOnlyFormDocument = gql`
    mutation CompleteProviderOnlyForm($input: CompleteProviderOnlyFormInput!) {
  completeProviderOnlyForm(input: $input) {
    id
    assessment {
      id
      name
    }
    completedAt
  }
}
    `;
export type CompleteProviderOnlyFormMutationFn = Apollo.MutationFunction<CompleteProviderOnlyFormMutation, CompleteProviderOnlyFormMutationVariables>;

/**
 * __useCompleteProviderOnlyFormMutation__
 *
 * To run a mutation, you first call `useCompleteProviderOnlyFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteProviderOnlyFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeProviderOnlyFormMutation, { data, loading, error }] = useCompleteProviderOnlyFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteProviderOnlyFormMutation(baseOptions?: Apollo.MutationHookOptions<CompleteProviderOnlyFormMutation, CompleteProviderOnlyFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteProviderOnlyFormMutation, CompleteProviderOnlyFormMutationVariables>(CompleteProviderOnlyFormDocument, options);
      }
export type CompleteProviderOnlyFormMutationHookResult = ReturnType<typeof useCompleteProviderOnlyFormMutation>;
export type CompleteProviderOnlyFormMutationResult = Apollo.MutationResult<CompleteProviderOnlyFormMutation>;
export type CompleteProviderOnlyFormMutationOptions = Apollo.BaseMutationOptions<CompleteProviderOnlyFormMutation, CompleteProviderOnlyFormMutationVariables>;
export const ExternalPractitionerFormInvitesForContactDocument = gql`
    query ExternalPractitionerFormInvitesForContact($contactId: String!) {
  externalPractitionerFormInvitesForContact(contactId: $contactId) {
    id
    url
    formName
    sentAt
    expiresAt
    status
  }
}
    `;

/**
 * __useExternalPractitionerFormInvitesForContactQuery__
 *
 * To run a query within a React component, call `useExternalPractitionerFormInvitesForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalPractitionerFormInvitesForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalPractitionerFormInvitesForContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useExternalPractitionerFormInvitesForContactQuery(baseOptions: Apollo.QueryHookOptions<ExternalPractitionerFormInvitesForContactQuery, ExternalPractitionerFormInvitesForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalPractitionerFormInvitesForContactQuery, ExternalPractitionerFormInvitesForContactQueryVariables>(ExternalPractitionerFormInvitesForContactDocument, options);
      }
export function useExternalPractitionerFormInvitesForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalPractitionerFormInvitesForContactQuery, ExternalPractitionerFormInvitesForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalPractitionerFormInvitesForContactQuery, ExternalPractitionerFormInvitesForContactQueryVariables>(ExternalPractitionerFormInvitesForContactDocument, options);
        }
export type ExternalPractitionerFormInvitesForContactQueryHookResult = ReturnType<typeof useExternalPractitionerFormInvitesForContactQuery>;
export type ExternalPractitionerFormInvitesForContactLazyQueryHookResult = ReturnType<typeof useExternalPractitionerFormInvitesForContactLazyQuery>;
export type ExternalPractitionerFormInvitesForContactQueryResult = Apollo.QueryResult<ExternalPractitionerFormInvitesForContactQuery, ExternalPractitionerFormInvitesForContactQueryVariables>;
export const CreateExternalPractitionerFormInviteDocument = gql`
    mutation CreateExternalPractitionerFormInvite($input: CreateExternalPractitionerFormInviteInput!) {
  createExternalPractitionerFormInvite(input: $input) {
    inviteId
    url
    expiresAt
    programAssessmentId
  }
}
    `;
export type CreateExternalPractitionerFormInviteMutationFn = Apollo.MutationFunction<CreateExternalPractitionerFormInviteMutation, CreateExternalPractitionerFormInviteMutationVariables>;

/**
 * __useCreateExternalPractitionerFormInviteMutation__
 *
 * To run a mutation, you first call `useCreateExternalPractitionerFormInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExternalPractitionerFormInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExternalPractitionerFormInviteMutation, { data, loading, error }] = useCreateExternalPractitionerFormInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExternalPractitionerFormInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateExternalPractitionerFormInviteMutation, CreateExternalPractitionerFormInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExternalPractitionerFormInviteMutation, CreateExternalPractitionerFormInviteMutationVariables>(CreateExternalPractitionerFormInviteDocument, options);
      }
export type CreateExternalPractitionerFormInviteMutationHookResult = ReturnType<typeof useCreateExternalPractitionerFormInviteMutation>;
export type CreateExternalPractitionerFormInviteMutationResult = Apollo.MutationResult<CreateExternalPractitionerFormInviteMutation>;
export type CreateExternalPractitionerFormInviteMutationOptions = Apollo.BaseMutationOptions<CreateExternalPractitionerFormInviteMutation, CreateExternalPractitionerFormInviteMutationVariables>;
export const PatientCompletedProgramAssessmentsDataDocument = gql`
    query PatientCompletedProgramAssessmentsData($assessmentId: String!) {
  patientCompletedProgramAssessmentsByAssessment(assessmentId: $assessmentId) {
    ...programAssessmentData
    id
    startDate
    completedAt
    completedByType
    completedByExternalName
    completedByProviderUser {
      name
    }
    programAssessmentSignatureUsers {
      providerUser {
        name
      }
      signedAt
    }
    additionalThoughts
    completionData {
      schemaType
      ... on MultipleChoiceSumScoredAssessmentCompletionData {
        score
        categorization
        color
      }
      ... on HADSAssessmentCompletionData {
        subscores {
          score
          color
          categorization
        }
      }
      ... on ASRS19AssessmentCompletionData {
        subscores {
          score
          color
          categorization
        }
      }
      ... on CBIAssessmentCompletionData {
        subscores {
          subscale
          score
          color
          categorization
        }
      }
    }
  }
}
    ${ProgramAssessmentDataFragmentDoc}`;

/**
 * __usePatientCompletedProgramAssessmentsDataQuery__
 *
 * To run a query within a React component, call `usePatientCompletedProgramAssessmentsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientCompletedProgramAssessmentsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientCompletedProgramAssessmentsDataQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function usePatientCompletedProgramAssessmentsDataQuery(baseOptions: Apollo.QueryHookOptions<PatientCompletedProgramAssessmentsDataQuery, PatientCompletedProgramAssessmentsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientCompletedProgramAssessmentsDataQuery, PatientCompletedProgramAssessmentsDataQueryVariables>(PatientCompletedProgramAssessmentsDataDocument, options);
      }
export function usePatientCompletedProgramAssessmentsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientCompletedProgramAssessmentsDataQuery, PatientCompletedProgramAssessmentsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientCompletedProgramAssessmentsDataQuery, PatientCompletedProgramAssessmentsDataQueryVariables>(PatientCompletedProgramAssessmentsDataDocument, options);
        }
export type PatientCompletedProgramAssessmentsDataQueryHookResult = ReturnType<typeof usePatientCompletedProgramAssessmentsDataQuery>;
export type PatientCompletedProgramAssessmentsDataLazyQueryHookResult = ReturnType<typeof usePatientCompletedProgramAssessmentsDataLazyQuery>;
export type PatientCompletedProgramAssessmentsDataQueryResult = Apollo.QueryResult<PatientCompletedProgramAssessmentsDataQuery, PatientCompletedProgramAssessmentsDataQueryVariables>;
export const AuditLogsDocument = gql`
    query AuditLogs($entityType: String!, $entityId: String!, $limit: Int, $offset: Int) {
  auditLogs(
    entityType: $entityType
    entityId: $entityId
    limit: $limit
    offset: $offset
  ) {
    id
    activityType
    actorType
    performedByProviderUser {
      id
      name
      profileImageMedia {
        url
      }
    }
    performedAt
    extraMetadata
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *      entityId: // value for 'entityId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;
export const AuthenticationRequestVerificationCodeDocument = gql`
    mutation AuthenticationRequestVerificationCode($input: AuthenticationRequestCodeInput!) {
  authenticationRequestCode(input: $input) {
    success
    verificationId
    maskedEmail
    codeSent
    nextResendAllowedAt
    errors {
      field
      message
    }
  }
}
    `;
export type AuthenticationRequestVerificationCodeMutationFn = Apollo.MutationFunction<AuthenticationRequestVerificationCodeMutation, AuthenticationRequestVerificationCodeMutationVariables>;

/**
 * __useAuthenticationRequestVerificationCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticationRequestVerificationCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationRequestVerificationCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationRequestVerificationCodeMutation, { data, loading, error }] = useAuthenticationRequestVerificationCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationRequestVerificationCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationRequestVerificationCodeMutation, AuthenticationRequestVerificationCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationRequestVerificationCodeMutation, AuthenticationRequestVerificationCodeMutationVariables>(AuthenticationRequestVerificationCodeDocument, options);
      }
export type AuthenticationRequestVerificationCodeMutationHookResult = ReturnType<typeof useAuthenticationRequestVerificationCodeMutation>;
export type AuthenticationRequestVerificationCodeMutationResult = Apollo.MutationResult<AuthenticationRequestVerificationCodeMutation>;
export type AuthenticationRequestVerificationCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticationRequestVerificationCodeMutation, AuthenticationRequestVerificationCodeMutationVariables>;
export const AuthenticationResendCodeDocument = gql`
    mutation AuthenticationResendCode($input: AuthenticationResendCodeInput!) {
  authenticationResendCode(input: $input) {
    success
    verificationId
    maskedEmail
    codeSent
    nextResendAllowedAt
    errors {
      field
      message
    }
  }
}
    `;
export type AuthenticationResendCodeMutationFn = Apollo.MutationFunction<AuthenticationResendCodeMutation, AuthenticationResendCodeMutationVariables>;

/**
 * __useAuthenticationResendCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticationResendCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationResendCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationResendCodeMutation, { data, loading, error }] = useAuthenticationResendCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationResendCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationResendCodeMutation, AuthenticationResendCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationResendCodeMutation, AuthenticationResendCodeMutationVariables>(AuthenticationResendCodeDocument, options);
      }
export type AuthenticationResendCodeMutationHookResult = ReturnType<typeof useAuthenticationResendCodeMutation>;
export type AuthenticationResendCodeMutationResult = Apollo.MutationResult<AuthenticationResendCodeMutation>;
export type AuthenticationResendCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticationResendCodeMutation, AuthenticationResendCodeMutationVariables>;
export const AuthenticationVerifyCodeDocument = gql`
    mutation AuthenticationVerifyCode($input: AuthenticationVerifyCodeInput!) {
  authenticationVerifyCode(input: $input) {
    success
    sessionToken
    userId
    userType
    createdAt
    expiresAt
    errors {
      field
      message
    }
  }
}
    `;
export type AuthenticationVerifyCodeMutationFn = Apollo.MutationFunction<AuthenticationVerifyCodeMutation, AuthenticationVerifyCodeMutationVariables>;

/**
 * __useAuthenticationVerifyCodeMutation__
 *
 * To run a mutation, you first call `useAuthenticationVerifyCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationVerifyCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationVerifyCodeMutation, { data, loading, error }] = useAuthenticationVerifyCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAuthenticationVerifyCodeMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationVerifyCodeMutation, AuthenticationVerifyCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationVerifyCodeMutation, AuthenticationVerifyCodeMutationVariables>(AuthenticationVerifyCodeDocument, options);
      }
export type AuthenticationVerifyCodeMutationHookResult = ReturnType<typeof useAuthenticationVerifyCodeMutation>;
export type AuthenticationVerifyCodeMutationResult = Apollo.MutationResult<AuthenticationVerifyCodeMutation>;
export type AuthenticationVerifyCodeMutationOptions = Apollo.BaseMutationOptions<AuthenticationVerifyCodeMutation, AuthenticationVerifyCodeMutationVariables>;
export const AuthenticationCodeVerificationDocument = gql`
    query AuthenticationCodeVerification($verificationId: ID!) {
  authenticationCodeVerification(verificationId: $verificationId) {
    success
    verificationId
    maskedEmail
    nextResendAllowedAt
    providerWordmarkLogoUrl
    errors {
      field
      message
    }
  }
}
    `;

/**
 * __useAuthenticationCodeVerificationQuery__
 *
 * To run a query within a React component, call `useAuthenticationCodeVerificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationCodeVerificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationCodeVerificationQuery({
 *   variables: {
 *      verificationId: // value for 'verificationId'
 *   },
 * });
 */
export function useAuthenticationCodeVerificationQuery(baseOptions: Apollo.QueryHookOptions<AuthenticationCodeVerificationQuery, AuthenticationCodeVerificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticationCodeVerificationQuery, AuthenticationCodeVerificationQueryVariables>(AuthenticationCodeVerificationDocument, options);
      }
export function useAuthenticationCodeVerificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticationCodeVerificationQuery, AuthenticationCodeVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticationCodeVerificationQuery, AuthenticationCodeVerificationQueryVariables>(AuthenticationCodeVerificationDocument, options);
        }
export type AuthenticationCodeVerificationQueryHookResult = ReturnType<typeof useAuthenticationCodeVerificationQuery>;
export type AuthenticationCodeVerificationLazyQueryHookResult = ReturnType<typeof useAuthenticationCodeVerificationLazyQuery>;
export type AuthenticationCodeVerificationQueryResult = Apollo.QueryResult<AuthenticationCodeVerificationQuery, AuthenticationCodeVerificationQueryVariables>;
export const AuthenticationLogoutDocument = gql`
    mutation AuthenticationLogout {
  authenticationLogout {
    success
    errors {
      field
      message
    }
  }
}
    `;
export type AuthenticationLogoutMutationFn = Apollo.MutationFunction<AuthenticationLogoutMutation, AuthenticationLogoutMutationVariables>;

/**
 * __useAuthenticationLogoutMutation__
 *
 * To run a mutation, you first call `useAuthenticationLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticationLogoutMutation, { data, loading, error }] = useAuthenticationLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticationLogoutMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticationLogoutMutation, AuthenticationLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticationLogoutMutation, AuthenticationLogoutMutationVariables>(AuthenticationLogoutDocument, options);
      }
export type AuthenticationLogoutMutationHookResult = ReturnType<typeof useAuthenticationLogoutMutation>;
export type AuthenticationLogoutMutationResult = Apollo.MutationResult<AuthenticationLogoutMutation>;
export type AuthenticationLogoutMutationOptions = Apollo.BaseMutationOptions<AuthenticationLogoutMutation, AuthenticationLogoutMutationVariables>;
export const AutomationRulesDocument = gql`
    query AutomationRules($limit: Int = 100) {
  automationRules(limit: $limit) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;

/**
 * __useAutomationRulesQuery__
 *
 * To run a query within a React component, call `useAutomationRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationRulesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAutomationRulesQuery(baseOptions?: Apollo.QueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationRulesQuery, AutomationRulesQueryVariables>(AutomationRulesDocument, options);
      }
export function useAutomationRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationRulesQuery, AutomationRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationRulesQuery, AutomationRulesQueryVariables>(AutomationRulesDocument, options);
        }
export type AutomationRulesQueryHookResult = ReturnType<typeof useAutomationRulesQuery>;
export type AutomationRulesLazyQueryHookResult = ReturnType<typeof useAutomationRulesLazyQuery>;
export type AutomationRulesQueryResult = Apollo.QueryResult<AutomationRulesQuery, AutomationRulesQueryVariables>;
export const AutomationRuleDocument = gql`
    query AutomationRule($automationRuleId: String!) {
  automationRule(automationRuleId: $automationRuleId) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;

/**
 * __useAutomationRuleQuery__
 *
 * To run a query within a React component, call `useAutomationRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationRuleQuery({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *   },
 * });
 */
export function useAutomationRuleQuery(baseOptions: Apollo.QueryHookOptions<AutomationRuleQuery, AutomationRuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationRuleQuery, AutomationRuleQueryVariables>(AutomationRuleDocument, options);
      }
export function useAutomationRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationRuleQuery, AutomationRuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationRuleQuery, AutomationRuleQueryVariables>(AutomationRuleDocument, options);
        }
export type AutomationRuleQueryHookResult = ReturnType<typeof useAutomationRuleQuery>;
export type AutomationRuleLazyQueryHookResult = ReturnType<typeof useAutomationRuleLazyQuery>;
export type AutomationRuleQueryResult = Apollo.QueryResult<AutomationRuleQuery, AutomationRuleQueryVariables>;
export const CreateAutomationRuleDocument = gql`
    mutation CreateAutomationRule($input: CreateAutomationRuleInput!) {
  createAutomationRule(input: $input) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;
export type CreateAutomationRuleMutationFn = Apollo.MutationFunction<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>;

/**
 * __useCreateAutomationRuleMutation__
 *
 * To run a mutation, you first call `useCreateAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationRuleMutation, { data, loading, error }] = useCreateAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>(CreateAutomationRuleDocument, options);
      }
export type CreateAutomationRuleMutationHookResult = ReturnType<typeof useCreateAutomationRuleMutation>;
export type CreateAutomationRuleMutationResult = Apollo.MutationResult<CreateAutomationRuleMutation>;
export type CreateAutomationRuleMutationOptions = Apollo.BaseMutationOptions<CreateAutomationRuleMutation, CreateAutomationRuleMutationVariables>;
export const UpdateAutomationRuleDocument = gql`
    mutation UpdateAutomationRule($input: UpdateAutomationRuleInput!) {
  updateAutomationRule(input: $input) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;
export type UpdateAutomationRuleMutationFn = Apollo.MutationFunction<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>;

/**
 * __useUpdateAutomationRuleMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationRuleMutation, { data, loading, error }] = useUpdateAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>(UpdateAutomationRuleDocument, options);
      }
export type UpdateAutomationRuleMutationHookResult = ReturnType<typeof useUpdateAutomationRuleMutation>;
export type UpdateAutomationRuleMutationResult = Apollo.MutationResult<UpdateAutomationRuleMutation>;
export type UpdateAutomationRuleMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationRuleMutation, UpdateAutomationRuleMutationVariables>;
export const DeleteAutomationRuleDocument = gql`
    mutation DeleteAutomationRule($automationRuleId: String!) {
  deleteAutomationRule(automationRuleId: $automationRuleId)
}
    `;
export type DeleteAutomationRuleMutationFn = Apollo.MutationFunction<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>;

/**
 * __useDeleteAutomationRuleMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationRuleMutation, { data, loading, error }] = useDeleteAutomationRuleMutation({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *   },
 * });
 */
export function useDeleteAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>(DeleteAutomationRuleDocument, options);
      }
export type DeleteAutomationRuleMutationHookResult = ReturnType<typeof useDeleteAutomationRuleMutation>;
export type DeleteAutomationRuleMutationResult = Apollo.MutationResult<DeleteAutomationRuleMutation>;
export type DeleteAutomationRuleMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationRuleMutation, DeleteAutomationRuleMutationVariables>;
export const EnableAutomationRuleDocument = gql`
    mutation EnableAutomationRule($automationRuleId: String!) {
  enableAutomationRule(automationRuleId: $automationRuleId) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;
export type EnableAutomationRuleMutationFn = Apollo.MutationFunction<EnableAutomationRuleMutation, EnableAutomationRuleMutationVariables>;

/**
 * __useEnableAutomationRuleMutation__
 *
 * To run a mutation, you first call `useEnableAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAutomationRuleMutation, { data, loading, error }] = useEnableAutomationRuleMutation({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *   },
 * });
 */
export function useEnableAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<EnableAutomationRuleMutation, EnableAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableAutomationRuleMutation, EnableAutomationRuleMutationVariables>(EnableAutomationRuleDocument, options);
      }
export type EnableAutomationRuleMutationHookResult = ReturnType<typeof useEnableAutomationRuleMutation>;
export type EnableAutomationRuleMutationResult = Apollo.MutationResult<EnableAutomationRuleMutation>;
export type EnableAutomationRuleMutationOptions = Apollo.BaseMutationOptions<EnableAutomationRuleMutation, EnableAutomationRuleMutationVariables>;
export const DisableAutomationRuleDocument = gql`
    mutation DisableAutomationRule($automationRuleId: String!) {
  disableAutomationRule(automationRuleId: $automationRuleId) {
    ...automationRuleData
  }
}
    ${AutomationRuleDataFragmentDoc}`;
export type DisableAutomationRuleMutationFn = Apollo.MutationFunction<DisableAutomationRuleMutation, DisableAutomationRuleMutationVariables>;

/**
 * __useDisableAutomationRuleMutation__
 *
 * To run a mutation, you first call `useDisableAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAutomationRuleMutation, { data, loading, error }] = useDisableAutomationRuleMutation({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *   },
 * });
 */
export function useDisableAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<DisableAutomationRuleMutation, DisableAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableAutomationRuleMutation, DisableAutomationRuleMutationVariables>(DisableAutomationRuleDocument, options);
      }
export type DisableAutomationRuleMutationHookResult = ReturnType<typeof useDisableAutomationRuleMutation>;
export type DisableAutomationRuleMutationResult = Apollo.MutationResult<DisableAutomationRuleMutation>;
export type DisableAutomationRuleMutationOptions = Apollo.BaseMutationOptions<DisableAutomationRuleMutation, DisableAutomationRuleMutationVariables>;
export const CopyAutomationRuleDocument = gql`
    mutation CopyAutomationRule($automationRuleId: String!, $name: String) {
  copyAutomationRule(automationRuleId: $automationRuleId, name: $name) {
    automationRule {
      ...automationRuleData
    }
  }
}
    ${AutomationRuleDataFragmentDoc}`;
export type CopyAutomationRuleMutationFn = Apollo.MutationFunction<CopyAutomationRuleMutation, CopyAutomationRuleMutationVariables>;

/**
 * __useCopyAutomationRuleMutation__
 *
 * To run a mutation, you first call `useCopyAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyAutomationRuleMutation, { data, loading, error }] = useCopyAutomationRuleMutation({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCopyAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<CopyAutomationRuleMutation, CopyAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyAutomationRuleMutation, CopyAutomationRuleMutationVariables>(CopyAutomationRuleDocument, options);
      }
export type CopyAutomationRuleMutationHookResult = ReturnType<typeof useCopyAutomationRuleMutation>;
export type CopyAutomationRuleMutationResult = Apollo.MutationResult<CopyAutomationRuleMutation>;
export type CopyAutomationRuleMutationOptions = Apollo.BaseMutationOptions<CopyAutomationRuleMutation, CopyAutomationRuleMutationVariables>;
export const TestAutomationRuleDocument = gql`
    mutation TestAutomationRule($input: TestAutomationRuleInput!) {
  testAutomationRule(input: $input) {
    success
    triggeredAt
    result
  }
}
    `;
export type TestAutomationRuleMutationFn = Apollo.MutationFunction<TestAutomationRuleMutation, TestAutomationRuleMutationVariables>;

/**
 * __useTestAutomationRuleMutation__
 *
 * To run a mutation, you first call `useTestAutomationRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAutomationRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAutomationRuleMutation, { data, loading, error }] = useTestAutomationRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestAutomationRuleMutation(baseOptions?: Apollo.MutationHookOptions<TestAutomationRuleMutation, TestAutomationRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestAutomationRuleMutation, TestAutomationRuleMutationVariables>(TestAutomationRuleDocument, options);
      }
export type TestAutomationRuleMutationHookResult = ReturnType<typeof useTestAutomationRuleMutation>;
export type TestAutomationRuleMutationResult = Apollo.MutationResult<TestAutomationRuleMutation>;
export type TestAutomationRuleMutationOptions = Apollo.BaseMutationOptions<TestAutomationRuleMutation, TestAutomationRuleMutationVariables>;
export const AutomationExecutionsDocument = gql`
    query AutomationExecutions($automationRuleId: String, $status: AutomationExecutionStatus, $limit: Int = 100) {
  automationExecutions(
    automationRuleId: $automationRuleId
    status: $status
    limit: $limit
  ) {
    id
    automationExecutionId
    automationRuleId
    providerId
    status
    triggerEventType
    eventId
    eventData
    conditionsMet
    actionsExecuted
    actionsSucceeded
    actionsFailed
    errorMessage
    executionResults
    startedAt
    completedAt
    createdAt
  }
}
    `;

/**
 * __useAutomationExecutionsQuery__
 *
 * To run a query within a React component, call `useAutomationExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationExecutionsQuery({
 *   variables: {
 *      automationRuleId: // value for 'automationRuleId'
 *      status: // value for 'status'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAutomationExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<AutomationExecutionsQuery, AutomationExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationExecutionsQuery, AutomationExecutionsQueryVariables>(AutomationExecutionsDocument, options);
      }
export function useAutomationExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationExecutionsQuery, AutomationExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationExecutionsQuery, AutomationExecutionsQueryVariables>(AutomationExecutionsDocument, options);
        }
export type AutomationExecutionsQueryHookResult = ReturnType<typeof useAutomationExecutionsQuery>;
export type AutomationExecutionsLazyQueryHookResult = ReturnType<typeof useAutomationExecutionsLazyQuery>;
export type AutomationExecutionsQueryResult = Apollo.QueryResult<AutomationExecutionsQuery, AutomationExecutionsQueryVariables>;
export const AutomationWebhookConfigDocument = gql`
    query AutomationWebhookConfig {
  automationWebhookConfig {
    webhookUrl
  }
}
    `;

/**
 * __useAutomationWebhookConfigQuery__
 *
 * To run a query within a React component, call `useAutomationWebhookConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutomationWebhookConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationWebhookConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutomationWebhookConfigQuery(baseOptions?: Apollo.QueryHookOptions<AutomationWebhookConfigQuery, AutomationWebhookConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationWebhookConfigQuery, AutomationWebhookConfigQueryVariables>(AutomationWebhookConfigDocument, options);
      }
export function useAutomationWebhookConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationWebhookConfigQuery, AutomationWebhookConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationWebhookConfigQuery, AutomationWebhookConfigQueryVariables>(AutomationWebhookConfigDocument, options);
        }
export type AutomationWebhookConfigQueryHookResult = ReturnType<typeof useAutomationWebhookConfigQuery>;
export type AutomationWebhookConfigLazyQueryHookResult = ReturnType<typeof useAutomationWebhookConfigLazyQuery>;
export type AutomationWebhookConfigQueryResult = Apollo.QueryResult<AutomationWebhookConfigQuery, AutomationWebhookConfigQueryVariables>;
export const UpdateAutomationWebhookConfigDocument = gql`
    mutation UpdateAutomationWebhookConfig($input: UpdateAutomationWebhookConfigInput!) {
  updateAutomationWebhookConfig(input: $input) {
    webhookUrl
  }
}
    `;
export type UpdateAutomationWebhookConfigMutationFn = Apollo.MutationFunction<UpdateAutomationWebhookConfigMutation, UpdateAutomationWebhookConfigMutationVariables>;

/**
 * __useUpdateAutomationWebhookConfigMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationWebhookConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationWebhookConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationWebhookConfigMutation, { data, loading, error }] = useUpdateAutomationWebhookConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutomationWebhookConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationWebhookConfigMutation, UpdateAutomationWebhookConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationWebhookConfigMutation, UpdateAutomationWebhookConfigMutationVariables>(UpdateAutomationWebhookConfigDocument, options);
      }
export type UpdateAutomationWebhookConfigMutationHookResult = ReturnType<typeof useUpdateAutomationWebhookConfigMutation>;
export type UpdateAutomationWebhookConfigMutationResult = Apollo.MutationResult<UpdateAutomationWebhookConfigMutation>;
export type UpdateAutomationWebhookConfigMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationWebhookConfigMutation, UpdateAutomationWebhookConfigMutationVariables>;
export const TestAutomationWebhookDocument = gql`
    mutation TestAutomationWebhook($input: TestAutomationWebhookInput!) {
  testAutomationWebhook(input: $input) {
    success
    statusCode
    message
  }
}
    `;
export type TestAutomationWebhookMutationFn = Apollo.MutationFunction<TestAutomationWebhookMutation, TestAutomationWebhookMutationVariables>;

/**
 * __useTestAutomationWebhookMutation__
 *
 * To run a mutation, you first call `useTestAutomationWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAutomationWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAutomationWebhookMutation, { data, loading, error }] = useTestAutomationWebhookMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTestAutomationWebhookMutation(baseOptions?: Apollo.MutationHookOptions<TestAutomationWebhookMutation, TestAutomationWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TestAutomationWebhookMutation, TestAutomationWebhookMutationVariables>(TestAutomationWebhookDocument, options);
      }
export type TestAutomationWebhookMutationHookResult = ReturnType<typeof useTestAutomationWebhookMutation>;
export type TestAutomationWebhookMutationResult = Apollo.MutationResult<TestAutomationWebhookMutation>;
export type TestAutomationWebhookMutationOptions = Apollo.BaseMutationOptions<TestAutomationWebhookMutation, TestAutomationWebhookMutationVariables>;
export const BrandingBrandSettingsDocument = gql`
    query BrandingBrandSettings {
  brandingBrandSettings {
    id
    primaryColor
    secondaryColor
    verifiedEmailSender {
      id
      status
      fromEmail
      fromName
    }
  }
}
    `;

/**
 * __useBrandingBrandSettingsQuery__
 *
 * To run a query within a React component, call `useBrandingBrandSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandingBrandSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandingBrandSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBrandingBrandSettingsQuery(baseOptions?: Apollo.QueryHookOptions<BrandingBrandSettingsQuery, BrandingBrandSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandingBrandSettingsQuery, BrandingBrandSettingsQueryVariables>(BrandingBrandSettingsDocument, options);
      }
export function useBrandingBrandSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandingBrandSettingsQuery, BrandingBrandSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandingBrandSettingsQuery, BrandingBrandSettingsQueryVariables>(BrandingBrandSettingsDocument, options);
        }
export type BrandingBrandSettingsQueryHookResult = ReturnType<typeof useBrandingBrandSettingsQuery>;
export type BrandingBrandSettingsLazyQueryHookResult = ReturnType<typeof useBrandingBrandSettingsLazyQuery>;
export type BrandingBrandSettingsQueryResult = Apollo.QueryResult<BrandingBrandSettingsQuery, BrandingBrandSettingsQueryVariables>;
export const BrandingCreateVerifiedEmailSenderDocument = gql`
    mutation BrandingCreateVerifiedEmailSender($input: BrandingCreateVerifiedEmailSenderInput!) {
  brandingCreateVerifiedEmailSender(input: $input) {
    success
    verificationId
    verificationStatus
    errors {
      field
      message
    }
  }
}
    `;
export type BrandingCreateVerifiedEmailSenderMutationFn = Apollo.MutationFunction<BrandingCreateVerifiedEmailSenderMutation, BrandingCreateVerifiedEmailSenderMutationVariables>;

/**
 * __useBrandingCreateVerifiedEmailSenderMutation__
 *
 * To run a mutation, you first call `useBrandingCreateVerifiedEmailSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingCreateVerifiedEmailSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingCreateVerifiedEmailSenderMutation, { data, loading, error }] = useBrandingCreateVerifiedEmailSenderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBrandingCreateVerifiedEmailSenderMutation(baseOptions?: Apollo.MutationHookOptions<BrandingCreateVerifiedEmailSenderMutation, BrandingCreateVerifiedEmailSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingCreateVerifiedEmailSenderMutation, BrandingCreateVerifiedEmailSenderMutationVariables>(BrandingCreateVerifiedEmailSenderDocument, options);
      }
export type BrandingCreateVerifiedEmailSenderMutationHookResult = ReturnType<typeof useBrandingCreateVerifiedEmailSenderMutation>;
export type BrandingCreateVerifiedEmailSenderMutationResult = Apollo.MutationResult<BrandingCreateVerifiedEmailSenderMutation>;
export type BrandingCreateVerifiedEmailSenderMutationOptions = Apollo.BaseMutationOptions<BrandingCreateVerifiedEmailSenderMutation, BrandingCreateVerifiedEmailSenderMutationVariables>;
export const BrandingDeleteVerifiedEmailSenderDocument = gql`
    mutation BrandingDeleteVerifiedEmailSender {
  brandingDeleteVerifiedEmailSender {
    success
    errors {
      field
      message
    }
  }
}
    `;
export type BrandingDeleteVerifiedEmailSenderMutationFn = Apollo.MutationFunction<BrandingDeleteVerifiedEmailSenderMutation, BrandingDeleteVerifiedEmailSenderMutationVariables>;

/**
 * __useBrandingDeleteVerifiedEmailSenderMutation__
 *
 * To run a mutation, you first call `useBrandingDeleteVerifiedEmailSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingDeleteVerifiedEmailSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingDeleteVerifiedEmailSenderMutation, { data, loading, error }] = useBrandingDeleteVerifiedEmailSenderMutation({
 *   variables: {
 *   },
 * });
 */
export function useBrandingDeleteVerifiedEmailSenderMutation(baseOptions?: Apollo.MutationHookOptions<BrandingDeleteVerifiedEmailSenderMutation, BrandingDeleteVerifiedEmailSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingDeleteVerifiedEmailSenderMutation, BrandingDeleteVerifiedEmailSenderMutationVariables>(BrandingDeleteVerifiedEmailSenderDocument, options);
      }
export type BrandingDeleteVerifiedEmailSenderMutationHookResult = ReturnType<typeof useBrandingDeleteVerifiedEmailSenderMutation>;
export type BrandingDeleteVerifiedEmailSenderMutationResult = Apollo.MutationResult<BrandingDeleteVerifiedEmailSenderMutation>;
export type BrandingDeleteVerifiedEmailSenderMutationOptions = Apollo.BaseMutationOptions<BrandingDeleteVerifiedEmailSenderMutation, BrandingDeleteVerifiedEmailSenderMutationVariables>;
export const BrandingVerifyEmailSenderDocument = gql`
    mutation BrandingVerifyEmailSender {
  brandingVerifyEmailSender {
    success
    verificationStatus
    verified
    errors {
      field
      message
    }
  }
}
    `;
export type BrandingVerifyEmailSenderMutationFn = Apollo.MutationFunction<BrandingVerifyEmailSenderMutation, BrandingVerifyEmailSenderMutationVariables>;

/**
 * __useBrandingVerifyEmailSenderMutation__
 *
 * To run a mutation, you first call `useBrandingVerifyEmailSenderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBrandingVerifyEmailSenderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [brandingVerifyEmailSenderMutation, { data, loading, error }] = useBrandingVerifyEmailSenderMutation({
 *   variables: {
 *   },
 * });
 */
export function useBrandingVerifyEmailSenderMutation(baseOptions?: Apollo.MutationHookOptions<BrandingVerifyEmailSenderMutation, BrandingVerifyEmailSenderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BrandingVerifyEmailSenderMutation, BrandingVerifyEmailSenderMutationVariables>(BrandingVerifyEmailSenderDocument, options);
      }
export type BrandingVerifyEmailSenderMutationHookResult = ReturnType<typeof useBrandingVerifyEmailSenderMutation>;
export type BrandingVerifyEmailSenderMutationResult = Apollo.MutationResult<BrandingVerifyEmailSenderMutation>;
export type BrandingVerifyEmailSenderMutationOptions = Apollo.BaseMutationOptions<BrandingVerifyEmailSenderMutation, BrandingVerifyEmailSenderMutationVariables>;
export const NylasAuthUrlDocument = gql`
    query NylasAuthUrl($provider: CalendarProvider!) {
  nylasAuthUrl(provider: $provider)
}
    `;

/**
 * __useNylasAuthUrlQuery__
 *
 * To run a query within a React component, call `useNylasAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasAuthUrlQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useNylasAuthUrlQuery(baseOptions: Apollo.QueryHookOptions<NylasAuthUrlQuery, NylasAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasAuthUrlQuery, NylasAuthUrlQueryVariables>(NylasAuthUrlDocument, options);
      }
export function useNylasAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasAuthUrlQuery, NylasAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasAuthUrlQuery, NylasAuthUrlQueryVariables>(NylasAuthUrlDocument, options);
        }
export type NylasAuthUrlQueryHookResult = ReturnType<typeof useNylasAuthUrlQuery>;
export type NylasAuthUrlLazyQueryHookResult = ReturnType<typeof useNylasAuthUrlLazyQuery>;
export type NylasAuthUrlQueryResult = Apollo.QueryResult<NylasAuthUrlQuery, NylasAuthUrlQueryVariables>;
export const NylasSupportedProvidersDocument = gql`
    query NylasSupportedProviders {
  nylasSupportedProviders
}
    `;

/**
 * __useNylasSupportedProvidersQuery__
 *
 * To run a query within a React component, call `useNylasSupportedProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasSupportedProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasSupportedProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useNylasSupportedProvidersQuery(baseOptions?: Apollo.QueryHookOptions<NylasSupportedProvidersQuery, NylasSupportedProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasSupportedProvidersQuery, NylasSupportedProvidersQueryVariables>(NylasSupportedProvidersDocument, options);
      }
export function useNylasSupportedProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasSupportedProvidersQuery, NylasSupportedProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasSupportedProvidersQuery, NylasSupportedProvidersQueryVariables>(NylasSupportedProvidersDocument, options);
        }
export type NylasSupportedProvidersQueryHookResult = ReturnType<typeof useNylasSupportedProvidersQuery>;
export type NylasSupportedProvidersLazyQueryHookResult = ReturnType<typeof useNylasSupportedProvidersLazyQuery>;
export type NylasSupportedProvidersQueryResult = Apollo.QueryResult<NylasSupportedProvidersQuery, NylasSupportedProvidersQueryVariables>;
export const NylasPrimaryCalendarDocument = gql`
    query NylasPrimaryCalendar {
  nylasPrimaryCalendar {
    ...nylasCalendarData
  }
}
    ${NylasCalendarDataFragmentDoc}`;

/**
 * __useNylasPrimaryCalendarQuery__
 *
 * To run a query within a React component, call `useNylasPrimaryCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasPrimaryCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasPrimaryCalendarQuery({
 *   variables: {
 *   },
 * });
 */
export function useNylasPrimaryCalendarQuery(baseOptions?: Apollo.QueryHookOptions<NylasPrimaryCalendarQuery, NylasPrimaryCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasPrimaryCalendarQuery, NylasPrimaryCalendarQueryVariables>(NylasPrimaryCalendarDocument, options);
      }
export function useNylasPrimaryCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasPrimaryCalendarQuery, NylasPrimaryCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasPrimaryCalendarQuery, NylasPrimaryCalendarQueryVariables>(NylasPrimaryCalendarDocument, options);
        }
export type NylasPrimaryCalendarQueryHookResult = ReturnType<typeof useNylasPrimaryCalendarQuery>;
export type NylasPrimaryCalendarLazyQueryHookResult = ReturnType<typeof useNylasPrimaryCalendarLazyQuery>;
export type NylasPrimaryCalendarQueryResult = Apollo.QueryResult<NylasPrimaryCalendarQuery, NylasPrimaryCalendarQueryVariables>;
export const NylasCalendarsDocument = gql`
    query nylasCalendars {
  nylasCalendars {
    ...nylasCalendarData
  }
}
    ${NylasCalendarDataFragmentDoc}`;

/**
 * __useNylasCalendarsQuery__
 *
 * To run a query within a React component, call `useNylasCalendarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasCalendarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasCalendarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNylasCalendarsQuery(baseOptions?: Apollo.QueryHookOptions<NylasCalendarsQuery, NylasCalendarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasCalendarsQuery, NylasCalendarsQueryVariables>(NylasCalendarsDocument, options);
      }
export function useNylasCalendarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasCalendarsQuery, NylasCalendarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasCalendarsQuery, NylasCalendarsQueryVariables>(NylasCalendarsDocument, options);
        }
export type NylasCalendarsQueryHookResult = ReturnType<typeof useNylasCalendarsQuery>;
export type NylasCalendarsLazyQueryHookResult = ReturnType<typeof useNylasCalendarsLazyQuery>;
export type NylasCalendarsQueryResult = Apollo.QueryResult<NylasCalendarsQuery, NylasCalendarsQueryVariables>;
export const NylasRoomResourcesDocument = gql`
    query nylasRoomResources {
  nylasRoomResources {
    ...nylasRoomResourceData
  }
}
    ${NylasRoomResourceDataFragmentDoc}`;

/**
 * __useNylasRoomResourcesQuery__
 *
 * To run a query within a React component, call `useNylasRoomResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasRoomResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasRoomResourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNylasRoomResourcesQuery(baseOptions?: Apollo.QueryHookOptions<NylasRoomResourcesQuery, NylasRoomResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasRoomResourcesQuery, NylasRoomResourcesQueryVariables>(NylasRoomResourcesDocument, options);
      }
export function useNylasRoomResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasRoomResourcesQuery, NylasRoomResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasRoomResourcesQuery, NylasRoomResourcesQueryVariables>(NylasRoomResourcesDocument, options);
        }
export type NylasRoomResourcesQueryHookResult = ReturnType<typeof useNylasRoomResourcesQuery>;
export type NylasRoomResourcesLazyQueryHookResult = ReturnType<typeof useNylasRoomResourcesLazyQuery>;
export type NylasRoomResourcesQueryResult = Apollo.QueryResult<NylasRoomResourcesQuery, NylasRoomResourcesQueryVariables>;
export const NylasCalendarEventsDocument = gql`
    query NylasCalendarEvents($input: NylasCalendarEventsInput!) {
  nylasCalendarEvents(input: $input) {
    ...nylasCalendarEventData
  }
}
    ${NylasCalendarEventDataFragmentDoc}`;

/**
 * __useNylasCalendarEventsQuery__
 *
 * To run a query within a React component, call `useNylasCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNylasCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNylasCalendarEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNylasCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<NylasCalendarEventsQuery, NylasCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NylasCalendarEventsQuery, NylasCalendarEventsQueryVariables>(NylasCalendarEventsDocument, options);
      }
export function useNylasCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NylasCalendarEventsQuery, NylasCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NylasCalendarEventsQuery, NylasCalendarEventsQueryVariables>(NylasCalendarEventsDocument, options);
        }
export type NylasCalendarEventsQueryHookResult = ReturnType<typeof useNylasCalendarEventsQuery>;
export type NylasCalendarEventsLazyQueryHookResult = ReturnType<typeof useNylasCalendarEventsLazyQuery>;
export type NylasCalendarEventsQueryResult = Apollo.QueryResult<NylasCalendarEventsQuery, NylasCalendarEventsQueryVariables>;
export const AddNylasIntegrationDocument = gql`
    mutation AddNylasIntegration($code: String!, $provider: CalendarProvider!) {
  addNylasIntegration(code: $code, provider: $provider)
}
    `;
export type AddNylasIntegrationMutationFn = Apollo.MutationFunction<AddNylasIntegrationMutation, AddNylasIntegrationMutationVariables>;

/**
 * __useAddNylasIntegrationMutation__
 *
 * To run a mutation, you first call `useAddNylasIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNylasIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNylasIntegrationMutation, { data, loading, error }] = useAddNylasIntegrationMutation({
 *   variables: {
 *      code: // value for 'code'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useAddNylasIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AddNylasIntegrationMutation, AddNylasIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNylasIntegrationMutation, AddNylasIntegrationMutationVariables>(AddNylasIntegrationDocument, options);
      }
export type AddNylasIntegrationMutationHookResult = ReturnType<typeof useAddNylasIntegrationMutation>;
export type AddNylasIntegrationMutationResult = Apollo.MutationResult<AddNylasIntegrationMutation>;
export type AddNylasIntegrationMutationOptions = Apollo.BaseMutationOptions<AddNylasIntegrationMutation, AddNylasIntegrationMutationVariables>;
export const RevokeNylasIntegrationDocument = gql`
    mutation RevokeNylasIntegration {
  revokeNylasIntegration
}
    `;
export type RevokeNylasIntegrationMutationFn = Apollo.MutationFunction<RevokeNylasIntegrationMutation, RevokeNylasIntegrationMutationVariables>;

/**
 * __useRevokeNylasIntegrationMutation__
 *
 * To run a mutation, you first call `useRevokeNylasIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeNylasIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeNylasIntegrationMutation, { data, loading, error }] = useRevokeNylasIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeNylasIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeNylasIntegrationMutation, RevokeNylasIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeNylasIntegrationMutation, RevokeNylasIntegrationMutationVariables>(RevokeNylasIntegrationDocument, options);
      }
export type RevokeNylasIntegrationMutationHookResult = ReturnType<typeof useRevokeNylasIntegrationMutation>;
export type RevokeNylasIntegrationMutationResult = Apollo.MutationResult<RevokeNylasIntegrationMutation>;
export type RevokeNylasIntegrationMutationOptions = Apollo.BaseMutationOptions<RevokeNylasIntegrationMutation, RevokeNylasIntegrationMutationVariables>;
export const UpdateNylasCalendarDocument = gql`
    mutation UpdateNylasCalendar($input: UpdateNylasCalendarInput!) {
  updateNylasCalendar(input: $input) {
    ...nylasCalendarData
  }
}
    ${NylasCalendarDataFragmentDoc}`;
export type UpdateNylasCalendarMutationFn = Apollo.MutationFunction<UpdateNylasCalendarMutation, UpdateNylasCalendarMutationVariables>;

/**
 * __useUpdateNylasCalendarMutation__
 *
 * To run a mutation, you first call `useUpdateNylasCalendarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNylasCalendarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNylasCalendarMutation, { data, loading, error }] = useUpdateNylasCalendarMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNylasCalendarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNylasCalendarMutation, UpdateNylasCalendarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNylasCalendarMutation, UpdateNylasCalendarMutationVariables>(UpdateNylasCalendarDocument, options);
      }
export type UpdateNylasCalendarMutationHookResult = ReturnType<typeof useUpdateNylasCalendarMutation>;
export type UpdateNylasCalendarMutationResult = Apollo.MutationResult<UpdateNylasCalendarMutation>;
export type UpdateNylasCalendarMutationOptions = Apollo.BaseMutationOptions<UpdateNylasCalendarMutation, UpdateNylasCalendarMutationVariables>;
export const DeleteNylasCalendarEventDocument = gql`
    mutation DeleteNylasCalendarEvent($input: DeleteNylasCalendarEventInput!) {
  deleteNylasCalendarEvent(input: $input)
}
    `;
export type DeleteNylasCalendarEventMutationFn = Apollo.MutationFunction<DeleteNylasCalendarEventMutation, DeleteNylasCalendarEventMutationVariables>;

/**
 * __useDeleteNylasCalendarEventMutation__
 *
 * To run a mutation, you first call `useDeleteNylasCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNylasCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNylasCalendarEventMutation, { data, loading, error }] = useDeleteNylasCalendarEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNylasCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNylasCalendarEventMutation, DeleteNylasCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNylasCalendarEventMutation, DeleteNylasCalendarEventMutationVariables>(DeleteNylasCalendarEventDocument, options);
      }
export type DeleteNylasCalendarEventMutationHookResult = ReturnType<typeof useDeleteNylasCalendarEventMutation>;
export type DeleteNylasCalendarEventMutationResult = Apollo.MutationResult<DeleteNylasCalendarEventMutation>;
export type DeleteNylasCalendarEventMutationOptions = Apollo.BaseMutationOptions<DeleteNylasCalendarEventMutation, DeleteNylasCalendarEventMutationVariables>;
export const CreateNylasCalendarEventDocument = gql`
    mutation CreateNylasCalendarEvent($input: CreateNylasCalendarEventInput!) {
  createNylasCalendarEvent(input: $input) {
    success
    event {
      ...nylasCalendarEventData
    }
    error
    errors
  }
}
    ${NylasCalendarEventDataFragmentDoc}`;
export type CreateNylasCalendarEventMutationFn = Apollo.MutationFunction<CreateNylasCalendarEventMutation, CreateNylasCalendarEventMutationVariables>;

/**
 * __useCreateNylasCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateNylasCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNylasCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNylasCalendarEventMutation, { data, loading, error }] = useCreateNylasCalendarEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNylasCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateNylasCalendarEventMutation, CreateNylasCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNylasCalendarEventMutation, CreateNylasCalendarEventMutationVariables>(CreateNylasCalendarEventDocument, options);
      }
export type CreateNylasCalendarEventMutationHookResult = ReturnType<typeof useCreateNylasCalendarEventMutation>;
export type CreateNylasCalendarEventMutationResult = Apollo.MutationResult<CreateNylasCalendarEventMutation>;
export type CreateNylasCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateNylasCalendarEventMutation, CreateNylasCalendarEventMutationVariables>;
export const UpdateNylasCalendarEventDocument = gql`
    mutation UpdateNylasCalendarEvent($input: UpdateNylasCalendarEventInput!) {
  updateNylasCalendarEvent(input: $input) {
    success
    event {
      ...nylasCalendarEventData
    }
    error
    errors
  }
}
    ${NylasCalendarEventDataFragmentDoc}`;
export type UpdateNylasCalendarEventMutationFn = Apollo.MutationFunction<UpdateNylasCalendarEventMutation, UpdateNylasCalendarEventMutationVariables>;

/**
 * __useUpdateNylasCalendarEventMutation__
 *
 * To run a mutation, you first call `useUpdateNylasCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNylasCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNylasCalendarEventMutation, { data, loading, error }] = useUpdateNylasCalendarEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNylasCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNylasCalendarEventMutation, UpdateNylasCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNylasCalendarEventMutation, UpdateNylasCalendarEventMutationVariables>(UpdateNylasCalendarEventDocument, options);
      }
export type UpdateNylasCalendarEventMutationHookResult = ReturnType<typeof useUpdateNylasCalendarEventMutation>;
export type UpdateNylasCalendarEventMutationResult = Apollo.MutationResult<UpdateNylasCalendarEventMutation>;
export type UpdateNylasCalendarEventMutationOptions = Apollo.BaseMutationOptions<UpdateNylasCalendarEventMutation, UpdateNylasCalendarEventMutationVariables>;
export const CreateClientSessionFromEventDocument = gql`
    mutation CreateClientSessionFromEvent($input: CreateClientSessionFromEventInput!) {
  createClientSessionFromEvent(input: $input) {
    success
    error
    errors {
      field
      message
    }
    clientSession {
      ... on ClientSessionIndividual {
        id
      }
      ... on ClientSessionGroup {
        id
      }
    }
  }
}
    `;
export type CreateClientSessionFromEventMutationFn = Apollo.MutationFunction<CreateClientSessionFromEventMutation, CreateClientSessionFromEventMutationVariables>;

/**
 * __useCreateClientSessionFromEventMutation__
 *
 * To run a mutation, you first call `useCreateClientSessionFromEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientSessionFromEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientSessionFromEventMutation, { data, loading, error }] = useCreateClientSessionFromEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientSessionFromEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientSessionFromEventMutation, CreateClientSessionFromEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientSessionFromEventMutation, CreateClientSessionFromEventMutationVariables>(CreateClientSessionFromEventDocument, options);
      }
export type CreateClientSessionFromEventMutationHookResult = ReturnType<typeof useCreateClientSessionFromEventMutation>;
export type CreateClientSessionFromEventMutationResult = Apollo.MutationResult<CreateClientSessionFromEventMutation>;
export type CreateClientSessionFromEventMutationOptions = Apollo.BaseMutationOptions<CreateClientSessionFromEventMutation, CreateClientSessionFromEventMutationVariables>;
export const SearchCalendarParticipantsDocument = gql`
    query SearchCalendarParticipants($searchQuery: String, $limit: Int) {
  patientsV2(
    patientLifecycleStatuses: [Active]
    searchQuery: $searchQuery
    sortOrder: AlphabeticalAsc
    pageSize: $limit
    page: 1
  ) {
    name
    email
    profileImageMedia {
      url
    }
  }
}
    `;

/**
 * __useSearchCalendarParticipantsQuery__
 *
 * To run a query within a React component, call `useSearchCalendarParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCalendarParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCalendarParticipantsQuery({
 *   variables: {
 *      searchQuery: // value for 'searchQuery'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchCalendarParticipantsQuery(baseOptions?: Apollo.QueryHookOptions<SearchCalendarParticipantsQuery, SearchCalendarParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCalendarParticipantsQuery, SearchCalendarParticipantsQueryVariables>(SearchCalendarParticipantsDocument, options);
      }
export function useSearchCalendarParticipantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCalendarParticipantsQuery, SearchCalendarParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCalendarParticipantsQuery, SearchCalendarParticipantsQueryVariables>(SearchCalendarParticipantsDocument, options);
        }
export type SearchCalendarParticipantsQueryHookResult = ReturnType<typeof useSearchCalendarParticipantsQuery>;
export type SearchCalendarParticipantsLazyQueryHookResult = ReturnType<typeof useSearchCalendarParticipantsLazyQuery>;
export type SearchCalendarParticipantsQueryResult = Apollo.QueryResult<SearchCalendarParticipantsQuery, SearchCalendarParticipantsQueryVariables>;
export const ClientFilesDocument = gql`
    query ClientFiles {
  clientFiles {
    ...clientFileData
  }
}
    ${ClientFileDataFragmentDoc}`;

/**
 * __useClientFilesQuery__
 *
 * To run a query within a React component, call `useClientFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientFilesQuery(baseOptions?: Apollo.QueryHookOptions<ClientFilesQuery, ClientFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFilesQuery, ClientFilesQueryVariables>(ClientFilesDocument, options);
      }
export function useClientFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFilesQuery, ClientFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFilesQuery, ClientFilesQueryVariables>(ClientFilesDocument, options);
        }
export type ClientFilesQueryHookResult = ReturnType<typeof useClientFilesQuery>;
export type ClientFilesLazyQueryHookResult = ReturnType<typeof useClientFilesLazyQuery>;
export type ClientFilesQueryResult = Apollo.QueryResult<ClientFilesQuery, ClientFilesQueryVariables>;
export const ClientFilesForProgramDocument = gql`
    query ClientFilesForProgram($programId: String!) {
  clientFilesForProgram(programId: $programId) {
    ...clientFileData
  }
}
    ${ClientFileDataFragmentDoc}`;

/**
 * __useClientFilesForProgramQuery__
 *
 * To run a query within a React component, call `useClientFilesForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientFilesForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientFilesForProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useClientFilesForProgramQuery(baseOptions: Apollo.QueryHookOptions<ClientFilesForProgramQuery, ClientFilesForProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientFilesForProgramQuery, ClientFilesForProgramQueryVariables>(ClientFilesForProgramDocument, options);
      }
export function useClientFilesForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientFilesForProgramQuery, ClientFilesForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientFilesForProgramQuery, ClientFilesForProgramQueryVariables>(ClientFilesForProgramDocument, options);
        }
export type ClientFilesForProgramQueryHookResult = ReturnType<typeof useClientFilesForProgramQuery>;
export type ClientFilesForProgramLazyQueryHookResult = ReturnType<typeof useClientFilesForProgramLazyQuery>;
export type ClientFilesForProgramQueryResult = Apollo.QueryResult<ClientFilesForProgramQuery, ClientFilesForProgramQueryVariables>;
export const ExternalPartyFilesForProgramDocument = gql`
    query ExternalPartyFilesForProgram($programId: String!) {
  externalPartyFilesForProgram(programId: $programId) {
    ...clientFileData
  }
}
    ${ClientFileDataFragmentDoc}`;

/**
 * __useExternalPartyFilesForProgramQuery__
 *
 * To run a query within a React component, call `useExternalPartyFilesForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalPartyFilesForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalPartyFilesForProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useExternalPartyFilesForProgramQuery(baseOptions: Apollo.QueryHookOptions<ExternalPartyFilesForProgramQuery, ExternalPartyFilesForProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalPartyFilesForProgramQuery, ExternalPartyFilesForProgramQueryVariables>(ExternalPartyFilesForProgramDocument, options);
      }
export function useExternalPartyFilesForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalPartyFilesForProgramQuery, ExternalPartyFilesForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalPartyFilesForProgramQuery, ExternalPartyFilesForProgramQueryVariables>(ExternalPartyFilesForProgramDocument, options);
        }
export type ExternalPartyFilesForProgramQueryHookResult = ReturnType<typeof useExternalPartyFilesForProgramQuery>;
export type ExternalPartyFilesForProgramLazyQueryHookResult = ReturnType<typeof useExternalPartyFilesForProgramLazyQuery>;
export type ExternalPartyFilesForProgramQueryResult = Apollo.QueryResult<ExternalPartyFilesForProgramQuery, ExternalPartyFilesForProgramQueryVariables>;
export const UploadClientFileDocument = gql`
    mutation UploadClientFile($input: ClientFilesUploadFileInput!) {
  clientFilesUploadFile(input: $input) {
    ...clientFileData
  }
}
    ${ClientFileDataFragmentDoc}`;
export type UploadClientFileMutationFn = Apollo.MutationFunction<UploadClientFileMutation, UploadClientFileMutationVariables>;

/**
 * __useUploadClientFileMutation__
 *
 * To run a mutation, you first call `useUploadClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadClientFileMutation, { data, loading, error }] = useUploadClientFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadClientFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadClientFileMutation, UploadClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadClientFileMutation, UploadClientFileMutationVariables>(UploadClientFileDocument, options);
      }
export type UploadClientFileMutationHookResult = ReturnType<typeof useUploadClientFileMutation>;
export type UploadClientFileMutationResult = Apollo.MutationResult<UploadClientFileMutation>;
export type UploadClientFileMutationOptions = Apollo.BaseMutationOptions<UploadClientFileMutation, UploadClientFileMutationVariables>;
export const DeleteClientFileDocument = gql`
    mutation DeleteClientFile($clientFileId: String!) {
  clientFilesDeleteFile(clientFileId: $clientFileId) {
    success
  }
}
    `;
export type DeleteClientFileMutationFn = Apollo.MutationFunction<DeleteClientFileMutation, DeleteClientFileMutationVariables>;

/**
 * __useDeleteClientFileMutation__
 *
 * To run a mutation, you first call `useDeleteClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientFileMutation, { data, loading, error }] = useDeleteClientFileMutation({
 *   variables: {
 *      clientFileId: // value for 'clientFileId'
 *   },
 * });
 */
export function useDeleteClientFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientFileMutation, DeleteClientFileMutationVariables>(DeleteClientFileDocument, options);
      }
export type DeleteClientFileMutationHookResult = ReturnType<typeof useDeleteClientFileMutation>;
export type DeleteClientFileMutationResult = Apollo.MutationResult<DeleteClientFileMutation>;
export type DeleteClientFileMutationOptions = Apollo.BaseMutationOptions<DeleteClientFileMutation, DeleteClientFileMutationVariables>;
export const DismissClientSessionsDocument = gql`
    mutation DismissClientSessions($ids: [ID!]!) {
  dismissClientSessions(ids: $ids) {
    success
    errors {
      sessionId
      message
    }
    summary {
      requestedCount
      processedCount
      skippedCount
      errorCount
    }
  }
}
    `;
export type DismissClientSessionsMutationFn = Apollo.MutationFunction<DismissClientSessionsMutation, DismissClientSessionsMutationVariables>;

/**
 * __useDismissClientSessionsMutation__
 *
 * To run a mutation, you first call `useDismissClientSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissClientSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissClientSessionsMutation, { data, loading, error }] = useDismissClientSessionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDismissClientSessionsMutation(baseOptions?: Apollo.MutationHookOptions<DismissClientSessionsMutation, DismissClientSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissClientSessionsMutation, DismissClientSessionsMutationVariables>(DismissClientSessionsDocument, options);
      }
export type DismissClientSessionsMutationHookResult = ReturnType<typeof useDismissClientSessionsMutation>;
export type DismissClientSessionsMutationResult = Apollo.MutationResult<DismissClientSessionsMutation>;
export type DismissClientSessionsMutationOptions = Apollo.BaseMutationOptions<DismissClientSessionsMutation, DismissClientSessionsMutationVariables>;
export const RestoreClientSessionsDocument = gql`
    mutation RestoreClientSessions($ids: [ID!]!) {
  restoreClientSessions(ids: $ids) {
    success
    errors {
      sessionId
      message
    }
    summary {
      requestedCount
      processedCount
      skippedCount
      errorCount
    }
  }
}
    `;
export type RestoreClientSessionsMutationFn = Apollo.MutationFunction<RestoreClientSessionsMutation, RestoreClientSessionsMutationVariables>;

/**
 * __useRestoreClientSessionsMutation__
 *
 * To run a mutation, you first call `useRestoreClientSessionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreClientSessionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreClientSessionsMutation, { data, loading, error }] = useRestoreClientSessionsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRestoreClientSessionsMutation(baseOptions?: Apollo.MutationHookOptions<RestoreClientSessionsMutation, RestoreClientSessionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreClientSessionsMutation, RestoreClientSessionsMutationVariables>(RestoreClientSessionsDocument, options);
      }
export type RestoreClientSessionsMutationHookResult = ReturnType<typeof useRestoreClientSessionsMutation>;
export type RestoreClientSessionsMutationResult = Apollo.MutationResult<RestoreClientSessionsMutation>;
export type RestoreClientSessionsMutationOptions = Apollo.BaseMutationOptions<RestoreClientSessionsMutation, RestoreClientSessionsMutationVariables>;
export const GetClientSessionsDocument = gql`
    query GetClientSessions($input: ClientSessionListInput) {
  clientSessions(input: $input) {
    edges {
      ...clientSessionFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${ClientSessionFieldsFragmentDoc}`;

/**
 * __useGetClientSessionsQuery__
 *
 * To run a query within a React component, call `useGetClientSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSessionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientSessionsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientSessionsQuery, GetClientSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSessionsQuery, GetClientSessionsQueryVariables>(GetClientSessionsDocument, options);
      }
export function useGetClientSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSessionsQuery, GetClientSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSessionsQuery, GetClientSessionsQueryVariables>(GetClientSessionsDocument, options);
        }
export type GetClientSessionsQueryHookResult = ReturnType<typeof useGetClientSessionsQuery>;
export type GetClientSessionsLazyQueryHookResult = ReturnType<typeof useGetClientSessionsLazyQuery>;
export type GetClientSessionsQueryResult = Apollo.QueryResult<GetClientSessionsQuery, GetClientSessionsQueryVariables>;
export const GetClientSessionsCountDocument = gql`
    query GetClientSessionsCount($input: ClientSessionFilterInput) {
  clientSessionsCount(input: $input)
}
    `;

/**
 * __useGetClientSessionsCountQuery__
 *
 * To run a query within a React component, call `useGetClientSessionsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSessionsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSessionsCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientSessionsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetClientSessionsCountQuery, GetClientSessionsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSessionsCountQuery, GetClientSessionsCountQueryVariables>(GetClientSessionsCountDocument, options);
      }
export function useGetClientSessionsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSessionsCountQuery, GetClientSessionsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSessionsCountQuery, GetClientSessionsCountQueryVariables>(GetClientSessionsCountDocument, options);
        }
export type GetClientSessionsCountQueryHookResult = ReturnType<typeof useGetClientSessionsCountQuery>;
export type GetClientSessionsCountLazyQueryHookResult = ReturnType<typeof useGetClientSessionsCountLazyQuery>;
export type GetClientSessionsCountQueryResult = Apollo.QueryResult<GetClientSessionsCountQuery, GetClientSessionsCountQueryVariables>;
export const GetClientSessionDocument = gql`
    query GetClientSession($id: ID!) {
  clientSession(id: $id) {
    ...clientSessionFields
  }
}
    ${ClientSessionFieldsFragmentDoc}`;

/**
 * __useGetClientSessionQuery__
 *
 * To run a query within a React component, call `useGetClientSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSessionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientSessionQuery(baseOptions: Apollo.QueryHookOptions<GetClientSessionQuery, GetClientSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSessionQuery, GetClientSessionQueryVariables>(GetClientSessionDocument, options);
      }
export function useGetClientSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSessionQuery, GetClientSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSessionQuery, GetClientSessionQueryVariables>(GetClientSessionDocument, options);
        }
export type GetClientSessionQueryHookResult = ReturnType<typeof useGetClientSessionQuery>;
export type GetClientSessionLazyQueryHookResult = ReturnType<typeof useGetClientSessionLazyQuery>;
export type GetClientSessionQueryResult = Apollo.QueryResult<GetClientSessionQuery, GetClientSessionQueryVariables>;
export const FindClientSessionFormByTypeDocument = gql`
    query FindClientSessionFormByType($clientSessionId: ID!, $formType: ClientSessionFormType!) {
  findClientSessionFormByType(
    clientSessionId: $clientSessionId
    formType: $formType
  ) {
    id
    clientSessionId
    formType
    data
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useFindClientSessionFormByTypeQuery__
 *
 * To run a query within a React component, call `useFindClientSessionFormByTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindClientSessionFormByTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindClientSessionFormByTypeQuery({
 *   variables: {
 *      clientSessionId: // value for 'clientSessionId'
 *      formType: // value for 'formType'
 *   },
 * });
 */
export function useFindClientSessionFormByTypeQuery(baseOptions: Apollo.QueryHookOptions<FindClientSessionFormByTypeQuery, FindClientSessionFormByTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindClientSessionFormByTypeQuery, FindClientSessionFormByTypeQueryVariables>(FindClientSessionFormByTypeDocument, options);
      }
export function useFindClientSessionFormByTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindClientSessionFormByTypeQuery, FindClientSessionFormByTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindClientSessionFormByTypeQuery, FindClientSessionFormByTypeQueryVariables>(FindClientSessionFormByTypeDocument, options);
        }
export type FindClientSessionFormByTypeQueryHookResult = ReturnType<typeof useFindClientSessionFormByTypeQuery>;
export type FindClientSessionFormByTypeLazyQueryHookResult = ReturnType<typeof useFindClientSessionFormByTypeLazyQuery>;
export type FindClientSessionFormByTypeQueryResult = Apollo.QueryResult<FindClientSessionFormByTypeQuery, FindClientSessionFormByTypeQueryVariables>;
export const SubmitClientSessionFormDocument = gql`
    mutation SubmitClientSessionForm($input: ClientSessionFormSubmitInput!) {
  submitClientSessionForm(input: $input) {
    success
    errors {
      field
      message
    }
    form {
      id
      formType
      data
      createdAt
      updatedAt
    }
  }
}
    `;
export type SubmitClientSessionFormMutationFn = Apollo.MutationFunction<SubmitClientSessionFormMutation, SubmitClientSessionFormMutationVariables>;

/**
 * __useSubmitClientSessionFormMutation__
 *
 * To run a mutation, you first call `useSubmitClientSessionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitClientSessionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitClientSessionFormMutation, { data, loading, error }] = useSubmitClientSessionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitClientSessionFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitClientSessionFormMutation, SubmitClientSessionFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitClientSessionFormMutation, SubmitClientSessionFormMutationVariables>(SubmitClientSessionFormDocument, options);
      }
export type SubmitClientSessionFormMutationHookResult = ReturnType<typeof useSubmitClientSessionFormMutation>;
export type SubmitClientSessionFormMutationResult = Apollo.MutationResult<SubmitClientSessionFormMutation>;
export type SubmitClientSessionFormMutationOptions = Apollo.BaseMutationOptions<SubmitClientSessionFormMutation, SubmitClientSessionFormMutationVariables>;
export const UpdateClientSessionFormDocument = gql`
    mutation UpdateClientSessionForm($input: ClientSessionFormUpdateInput!) {
  updateClientSessionForm(input: $input) {
    success
    errors {
      field
      message
    }
    form {
      id
      formType
      data
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateClientSessionFormMutationFn = Apollo.MutationFunction<UpdateClientSessionFormMutation, UpdateClientSessionFormMutationVariables>;

/**
 * __useUpdateClientSessionFormMutation__
 *
 * To run a mutation, you first call `useUpdateClientSessionFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientSessionFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientSessionFormMutation, { data, loading, error }] = useUpdateClientSessionFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientSessionFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientSessionFormMutation, UpdateClientSessionFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientSessionFormMutation, UpdateClientSessionFormMutationVariables>(UpdateClientSessionFormDocument, options);
      }
export type UpdateClientSessionFormMutationHookResult = ReturnType<typeof useUpdateClientSessionFormMutation>;
export type UpdateClientSessionFormMutationResult = Apollo.MutationResult<UpdateClientSessionFormMutation>;
export type UpdateClientSessionFormMutationOptions = Apollo.BaseMutationOptions<UpdateClientSessionFormMutation, UpdateClientSessionFormMutationVariables>;
export const UpdateClientSessionDocument = gql`
    mutation UpdateClientSession($input: UpdateClientSessionInput!) {
  updateClientSession(input: $input) {
    success
    clientSession {
      ...clientSessionFields
    }
    errors {
      field
      message
    }
  }
}
    ${ClientSessionFieldsFragmentDoc}`;
export type UpdateClientSessionMutationFn = Apollo.MutationFunction<UpdateClientSessionMutation, UpdateClientSessionMutationVariables>;

/**
 * __useUpdateClientSessionMutation__
 *
 * To run a mutation, you first call `useUpdateClientSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientSessionMutation, { data, loading, error }] = useUpdateClientSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientSessionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientSessionMutation, UpdateClientSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientSessionMutation, UpdateClientSessionMutationVariables>(UpdateClientSessionDocument, options);
      }
export type UpdateClientSessionMutationHookResult = ReturnType<typeof useUpdateClientSessionMutation>;
export type UpdateClientSessionMutationResult = Apollo.MutationResult<UpdateClientSessionMutation>;
export type UpdateClientSessionMutationOptions = Apollo.BaseMutationOptions<UpdateClientSessionMutation, UpdateClientSessionMutationVariables>;
export const CreateManualClientSessionDocument = gql`
    mutation CreateManualClientSession($input: CreateManualClientSessionInput!) {
  createManualClientSession(input: $input) {
    success
    clientSession {
      ...clientSessionFields
    }
    error
    errors {
      field
      message
    }
  }
}
    ${ClientSessionFieldsFragmentDoc}`;
export type CreateManualClientSessionMutationFn = Apollo.MutationFunction<CreateManualClientSessionMutation, CreateManualClientSessionMutationVariables>;

/**
 * __useCreateManualClientSessionMutation__
 *
 * To run a mutation, you first call `useCreateManualClientSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManualClientSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManualClientSessionMutation, { data, loading, error }] = useCreateManualClientSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManualClientSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateManualClientSessionMutation, CreateManualClientSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManualClientSessionMutation, CreateManualClientSessionMutationVariables>(CreateManualClientSessionDocument, options);
      }
export type CreateManualClientSessionMutationHookResult = ReturnType<typeof useCreateManualClientSessionMutation>;
export type CreateManualClientSessionMutationResult = Apollo.MutationResult<CreateManualClientSessionMutation>;
export type CreateManualClientSessionMutationOptions = Apollo.BaseMutationOptions<CreateManualClientSessionMutation, CreateManualClientSessionMutationVariables>;
export const GetProviderCalendarSessionSyncSettingsDocument = gql`
    query GetProviderCalendarSessionSyncSettings {
  providerCalendarSessionSyncSettings {
    id
    providerId
    enableCalendarSyncForSessions
    includeArchivedPatients
    syncCalendarSessionsForCollaborators
    includeDeactivatedStaff
  }
}
    `;

/**
 * __useGetProviderCalendarSessionSyncSettingsQuery__
 *
 * To run a query within a React component, call `useGetProviderCalendarSessionSyncSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderCalendarSessionSyncSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderCalendarSessionSyncSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderCalendarSessionSyncSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderCalendarSessionSyncSettingsQuery, GetProviderCalendarSessionSyncSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderCalendarSessionSyncSettingsQuery, GetProviderCalendarSessionSyncSettingsQueryVariables>(GetProviderCalendarSessionSyncSettingsDocument, options);
      }
export function useGetProviderCalendarSessionSyncSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderCalendarSessionSyncSettingsQuery, GetProviderCalendarSessionSyncSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderCalendarSessionSyncSettingsQuery, GetProviderCalendarSessionSyncSettingsQueryVariables>(GetProviderCalendarSessionSyncSettingsDocument, options);
        }
export type GetProviderCalendarSessionSyncSettingsQueryHookResult = ReturnType<typeof useGetProviderCalendarSessionSyncSettingsQuery>;
export type GetProviderCalendarSessionSyncSettingsLazyQueryHookResult = ReturnType<typeof useGetProviderCalendarSessionSyncSettingsLazyQuery>;
export type GetProviderCalendarSessionSyncSettingsQueryResult = Apollo.QueryResult<GetProviderCalendarSessionSyncSettingsQuery, GetProviderCalendarSessionSyncSettingsQueryVariables>;
export const UpdateProviderCalendarSessionSyncSettingsDocument = gql`
    mutation UpdateProviderCalendarSessionSyncSettings($input: UpdateProviderCalendarSessionSyncSettingsInput!) {
  updateProviderCalendarSessionSyncSettings(input: $input) {
    success
    settings {
      id
      providerId
      enableCalendarSyncForSessions
      includeArchivedPatients
      syncCalendarSessionsForCollaborators
      includeDeactivatedStaff
    }
    error
  }
}
    `;
export type UpdateProviderCalendarSessionSyncSettingsMutationFn = Apollo.MutationFunction<UpdateProviderCalendarSessionSyncSettingsMutation, UpdateProviderCalendarSessionSyncSettingsMutationVariables>;

/**
 * __useUpdateProviderCalendarSessionSyncSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateProviderCalendarSessionSyncSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderCalendarSessionSyncSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderCalendarSessionSyncSettingsMutation, { data, loading, error }] = useUpdateProviderCalendarSessionSyncSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderCalendarSessionSyncSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderCalendarSessionSyncSettingsMutation, UpdateProviderCalendarSessionSyncSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderCalendarSessionSyncSettingsMutation, UpdateProviderCalendarSessionSyncSettingsMutationVariables>(UpdateProviderCalendarSessionSyncSettingsDocument, options);
      }
export type UpdateProviderCalendarSessionSyncSettingsMutationHookResult = ReturnType<typeof useUpdateProviderCalendarSessionSyncSettingsMutation>;
export type UpdateProviderCalendarSessionSyncSettingsMutationResult = Apollo.MutationResult<UpdateProviderCalendarSessionSyncSettingsMutation>;
export type UpdateProviderCalendarSessionSyncSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateProviderCalendarSessionSyncSettingsMutation, UpdateProviderCalendarSessionSyncSettingsMutationVariables>;
export const ProviderCollectionsDocument = gql`
    query ProviderCollections {
  providerCollections {
    ...providerCollectionData
  }
}
    ${ProviderCollectionDataFragmentDoc}`;

/**
 * __useProviderCollectionsQuery__
 *
 * To run a query within a React component, call `useProviderCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<ProviderCollectionsQuery, ProviderCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderCollectionsQuery, ProviderCollectionsQueryVariables>(ProviderCollectionsDocument, options);
      }
export function useProviderCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderCollectionsQuery, ProviderCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderCollectionsQuery, ProviderCollectionsQueryVariables>(ProviderCollectionsDocument, options);
        }
export type ProviderCollectionsQueryHookResult = ReturnType<typeof useProviderCollectionsQuery>;
export type ProviderCollectionsLazyQueryHookResult = ReturnType<typeof useProviderCollectionsLazyQuery>;
export type ProviderCollectionsQueryResult = Apollo.QueryResult<ProviderCollectionsQuery, ProviderCollectionsQueryVariables>;
export const CreateProviderCollectionDocument = gql`
    mutation CreateProviderCollection($name: String!) {
  createProviderCollection(name: $name) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type CreateProviderCollectionMutationFn = Apollo.MutationFunction<CreateProviderCollectionMutation, CreateProviderCollectionMutationVariables>;

/**
 * __useCreateProviderCollectionMutation__
 *
 * To run a mutation, you first call `useCreateProviderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderCollectionMutation, { data, loading, error }] = useCreateProviderCollectionMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateProviderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderCollectionMutation, CreateProviderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderCollectionMutation, CreateProviderCollectionMutationVariables>(CreateProviderCollectionDocument, options);
      }
export type CreateProviderCollectionMutationHookResult = ReturnType<typeof useCreateProviderCollectionMutation>;
export type CreateProviderCollectionMutationResult = Apollo.MutationResult<CreateProviderCollectionMutation>;
export type CreateProviderCollectionMutationOptions = Apollo.BaseMutationOptions<CreateProviderCollectionMutation, CreateProviderCollectionMutationVariables>;
export const UpdateProviderCollectionDocument = gql`
    mutation UpdateProviderCollection($input: UpdateProviderCollectionInput!) {
  updateProviderCollection(input: $input) {
    id
    name
    createdAt
    updatedAt
  }
}
    `;
export type UpdateProviderCollectionMutationFn = Apollo.MutationFunction<UpdateProviderCollectionMutation, UpdateProviderCollectionMutationVariables>;

/**
 * __useUpdateProviderCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateProviderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderCollectionMutation, { data, loading, error }] = useUpdateProviderCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderCollectionMutation, UpdateProviderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderCollectionMutation, UpdateProviderCollectionMutationVariables>(UpdateProviderCollectionDocument, options);
      }
export type UpdateProviderCollectionMutationHookResult = ReturnType<typeof useUpdateProviderCollectionMutation>;
export type UpdateProviderCollectionMutationResult = Apollo.MutationResult<UpdateProviderCollectionMutation>;
export type UpdateProviderCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateProviderCollectionMutation, UpdateProviderCollectionMutationVariables>;
export const DeleteProviderCollectionDocument = gql`
    mutation DeleteProviderCollection($providerCollectionId: String!) {
  deleteProviderCollection(providerCollectionId: $providerCollectionId)
}
    `;
export type DeleteProviderCollectionMutationFn = Apollo.MutationFunction<DeleteProviderCollectionMutation, DeleteProviderCollectionMutationVariables>;

/**
 * __useDeleteProviderCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteProviderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderCollectionMutation, { data, loading, error }] = useDeleteProviderCollectionMutation({
 *   variables: {
 *      providerCollectionId: // value for 'providerCollectionId'
 *   },
 * });
 */
export function useDeleteProviderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderCollectionMutation, DeleteProviderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderCollectionMutation, DeleteProviderCollectionMutationVariables>(DeleteProviderCollectionDocument, options);
      }
export type DeleteProviderCollectionMutationHookResult = ReturnType<typeof useDeleteProviderCollectionMutation>;
export type DeleteProviderCollectionMutationResult = Apollo.MutationResult<DeleteProviderCollectionMutation>;
export type DeleteProviderCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteProviderCollectionMutation, DeleteProviderCollectionMutationVariables>;
export const AddActivityToProviderCollectionDocument = gql`
    mutation addActivityToProviderCollection($input: ProviderCollectionActivityInput!) {
  addActivityToProviderCollection(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddActivityToProviderCollectionMutationFn = Apollo.MutationFunction<AddActivityToProviderCollectionMutation, AddActivityToProviderCollectionMutationVariables>;

/**
 * __useAddActivityToProviderCollectionMutation__
 *
 * To run a mutation, you first call `useAddActivityToProviderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddActivityToProviderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addActivityToProviderCollectionMutation, { data, loading, error }] = useAddActivityToProviderCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddActivityToProviderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<AddActivityToProviderCollectionMutation, AddActivityToProviderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddActivityToProviderCollectionMutation, AddActivityToProviderCollectionMutationVariables>(AddActivityToProviderCollectionDocument, options);
      }
export type AddActivityToProviderCollectionMutationHookResult = ReturnType<typeof useAddActivityToProviderCollectionMutation>;
export type AddActivityToProviderCollectionMutationResult = Apollo.MutationResult<AddActivityToProviderCollectionMutation>;
export type AddActivityToProviderCollectionMutationOptions = Apollo.BaseMutationOptions<AddActivityToProviderCollectionMutation, AddActivityToProviderCollectionMutationVariables>;
export const RemoveActivityFromProviderCollectionDocument = gql`
    mutation RemoveActivityFromProviderCollection($input: ProviderCollectionActivityInput!) {
  removeActivityFromProviderCollection(input: $input) {
    ...activityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type RemoveActivityFromProviderCollectionMutationFn = Apollo.MutationFunction<RemoveActivityFromProviderCollectionMutation, RemoveActivityFromProviderCollectionMutationVariables>;

/**
 * __useRemoveActivityFromProviderCollectionMutation__
 *
 * To run a mutation, you first call `useRemoveActivityFromProviderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveActivityFromProviderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeActivityFromProviderCollectionMutation, { data, loading, error }] = useRemoveActivityFromProviderCollectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveActivityFromProviderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveActivityFromProviderCollectionMutation, RemoveActivityFromProviderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveActivityFromProviderCollectionMutation, RemoveActivityFromProviderCollectionMutationVariables>(RemoveActivityFromProviderCollectionDocument, options);
      }
export type RemoveActivityFromProviderCollectionMutationHookResult = ReturnType<typeof useRemoveActivityFromProviderCollectionMutation>;
export type RemoveActivityFromProviderCollectionMutationResult = Apollo.MutationResult<RemoveActivityFromProviderCollectionMutation>;
export type RemoveActivityFromProviderCollectionMutationOptions = Apollo.BaseMutationOptions<RemoveActivityFromProviderCollectionMutation, RemoveActivityFromProviderCollectionMutationVariables>;
export const CopyCollectionToLibraryDocument = gql`
    mutation CopyCollectionToLibrary($input: CopyCollectionToLibraryInput!) {
  copyCollectionToLibrary(input: $input) {
    id
  }
}
    `;
export type CopyCollectionToLibraryMutationFn = Apollo.MutationFunction<CopyCollectionToLibraryMutation, CopyCollectionToLibraryMutationVariables>;

/**
 * __useCopyCollectionToLibraryMutation__
 *
 * To run a mutation, you first call `useCopyCollectionToLibraryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyCollectionToLibraryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyCollectionToLibraryMutation, { data, loading, error }] = useCopyCollectionToLibraryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyCollectionToLibraryMutation(baseOptions?: Apollo.MutationHookOptions<CopyCollectionToLibraryMutation, CopyCollectionToLibraryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyCollectionToLibraryMutation, CopyCollectionToLibraryMutationVariables>(CopyCollectionToLibraryDocument, options);
      }
export type CopyCollectionToLibraryMutationHookResult = ReturnType<typeof useCopyCollectionToLibraryMutation>;
export type CopyCollectionToLibraryMutationResult = Apollo.MutationResult<CopyCollectionToLibraryMutation>;
export type CopyCollectionToLibraryMutationOptions = Apollo.BaseMutationOptions<CopyCollectionToLibraryMutation, CopyCollectionToLibraryMutationVariables>;
export const CuratedProviderCollectionsDocument = gql`
    query CuratedProviderCollections {
  curatedProviderCollections {
    id
    description
    curatorName
    createdAt
    updatedAt
    headerMedia {
      ...mediaData
    }
    curatorAvatarMedia {
      ...mediaData
    }
    providerCollection {
      ...providerCollectionData
      activities {
        ...activityData
      }
    }
  }
}
    ${MediaDataFragmentDoc}
${ProviderCollectionDataFragmentDoc}
${ActivityDataFragmentDoc}`;

/**
 * __useCuratedProviderCollectionsQuery__
 *
 * To run a query within a React component, call `useCuratedProviderCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCuratedProviderCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCuratedProviderCollectionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCuratedProviderCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<CuratedProviderCollectionsQuery, CuratedProviderCollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CuratedProviderCollectionsQuery, CuratedProviderCollectionsQueryVariables>(CuratedProviderCollectionsDocument, options);
      }
export function useCuratedProviderCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CuratedProviderCollectionsQuery, CuratedProviderCollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CuratedProviderCollectionsQuery, CuratedProviderCollectionsQueryVariables>(CuratedProviderCollectionsDocument, options);
        }
export type CuratedProviderCollectionsQueryHookResult = ReturnType<typeof useCuratedProviderCollectionsQuery>;
export type CuratedProviderCollectionsLazyQueryHookResult = ReturnType<typeof useCuratedProviderCollectionsLazyQuery>;
export type CuratedProviderCollectionsQueryResult = Apollo.QueryResult<CuratedProviderCollectionsQuery, CuratedProviderCollectionsQueryVariables>;
export const ProgramCommentsDocument = gql`
    query ProgramComments($programId: String!, $before: Datetime, $chunkSize: Int) {
  patient(programId: $programId) {
    unreadCommentCount
    comments(before: $before, chunkSize: $chunkSize) {
      ...commentData
    }
  }
}
    ${CommentDataFragmentDoc}`;

/**
 * __useProgramCommentsQuery__
 *
 * To run a query within a React component, call `useProgramCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramCommentsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      before: // value for 'before'
 *      chunkSize: // value for 'chunkSize'
 *   },
 * });
 */
export function useProgramCommentsQuery(baseOptions: Apollo.QueryHookOptions<ProgramCommentsQuery, ProgramCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramCommentsQuery, ProgramCommentsQueryVariables>(ProgramCommentsDocument, options);
      }
export function useProgramCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramCommentsQuery, ProgramCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramCommentsQuery, ProgramCommentsQueryVariables>(ProgramCommentsDocument, options);
        }
export type ProgramCommentsQueryHookResult = ReturnType<typeof useProgramCommentsQuery>;
export type ProgramCommentsLazyQueryHookResult = ReturnType<typeof useProgramCommentsLazyQuery>;
export type ProgramCommentsQueryResult = Apollo.QueryResult<ProgramCommentsQuery, ProgramCommentsQueryVariables>;
export const AddCommentDocument = gql`
    mutation AddComment($input: CommentInput!) {
  addComment(input: $input) {
    ...commentData
  }
}
    ${CommentDataFragmentDoc}`;
export type AddCommentMutationFn = Apollo.MutationFunction<AddCommentMutation, AddCommentMutationVariables>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation, AddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult = Apollo.MutationResult<AddCommentMutation>;
export type AddCommentMutationOptions = Apollo.BaseMutationOptions<AddCommentMutation, AddCommentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($commentId: String!) {
  deleteComment(commentId: $commentId)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const MarkCommentsReadDocument = gql`
    mutation MarkCommentsRead($input: MarkCommentsReadInput!) {
  markCommentsRead(input: $input)
}
    `;
export type MarkCommentsReadMutationFn = Apollo.MutationFunction<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>;

/**
 * __useMarkCommentsReadMutation__
 *
 * To run a mutation, you first call `useMarkCommentsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCommentsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCommentsReadMutation, { data, loading, error }] = useMarkCommentsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkCommentsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>(MarkCommentsReadDocument, options);
      }
export type MarkCommentsReadMutationHookResult = ReturnType<typeof useMarkCommentsReadMutation>;
export type MarkCommentsReadMutationResult = Apollo.MutationResult<MarkCommentsReadMutation>;
export type MarkCommentsReadMutationOptions = Apollo.BaseMutationOptions<MarkCommentsReadMutation, MarkCommentsReadMutationVariables>;
export const MePatientCommentsDocument = gql`
    query MePatientComments($before: Datetime, $chunkSize: Int) {
  mePatient {
    comments(before: $before, chunkSize: $chunkSize) {
      ...commentData
    }
    programInstanceId
  }
}
    ${CommentDataFragmentDoc}`;

/**
 * __useMePatientCommentsQuery__
 *
 * To run a query within a React component, call `useMePatientCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePatientCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePatientCommentsQuery({
 *   variables: {
 *      before: // value for 'before'
 *      chunkSize: // value for 'chunkSize'
 *   },
 * });
 */
export function useMePatientCommentsQuery(baseOptions?: Apollo.QueryHookOptions<MePatientCommentsQuery, MePatientCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePatientCommentsQuery, MePatientCommentsQueryVariables>(MePatientCommentsDocument, options);
      }
export function useMePatientCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePatientCommentsQuery, MePatientCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePatientCommentsQuery, MePatientCommentsQueryVariables>(MePatientCommentsDocument, options);
        }
export type MePatientCommentsQueryHookResult = ReturnType<typeof useMePatientCommentsQuery>;
export type MePatientCommentsLazyQueryHookResult = ReturnType<typeof useMePatientCommentsLazyQuery>;
export type MePatientCommentsQueryResult = Apollo.QueryResult<MePatientCommentsQuery, MePatientCommentsQueryVariables>;
export const GetMyMembershipsDocument = gql`
    query GetMyMemberships($input: MyMembershipsInput!) {
  myMemberships(input: $input) {
    ...ProviderUserMembershipFields
  }
}
    ${ProviderUserMembershipFieldsFragmentDoc}`;

/**
 * __useGetMyMembershipsQuery__
 *
 * To run a query within a React component, call `useGetMyMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMembershipsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMyMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetMyMembershipsQuery, GetMyMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMembershipsQuery, GetMyMembershipsQueryVariables>(GetMyMembershipsDocument, options);
      }
export function useGetMyMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMembershipsQuery, GetMyMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMembershipsQuery, GetMyMembershipsQueryVariables>(GetMyMembershipsDocument, options);
        }
export type GetMyMembershipsQueryHookResult = ReturnType<typeof useGetMyMembershipsQuery>;
export type GetMyMembershipsLazyQueryHookResult = ReturnType<typeof useGetMyMembershipsLazyQuery>;
export type GetMyMembershipsQueryResult = Apollo.QueryResult<GetMyMembershipsQuery, GetMyMembershipsQueryVariables>;
export const GetProviderMembershipsDocument = gql`
    query GetProviderMemberships($input: ProviderMembershipsInput!) {
  providerMemberships(input: $input) {
    ...ProviderUserMembershipFields
  }
}
    ${ProviderUserMembershipFieldsFragmentDoc}`;

/**
 * __useGetProviderMembershipsQuery__
 *
 * To run a query within a React component, call `useGetProviderMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderMembershipsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProviderMembershipsQuery(baseOptions: Apollo.QueryHookOptions<GetProviderMembershipsQuery, GetProviderMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderMembershipsQuery, GetProviderMembershipsQueryVariables>(GetProviderMembershipsDocument, options);
      }
export function useGetProviderMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderMembershipsQuery, GetProviderMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderMembershipsQuery, GetProviderMembershipsQueryVariables>(GetProviderMembershipsDocument, options);
        }
export type GetProviderMembershipsQueryHookResult = ReturnType<typeof useGetProviderMembershipsQuery>;
export type GetProviderMembershipsLazyQueryHookResult = ReturnType<typeof useGetProviderMembershipsLazyQuery>;
export type GetProviderMembershipsQueryResult = Apollo.QueryResult<GetProviderMembershipsQuery, GetProviderMembershipsQueryVariables>;
export const GetAvailableProviderContextsDocument = gql`
    query GetAvailableProviderContexts($input: AvailableProviderContextsInput) {
  availableProviderContexts(input: $input) {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useGetAvailableProviderContextsQuery__
 *
 * To run a query within a React component, call `useGetAvailableProviderContextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableProviderContextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableProviderContextsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAvailableProviderContextsQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableProviderContextsQuery, GetAvailableProviderContextsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableProviderContextsQuery, GetAvailableProviderContextsQueryVariables>(GetAvailableProviderContextsDocument, options);
      }
export function useGetAvailableProviderContextsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableProviderContextsQuery, GetAvailableProviderContextsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableProviderContextsQuery, GetAvailableProviderContextsQueryVariables>(GetAvailableProviderContextsDocument, options);
        }
export type GetAvailableProviderContextsQueryHookResult = ReturnType<typeof useGetAvailableProviderContextsQuery>;
export type GetAvailableProviderContextsLazyQueryHookResult = ReturnType<typeof useGetAvailableProviderContextsLazyQuery>;
export type GetAvailableProviderContextsQueryResult = Apollo.QueryResult<GetAvailableProviderContextsQuery, GetAvailableProviderContextsQueryVariables>;
export const GetActiveProviderContextDocument = gql`
    query GetActiveProviderContext {
  activeProviderContext {
    ...ProviderFields
  }
}
    ${ProviderFieldsFragmentDoc}`;

/**
 * __useGetActiveProviderContextQuery__
 *
 * To run a query within a React component, call `useGetActiveProviderContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveProviderContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveProviderContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActiveProviderContextQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveProviderContextQuery, GetActiveProviderContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveProviderContextQuery, GetActiveProviderContextQueryVariables>(GetActiveProviderContextDocument, options);
      }
export function useGetActiveProviderContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveProviderContextQuery, GetActiveProviderContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveProviderContextQuery, GetActiveProviderContextQueryVariables>(GetActiveProviderContextDocument, options);
        }
export type GetActiveProviderContextQueryHookResult = ReturnType<typeof useGetActiveProviderContextQuery>;
export type GetActiveProviderContextLazyQueryHookResult = ReturnType<typeof useGetActiveProviderContextLazyQuery>;
export type GetActiveProviderContextQueryResult = Apollo.QueryResult<GetActiveProviderContextQuery, GetActiveProviderContextQueryVariables>;
export const MyPendingInvitationsDocument = gql`
    query MyPendingInvitations {
  myMemberships(input: {statuses: [INVITED]}) {
    id
    provider {
      id
      name
      squareLogoMedia {
        url
      }
    }
    role
    invitedAt
    invitationExpiresAt
  }
}
    `;

/**
 * __useMyPendingInvitationsQuery__
 *
 * To run a query within a React component, call `useMyPendingInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPendingInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPendingInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyPendingInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<MyPendingInvitationsQuery, MyPendingInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPendingInvitationsQuery, MyPendingInvitationsQueryVariables>(MyPendingInvitationsDocument, options);
      }
export function useMyPendingInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPendingInvitationsQuery, MyPendingInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPendingInvitationsQuery, MyPendingInvitationsQueryVariables>(MyPendingInvitationsDocument, options);
        }
export type MyPendingInvitationsQueryHookResult = ReturnType<typeof useMyPendingInvitationsQuery>;
export type MyPendingInvitationsLazyQueryHookResult = ReturnType<typeof useMyPendingInvitationsLazyQuery>;
export type MyPendingInvitationsQueryResult = Apollo.QueryResult<MyPendingInvitationsQuery, MyPendingInvitationsQueryVariables>;
export const InviteExternalCollaboratorDocument = gql`
    mutation InviteExternalCollaborator($input: InviteExternalCollaboratorInput!) {
  inviteExternalCollaborator(input: $input) {
    success
    message
    membership {
      id
      status
    }
  }
}
    `;
export type InviteExternalCollaboratorMutationFn = Apollo.MutationFunction<InviteExternalCollaboratorMutation, InviteExternalCollaboratorMutationVariables>;

/**
 * __useInviteExternalCollaboratorMutation__
 *
 * To run a mutation, you first call `useInviteExternalCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteExternalCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteExternalCollaboratorMutation, { data, loading, error }] = useInviteExternalCollaboratorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteExternalCollaboratorMutation(baseOptions?: Apollo.MutationHookOptions<InviteExternalCollaboratorMutation, InviteExternalCollaboratorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteExternalCollaboratorMutation, InviteExternalCollaboratorMutationVariables>(InviteExternalCollaboratorDocument, options);
      }
export type InviteExternalCollaboratorMutationHookResult = ReturnType<typeof useInviteExternalCollaboratorMutation>;
export type InviteExternalCollaboratorMutationResult = Apollo.MutationResult<InviteExternalCollaboratorMutation>;
export type InviteExternalCollaboratorMutationOptions = Apollo.BaseMutationOptions<InviteExternalCollaboratorMutation, InviteExternalCollaboratorMutationVariables>;
export const SwitchProviderContextDocument = gql`
    mutation SwitchProviderContext($input: SwitchProviderContextInput!) {
  switchProviderContext(input: $input) {
    success
    message
    provider {
      ...ProviderFields
    }
  }
}
    ${ProviderFieldsFragmentDoc}`;
export type SwitchProviderContextMutationFn = Apollo.MutationFunction<SwitchProviderContextMutation, SwitchProviderContextMutationVariables>;

/**
 * __useSwitchProviderContextMutation__
 *
 * To run a mutation, you first call `useSwitchProviderContextMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchProviderContextMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchProviderContextMutation, { data, loading, error }] = useSwitchProviderContextMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchProviderContextMutation(baseOptions?: Apollo.MutationHookOptions<SwitchProviderContextMutation, SwitchProviderContextMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchProviderContextMutation, SwitchProviderContextMutationVariables>(SwitchProviderContextDocument, options);
      }
export type SwitchProviderContextMutationHookResult = ReturnType<typeof useSwitchProviderContextMutation>;
export type SwitchProviderContextMutationResult = Apollo.MutationResult<SwitchProviderContextMutation>;
export type SwitchProviderContextMutationOptions = Apollo.BaseMutationOptions<SwitchProviderContextMutation, SwitchProviderContextMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($input: AcceptCollaboratorInvitationInput!) {
  acceptCollaboratorInvitation(input: $input) {
    success
    message
    membership {
      id
      status
    }
  }
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const DeclineCollaboratorInvitationDocument = gql`
    mutation DeclineCollaboratorInvitation($input: DeclineCollaboratorInvitationInput!) {
  declineCollaboratorInvitation(input: $input) {
    success
    message
    membership {
      id
      status
      provider {
        id
        name
      }
    }
  }
}
    `;
export type DeclineCollaboratorInvitationMutationFn = Apollo.MutationFunction<DeclineCollaboratorInvitationMutation, DeclineCollaboratorInvitationMutationVariables>;

/**
 * __useDeclineCollaboratorInvitationMutation__
 *
 * To run a mutation, you first call `useDeclineCollaboratorInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineCollaboratorInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineCollaboratorInvitationMutation, { data, loading, error }] = useDeclineCollaboratorInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeclineCollaboratorInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeclineCollaboratorInvitationMutation, DeclineCollaboratorInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineCollaboratorInvitationMutation, DeclineCollaboratorInvitationMutationVariables>(DeclineCollaboratorInvitationDocument, options);
      }
export type DeclineCollaboratorInvitationMutationHookResult = ReturnType<typeof useDeclineCollaboratorInvitationMutation>;
export type DeclineCollaboratorInvitationMutationResult = Apollo.MutationResult<DeclineCollaboratorInvitationMutation>;
export type DeclineCollaboratorInvitationMutationOptions = Apollo.BaseMutationOptions<DeclineCollaboratorInvitationMutation, DeclineCollaboratorInvitationMutationVariables>;
export const EnabledFeaturesDocument = gql`
    query EnabledFeatures {
  enabledFeatures
}
    `;

/**
 * __useEnabledFeaturesQuery__
 *
 * To run a query within a React component, call `useEnabledFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnabledFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<EnabledFeaturesQuery, EnabledFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledFeaturesQuery, EnabledFeaturesQueryVariables>(EnabledFeaturesDocument, options);
      }
export function useEnabledFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledFeaturesQuery, EnabledFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledFeaturesQuery, EnabledFeaturesQueryVariables>(EnabledFeaturesDocument, options);
        }
export type EnabledFeaturesQueryHookResult = ReturnType<typeof useEnabledFeaturesQuery>;
export type EnabledFeaturesLazyQueryHookResult = ReturnType<typeof useEnabledFeaturesLazyQuery>;
export type EnabledFeaturesQueryResult = Apollo.QueryResult<EnabledFeaturesQuery, EnabledFeaturesQueryVariables>;
export const ProgramFollowUpsDocument = gql`
    query ProgramFollowUps($programId: String!) {
  programFollowUps(programId: $programId) {
    ...basicFollowUpData
  }
}
    ${BasicFollowUpDataFragmentDoc}`;

/**
 * __useProgramFollowUpsQuery__
 *
 * To run a query within a React component, call `useProgramFollowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramFollowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramFollowUpsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramFollowUpsQuery(baseOptions: Apollo.QueryHookOptions<ProgramFollowUpsQuery, ProgramFollowUpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramFollowUpsQuery, ProgramFollowUpsQueryVariables>(ProgramFollowUpsDocument, options);
      }
export function useProgramFollowUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramFollowUpsQuery, ProgramFollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramFollowUpsQuery, ProgramFollowUpsQueryVariables>(ProgramFollowUpsDocument, options);
        }
export type ProgramFollowUpsQueryHookResult = ReturnType<typeof useProgramFollowUpsQuery>;
export type ProgramFollowUpsLazyQueryHookResult = ReturnType<typeof useProgramFollowUpsLazyQuery>;
export type ProgramFollowUpsQueryResult = Apollo.QueryResult<ProgramFollowUpsQuery, ProgramFollowUpsQueryVariables>;
export const PatientProgramFollowUpsDocument = gql`
    query PatientProgramFollowUps($programId: String!) {
  programFollowUps(programId: $programId) {
    ...patientCardFollowUpData
  }
}
    ${PatientCardFollowUpDataFragmentDoc}`;

/**
 * __usePatientProgramFollowUpsQuery__
 *
 * To run a query within a React component, call `usePatientProgramFollowUpsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientProgramFollowUpsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientProgramFollowUpsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function usePatientProgramFollowUpsQuery(baseOptions: Apollo.QueryHookOptions<PatientProgramFollowUpsQuery, PatientProgramFollowUpsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientProgramFollowUpsQuery, PatientProgramFollowUpsQueryVariables>(PatientProgramFollowUpsDocument, options);
      }
export function usePatientProgramFollowUpsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientProgramFollowUpsQuery, PatientProgramFollowUpsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientProgramFollowUpsQuery, PatientProgramFollowUpsQueryVariables>(PatientProgramFollowUpsDocument, options);
        }
export type PatientProgramFollowUpsQueryHookResult = ReturnType<typeof usePatientProgramFollowUpsQuery>;
export type PatientProgramFollowUpsLazyQueryHookResult = ReturnType<typeof usePatientProgramFollowUpsLazyQuery>;
export type PatientProgramFollowUpsQueryResult = Apollo.QueryResult<PatientProgramFollowUpsQuery, PatientProgramFollowUpsQueryVariables>;
export const ProgramFollowUpDocument = gql`
    query ProgramFollowUp($programFollowUpId: String!) {
  programFollowUp(programFollowUpId: $programFollowUpId) {
    ...followUpData
  }
}
    ${FollowUpDataFragmentDoc}`;

/**
 * __useProgramFollowUpQuery__
 *
 * To run a query within a React component, call `useProgramFollowUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramFollowUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramFollowUpQuery({
 *   variables: {
 *      programFollowUpId: // value for 'programFollowUpId'
 *   },
 * });
 */
export function useProgramFollowUpQuery(baseOptions: Apollo.QueryHookOptions<ProgramFollowUpQuery, ProgramFollowUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramFollowUpQuery, ProgramFollowUpQueryVariables>(ProgramFollowUpDocument, options);
      }
export function useProgramFollowUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramFollowUpQuery, ProgramFollowUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramFollowUpQuery, ProgramFollowUpQueryVariables>(ProgramFollowUpDocument, options);
        }
export type ProgramFollowUpQueryHookResult = ReturnType<typeof useProgramFollowUpQuery>;
export type ProgramFollowUpLazyQueryHookResult = ReturnType<typeof useProgramFollowUpLazyQuery>;
export type ProgramFollowUpQueryResult = Apollo.QueryResult<ProgramFollowUpQuery, ProgramFollowUpQueryVariables>;
export const PatientNamesForRecipientsDocument = gql`
    query PatientNamesForRecipients($programIds: [String!], $programTagIds: [String!]) {
  patientNamesForRecipients(
    programIds: $programIds
    programTagIds: $programTagIds
  ) {
    ...patientNameData
  }
}
    ${PatientNameDataFragmentDoc}`;

/**
 * __usePatientNamesForRecipientsQuery__
 *
 * To run a query within a React component, call `usePatientNamesForRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientNamesForRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientNamesForRecipientsQuery({
 *   variables: {
 *      programIds: // value for 'programIds'
 *      programTagIds: // value for 'programTagIds'
 *   },
 * });
 */
export function usePatientNamesForRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<PatientNamesForRecipientsQuery, PatientNamesForRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientNamesForRecipientsQuery, PatientNamesForRecipientsQueryVariables>(PatientNamesForRecipientsDocument, options);
      }
export function usePatientNamesForRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientNamesForRecipientsQuery, PatientNamesForRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientNamesForRecipientsQuery, PatientNamesForRecipientsQueryVariables>(PatientNamesForRecipientsDocument, options);
        }
export type PatientNamesForRecipientsQueryHookResult = ReturnType<typeof usePatientNamesForRecipientsQuery>;
export type PatientNamesForRecipientsLazyQueryHookResult = ReturnType<typeof usePatientNamesForRecipientsLazyQuery>;
export type PatientNamesForRecipientsQueryResult = Apollo.QueryResult<PatientNamesForRecipientsQuery, PatientNamesForRecipientsQueryVariables>;
export const AddVoiceNoteDocument = gql`
    mutation AddVoiceNote($input: VoiceNoteInput!) {
  addVoiceNote(input: $input) {
    id
  }
}
    `;
export type AddVoiceNoteMutationFn = Apollo.MutationFunction<AddVoiceNoteMutation, AddVoiceNoteMutationVariables>;

/**
 * __useAddVoiceNoteMutation__
 *
 * To run a mutation, you first call `useAddVoiceNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVoiceNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVoiceNoteMutation, { data, loading, error }] = useAddVoiceNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddVoiceNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddVoiceNoteMutation, AddVoiceNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVoiceNoteMutation, AddVoiceNoteMutationVariables>(AddVoiceNoteDocument, options);
      }
export type AddVoiceNoteMutationHookResult = ReturnType<typeof useAddVoiceNoteMutation>;
export type AddVoiceNoteMutationResult = Apollo.MutationResult<AddVoiceNoteMutation>;
export type AddVoiceNoteMutationOptions = Apollo.BaseMutationOptions<AddVoiceNoteMutation, AddVoiceNoteMutationVariables>;
export const SendFollowUpToManyDocument = gql`
    mutation SendFollowUpToMany($input: SendFollowUpToManyInput!) {
  sendFollowUpToMany(input: $input) {
    ...followUpData
  }
}
    ${FollowUpDataFragmentDoc}`;
export type SendFollowUpToManyMutationFn = Apollo.MutationFunction<SendFollowUpToManyMutation, SendFollowUpToManyMutationVariables>;

/**
 * __useSendFollowUpToManyMutation__
 *
 * To run a mutation, you first call `useSendFollowUpToManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFollowUpToManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFollowUpToManyMutation, { data, loading, error }] = useSendFollowUpToManyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendFollowUpToManyMutation(baseOptions?: Apollo.MutationHookOptions<SendFollowUpToManyMutation, SendFollowUpToManyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFollowUpToManyMutation, SendFollowUpToManyMutationVariables>(SendFollowUpToManyDocument, options);
      }
export type SendFollowUpToManyMutationHookResult = ReturnType<typeof useSendFollowUpToManyMutation>;
export type SendFollowUpToManyMutationResult = Apollo.MutationResult<SendFollowUpToManyMutation>;
export type SendFollowUpToManyMutationOptions = Apollo.BaseMutationOptions<SendFollowUpToManyMutation, SendFollowUpToManyMutationVariables>;
export const SendFollowUpEmailDocument = gql`
    mutation SendFollowUpEmail($programFollowUpId: String!) {
  sendFollowUpEmail(programFollowUpId: $programFollowUpId)
}
    `;
export type SendFollowUpEmailMutationFn = Apollo.MutationFunction<SendFollowUpEmailMutation, SendFollowUpEmailMutationVariables>;

/**
 * __useSendFollowUpEmailMutation__
 *
 * To run a mutation, you first call `useSendFollowUpEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFollowUpEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFollowUpEmailMutation, { data, loading, error }] = useSendFollowUpEmailMutation({
 *   variables: {
 *      programFollowUpId: // value for 'programFollowUpId'
 *   },
 * });
 */
export function useSendFollowUpEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendFollowUpEmailMutation, SendFollowUpEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFollowUpEmailMutation, SendFollowUpEmailMutationVariables>(SendFollowUpEmailDocument, options);
      }
export type SendFollowUpEmailMutationHookResult = ReturnType<typeof useSendFollowUpEmailMutation>;
export type SendFollowUpEmailMutationResult = Apollo.MutationResult<SendFollowUpEmailMutation>;
export type SendFollowUpEmailMutationOptions = Apollo.BaseMutationOptions<SendFollowUpEmailMutation, SendFollowUpEmailMutationVariables>;
export const EditSentMailMessageDocument = gql`
    mutation EditSentMailMessage($input: EditSentMailMessageInput!) {
  editSentMailMessage(input: $input) {
    ...followUpData
  }
}
    ${FollowUpDataFragmentDoc}`;
export type EditSentMailMessageMutationFn = Apollo.MutationFunction<EditSentMailMessageMutation, EditSentMailMessageMutationVariables>;

/**
 * __useEditSentMailMessageMutation__
 *
 * To run a mutation, you first call `useEditSentMailMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditSentMailMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editSentMailMessageMutation, { data, loading, error }] = useEditSentMailMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditSentMailMessageMutation(baseOptions?: Apollo.MutationHookOptions<EditSentMailMessageMutation, EditSentMailMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditSentMailMessageMutation, EditSentMailMessageMutationVariables>(EditSentMailMessageDocument, options);
      }
export type EditSentMailMessageMutationHookResult = ReturnType<typeof useEditSentMailMessageMutation>;
export type EditSentMailMessageMutationResult = Apollo.MutationResult<EditSentMailMessageMutation>;
export type EditSentMailMessageMutationOptions = Apollo.BaseMutationOptions<EditSentMailMessageMutation, EditSentMailMessageMutationVariables>;
export const FollowUpTemplatesForPickerDocument = gql`
    query FollowUpTemplatesForPicker($input: FollowUpTemplatesInput!) {
  followUpTemplates(input: $input) {
    ...followUpTemplatePickerItem
  }
}
    ${FollowUpTemplatePickerItemFragmentDoc}`;

/**
 * __useFollowUpTemplatesForPickerQuery__
 *
 * To run a query within a React component, call `useFollowUpTemplatesForPickerQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpTemplatesForPickerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpTemplatesForPickerQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowUpTemplatesForPickerQuery(baseOptions: Apollo.QueryHookOptions<FollowUpTemplatesForPickerQuery, FollowUpTemplatesForPickerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpTemplatesForPickerQuery, FollowUpTemplatesForPickerQueryVariables>(FollowUpTemplatesForPickerDocument, options);
      }
export function useFollowUpTemplatesForPickerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpTemplatesForPickerQuery, FollowUpTemplatesForPickerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpTemplatesForPickerQuery, FollowUpTemplatesForPickerQueryVariables>(FollowUpTemplatesForPickerDocument, options);
        }
export type FollowUpTemplatesForPickerQueryHookResult = ReturnType<typeof useFollowUpTemplatesForPickerQuery>;
export type FollowUpTemplatesForPickerLazyQueryHookResult = ReturnType<typeof useFollowUpTemplatesForPickerLazyQuery>;
export type FollowUpTemplatesForPickerQueryResult = Apollo.QueryResult<FollowUpTemplatesForPickerQuery, FollowUpTemplatesForPickerQueryVariables>;
export const FollowUpTemplatesDocument = gql`
    query FollowUpTemplates($input: FollowUpTemplatesInput!) {
  followUpTemplates(input: $input) {
    ...followUpTemplateData
  }
}
    ${FollowUpTemplateDataFragmentDoc}`;

/**
 * __useFollowUpTemplatesQuery__
 *
 * To run a query within a React component, call `useFollowUpTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpTemplatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowUpTemplatesQuery(baseOptions: Apollo.QueryHookOptions<FollowUpTemplatesQuery, FollowUpTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpTemplatesQuery, FollowUpTemplatesQueryVariables>(FollowUpTemplatesDocument, options);
      }
export function useFollowUpTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpTemplatesQuery, FollowUpTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpTemplatesQuery, FollowUpTemplatesQueryVariables>(FollowUpTemplatesDocument, options);
        }
export type FollowUpTemplatesQueryHookResult = ReturnType<typeof useFollowUpTemplatesQuery>;
export type FollowUpTemplatesLazyQueryHookResult = ReturnType<typeof useFollowUpTemplatesLazyQuery>;
export type FollowUpTemplatesQueryResult = Apollo.QueryResult<FollowUpTemplatesQuery, FollowUpTemplatesQueryVariables>;
export const FollowUpTemplateDocument = gql`
    query FollowUpTemplate($followUpTemplateId: String!) {
  followUpTemplate(followUpTemplateId: $followUpTemplateId) {
    ...followUpTemplateData
  }
}
    ${FollowUpTemplateDataFragmentDoc}`;

/**
 * __useFollowUpTemplateQuery__
 *
 * To run a query within a React component, call `useFollowUpTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowUpTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowUpTemplateQuery({
 *   variables: {
 *      followUpTemplateId: // value for 'followUpTemplateId'
 *   },
 * });
 */
export function useFollowUpTemplateQuery(baseOptions: Apollo.QueryHookOptions<FollowUpTemplateQuery, FollowUpTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FollowUpTemplateQuery, FollowUpTemplateQueryVariables>(FollowUpTemplateDocument, options);
      }
export function useFollowUpTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FollowUpTemplateQuery, FollowUpTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FollowUpTemplateQuery, FollowUpTemplateQueryVariables>(FollowUpTemplateDocument, options);
        }
export type FollowUpTemplateQueryHookResult = ReturnType<typeof useFollowUpTemplateQuery>;
export type FollowUpTemplateLazyQueryHookResult = ReturnType<typeof useFollowUpTemplateLazyQuery>;
export type FollowUpTemplateQueryResult = Apollo.QueryResult<FollowUpTemplateQuery, FollowUpTemplateQueryVariables>;
export const SaveFollowUpTemplateDocument = gql`
    mutation SaveFollowUpTemplate($input: SaveFollowUpTemplateInput!) {
  saveFollowUpTemplate(input: $input) {
    ...followUpTemplateData
  }
}
    ${FollowUpTemplateDataFragmentDoc}`;
export type SaveFollowUpTemplateMutationFn = Apollo.MutationFunction<SaveFollowUpTemplateMutation, SaveFollowUpTemplateMutationVariables>;

/**
 * __useSaveFollowUpTemplateMutation__
 *
 * To run a mutation, you first call `useSaveFollowUpTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFollowUpTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFollowUpTemplateMutation, { data, loading, error }] = useSaveFollowUpTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFollowUpTemplateMutation(baseOptions?: Apollo.MutationHookOptions<SaveFollowUpTemplateMutation, SaveFollowUpTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFollowUpTemplateMutation, SaveFollowUpTemplateMutationVariables>(SaveFollowUpTemplateDocument, options);
      }
export type SaveFollowUpTemplateMutationHookResult = ReturnType<typeof useSaveFollowUpTemplateMutation>;
export type SaveFollowUpTemplateMutationResult = Apollo.MutationResult<SaveFollowUpTemplateMutation>;
export type SaveFollowUpTemplateMutationOptions = Apollo.BaseMutationOptions<SaveFollowUpTemplateMutation, SaveFollowUpTemplateMutationVariables>;
export const RenameFollowUpTemplateDocument = gql`
    mutation RenameFollowUpTemplate($input: RenameFollowUpTemplateInput!) {
  renameFollowUpTemplate(input: $input) {
    ...followUpTemplateData
  }
}
    ${FollowUpTemplateDataFragmentDoc}`;
export type RenameFollowUpTemplateMutationFn = Apollo.MutationFunction<RenameFollowUpTemplateMutation, RenameFollowUpTemplateMutationVariables>;

/**
 * __useRenameFollowUpTemplateMutation__
 *
 * To run a mutation, you first call `useRenameFollowUpTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFollowUpTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFollowUpTemplateMutation, { data, loading, error }] = useRenameFollowUpTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameFollowUpTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RenameFollowUpTemplateMutation, RenameFollowUpTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameFollowUpTemplateMutation, RenameFollowUpTemplateMutationVariables>(RenameFollowUpTemplateDocument, options);
      }
export type RenameFollowUpTemplateMutationHookResult = ReturnType<typeof useRenameFollowUpTemplateMutation>;
export type RenameFollowUpTemplateMutationResult = Apollo.MutationResult<RenameFollowUpTemplateMutation>;
export type RenameFollowUpTemplateMutationOptions = Apollo.BaseMutationOptions<RenameFollowUpTemplateMutation, RenameFollowUpTemplateMutationVariables>;
export const DuplicateFollowUpTemplateDocument = gql`
    mutation DuplicateFollowUpTemplate($input: DuplicateFollowUpTemplateInput!) {
  duplicateFollowUpTemplate(input: $input) {
    ...followUpTemplateData
  }
}
    ${FollowUpTemplateDataFragmentDoc}`;
export type DuplicateFollowUpTemplateMutationFn = Apollo.MutationFunction<DuplicateFollowUpTemplateMutation, DuplicateFollowUpTemplateMutationVariables>;

/**
 * __useDuplicateFollowUpTemplateMutation__
 *
 * To run a mutation, you first call `useDuplicateFollowUpTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateFollowUpTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateFollowUpTemplateMutation, { data, loading, error }] = useDuplicateFollowUpTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateFollowUpTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateFollowUpTemplateMutation, DuplicateFollowUpTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateFollowUpTemplateMutation, DuplicateFollowUpTemplateMutationVariables>(DuplicateFollowUpTemplateDocument, options);
      }
export type DuplicateFollowUpTemplateMutationHookResult = ReturnType<typeof useDuplicateFollowUpTemplateMutation>;
export type DuplicateFollowUpTemplateMutationResult = Apollo.MutationResult<DuplicateFollowUpTemplateMutation>;
export type DuplicateFollowUpTemplateMutationOptions = Apollo.BaseMutationOptions<DuplicateFollowUpTemplateMutation, DuplicateFollowUpTemplateMutationVariables>;
export const DeleteFollowUpTemplateDocument = gql`
    mutation DeleteFollowUpTemplate($input: DeleteFollowUpTemplateInput!) {
  deleteFollowUpTemplate(input: $input)
}
    `;
export type DeleteFollowUpTemplateMutationFn = Apollo.MutationFunction<DeleteFollowUpTemplateMutation, DeleteFollowUpTemplateMutationVariables>;

/**
 * __useDeleteFollowUpTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteFollowUpTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFollowUpTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFollowUpTemplateMutation, { data, loading, error }] = useDeleteFollowUpTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFollowUpTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFollowUpTemplateMutation, DeleteFollowUpTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFollowUpTemplateMutation, DeleteFollowUpTemplateMutationVariables>(DeleteFollowUpTemplateDocument, options);
      }
export type DeleteFollowUpTemplateMutationHookResult = ReturnType<typeof useDeleteFollowUpTemplateMutation>;
export type DeleteFollowUpTemplateMutationResult = Apollo.MutationResult<DeleteFollowUpTemplateMutation>;
export type DeleteFollowUpTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteFollowUpTemplateMutation, DeleteFollowUpTemplateMutationVariables>;
export const AddCalendlyIntegrationDocument = gql`
    mutation AddCalendlyIntegration($authorizationCode: String!) {
  addCalendlyIntegration(authorizationCode: $authorizationCode) {
    id
  }
}
    `;
export type AddCalendlyIntegrationMutationFn = Apollo.MutationFunction<AddCalendlyIntegrationMutation, AddCalendlyIntegrationMutationVariables>;

/**
 * __useAddCalendlyIntegrationMutation__
 *
 * To run a mutation, you first call `useAddCalendlyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCalendlyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCalendlyIntegrationMutation, { data, loading, error }] = useAddCalendlyIntegrationMutation({
 *   variables: {
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useAddCalendlyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AddCalendlyIntegrationMutation, AddCalendlyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCalendlyIntegrationMutation, AddCalendlyIntegrationMutationVariables>(AddCalendlyIntegrationDocument, options);
      }
export type AddCalendlyIntegrationMutationHookResult = ReturnType<typeof useAddCalendlyIntegrationMutation>;
export type AddCalendlyIntegrationMutationResult = Apollo.MutationResult<AddCalendlyIntegrationMutation>;
export type AddCalendlyIntegrationMutationOptions = Apollo.BaseMutationOptions<AddCalendlyIntegrationMutation, AddCalendlyIntegrationMutationVariables>;
export const RemoveCalendlyIntegrationDocument = gql`
    mutation RemoveCalendlyIntegration {
  removeCalendlyIntegration {
    id
  }
}
    `;
export type RemoveCalendlyIntegrationMutationFn = Apollo.MutationFunction<RemoveCalendlyIntegrationMutation, RemoveCalendlyIntegrationMutationVariables>;

/**
 * __useRemoveCalendlyIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveCalendlyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCalendlyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCalendlyIntegrationMutation, { data, loading, error }] = useRemoveCalendlyIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveCalendlyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCalendlyIntegrationMutation, RemoveCalendlyIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCalendlyIntegrationMutation, RemoveCalendlyIntegrationMutationVariables>(RemoveCalendlyIntegrationDocument, options);
      }
export type RemoveCalendlyIntegrationMutationHookResult = ReturnType<typeof useRemoveCalendlyIntegrationMutation>;
export type RemoveCalendlyIntegrationMutationResult = Apollo.MutationResult<RemoveCalendlyIntegrationMutation>;
export type RemoveCalendlyIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveCalendlyIntegrationMutation, RemoveCalendlyIntegrationMutationVariables>;
export const AddStripeIntegrationDocument = gql`
    mutation AddStripeIntegration($authorizationCode: String!) {
  addStripeIntegration(authorizationCode: $authorizationCode)
}
    `;
export type AddStripeIntegrationMutationFn = Apollo.MutationFunction<AddStripeIntegrationMutation, AddStripeIntegrationMutationVariables>;

/**
 * __useAddStripeIntegrationMutation__
 *
 * To run a mutation, you first call `useAddStripeIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddStripeIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addStripeIntegrationMutation, { data, loading, error }] = useAddStripeIntegrationMutation({
 *   variables: {
 *      authorizationCode: // value for 'authorizationCode'
 *   },
 * });
 */
export function useAddStripeIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<AddStripeIntegrationMutation, AddStripeIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddStripeIntegrationMutation, AddStripeIntegrationMutationVariables>(AddStripeIntegrationDocument, options);
      }
export type AddStripeIntegrationMutationHookResult = ReturnType<typeof useAddStripeIntegrationMutation>;
export type AddStripeIntegrationMutationResult = Apollo.MutationResult<AddStripeIntegrationMutation>;
export type AddStripeIntegrationMutationOptions = Apollo.BaseMutationOptions<AddStripeIntegrationMutation, AddStripeIntegrationMutationVariables>;
export const RemoveStripeIntegrationDocument = gql`
    mutation RemoveStripeIntegration {
  removeStripeIntegration
}
    `;
export type RemoveStripeIntegrationMutationFn = Apollo.MutationFunction<RemoveStripeIntegrationMutation, RemoveStripeIntegrationMutationVariables>;

/**
 * __useRemoveStripeIntegrationMutation__
 *
 * To run a mutation, you first call `useRemoveStripeIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStripeIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStripeIntegrationMutation, { data, loading, error }] = useRemoveStripeIntegrationMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveStripeIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStripeIntegrationMutation, RemoveStripeIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStripeIntegrationMutation, RemoveStripeIntegrationMutationVariables>(RemoveStripeIntegrationDocument, options);
      }
export type RemoveStripeIntegrationMutationHookResult = ReturnType<typeof useRemoveStripeIntegrationMutation>;
export type RemoveStripeIntegrationMutationResult = Apollo.MutationResult<RemoveStripeIntegrationMutation>;
export type RemoveStripeIntegrationMutationOptions = Apollo.BaseMutationOptions<RemoveStripeIntegrationMutation, RemoveStripeIntegrationMutationVariables>;
export const ProgramInvoicesDocument = gql`
    query ProgramInvoices($includeArchived: Boolean) {
  programInvoices(includeArchived: $includeArchived) {
    ...programInvoiceData
  }
}
    ${ProgramInvoiceDataFragmentDoc}`;

/**
 * __useProgramInvoicesQuery__
 *
 * To run a query within a React component, call `useProgramInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramInvoicesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useProgramInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<ProgramInvoicesQuery, ProgramInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramInvoicesQuery, ProgramInvoicesQueryVariables>(ProgramInvoicesDocument, options);
      }
export function useProgramInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramInvoicesQuery, ProgramInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramInvoicesQuery, ProgramInvoicesQueryVariables>(ProgramInvoicesDocument, options);
        }
export type ProgramInvoicesQueryHookResult = ReturnType<typeof useProgramInvoicesQuery>;
export type ProgramInvoicesLazyQueryHookResult = ReturnType<typeof useProgramInvoicesLazyQuery>;
export type ProgramInvoicesQueryResult = Apollo.QueryResult<ProgramInvoicesQuery, ProgramInvoicesQueryVariables>;
export const ProgramInvoicesForProgramDocument = gql`
    query ProgramInvoicesForProgram($programId: String, $includeArchived: Boolean) {
  programInvoices(programId: $programId, includeArchived: $includeArchived) {
    ...programInvoiceData
  }
}
    ${ProgramInvoiceDataFragmentDoc}`;

/**
 * __useProgramInvoicesForProgramQuery__
 *
 * To run a query within a React component, call `useProgramInvoicesForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramInvoicesForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramInvoicesForProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useProgramInvoicesForProgramQuery(baseOptions?: Apollo.QueryHookOptions<ProgramInvoicesForProgramQuery, ProgramInvoicesForProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramInvoicesForProgramQuery, ProgramInvoicesForProgramQueryVariables>(ProgramInvoicesForProgramDocument, options);
      }
export function useProgramInvoicesForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramInvoicesForProgramQuery, ProgramInvoicesForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramInvoicesForProgramQuery, ProgramInvoicesForProgramQueryVariables>(ProgramInvoicesForProgramDocument, options);
        }
export type ProgramInvoicesForProgramQueryHookResult = ReturnType<typeof useProgramInvoicesForProgramQuery>;
export type ProgramInvoicesForProgramLazyQueryHookResult = ReturnType<typeof useProgramInvoicesForProgramLazyQuery>;
export type ProgramInvoicesForProgramQueryResult = Apollo.QueryResult<ProgramInvoicesForProgramQuery, ProgramInvoicesForProgramQueryVariables>;
export const SearchStripeProductsDocument = gql`
    query SearchStripeProducts($query: String!) {
  searchStripeProducts(query: $query) {
    name
    price
    stripePriceId
  }
}
    `;

/**
 * __useSearchStripeProductsQuery__
 *
 * To run a query within a React component, call `useSearchStripeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchStripeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchStripeProductsQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchStripeProductsQuery(baseOptions: Apollo.QueryHookOptions<SearchStripeProductsQuery, SearchStripeProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchStripeProductsQuery, SearchStripeProductsQueryVariables>(SearchStripeProductsDocument, options);
      }
export function useSearchStripeProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchStripeProductsQuery, SearchStripeProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchStripeProductsQuery, SearchStripeProductsQueryVariables>(SearchStripeProductsDocument, options);
        }
export type SearchStripeProductsQueryHookResult = ReturnType<typeof useSearchStripeProductsQuery>;
export type SearchStripeProductsLazyQueryHookResult = ReturnType<typeof useSearchStripeProductsLazyQuery>;
export type SearchStripeProductsQueryResult = Apollo.QueryResult<SearchStripeProductsQuery, SearchStripeProductsQueryVariables>;
export const ProgramHasDefaultPaymentMethodDocument = gql`
    query ProgramHasDefaultPaymentMethod($programId: String!) {
  programHasDefaultPaymentMethod(programId: $programId)
}
    `;

/**
 * __useProgramHasDefaultPaymentMethodQuery__
 *
 * To run a query within a React component, call `useProgramHasDefaultPaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramHasDefaultPaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramHasDefaultPaymentMethodQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramHasDefaultPaymentMethodQuery(baseOptions: Apollo.QueryHookOptions<ProgramHasDefaultPaymentMethodQuery, ProgramHasDefaultPaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramHasDefaultPaymentMethodQuery, ProgramHasDefaultPaymentMethodQueryVariables>(ProgramHasDefaultPaymentMethodDocument, options);
      }
export function useProgramHasDefaultPaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramHasDefaultPaymentMethodQuery, ProgramHasDefaultPaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramHasDefaultPaymentMethodQuery, ProgramHasDefaultPaymentMethodQueryVariables>(ProgramHasDefaultPaymentMethodDocument, options);
        }
export type ProgramHasDefaultPaymentMethodQueryHookResult = ReturnType<typeof useProgramHasDefaultPaymentMethodQuery>;
export type ProgramHasDefaultPaymentMethodLazyQueryHookResult = ReturnType<typeof useProgramHasDefaultPaymentMethodLazyQuery>;
export type ProgramHasDefaultPaymentMethodQueryResult = Apollo.QueryResult<ProgramHasDefaultPaymentMethodQuery, ProgramHasDefaultPaymentMethodQueryVariables>;
export const ProviderStripeCardProcessingFeeScheduleDocument = gql`
    query ProviderStripeCardProcessingFeeSchedule {
  providerStripeCardProcessingFeeSchedule {
    country
    currency
    percentFee
    fixedFee
    label
  }
}
    `;

/**
 * __useProviderStripeCardProcessingFeeScheduleQuery__
 *
 * To run a query within a React component, call `useProviderStripeCardProcessingFeeScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderStripeCardProcessingFeeScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderStripeCardProcessingFeeScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderStripeCardProcessingFeeScheduleQuery(baseOptions?: Apollo.QueryHookOptions<ProviderStripeCardProcessingFeeScheduleQuery, ProviderStripeCardProcessingFeeScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderStripeCardProcessingFeeScheduleQuery, ProviderStripeCardProcessingFeeScheduleQueryVariables>(ProviderStripeCardProcessingFeeScheduleDocument, options);
      }
export function useProviderStripeCardProcessingFeeScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderStripeCardProcessingFeeScheduleQuery, ProviderStripeCardProcessingFeeScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderStripeCardProcessingFeeScheduleQuery, ProviderStripeCardProcessingFeeScheduleQueryVariables>(ProviderStripeCardProcessingFeeScheduleDocument, options);
        }
export type ProviderStripeCardProcessingFeeScheduleQueryHookResult = ReturnType<typeof useProviderStripeCardProcessingFeeScheduleQuery>;
export type ProviderStripeCardProcessingFeeScheduleLazyQueryHookResult = ReturnType<typeof useProviderStripeCardProcessingFeeScheduleLazyQuery>;
export type ProviderStripeCardProcessingFeeScheduleQueryResult = Apollo.QueryResult<ProviderStripeCardProcessingFeeScheduleQuery, ProviderStripeCardProcessingFeeScheduleQueryVariables>;
export const SendInvoiceDocument = gql`
    mutation SendInvoice($input: SendInvoiceInput!) {
  sendInvoice(input: $input) {
    id
  }
}
    `;
export type SendInvoiceMutationFn = Apollo.MutationFunction<SendInvoiceMutation, SendInvoiceMutationVariables>;

/**
 * __useSendInvoiceMutation__
 *
 * To run a mutation, you first call `useSendInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceMutation, { data, loading, error }] = useSendInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceMutation, SendInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceMutation, SendInvoiceMutationVariables>(SendInvoiceDocument, options);
      }
export type SendInvoiceMutationHookResult = ReturnType<typeof useSendInvoiceMutation>;
export type SendInvoiceMutationResult = Apollo.MutationResult<SendInvoiceMutation>;
export type SendInvoiceMutationOptions = Apollo.BaseMutationOptions<SendInvoiceMutation, SendInvoiceMutationVariables>;
export const SendInvoiceReminderDocument = gql`
    mutation SendInvoiceReminder($programInvoiceId: String!) {
  sendInvoiceReminder(programInvoiceId: $programInvoiceId)
}
    `;
export type SendInvoiceReminderMutationFn = Apollo.MutationFunction<SendInvoiceReminderMutation, SendInvoiceReminderMutationVariables>;

/**
 * __useSendInvoiceReminderMutation__
 *
 * To run a mutation, you first call `useSendInvoiceReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvoiceReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvoiceReminderMutation, { data, loading, error }] = useSendInvoiceReminderMutation({
 *   variables: {
 *      programInvoiceId: // value for 'programInvoiceId'
 *   },
 * });
 */
export function useSendInvoiceReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendInvoiceReminderMutation, SendInvoiceReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvoiceReminderMutation, SendInvoiceReminderMutationVariables>(SendInvoiceReminderDocument, options);
      }
export type SendInvoiceReminderMutationHookResult = ReturnType<typeof useSendInvoiceReminderMutation>;
export type SendInvoiceReminderMutationResult = Apollo.MutationResult<SendInvoiceReminderMutation>;
export type SendInvoiceReminderMutationOptions = Apollo.BaseMutationOptions<SendInvoiceReminderMutation, SendInvoiceReminderMutationVariables>;
export const VoidInvoiceDocument = gql`
    mutation VoidInvoice($programInvoiceId: String!) {
  voidInvoice(programInvoiceId: $programInvoiceId)
}
    `;
export type VoidInvoiceMutationFn = Apollo.MutationFunction<VoidInvoiceMutation, VoidInvoiceMutationVariables>;

/**
 * __useVoidInvoiceMutation__
 *
 * To run a mutation, you first call `useVoidInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVoidInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [voidInvoiceMutation, { data, loading, error }] = useVoidInvoiceMutation({
 *   variables: {
 *      programInvoiceId: // value for 'programInvoiceId'
 *   },
 * });
 */
export function useVoidInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<VoidInvoiceMutation, VoidInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VoidInvoiceMutation, VoidInvoiceMutationVariables>(VoidInvoiceDocument, options);
      }
export type VoidInvoiceMutationHookResult = ReturnType<typeof useVoidInvoiceMutation>;
export type VoidInvoiceMutationResult = Apollo.MutationResult<VoidInvoiceMutation>;
export type VoidInvoiceMutationOptions = Apollo.BaseMutationOptions<VoidInvoiceMutation, VoidInvoiceMutationVariables>;
export const RecordInvoiceDownloadDocument = gql`
    mutation RecordInvoiceDownload($programInvoiceId: String!, $sourcePage: String) {
  recordInvoiceDownload(
    programInvoiceId: $programInvoiceId
    sourcePage: $sourcePage
  )
}
    `;
export type RecordInvoiceDownloadMutationFn = Apollo.MutationFunction<RecordInvoiceDownloadMutation, RecordInvoiceDownloadMutationVariables>;

/**
 * __useRecordInvoiceDownloadMutation__
 *
 * To run a mutation, you first call `useRecordInvoiceDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordInvoiceDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordInvoiceDownloadMutation, { data, loading, error }] = useRecordInvoiceDownloadMutation({
 *   variables: {
 *      programInvoiceId: // value for 'programInvoiceId'
 *      sourcePage: // value for 'sourcePage'
 *   },
 * });
 */
export function useRecordInvoiceDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RecordInvoiceDownloadMutation, RecordInvoiceDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordInvoiceDownloadMutation, RecordInvoiceDownloadMutationVariables>(RecordInvoiceDownloadDocument, options);
      }
export type RecordInvoiceDownloadMutationHookResult = ReturnType<typeof useRecordInvoiceDownloadMutation>;
export type RecordInvoiceDownloadMutationResult = Apollo.MutationResult<RecordInvoiceDownloadMutation>;
export type RecordInvoiceDownloadMutationOptions = Apollo.BaseMutationOptions<RecordInvoiceDownloadMutation, RecordInvoiceDownloadMutationVariables>;
export const RecordInvoiceListExportDocument = gql`
    mutation RecordInvoiceListExport($invoiceCount: Int!, $filtered: Boolean!) {
  recordInvoiceListExport(invoiceCount: $invoiceCount, filtered: $filtered)
}
    `;
export type RecordInvoiceListExportMutationFn = Apollo.MutationFunction<RecordInvoiceListExportMutation, RecordInvoiceListExportMutationVariables>;

/**
 * __useRecordInvoiceListExportMutation__
 *
 * To run a mutation, you first call `useRecordInvoiceListExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordInvoiceListExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordInvoiceListExportMutation, { data, loading, error }] = useRecordInvoiceListExportMutation({
 *   variables: {
 *      invoiceCount: // value for 'invoiceCount'
 *      filtered: // value for 'filtered'
 *   },
 * });
 */
export function useRecordInvoiceListExportMutation(baseOptions?: Apollo.MutationHookOptions<RecordInvoiceListExportMutation, RecordInvoiceListExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordInvoiceListExportMutation, RecordInvoiceListExportMutationVariables>(RecordInvoiceListExportDocument, options);
      }
export type RecordInvoiceListExportMutationHookResult = ReturnType<typeof useRecordInvoiceListExportMutation>;
export type RecordInvoiceListExportMutationResult = Apollo.MutationResult<RecordInvoiceListExportMutation>;
export type RecordInvoiceListExportMutationOptions = Apollo.BaseMutationOptions<RecordInvoiceListExportMutation, RecordInvoiceListExportMutationVariables>;
export const RefreshProgramInvoiceUrlsDocument = gql`
    mutation RefreshProgramInvoiceUrls($programInvoiceId: String!) {
  refreshProgramInvoiceUrls(programInvoiceId: $programInvoiceId) {
    id
    stripeInvoiceUrl
    stripeInvoicePdfUrl
    status
  }
}
    `;
export type RefreshProgramInvoiceUrlsMutationFn = Apollo.MutationFunction<RefreshProgramInvoiceUrlsMutation, RefreshProgramInvoiceUrlsMutationVariables>;

/**
 * __useRefreshProgramInvoiceUrlsMutation__
 *
 * To run a mutation, you first call `useRefreshProgramInvoiceUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshProgramInvoiceUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshProgramInvoiceUrlsMutation, { data, loading, error }] = useRefreshProgramInvoiceUrlsMutation({
 *   variables: {
 *      programInvoiceId: // value for 'programInvoiceId'
 *   },
 * });
 */
export function useRefreshProgramInvoiceUrlsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshProgramInvoiceUrlsMutation, RefreshProgramInvoiceUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshProgramInvoiceUrlsMutation, RefreshProgramInvoiceUrlsMutationVariables>(RefreshProgramInvoiceUrlsDocument, options);
      }
export type RefreshProgramInvoiceUrlsMutationHookResult = ReturnType<typeof useRefreshProgramInvoiceUrlsMutation>;
export type RefreshProgramInvoiceUrlsMutationResult = Apollo.MutationResult<RefreshProgramInvoiceUrlsMutation>;
export type RefreshProgramInvoiceUrlsMutationOptions = Apollo.BaseMutationOptions<RefreshProgramInvoiceUrlsMutation, RefreshProgramInvoiceUrlsMutationVariables>;
export const MarkInvoicePaidDocument = gql`
    mutation MarkInvoicePaid($input: MarkInvoicePaidInput!) {
  markInvoicePaid(input: $input) {
    id
    status
  }
}
    `;
export type MarkInvoicePaidMutationFn = Apollo.MutationFunction<MarkInvoicePaidMutation, MarkInvoicePaidMutationVariables>;

/**
 * __useMarkInvoicePaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoicePaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoicePaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoicePaidMutation, { data, loading, error }] = useMarkInvoicePaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkInvoicePaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoicePaidMutation, MarkInvoicePaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoicePaidMutation, MarkInvoicePaidMutationVariables>(MarkInvoicePaidDocument, options);
      }
export type MarkInvoicePaidMutationHookResult = ReturnType<typeof useMarkInvoicePaidMutation>;
export type MarkInvoicePaidMutationResult = Apollo.MutationResult<MarkInvoicePaidMutation>;
export type MarkInvoicePaidMutationOptions = Apollo.BaseMutationOptions<MarkInvoicePaidMutation, MarkInvoicePaidMutationVariables>;
export const ProviderLibraryActivitiesDocument = gql`
    query ProviderLibraryActivities($limit: Int, $offset: Int) {
  providerLibraryActivities(limit: $limit, offset: $offset) {
    id
    entityType
    entityId
    activityType
    actorType
    performedByProviderUser {
      id
      name
      profileImageMedia {
        url
      }
    }
    performedAt
    extraMetadata
  }
}
    `;

/**
 * __useProviderLibraryActivitiesQuery__
 *
 * To run a query within a React component, call `useProviderLibraryActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderLibraryActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderLibraryActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProviderLibraryActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderLibraryActivitiesQuery, ProviderLibraryActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderLibraryActivitiesQuery, ProviderLibraryActivitiesQueryVariables>(ProviderLibraryActivitiesDocument, options);
      }
export function useProviderLibraryActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderLibraryActivitiesQuery, ProviderLibraryActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderLibraryActivitiesQuery, ProviderLibraryActivitiesQueryVariables>(ProviderLibraryActivitiesDocument, options);
        }
export type ProviderLibraryActivitiesQueryHookResult = ReturnType<typeof useProviderLibraryActivitiesQuery>;
export type ProviderLibraryActivitiesLazyQueryHookResult = ReturnType<typeof useProviderLibraryActivitiesLazyQuery>;
export type ProviderLibraryActivitiesQueryResult = Apollo.QueryResult<ProviderLibraryActivitiesQuery, ProviderLibraryActivitiesQueryVariables>;
export const MailSequenceTemplatesDocument = gql`
    query MailSequenceTemplates {
  mailSequenceTemplates {
    ...mailSequenceTemplateData
  }
}
    ${MailSequenceTemplateDataFragmentDoc}`;

/**
 * __useMailSequenceTemplatesQuery__
 *
 * To run a query within a React component, call `useMailSequenceTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailSequenceTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailSequenceTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<MailSequenceTemplatesQuery, MailSequenceTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailSequenceTemplatesQuery, MailSequenceTemplatesQueryVariables>(MailSequenceTemplatesDocument, options);
      }
export function useMailSequenceTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailSequenceTemplatesQuery, MailSequenceTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailSequenceTemplatesQuery, MailSequenceTemplatesQueryVariables>(MailSequenceTemplatesDocument, options);
        }
export type MailSequenceTemplatesQueryHookResult = ReturnType<typeof useMailSequenceTemplatesQuery>;
export type MailSequenceTemplatesLazyQueryHookResult = ReturnType<typeof useMailSequenceTemplatesLazyQuery>;
export type MailSequenceTemplatesQueryResult = Apollo.QueryResult<MailSequenceTemplatesQuery, MailSequenceTemplatesQueryVariables>;
export const MailSequenceEnrollmentsForProgramDocument = gql`
    query MailSequenceEnrollmentsForProgram($programId: String!) {
  mailSequenceEnrollmentsForProgram(programId: $programId) {
    ...mailSequenceEnrollmentData
  }
}
    ${MailSequenceEnrollmentDataFragmentDoc}`;

/**
 * __useMailSequenceEnrollmentsForProgramQuery__
 *
 * To run a query within a React component, call `useMailSequenceEnrollmentsForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceEnrollmentsForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailSequenceEnrollmentsForProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useMailSequenceEnrollmentsForProgramQuery(baseOptions: Apollo.QueryHookOptions<MailSequenceEnrollmentsForProgramQuery, MailSequenceEnrollmentsForProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailSequenceEnrollmentsForProgramQuery, MailSequenceEnrollmentsForProgramQueryVariables>(MailSequenceEnrollmentsForProgramDocument, options);
      }
export function useMailSequenceEnrollmentsForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailSequenceEnrollmentsForProgramQuery, MailSequenceEnrollmentsForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailSequenceEnrollmentsForProgramQuery, MailSequenceEnrollmentsForProgramQueryVariables>(MailSequenceEnrollmentsForProgramDocument, options);
        }
export type MailSequenceEnrollmentsForProgramQueryHookResult = ReturnType<typeof useMailSequenceEnrollmentsForProgramQuery>;
export type MailSequenceEnrollmentsForProgramLazyQueryHookResult = ReturnType<typeof useMailSequenceEnrollmentsForProgramLazyQuery>;
export type MailSequenceEnrollmentsForProgramQueryResult = Apollo.QueryResult<MailSequenceEnrollmentsForProgramQuery, MailSequenceEnrollmentsForProgramQueryVariables>;
export const MailSequenceEnrollmentDocument = gql`
    query MailSequenceEnrollment($enrollmentId: String!) {
  mailSequenceEnrollment(enrollmentId: $enrollmentId) {
    ...mailSequenceEnrollmentData
  }
}
    ${MailSequenceEnrollmentDataFragmentDoc}`;

/**
 * __useMailSequenceEnrollmentQuery__
 *
 * To run a query within a React component, call `useMailSequenceEnrollmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceEnrollmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailSequenceEnrollmentQuery({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useMailSequenceEnrollmentQuery(baseOptions: Apollo.QueryHookOptions<MailSequenceEnrollmentQuery, MailSequenceEnrollmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailSequenceEnrollmentQuery, MailSequenceEnrollmentQueryVariables>(MailSequenceEnrollmentDocument, options);
      }
export function useMailSequenceEnrollmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailSequenceEnrollmentQuery, MailSequenceEnrollmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailSequenceEnrollmentQuery, MailSequenceEnrollmentQueryVariables>(MailSequenceEnrollmentDocument, options);
        }
export type MailSequenceEnrollmentQueryHookResult = ReturnType<typeof useMailSequenceEnrollmentQuery>;
export type MailSequenceEnrollmentLazyQueryHookResult = ReturnType<typeof useMailSequenceEnrollmentLazyQuery>;
export type MailSequenceEnrollmentQueryResult = Apollo.QueryResult<MailSequenceEnrollmentQuery, MailSequenceEnrollmentQueryVariables>;
export const MailSequenceEnrollDocument = gql`
    mutation MailSequenceEnroll($input: MailSequenceEnrollInput!) {
  mailSequenceEnroll(input: $input) {
    success
    error
    enrollments {
      ...mailSequenceEnrollmentData
    }
  }
}
    ${MailSequenceEnrollmentDataFragmentDoc}`;
export type MailSequenceEnrollMutationFn = Apollo.MutationFunction<MailSequenceEnrollMutation, MailSequenceEnrollMutationVariables>;

/**
 * __useMailSequenceEnrollMutation__
 *
 * To run a mutation, you first call `useMailSequenceEnrollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceEnrollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceEnrollMutation, { data, loading, error }] = useMailSequenceEnrollMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailSequenceEnrollMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceEnrollMutation, MailSequenceEnrollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceEnrollMutation, MailSequenceEnrollMutationVariables>(MailSequenceEnrollDocument, options);
      }
export type MailSequenceEnrollMutationHookResult = ReturnType<typeof useMailSequenceEnrollMutation>;
export type MailSequenceEnrollMutationResult = Apollo.MutationResult<MailSequenceEnrollMutation>;
export type MailSequenceEnrollMutationOptions = Apollo.BaseMutationOptions<MailSequenceEnrollMutation, MailSequenceEnrollMutationVariables>;
export const MailSequencePreviewDatesDocument = gql`
    mutation MailSequencePreviewDates($input: MailSequencePreviewDatesInput!) {
  mailSequencePreviewDates(input: $input) {
    success
    error
    previews {
      ...mailSequenceClientPreviewData
    }
  }
}
    ${MailSequenceClientPreviewDataFragmentDoc}`;
export type MailSequencePreviewDatesMutationFn = Apollo.MutationFunction<MailSequencePreviewDatesMutation, MailSequencePreviewDatesMutationVariables>;

/**
 * __useMailSequencePreviewDatesMutation__
 *
 * To run a mutation, you first call `useMailSequencePreviewDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequencePreviewDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequencePreviewDatesMutation, { data, loading, error }] = useMailSequencePreviewDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailSequencePreviewDatesMutation(baseOptions?: Apollo.MutationHookOptions<MailSequencePreviewDatesMutation, MailSequencePreviewDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequencePreviewDatesMutation, MailSequencePreviewDatesMutationVariables>(MailSequencePreviewDatesDocument, options);
      }
export type MailSequencePreviewDatesMutationHookResult = ReturnType<typeof useMailSequencePreviewDatesMutation>;
export type MailSequencePreviewDatesMutationResult = Apollo.MutationResult<MailSequencePreviewDatesMutation>;
export type MailSequencePreviewDatesMutationOptions = Apollo.BaseMutationOptions<MailSequencePreviewDatesMutation, MailSequencePreviewDatesMutationVariables>;
export const MailSequenceCancelEnrollmentDocument = gql`
    mutation MailSequenceCancelEnrollment($enrollmentId: String!) {
  mailSequenceCancelEnrollment(enrollmentId: $enrollmentId) {
    success
    error
    enrollment {
      ...mailSequenceEnrollmentData
    }
  }
}
    ${MailSequenceEnrollmentDataFragmentDoc}`;
export type MailSequenceCancelEnrollmentMutationFn = Apollo.MutationFunction<MailSequenceCancelEnrollmentMutation, MailSequenceCancelEnrollmentMutationVariables>;

/**
 * __useMailSequenceCancelEnrollmentMutation__
 *
 * To run a mutation, you first call `useMailSequenceCancelEnrollmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceCancelEnrollmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceCancelEnrollmentMutation, { data, loading, error }] = useMailSequenceCancelEnrollmentMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *   },
 * });
 */
export function useMailSequenceCancelEnrollmentMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceCancelEnrollmentMutation, MailSequenceCancelEnrollmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceCancelEnrollmentMutation, MailSequenceCancelEnrollmentMutationVariables>(MailSequenceCancelEnrollmentDocument, options);
      }
export type MailSequenceCancelEnrollmentMutationHookResult = ReturnType<typeof useMailSequenceCancelEnrollmentMutation>;
export type MailSequenceCancelEnrollmentMutationResult = Apollo.MutationResult<MailSequenceCancelEnrollmentMutation>;
export type MailSequenceCancelEnrollmentMutationOptions = Apollo.BaseMutationOptions<MailSequenceCancelEnrollmentMutation, MailSequenceCancelEnrollmentMutationVariables>;
export const MailSequenceUpdateEnrollmentNameDocument = gql`
    mutation MailSequenceUpdateEnrollmentName($enrollmentId: String!, $name: String) {
  mailSequenceUpdateEnrollmentName(enrollmentId: $enrollmentId, name: $name) {
    success
    error
    enrollment {
      ...mailSequenceEnrollmentData
    }
  }
}
    ${MailSequenceEnrollmentDataFragmentDoc}`;
export type MailSequenceUpdateEnrollmentNameMutationFn = Apollo.MutationFunction<MailSequenceUpdateEnrollmentNameMutation, MailSequenceUpdateEnrollmentNameMutationVariables>;

/**
 * __useMailSequenceUpdateEnrollmentNameMutation__
 *
 * To run a mutation, you first call `useMailSequenceUpdateEnrollmentNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceUpdateEnrollmentNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceUpdateEnrollmentNameMutation, { data, loading, error }] = useMailSequenceUpdateEnrollmentNameMutation({
 *   variables: {
 *      enrollmentId: // value for 'enrollmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useMailSequenceUpdateEnrollmentNameMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceUpdateEnrollmentNameMutation, MailSequenceUpdateEnrollmentNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceUpdateEnrollmentNameMutation, MailSequenceUpdateEnrollmentNameMutationVariables>(MailSequenceUpdateEnrollmentNameDocument, options);
      }
export type MailSequenceUpdateEnrollmentNameMutationHookResult = ReturnType<typeof useMailSequenceUpdateEnrollmentNameMutation>;
export type MailSequenceUpdateEnrollmentNameMutationResult = Apollo.MutationResult<MailSequenceUpdateEnrollmentNameMutation>;
export type MailSequenceUpdateEnrollmentNameMutationOptions = Apollo.BaseMutationOptions<MailSequenceUpdateEnrollmentNameMutation, MailSequenceUpdateEnrollmentNameMutationVariables>;
export const MailSequenceSkipScheduledSendDocument = gql`
    mutation MailSequenceSkipScheduledSend($scheduledSendId: String!) {
  mailSequenceSkipScheduledSend(scheduledSendId: $scheduledSendId) {
    success
    error
    scheduledSend {
      ...mailSequenceScheduledSendData
    }
  }
}
    ${MailSequenceScheduledSendDataFragmentDoc}`;
export type MailSequenceSkipScheduledSendMutationFn = Apollo.MutationFunction<MailSequenceSkipScheduledSendMutation, MailSequenceSkipScheduledSendMutationVariables>;

/**
 * __useMailSequenceSkipScheduledSendMutation__
 *
 * To run a mutation, you first call `useMailSequenceSkipScheduledSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceSkipScheduledSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceSkipScheduledSendMutation, { data, loading, error }] = useMailSequenceSkipScheduledSendMutation({
 *   variables: {
 *      scheduledSendId: // value for 'scheduledSendId'
 *   },
 * });
 */
export function useMailSequenceSkipScheduledSendMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceSkipScheduledSendMutation, MailSequenceSkipScheduledSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceSkipScheduledSendMutation, MailSequenceSkipScheduledSendMutationVariables>(MailSequenceSkipScheduledSendDocument, options);
      }
export type MailSequenceSkipScheduledSendMutationHookResult = ReturnType<typeof useMailSequenceSkipScheduledSendMutation>;
export type MailSequenceSkipScheduledSendMutationResult = Apollo.MutationResult<MailSequenceSkipScheduledSendMutation>;
export type MailSequenceSkipScheduledSendMutationOptions = Apollo.BaseMutationOptions<MailSequenceSkipScheduledSendMutation, MailSequenceSkipScheduledSendMutationVariables>;
export const MailSequenceUpdateScheduledSendDocument = gql`
    mutation MailSequenceUpdateScheduledSend($input: MailSequenceUpdateScheduledSendInput!) {
  mailSequenceUpdateScheduledSend(input: $input) {
    success
    error
    scheduledSend {
      ...mailSequenceScheduledSendData
    }
  }
}
    ${MailSequenceScheduledSendDataFragmentDoc}`;
export type MailSequenceUpdateScheduledSendMutationFn = Apollo.MutationFunction<MailSequenceUpdateScheduledSendMutation, MailSequenceUpdateScheduledSendMutationVariables>;

/**
 * __useMailSequenceUpdateScheduledSendMutation__
 *
 * To run a mutation, you first call `useMailSequenceUpdateScheduledSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceUpdateScheduledSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceUpdateScheduledSendMutation, { data, loading, error }] = useMailSequenceUpdateScheduledSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailSequenceUpdateScheduledSendMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceUpdateScheduledSendMutation, MailSequenceUpdateScheduledSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceUpdateScheduledSendMutation, MailSequenceUpdateScheduledSendMutationVariables>(MailSequenceUpdateScheduledSendDocument, options);
      }
export type MailSequenceUpdateScheduledSendMutationHookResult = ReturnType<typeof useMailSequenceUpdateScheduledSendMutation>;
export type MailSequenceUpdateScheduledSendMutationResult = Apollo.MutationResult<MailSequenceUpdateScheduledSendMutation>;
export type MailSequenceUpdateScheduledSendMutationOptions = Apollo.BaseMutationOptions<MailSequenceUpdateScheduledSendMutation, MailSequenceUpdateScheduledSendMutationVariables>;
export const MailSequenceSaveTemplateDocument = gql`
    mutation MailSequenceSaveTemplate($input: MailSequenceSaveTemplateInput!) {
  mailSequenceSaveTemplate(input: $input) {
    success
    error
    template {
      ...mailSequenceTemplateData
    }
  }
}
    ${MailSequenceTemplateDataFragmentDoc}`;
export type MailSequenceSaveTemplateMutationFn = Apollo.MutationFunction<MailSequenceSaveTemplateMutation, MailSequenceSaveTemplateMutationVariables>;

/**
 * __useMailSequenceSaveTemplateMutation__
 *
 * To run a mutation, you first call `useMailSequenceSaveTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceSaveTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceSaveTemplateMutation, { data, loading, error }] = useMailSequenceSaveTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMailSequenceSaveTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceSaveTemplateMutation, MailSequenceSaveTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceSaveTemplateMutation, MailSequenceSaveTemplateMutationVariables>(MailSequenceSaveTemplateDocument, options);
      }
export type MailSequenceSaveTemplateMutationHookResult = ReturnType<typeof useMailSequenceSaveTemplateMutation>;
export type MailSequenceSaveTemplateMutationResult = Apollo.MutationResult<MailSequenceSaveTemplateMutation>;
export type MailSequenceSaveTemplateMutationOptions = Apollo.BaseMutationOptions<MailSequenceSaveTemplateMutation, MailSequenceSaveTemplateMutationVariables>;
export const MailSequenceDeleteTemplateDocument = gql`
    mutation MailSequenceDeleteTemplate($templateId: String!) {
  mailSequenceDeleteTemplate(templateId: $templateId) {
    success
    error
  }
}
    `;
export type MailSequenceDeleteTemplateMutationFn = Apollo.MutationFunction<MailSequenceDeleteTemplateMutation, MailSequenceDeleteTemplateMutationVariables>;

/**
 * __useMailSequenceDeleteTemplateMutation__
 *
 * To run a mutation, you first call `useMailSequenceDeleteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailSequenceDeleteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailSequenceDeleteTemplateMutation, { data, loading, error }] = useMailSequenceDeleteTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useMailSequenceDeleteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<MailSequenceDeleteTemplateMutation, MailSequenceDeleteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailSequenceDeleteTemplateMutation, MailSequenceDeleteTemplateMutationVariables>(MailSequenceDeleteTemplateDocument, options);
      }
export type MailSequenceDeleteTemplateMutationHookResult = ReturnType<typeof useMailSequenceDeleteTemplateMutation>;
export type MailSequenceDeleteTemplateMutationResult = Apollo.MutationResult<MailSequenceDeleteTemplateMutation>;
export type MailSequenceDeleteTemplateMutationOptions = Apollo.BaseMutationOptions<MailSequenceDeleteTemplateMutation, MailSequenceDeleteTemplateMutationVariables>;
export const UpdateMediaContentDocument = gql`
    mutation UpdateMediaContent($mediaId: String!, $content: String!) {
  updateMediaContent(mediaId: $mediaId, content: $content)
}
    `;
export type UpdateMediaContentMutationFn = Apollo.MutationFunction<UpdateMediaContentMutation, UpdateMediaContentMutationVariables>;

/**
 * __useUpdateMediaContentMutation__
 *
 * To run a mutation, you first call `useUpdateMediaContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaContentMutation, { data, loading, error }] = useUpdateMediaContentMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      content: // value for 'content'
 *   },
 * });
 */
export function useUpdateMediaContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaContentMutation, UpdateMediaContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaContentMutation, UpdateMediaContentMutationVariables>(UpdateMediaContentDocument, options);
      }
export type UpdateMediaContentMutationHookResult = ReturnType<typeof useUpdateMediaContentMutation>;
export type UpdateMediaContentMutationResult = Apollo.MutationResult<UpdateMediaContentMutation>;
export type UpdateMediaContentMutationOptions = Apollo.BaseMutationOptions<UpdateMediaContentMutation, UpdateMediaContentMutationVariables>;
export const UpdateMediaFileDocument = gql`
    mutation UpdateMediaFile($mediaId: String!, $file: Upload!) {
  updateMediaFile(mediaId: $mediaId, file: $file)
}
    `;
export type UpdateMediaFileMutationFn = Apollo.MutationFunction<UpdateMediaFileMutation, UpdateMediaFileMutationVariables>;

/**
 * __useUpdateMediaFileMutation__
 *
 * To run a mutation, you first call `useUpdateMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMediaFileMutation, { data, loading, error }] = useUpdateMediaFileMutation({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateMediaFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMediaFileMutation, UpdateMediaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMediaFileMutation, UpdateMediaFileMutationVariables>(UpdateMediaFileDocument, options);
      }
export type UpdateMediaFileMutationHookResult = ReturnType<typeof useUpdateMediaFileMutation>;
export type UpdateMediaFileMutationResult = Apollo.MutationResult<UpdateMediaFileMutation>;
export type UpdateMediaFileMutationOptions = Apollo.BaseMutationOptions<UpdateMediaFileMutation, UpdateMediaFileMutationVariables>;
export const CreateMediaFileDocument = gql`
    mutation CreateMediaFile($input: CreateMediaFileInput!) {
  createMediaFile(input: $input) {
    id
    url
  }
}
    `;
export type CreateMediaFileMutationFn = Apollo.MutationFunction<CreateMediaFileMutation, CreateMediaFileMutationVariables>;

/**
 * __useCreateMediaFileMutation__
 *
 * To run a mutation, you first call `useCreateMediaFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMediaFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMediaFileMutation, { data, loading, error }] = useCreateMediaFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMediaFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateMediaFileMutation, CreateMediaFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMediaFileMutation, CreateMediaFileMutationVariables>(CreateMediaFileDocument, options);
      }
export type CreateMediaFileMutationHookResult = ReturnType<typeof useCreateMediaFileMutation>;
export type CreateMediaFileMutationResult = Apollo.MutationResult<CreateMediaFileMutation>;
export type CreateMediaFileMutationOptions = Apollo.BaseMutationOptions<CreateMediaFileMutation, CreateMediaFileMutationVariables>;
export const IsFilePdfEditableDocument = gql`
    mutation IsFilePdfEditable($file: Upload!) {
  isFilePdfEditable(file: $file)
}
    `;
export type IsFilePdfEditableMutationFn = Apollo.MutationFunction<IsFilePdfEditableMutation, IsFilePdfEditableMutationVariables>;

/**
 * __useIsFilePdfEditableMutation__
 *
 * To run a mutation, you first call `useIsFilePdfEditableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIsFilePdfEditableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [isFilePdfEditableMutation, { data, loading, error }] = useIsFilePdfEditableMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useIsFilePdfEditableMutation(baseOptions?: Apollo.MutationHookOptions<IsFilePdfEditableMutation, IsFilePdfEditableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IsFilePdfEditableMutation, IsFilePdfEditableMutationVariables>(IsFilePdfEditableDocument, options);
      }
export type IsFilePdfEditableMutationHookResult = ReturnType<typeof useIsFilePdfEditableMutation>;
export type IsFilePdfEditableMutationResult = Apollo.MutationResult<IsFilePdfEditableMutation>;
export type IsFilePdfEditableMutationOptions = Apollo.BaseMutationOptions<IsFilePdfEditableMutation, IsFilePdfEditableMutationVariables>;
export const ProgramNotesDocument = gql`
    query ProgramNotes($programId: String!) {
  programNotes(programId: $programId) {
    ...programNoteData
  }
}
    ${ProgramNoteDataFragmentDoc}`;

/**
 * __useProgramNotesQuery__
 *
 * To run a query within a React component, call `useProgramNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramNotesQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramNotesQuery(baseOptions: Apollo.QueryHookOptions<ProgramNotesQuery, ProgramNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramNotesQuery, ProgramNotesQueryVariables>(ProgramNotesDocument, options);
      }
export function useProgramNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramNotesQuery, ProgramNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramNotesQuery, ProgramNotesQueryVariables>(ProgramNotesDocument, options);
        }
export type ProgramNotesQueryHookResult = ReturnType<typeof useProgramNotesQuery>;
export type ProgramNotesLazyQueryHookResult = ReturnType<typeof useProgramNotesLazyQuery>;
export type ProgramNotesQueryResult = Apollo.QueryResult<ProgramNotesQuery, ProgramNotesQueryVariables>;
export const ProgramNoteDocument = gql`
    query ProgramNote($programNoteId: String!) {
  programNote(programNoteId: $programNoteId) {
    ...programNoteData
  }
}
    ${ProgramNoteDataFragmentDoc}`;

/**
 * __useProgramNoteQuery__
 *
 * To run a query within a React component, call `useProgramNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramNoteQuery({
 *   variables: {
 *      programNoteId: // value for 'programNoteId'
 *   },
 * });
 */
export function useProgramNoteQuery(baseOptions: Apollo.QueryHookOptions<ProgramNoteQuery, ProgramNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramNoteQuery, ProgramNoteQueryVariables>(ProgramNoteDocument, options);
      }
export function useProgramNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramNoteQuery, ProgramNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramNoteQuery, ProgramNoteQueryVariables>(ProgramNoteDocument, options);
        }
export type ProgramNoteQueryHookResult = ReturnType<typeof useProgramNoteQuery>;
export type ProgramNoteLazyQueryHookResult = ReturnType<typeof useProgramNoteLazyQuery>;
export type ProgramNoteQueryResult = Apollo.QueryResult<ProgramNoteQuery, ProgramNoteQueryVariables>;
export const CreateProgramNoteDocument = gql`
    mutation CreateProgramNote($input: CreateProgramNoteInput!) {
  createProgramNote(input: $input) {
    id
  }
}
    `;
export type CreateProgramNoteMutationFn = Apollo.MutationFunction<CreateProgramNoteMutation, CreateProgramNoteMutationVariables>;

/**
 * __useCreateProgramNoteMutation__
 *
 * To run a mutation, you first call `useCreateProgramNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramNoteMutation, { data, loading, error }] = useCreateProgramNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramNoteMutation, CreateProgramNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramNoteMutation, CreateProgramNoteMutationVariables>(CreateProgramNoteDocument, options);
      }
export type CreateProgramNoteMutationHookResult = ReturnType<typeof useCreateProgramNoteMutation>;
export type CreateProgramNoteMutationResult = Apollo.MutationResult<CreateProgramNoteMutation>;
export type CreateProgramNoteMutationOptions = Apollo.BaseMutationOptions<CreateProgramNoteMutation, CreateProgramNoteMutationVariables>;
export const UpdateProgramNoteDocument = gql`
    mutation UpdateProgramNote($input: UpdateProgramNoteInput!) {
  updateProgramNote(input: $input) {
    id
  }
}
    `;
export type UpdateProgramNoteMutationFn = Apollo.MutationFunction<UpdateProgramNoteMutation, UpdateProgramNoteMutationVariables>;

/**
 * __useUpdateProgramNoteMutation__
 *
 * To run a mutation, you first call `useUpdateProgramNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramNoteMutation, { data, loading, error }] = useUpdateProgramNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramNoteMutation, UpdateProgramNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramNoteMutation, UpdateProgramNoteMutationVariables>(UpdateProgramNoteDocument, options);
      }
export type UpdateProgramNoteMutationHookResult = ReturnType<typeof useUpdateProgramNoteMutation>;
export type UpdateProgramNoteMutationResult = Apollo.MutationResult<UpdateProgramNoteMutation>;
export type UpdateProgramNoteMutationOptions = Apollo.BaseMutationOptions<UpdateProgramNoteMutation, UpdateProgramNoteMutationVariables>;
export const DeleteProgramNoteDocument = gql`
    mutation DeleteProgramNote($programNoteId: String!) {
  deleteProgramNote(programNoteId: $programNoteId)
}
    `;
export type DeleteProgramNoteMutationFn = Apollo.MutationFunction<DeleteProgramNoteMutation, DeleteProgramNoteMutationVariables>;

/**
 * __useDeleteProgramNoteMutation__
 *
 * To run a mutation, you first call `useDeleteProgramNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramNoteMutation, { data, loading, error }] = useDeleteProgramNoteMutation({
 *   variables: {
 *      programNoteId: // value for 'programNoteId'
 *   },
 * });
 */
export function useDeleteProgramNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramNoteMutation, DeleteProgramNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramNoteMutation, DeleteProgramNoteMutationVariables>(DeleteProgramNoteDocument, options);
      }
export type DeleteProgramNoteMutationHookResult = ReturnType<typeof useDeleteProgramNoteMutation>;
export type DeleteProgramNoteMutationResult = Apollo.MutationResult<DeleteProgramNoteMutation>;
export type DeleteProgramNoteMutationOptions = Apollo.BaseMutationOptions<DeleteProgramNoteMutation, DeleteProgramNoteMutationVariables>;
export const RecordProgramNotePdfDownloadDocument = gql`
    mutation RecordProgramNotePdfDownload($programNoteId: String!) {
  recordProgramNotePdfDownload(programNoteId: $programNoteId)
}
    `;
export type RecordProgramNotePdfDownloadMutationFn = Apollo.MutationFunction<RecordProgramNotePdfDownloadMutation, RecordProgramNotePdfDownloadMutationVariables>;

/**
 * __useRecordProgramNotePdfDownloadMutation__
 *
 * To run a mutation, you first call `useRecordProgramNotePdfDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProgramNotePdfDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProgramNotePdfDownloadMutation, { data, loading, error }] = useRecordProgramNotePdfDownloadMutation({
 *   variables: {
 *      programNoteId: // value for 'programNoteId'
 *   },
 * });
 */
export function useRecordProgramNotePdfDownloadMutation(baseOptions?: Apollo.MutationHookOptions<RecordProgramNotePdfDownloadMutation, RecordProgramNotePdfDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProgramNotePdfDownloadMutation, RecordProgramNotePdfDownloadMutationVariables>(RecordProgramNotePdfDownloadDocument, options);
      }
export type RecordProgramNotePdfDownloadMutationHookResult = ReturnType<typeof useRecordProgramNotePdfDownloadMutation>;
export type RecordProgramNotePdfDownloadMutationResult = Apollo.MutationResult<RecordProgramNotePdfDownloadMutation>;
export type RecordProgramNotePdfDownloadMutationOptions = Apollo.BaseMutationOptions<RecordProgramNotePdfDownloadMutation, RecordProgramNotePdfDownloadMutationVariables>;
export const NotifyProgramNoteDocument = gql`
    mutation NotifyProgramNote($input: NotifyProgramNoteInput!) {
  notifyProgramNote(input: $input) {
    success
    notifiedProviderUsers {
      ...basicProviderUserData
    }
  }
}
    ${BasicProviderUserDataFragmentDoc}`;
export type NotifyProgramNoteMutationFn = Apollo.MutationFunction<NotifyProgramNoteMutation, NotifyProgramNoteMutationVariables>;

/**
 * __useNotifyProgramNoteMutation__
 *
 * To run a mutation, you first call `useNotifyProgramNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyProgramNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyProgramNoteMutation, { data, loading, error }] = useNotifyProgramNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNotifyProgramNoteMutation(baseOptions?: Apollo.MutationHookOptions<NotifyProgramNoteMutation, NotifyProgramNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotifyProgramNoteMutation, NotifyProgramNoteMutationVariables>(NotifyProgramNoteDocument, options);
      }
export type NotifyProgramNoteMutationHookResult = ReturnType<typeof useNotifyProgramNoteMutation>;
export type NotifyProgramNoteMutationResult = Apollo.MutationResult<NotifyProgramNoteMutation>;
export type NotifyProgramNoteMutationOptions = Apollo.BaseMutationOptions<NotifyProgramNoteMutation, NotifyProgramNoteMutationVariables>;
export const CreateProgramNoteShareDocument = gql`
    mutation CreateProgramNoteShare($input: CreateProgramNoteShareInput!) {
  createProgramNoteShare(input: $input) {
    shareId
    url
    expiresAt
    recipientEmail
    recipientName
  }
}
    `;
export type CreateProgramNoteShareMutationFn = Apollo.MutationFunction<CreateProgramNoteShareMutation, CreateProgramNoteShareMutationVariables>;

/**
 * __useCreateProgramNoteShareMutation__
 *
 * To run a mutation, you first call `useCreateProgramNoteShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramNoteShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramNoteShareMutation, { data, loading, error }] = useCreateProgramNoteShareMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramNoteShareMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramNoteShareMutation, CreateProgramNoteShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramNoteShareMutation, CreateProgramNoteShareMutationVariables>(CreateProgramNoteShareDocument, options);
      }
export type CreateProgramNoteShareMutationHookResult = ReturnType<typeof useCreateProgramNoteShareMutation>;
export type CreateProgramNoteShareMutationResult = Apollo.MutationResult<CreateProgramNoteShareMutation>;
export type CreateProgramNoteShareMutationOptions = Apollo.BaseMutationOptions<CreateProgramNoteShareMutation, CreateProgramNoteShareMutationVariables>;
export const RevokeProgramNoteShareDocument = gql`
    mutation RevokeProgramNoteShare($shareId: String!) {
  revokeProgramNoteShare(shareId: $shareId)
}
    `;
export type RevokeProgramNoteShareMutationFn = Apollo.MutationFunction<RevokeProgramNoteShareMutation, RevokeProgramNoteShareMutationVariables>;

/**
 * __useRevokeProgramNoteShareMutation__
 *
 * To run a mutation, you first call `useRevokeProgramNoteShareMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeProgramNoteShareMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeProgramNoteShareMutation, { data, loading, error }] = useRevokeProgramNoteShareMutation({
 *   variables: {
 *      shareId: // value for 'shareId'
 *   },
 * });
 */
export function useRevokeProgramNoteShareMutation(baseOptions?: Apollo.MutationHookOptions<RevokeProgramNoteShareMutation, RevokeProgramNoteShareMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeProgramNoteShareMutation, RevokeProgramNoteShareMutationVariables>(RevokeProgramNoteShareDocument, options);
      }
export type RevokeProgramNoteShareMutationHookResult = ReturnType<typeof useRevokeProgramNoteShareMutation>;
export type RevokeProgramNoteShareMutationResult = Apollo.MutationResult<RevokeProgramNoteShareMutation>;
export type RevokeProgramNoteShareMutationOptions = Apollo.BaseMutationOptions<RevokeProgramNoteShareMutation, RevokeProgramNoteShareMutationVariables>;
export const ProgramNoteSharesDocument = gql`
    query ProgramNoteShares($programNoteId: String!) {
  programNoteShares(programNoteId: $programNoteId) {
    id
    status
    noteTitle
    recipientName
    recipientEmail
    recipientContactType
    sentAt
    expiresAt
    firstViewedAt
    downloadCount
    url
    revokedAt
  }
}
    `;

/**
 * __useProgramNoteSharesQuery__
 *
 * To run a query within a React component, call `useProgramNoteSharesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramNoteSharesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramNoteSharesQuery({
 *   variables: {
 *      programNoteId: // value for 'programNoteId'
 *   },
 * });
 */
export function useProgramNoteSharesQuery(baseOptions: Apollo.QueryHookOptions<ProgramNoteSharesQuery, ProgramNoteSharesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramNoteSharesQuery, ProgramNoteSharesQueryVariables>(ProgramNoteSharesDocument, options);
      }
export function useProgramNoteSharesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramNoteSharesQuery, ProgramNoteSharesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramNoteSharesQuery, ProgramNoteSharesQueryVariables>(ProgramNoteSharesDocument, options);
        }
export type ProgramNoteSharesQueryHookResult = ReturnType<typeof useProgramNoteSharesQuery>;
export type ProgramNoteSharesLazyQueryHookResult = ReturnType<typeof useProgramNoteSharesLazyQuery>;
export type ProgramNoteSharesQueryResult = Apollo.QueryResult<ProgramNoteSharesQuery, ProgramNoteSharesQueryVariables>;
export const ProgramNoteSharesForContactDocument = gql`
    query ProgramNoteSharesForContact($contactId: String!) {
  programNoteSharesForContact(contactId: $contactId) {
    id
    status
    noteTitle
    recipientName
    recipientEmail
    recipientContactType
    sentAt
    expiresAt
    firstViewedAt
    downloadCount
    url
    revokedAt
  }
}
    `;

/**
 * __useProgramNoteSharesForContactQuery__
 *
 * To run a query within a React component, call `useProgramNoteSharesForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramNoteSharesForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramNoteSharesForContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useProgramNoteSharesForContactQuery(baseOptions: Apollo.QueryHookOptions<ProgramNoteSharesForContactQuery, ProgramNoteSharesForContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramNoteSharesForContactQuery, ProgramNoteSharesForContactQueryVariables>(ProgramNoteSharesForContactDocument, options);
      }
export function useProgramNoteSharesForContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramNoteSharesForContactQuery, ProgramNoteSharesForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramNoteSharesForContactQuery, ProgramNoteSharesForContactQueryVariables>(ProgramNoteSharesForContactDocument, options);
        }
export type ProgramNoteSharesForContactQueryHookResult = ReturnType<typeof useProgramNoteSharesForContactQuery>;
export type ProgramNoteSharesForContactLazyQueryHookResult = ReturnType<typeof useProgramNoteSharesForContactLazyQuery>;
export type ProgramNoteSharesForContactQueryResult = Apollo.QueryResult<ProgramNoteSharesForContactQuery, ProgramNoteSharesForContactQueryVariables>;
export const ProviderNoteTemplatesDocument = gql`
    query ProviderNoteTemplates {
  providerNoteTemplates {
    ...basicProviderNoteTemplateData
  }
}
    ${BasicProviderNoteTemplateDataFragmentDoc}`;

/**
 * __useProviderNoteTemplatesQuery__
 *
 * To run a query within a React component, call `useProviderNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderNoteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderNoteTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderNoteTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderNoteTemplatesQuery, ProviderNoteTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderNoteTemplatesQuery, ProviderNoteTemplatesQueryVariables>(ProviderNoteTemplatesDocument, options);
      }
export function useProviderNoteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderNoteTemplatesQuery, ProviderNoteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderNoteTemplatesQuery, ProviderNoteTemplatesQueryVariables>(ProviderNoteTemplatesDocument, options);
        }
export type ProviderNoteTemplatesQueryHookResult = ReturnType<typeof useProviderNoteTemplatesQuery>;
export type ProviderNoteTemplatesLazyQueryHookResult = ReturnType<typeof useProviderNoteTemplatesLazyQuery>;
export type ProviderNoteTemplatesQueryResult = Apollo.QueryResult<ProviderNoteTemplatesQuery, ProviderNoteTemplatesQueryVariables>;
export const ProviderNoteTemplateDocument = gql`
    query ProviderNoteTemplate($providerNoteTemplateId: String!) {
  providerNoteTemplate(providerNoteTemplateId: $providerNoteTemplateId) {
    ...providerNoteTemplateData
  }
}
    ${ProviderNoteTemplateDataFragmentDoc}`;

/**
 * __useProviderNoteTemplateQuery__
 *
 * To run a query within a React component, call `useProviderNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderNoteTemplateQuery({
 *   variables: {
 *      providerNoteTemplateId: // value for 'providerNoteTemplateId'
 *   },
 * });
 */
export function useProviderNoteTemplateQuery(baseOptions: Apollo.QueryHookOptions<ProviderNoteTemplateQuery, ProviderNoteTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderNoteTemplateQuery, ProviderNoteTemplateQueryVariables>(ProviderNoteTemplateDocument, options);
      }
export function useProviderNoteTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderNoteTemplateQuery, ProviderNoteTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderNoteTemplateQuery, ProviderNoteTemplateQueryVariables>(ProviderNoteTemplateDocument, options);
        }
export type ProviderNoteTemplateQueryHookResult = ReturnType<typeof useProviderNoteTemplateQuery>;
export type ProviderNoteTemplateLazyQueryHookResult = ReturnType<typeof useProviderNoteTemplateLazyQuery>;
export type ProviderNoteTemplateQueryResult = Apollo.QueryResult<ProviderNoteTemplateQuery, ProviderNoteTemplateQueryVariables>;
export const CreateProviderNoteTemplateDocument = gql`
    mutation CreateProviderNoteTemplate($input: CreateProviderNoteTemplateInput!) {
  createProviderNoteTemplate(input: $input) {
    id
    title
    note
  }
}
    `;
export type CreateProviderNoteTemplateMutationFn = Apollo.MutationFunction<CreateProviderNoteTemplateMutation, CreateProviderNoteTemplateMutationVariables>;

/**
 * __useCreateProviderNoteTemplateMutation__
 *
 * To run a mutation, you first call `useCreateProviderNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderNoteTemplateMutation, { data, loading, error }] = useCreateProviderNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderNoteTemplateMutation, CreateProviderNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderNoteTemplateMutation, CreateProviderNoteTemplateMutationVariables>(CreateProviderNoteTemplateDocument, options);
      }
export type CreateProviderNoteTemplateMutationHookResult = ReturnType<typeof useCreateProviderNoteTemplateMutation>;
export type CreateProviderNoteTemplateMutationResult = Apollo.MutationResult<CreateProviderNoteTemplateMutation>;
export type CreateProviderNoteTemplateMutationOptions = Apollo.BaseMutationOptions<CreateProviderNoteTemplateMutation, CreateProviderNoteTemplateMutationVariables>;
export const UpdateProviderNoteTemplateDocument = gql`
    mutation UpdateProviderNoteTemplate($input: UpdateProviderNoteTemplateInput!) {
  updateProviderNoteTemplate(input: $input) {
    id
    title
    note
  }
}
    `;
export type UpdateProviderNoteTemplateMutationFn = Apollo.MutationFunction<UpdateProviderNoteTemplateMutation, UpdateProviderNoteTemplateMutationVariables>;

/**
 * __useUpdateProviderNoteTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateProviderNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderNoteTemplateMutation, { data, loading, error }] = useUpdateProviderNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderNoteTemplateMutation, UpdateProviderNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderNoteTemplateMutation, UpdateProviderNoteTemplateMutationVariables>(UpdateProviderNoteTemplateDocument, options);
      }
export type UpdateProviderNoteTemplateMutationHookResult = ReturnType<typeof useUpdateProviderNoteTemplateMutation>;
export type UpdateProviderNoteTemplateMutationResult = Apollo.MutationResult<UpdateProviderNoteTemplateMutation>;
export type UpdateProviderNoteTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateProviderNoteTemplateMutation, UpdateProviderNoteTemplateMutationVariables>;
export const RemoveProviderNoteTemplateDocument = gql`
    mutation RemoveProviderNoteTemplate($providerNoteTemplateId: String!) {
  removeProviderNoteTemplate(providerNoteTemplateId: $providerNoteTemplateId)
}
    `;
export type RemoveProviderNoteTemplateMutationFn = Apollo.MutationFunction<RemoveProviderNoteTemplateMutation, RemoveProviderNoteTemplateMutationVariables>;

/**
 * __useRemoveProviderNoteTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveProviderNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProviderNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProviderNoteTemplateMutation, { data, loading, error }] = useRemoveProviderNoteTemplateMutation({
 *   variables: {
 *      providerNoteTemplateId: // value for 'providerNoteTemplateId'
 *   },
 * });
 */
export function useRemoveProviderNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProviderNoteTemplateMutation, RemoveProviderNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProviderNoteTemplateMutation, RemoveProviderNoteTemplateMutationVariables>(RemoveProviderNoteTemplateDocument, options);
      }
export type RemoveProviderNoteTemplateMutationHookResult = ReturnType<typeof useRemoveProviderNoteTemplateMutation>;
export type RemoveProviderNoteTemplateMutationResult = Apollo.MutationResult<RemoveProviderNoteTemplateMutation>;
export type RemoveProviderNoteTemplateMutationOptions = Apollo.BaseMutationOptions<RemoveProviderNoteTemplateMutation, RemoveProviderNoteTemplateMutationVariables>;
export const MarkProviderUserNotificationReadDocument = gql`
    mutation MarkProviderUserNotificationRead($providerUserNotificationId: String!, $archivedNotification: Boolean!) {
  markProviderUserNotificationRead(
    providerUserNotificationId: $providerUserNotificationId
    archivedNotification: $archivedNotification
  )
}
    `;
export type MarkProviderUserNotificationReadMutationFn = Apollo.MutationFunction<MarkProviderUserNotificationReadMutation, MarkProviderUserNotificationReadMutationVariables>;

/**
 * __useMarkProviderUserNotificationReadMutation__
 *
 * To run a mutation, you first call `useMarkProviderUserNotificationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProviderUserNotificationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProviderUserNotificationReadMutation, { data, loading, error }] = useMarkProviderUserNotificationReadMutation({
 *   variables: {
 *      providerUserNotificationId: // value for 'providerUserNotificationId'
 *      archivedNotification: // value for 'archivedNotification'
 *   },
 * });
 */
export function useMarkProviderUserNotificationReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkProviderUserNotificationReadMutation, MarkProviderUserNotificationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProviderUserNotificationReadMutation, MarkProviderUserNotificationReadMutationVariables>(MarkProviderUserNotificationReadDocument, options);
      }
export type MarkProviderUserNotificationReadMutationHookResult = ReturnType<typeof useMarkProviderUserNotificationReadMutation>;
export type MarkProviderUserNotificationReadMutationResult = Apollo.MutationResult<MarkProviderUserNotificationReadMutation>;
export type MarkProviderUserNotificationReadMutationOptions = Apollo.BaseMutationOptions<MarkProviderUserNotificationReadMutation, MarkProviderUserNotificationReadMutationVariables>;
export const MarkAllProviderUserNotificationsReadDocument = gql`
    mutation MarkAllProviderUserNotificationsRead {
  markAllProviderUserNotificationsRead
}
    `;
export type MarkAllProviderUserNotificationsReadMutationFn = Apollo.MutationFunction<MarkAllProviderUserNotificationsReadMutation, MarkAllProviderUserNotificationsReadMutationVariables>;

/**
 * __useMarkAllProviderUserNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkAllProviderUserNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAllProviderUserNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAllProviderUserNotificationsReadMutation, { data, loading, error }] = useMarkAllProviderUserNotificationsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkAllProviderUserNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkAllProviderUserNotificationsReadMutation, MarkAllProviderUserNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAllProviderUserNotificationsReadMutation, MarkAllProviderUserNotificationsReadMutationVariables>(MarkAllProviderUserNotificationsReadDocument, options);
      }
export type MarkAllProviderUserNotificationsReadMutationHookResult = ReturnType<typeof useMarkAllProviderUserNotificationsReadMutation>;
export type MarkAllProviderUserNotificationsReadMutationResult = Apollo.MutationResult<MarkAllProviderUserNotificationsReadMutation>;
export type MarkAllProviderUserNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkAllProviderUserNotificationsReadMutation, MarkAllProviderUserNotificationsReadMutationVariables>;
export const UpdateProviderUserNotificationControlsDocument = gql`
    mutation UpdateProviderUserNotificationControls($input: UpdateProviderUserNotificationControlsInput!) {
  updateProviderUserNotificationControls(input: $input) {
    patientActivationEmailOption
    patientActivityCompletionEmailOption
    patientAssessmentCompletionEmailOption
    patientCommentEmailOption
    careTeamNotificationsEnabled
    allClientsFormCompletionEnabled
  }
}
    `;
export type UpdateProviderUserNotificationControlsMutationFn = Apollo.MutationFunction<UpdateProviderUserNotificationControlsMutation, UpdateProviderUserNotificationControlsMutationVariables>;

/**
 * __useUpdateProviderUserNotificationControlsMutation__
 *
 * To run a mutation, you first call `useUpdateProviderUserNotificationControlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderUserNotificationControlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderUserNotificationControlsMutation, { data, loading, error }] = useUpdateProviderUserNotificationControlsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderUserNotificationControlsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderUserNotificationControlsMutation, UpdateProviderUserNotificationControlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderUserNotificationControlsMutation, UpdateProviderUserNotificationControlsMutationVariables>(UpdateProviderUserNotificationControlsDocument, options);
      }
export type UpdateProviderUserNotificationControlsMutationHookResult = ReturnType<typeof useUpdateProviderUserNotificationControlsMutation>;
export type UpdateProviderUserNotificationControlsMutationResult = Apollo.MutationResult<UpdateProviderUserNotificationControlsMutation>;
export type UpdateProviderUserNotificationControlsMutationOptions = Apollo.BaseMutationOptions<UpdateProviderUserNotificationControlsMutation, UpdateProviderUserNotificationControlsMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    ...patientData
  }
}
    ${PatientDataFragmentDoc}`;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const PatientUpdateProfileDocument = gql`
    mutation PatientUpdateProfile($input: PatientUpdateProfileInput!) {
  patientUpdateProfile(input: $input) {
    id
    name
    firstName
    lastName
    phoneNumber
    dateOfBirth
    age
    addressStreet
    addressCity
    addressState
    addressPostalCode
    addressCountry
    preferredLanguage
    timezone
  }
}
    `;
export type PatientUpdateProfileMutationFn = Apollo.MutationFunction<PatientUpdateProfileMutation, PatientUpdateProfileMutationVariables>;

/**
 * __usePatientUpdateProfileMutation__
 *
 * To run a mutation, you first call `usePatientUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientUpdateProfileMutation, { data, loading, error }] = usePatientUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientUpdateProfileMutation(baseOptions?: Apollo.MutationHookOptions<PatientUpdateProfileMutation, PatientUpdateProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientUpdateProfileMutation, PatientUpdateProfileMutationVariables>(PatientUpdateProfileDocument, options);
      }
export type PatientUpdateProfileMutationHookResult = ReturnType<typeof usePatientUpdateProfileMutation>;
export type PatientUpdateProfileMutationResult = Apollo.MutationResult<PatientUpdateProfileMutation>;
export type PatientUpdateProfileMutationOptions = Apollo.BaseMutationOptions<PatientUpdateProfileMutation, PatientUpdateProfileMutationVariables>;
export const ProviderUpdatePatientProfileDocument = gql`
    mutation ProviderUpdatePatientProfile($input: ProviderUpdatePatientProfileInput!) {
  providerUpdatePatientProfile(input: $input) {
    id
    programInstanceId
    name
    firstName
    lastName
    phoneNumber
    email
    participantId
    dateOfBirth
    age
    addressStreet
    addressCity
    addressState
    addressPostalCode
    addressCountry
    preferredLanguage
    timezone
    programStartDate
    programEndDate
    referralSource
  }
}
    `;
export type ProviderUpdatePatientProfileMutationFn = Apollo.MutationFunction<ProviderUpdatePatientProfileMutation, ProviderUpdatePatientProfileMutationVariables>;

/**
 * __useProviderUpdatePatientProfileMutation__
 *
 * To run a mutation, you first call `useProviderUpdatePatientProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUpdatePatientProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUpdatePatientProfileMutation, { data, loading, error }] = useProviderUpdatePatientProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderUpdatePatientProfileMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUpdatePatientProfileMutation, ProviderUpdatePatientProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUpdatePatientProfileMutation, ProviderUpdatePatientProfileMutationVariables>(ProviderUpdatePatientProfileDocument, options);
      }
export type ProviderUpdatePatientProfileMutationHookResult = ReturnType<typeof useProviderUpdatePatientProfileMutation>;
export type ProviderUpdatePatientProfileMutationResult = Apollo.MutationResult<ProviderUpdatePatientProfileMutation>;
export type ProviderUpdatePatientProfileMutationOptions = Apollo.BaseMutationOptions<ProviderUpdatePatientProfileMutation, ProviderUpdatePatientProfileMutationVariables>;
export const ProviderUpdatePatientEmailDocument = gql`
    mutation ProviderUpdatePatientEmail($input: ProviderUpdatePatientEmailInput!) {
  providerUpdatePatientEmail(input: $input) {
    id
    email
  }
}
    `;
export type ProviderUpdatePatientEmailMutationFn = Apollo.MutationFunction<ProviderUpdatePatientEmailMutation, ProviderUpdatePatientEmailMutationVariables>;

/**
 * __useProviderUpdatePatientEmailMutation__
 *
 * To run a mutation, you first call `useProviderUpdatePatientEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUpdatePatientEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUpdatePatientEmailMutation, { data, loading, error }] = useProviderUpdatePatientEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderUpdatePatientEmailMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUpdatePatientEmailMutation, ProviderUpdatePatientEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUpdatePatientEmailMutation, ProviderUpdatePatientEmailMutationVariables>(ProviderUpdatePatientEmailDocument, options);
      }
export type ProviderUpdatePatientEmailMutationHookResult = ReturnType<typeof useProviderUpdatePatientEmailMutation>;
export type ProviderUpdatePatientEmailMutationResult = Apollo.MutationResult<ProviderUpdatePatientEmailMutation>;
export type ProviderUpdatePatientEmailMutationOptions = Apollo.BaseMutationOptions<ProviderUpdatePatientEmailMutation, ProviderUpdatePatientEmailMutationVariables>;
export const PublicServiceSignUpDocument = gql`
    mutation PublicServiceSignUp($input: PublicServiceSignUpInput!) {
  publicServiceSignUp(input: $input) {
    authToken
    serviceIntakePackageId
    error
  }
}
    `;
export type PublicServiceSignUpMutationFn = Apollo.MutationFunction<PublicServiceSignUpMutation, PublicServiceSignUpMutationVariables>;

/**
 * __usePublicServiceSignUpMutation__
 *
 * To run a mutation, you first call `usePublicServiceSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublicServiceSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publicServiceSignUpMutation, { data, loading, error }] = usePublicServiceSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublicServiceSignUpMutation(baseOptions?: Apollo.MutationHookOptions<PublicServiceSignUpMutation, PublicServiceSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublicServiceSignUpMutation, PublicServiceSignUpMutationVariables>(PublicServiceSignUpDocument, options);
      }
export type PublicServiceSignUpMutationHookResult = ReturnType<typeof usePublicServiceSignUpMutation>;
export type PublicServiceSignUpMutationResult = Apollo.MutationResult<PublicServiceSignUpMutation>;
export type PublicServiceSignUpMutationOptions = Apollo.BaseMutationOptions<PublicServiceSignUpMutation, PublicServiceSignUpMutationVariables>;
export const SignUpDeepLinkDocument = gql`
    query SignUpDeepLink {
  signUpDeepLink
}
    `;

/**
 * __useSignUpDeepLinkQuery__
 *
 * To run a query within a React component, call `useSignUpDeepLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpDeepLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpDeepLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignUpDeepLinkQuery(baseOptions?: Apollo.QueryHookOptions<SignUpDeepLinkQuery, SignUpDeepLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignUpDeepLinkQuery, SignUpDeepLinkQueryVariables>(SignUpDeepLinkDocument, options);
      }
export function useSignUpDeepLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignUpDeepLinkQuery, SignUpDeepLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignUpDeepLinkQuery, SignUpDeepLinkQueryVariables>(SignUpDeepLinkDocument, options);
        }
export type SignUpDeepLinkQueryHookResult = ReturnType<typeof useSignUpDeepLinkQuery>;
export type SignUpDeepLinkLazyQueryHookResult = ReturnType<typeof useSignUpDeepLinkLazyQuery>;
export type SignUpDeepLinkQueryResult = Apollo.QueryResult<SignUpDeepLinkQuery, SignUpDeepLinkQueryVariables>;
export const MePatientDocument = gql`
    query MePatient {
  mePatient {
    ...mePatientData
  }
}
    ${MePatientDataFragmentDoc}`;

/**
 * __useMePatientQuery__
 *
 * To run a query within a React component, call `useMePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePatientQuery({
 *   variables: {
 *   },
 * });
 */
export function useMePatientQuery(baseOptions?: Apollo.QueryHookOptions<MePatientQuery, MePatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePatientQuery, MePatientQueryVariables>(MePatientDocument, options);
      }
export function useMePatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePatientQuery, MePatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePatientQuery, MePatientQueryVariables>(MePatientDocument, options);
        }
export type MePatientQueryHookResult = ReturnType<typeof useMePatientQuery>;
export type MePatientLazyQueryHookResult = ReturnType<typeof useMePatientLazyQuery>;
export type MePatientQueryResult = Apollo.QueryResult<MePatientQuery, MePatientQueryVariables>;
export const ReactivatePatientsDocument = gql`
    mutation ReactivatePatients($input: ReactivatePatientsInput!) {
  reactivatePatients(input: $input) {
    reactivatedPatients {
      ...patientData
    }
  }
}
    ${PatientDataFragmentDoc}`;
export type ReactivatePatientsMutationFn = Apollo.MutationFunction<ReactivatePatientsMutation, ReactivatePatientsMutationVariables>;

/**
 * __useReactivatePatientsMutation__
 *
 * To run a mutation, you first call `useReactivatePatientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivatePatientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivatePatientsMutation, { data, loading, error }] = useReactivatePatientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReactivatePatientsMutation(baseOptions?: Apollo.MutationHookOptions<ReactivatePatientsMutation, ReactivatePatientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivatePatientsMutation, ReactivatePatientsMutationVariables>(ReactivatePatientsDocument, options);
      }
export type ReactivatePatientsMutationHookResult = ReturnType<typeof useReactivatePatientsMutation>;
export type ReactivatePatientsMutationResult = Apollo.MutationResult<ReactivatePatientsMutation>;
export type ReactivatePatientsMutationOptions = Apollo.BaseMutationOptions<ReactivatePatientsMutation, ReactivatePatientsMutationVariables>;
export const UploadPatientProfileImageDocument = gql`
    mutation UploadPatientProfileImage($file: Upload!) {
  uploadPatientProfileImage(file: $file) {
    id
    url
  }
}
    `;
export type UploadPatientProfileImageMutationFn = Apollo.MutationFunction<UploadPatientProfileImageMutation, UploadPatientProfileImageMutationVariables>;

/**
 * __useUploadPatientProfileImageMutation__
 *
 * To run a mutation, you first call `useUploadPatientProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPatientProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPatientProfileImageMutation, { data, loading, error }] = useUploadPatientProfileImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadPatientProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadPatientProfileImageMutation, UploadPatientProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPatientProfileImageMutation, UploadPatientProfileImageMutationVariables>(UploadPatientProfileImageDocument, options);
      }
export type UploadPatientProfileImageMutationHookResult = ReturnType<typeof useUploadPatientProfileImageMutation>;
export type UploadPatientProfileImageMutationResult = Apollo.MutationResult<UploadPatientProfileImageMutation>;
export type UploadPatientProfileImageMutationOptions = Apollo.BaseMutationOptions<UploadPatientProfileImageMutation, UploadPatientProfileImageMutationVariables>;
export const ProviderCreatePatientContactDocument = gql`
    mutation ProviderCreatePatientContact($input: ProviderCreatePatientContactInput!) {
  providerCreatePatientContact(input: $input) {
    ...patientContactData
  }
}
    ${PatientContactDataFragmentDoc}`;
export type ProviderCreatePatientContactMutationFn = Apollo.MutationFunction<ProviderCreatePatientContactMutation, ProviderCreatePatientContactMutationVariables>;

/**
 * __useProviderCreatePatientContactMutation__
 *
 * To run a mutation, you first call `useProviderCreatePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderCreatePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerCreatePatientContactMutation, { data, loading, error }] = useProviderCreatePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderCreatePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<ProviderCreatePatientContactMutation, ProviderCreatePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderCreatePatientContactMutation, ProviderCreatePatientContactMutationVariables>(ProviderCreatePatientContactDocument, options);
      }
export type ProviderCreatePatientContactMutationHookResult = ReturnType<typeof useProviderCreatePatientContactMutation>;
export type ProviderCreatePatientContactMutationResult = Apollo.MutationResult<ProviderCreatePatientContactMutation>;
export type ProviderCreatePatientContactMutationOptions = Apollo.BaseMutationOptions<ProviderCreatePatientContactMutation, ProviderCreatePatientContactMutationVariables>;
export const ProviderUpdatePatientContactDocument = gql`
    mutation ProviderUpdatePatientContact($input: ProviderUpdatePatientContactInput!) {
  providerUpdatePatientContact(input: $input) {
    ...patientContactData
  }
}
    ${PatientContactDataFragmentDoc}`;
export type ProviderUpdatePatientContactMutationFn = Apollo.MutationFunction<ProviderUpdatePatientContactMutation, ProviderUpdatePatientContactMutationVariables>;

/**
 * __useProviderUpdatePatientContactMutation__
 *
 * To run a mutation, you first call `useProviderUpdatePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUpdatePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUpdatePatientContactMutation, { data, loading, error }] = useProviderUpdatePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderUpdatePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUpdatePatientContactMutation, ProviderUpdatePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUpdatePatientContactMutation, ProviderUpdatePatientContactMutationVariables>(ProviderUpdatePatientContactDocument, options);
      }
export type ProviderUpdatePatientContactMutationHookResult = ReturnType<typeof useProviderUpdatePatientContactMutation>;
export type ProviderUpdatePatientContactMutationResult = Apollo.MutationResult<ProviderUpdatePatientContactMutation>;
export type ProviderUpdatePatientContactMutationOptions = Apollo.BaseMutationOptions<ProviderUpdatePatientContactMutation, ProviderUpdatePatientContactMutationVariables>;
export const ProviderDeletePatientContactDocument = gql`
    mutation ProviderDeletePatientContact($input: ProviderDeletePatientContactInput!) {
  providerDeletePatientContact(input: $input)
}
    `;
export type ProviderDeletePatientContactMutationFn = Apollo.MutationFunction<ProviderDeletePatientContactMutation, ProviderDeletePatientContactMutationVariables>;

/**
 * __useProviderDeletePatientContactMutation__
 *
 * To run a mutation, you first call `useProviderDeletePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderDeletePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerDeletePatientContactMutation, { data, loading, error }] = useProviderDeletePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderDeletePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<ProviderDeletePatientContactMutation, ProviderDeletePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderDeletePatientContactMutation, ProviderDeletePatientContactMutationVariables>(ProviderDeletePatientContactDocument, options);
      }
export type ProviderDeletePatientContactMutationHookResult = ReturnType<typeof useProviderDeletePatientContactMutation>;
export type ProviderDeletePatientContactMutationResult = Apollo.MutationResult<ProviderDeletePatientContactMutation>;
export type ProviderDeletePatientContactMutationOptions = Apollo.BaseMutationOptions<ProviderDeletePatientContactMutation, ProviderDeletePatientContactMutationVariables>;
export const PatientCreatePatientContactDocument = gql`
    mutation PatientCreatePatientContact($input: PatientCreatePatientContactInput!) {
  patientCreatePatientContact(input: $input) {
    ...patientContactData
  }
}
    ${PatientContactDataFragmentDoc}`;
export type PatientCreatePatientContactMutationFn = Apollo.MutationFunction<PatientCreatePatientContactMutation, PatientCreatePatientContactMutationVariables>;

/**
 * __usePatientCreatePatientContactMutation__
 *
 * To run a mutation, you first call `usePatientCreatePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientCreatePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientCreatePatientContactMutation, { data, loading, error }] = usePatientCreatePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientCreatePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<PatientCreatePatientContactMutation, PatientCreatePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientCreatePatientContactMutation, PatientCreatePatientContactMutationVariables>(PatientCreatePatientContactDocument, options);
      }
export type PatientCreatePatientContactMutationHookResult = ReturnType<typeof usePatientCreatePatientContactMutation>;
export type PatientCreatePatientContactMutationResult = Apollo.MutationResult<PatientCreatePatientContactMutation>;
export type PatientCreatePatientContactMutationOptions = Apollo.BaseMutationOptions<PatientCreatePatientContactMutation, PatientCreatePatientContactMutationVariables>;
export const PatientUpdatePatientContactDocument = gql`
    mutation PatientUpdatePatientContact($input: PatientUpdatePatientContactInput!) {
  patientUpdatePatientContact(input: $input) {
    ...patientContactData
  }
}
    ${PatientContactDataFragmentDoc}`;
export type PatientUpdatePatientContactMutationFn = Apollo.MutationFunction<PatientUpdatePatientContactMutation, PatientUpdatePatientContactMutationVariables>;

/**
 * __usePatientUpdatePatientContactMutation__
 *
 * To run a mutation, you first call `usePatientUpdatePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientUpdatePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientUpdatePatientContactMutation, { data, loading, error }] = usePatientUpdatePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientUpdatePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<PatientUpdatePatientContactMutation, PatientUpdatePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientUpdatePatientContactMutation, PatientUpdatePatientContactMutationVariables>(PatientUpdatePatientContactDocument, options);
      }
export type PatientUpdatePatientContactMutationHookResult = ReturnType<typeof usePatientUpdatePatientContactMutation>;
export type PatientUpdatePatientContactMutationResult = Apollo.MutationResult<PatientUpdatePatientContactMutation>;
export type PatientUpdatePatientContactMutationOptions = Apollo.BaseMutationOptions<PatientUpdatePatientContactMutation, PatientUpdatePatientContactMutationVariables>;
export const PatientDeletePatientContactDocument = gql`
    mutation PatientDeletePatientContact($input: PatientDeletePatientContactInput!) {
  patientDeletePatientContact(input: $input)
}
    `;
export type PatientDeletePatientContactMutationFn = Apollo.MutationFunction<PatientDeletePatientContactMutation, PatientDeletePatientContactMutationVariables>;

/**
 * __usePatientDeletePatientContactMutation__
 *
 * To run a mutation, you first call `usePatientDeletePatientContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientDeletePatientContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientDeletePatientContactMutation, { data, loading, error }] = usePatientDeletePatientContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientDeletePatientContactMutation(baseOptions?: Apollo.MutationHookOptions<PatientDeletePatientContactMutation, PatientDeletePatientContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientDeletePatientContactMutation, PatientDeletePatientContactMutationVariables>(PatientDeletePatientContactDocument, options);
      }
export type PatientDeletePatientContactMutationHookResult = ReturnType<typeof usePatientDeletePatientContactMutation>;
export type PatientDeletePatientContactMutationResult = Apollo.MutationResult<PatientDeletePatientContactMutation>;
export type PatientDeletePatientContactMutationOptions = Apollo.BaseMutationOptions<PatientDeletePatientContactMutation, PatientDeletePatientContactMutationVariables>;
export const ContactDeletionImpactDocument = gql`
    query ContactDeletionImpact($contactId: String!) {
  contactDeletionImpact(contactId: $contactId) {
    hasActiveLinks
    activeNoteShares {
      id
      noteTitle
      expiresAt
    }
    activeFormInvites {
      id
      formName
      expiresAt
    }
  }
}
    `;

/**
 * __useContactDeletionImpactQuery__
 *
 * To run a query within a React component, call `useContactDeletionImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDeletionImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDeletionImpactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactDeletionImpactQuery(baseOptions: Apollo.QueryHookOptions<ContactDeletionImpactQuery, ContactDeletionImpactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactDeletionImpactQuery, ContactDeletionImpactQueryVariables>(ContactDeletionImpactDocument, options);
      }
export function useContactDeletionImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactDeletionImpactQuery, ContactDeletionImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactDeletionImpactQuery, ContactDeletionImpactQueryVariables>(ContactDeletionImpactDocument, options);
        }
export type ContactDeletionImpactQueryHookResult = ReturnType<typeof useContactDeletionImpactQuery>;
export type ContactDeletionImpactLazyQueryHookResult = ReturnType<typeof useContactDeletionImpactLazyQuery>;
export type ContactDeletionImpactQueryResult = Apollo.QueryResult<ContactDeletionImpactQuery, ContactDeletionImpactQueryVariables>;
export const ContactHasActiveExternalLinksDocument = gql`
    query ContactHasActiveExternalLinks($contactId: String!) {
  contactHasActiveExternalLinks(contactId: $contactId)
}
    `;

/**
 * __useContactHasActiveExternalLinksQuery__
 *
 * To run a query within a React component, call `useContactHasActiveExternalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactHasActiveExternalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactHasActiveExternalLinksQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactHasActiveExternalLinksQuery(baseOptions: Apollo.QueryHookOptions<ContactHasActiveExternalLinksQuery, ContactHasActiveExternalLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactHasActiveExternalLinksQuery, ContactHasActiveExternalLinksQueryVariables>(ContactHasActiveExternalLinksDocument, options);
      }
export function useContactHasActiveExternalLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactHasActiveExternalLinksQuery, ContactHasActiveExternalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactHasActiveExternalLinksQuery, ContactHasActiveExternalLinksQueryVariables>(ContactHasActiveExternalLinksDocument, options);
        }
export type ContactHasActiveExternalLinksQueryHookResult = ReturnType<typeof useContactHasActiveExternalLinksQuery>;
export type ContactHasActiveExternalLinksLazyQueryHookResult = ReturnType<typeof useContactHasActiveExternalLinksLazyQuery>;
export type ContactHasActiveExternalLinksQueryResult = Apollo.QueryResult<ContactHasActiveExternalLinksQuery, ContactHasActiveExternalLinksQueryVariables>;
export const ProviderBookableServicesDocument = gql`
    query ProviderBookableServices {
  providerBookableServices {
    ...bookableProviderServiceData
  }
}
    ${BookableProviderServiceDataFragmentDoc}`;

/**
 * __useProviderBookableServicesQuery__
 *
 * To run a query within a React component, call `useProviderBookableServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderBookableServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderBookableServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderBookableServicesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderBookableServicesQuery, ProviderBookableServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderBookableServicesQuery, ProviderBookableServicesQueryVariables>(ProviderBookableServicesDocument, options);
      }
export function useProviderBookableServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderBookableServicesQuery, ProviderBookableServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderBookableServicesQuery, ProviderBookableServicesQueryVariables>(ProviderBookableServicesDocument, options);
        }
export type ProviderBookableServicesQueryHookResult = ReturnType<typeof useProviderBookableServicesQuery>;
export type ProviderBookableServicesLazyQueryHookResult = ReturnType<typeof useProviderBookableServicesLazyQuery>;
export type ProviderBookableServicesQueryResult = Apollo.QueryResult<ProviderBookableServicesQuery, ProviderBookableServicesQueryVariables>;
export const PatientPortalBookServiceDocument = gql`
    mutation PatientPortalBookService($input: PatientPortalBookServiceInput!) {
  patientPortalBookService(input: $input) {
    serviceIntakePackageId
    error
  }
}
    `;
export type PatientPortalBookServiceMutationFn = Apollo.MutationFunction<PatientPortalBookServiceMutation, PatientPortalBookServiceMutationVariables>;

/**
 * __usePatientPortalBookServiceMutation__
 *
 * To run a mutation, you first call `usePatientPortalBookServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePatientPortalBookServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [patientPortalBookServiceMutation, { data, loading, error }] = usePatientPortalBookServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientPortalBookServiceMutation(baseOptions?: Apollo.MutationHookOptions<PatientPortalBookServiceMutation, PatientPortalBookServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PatientPortalBookServiceMutation, PatientPortalBookServiceMutationVariables>(PatientPortalBookServiceDocument, options);
      }
export type PatientPortalBookServiceMutationHookResult = ReturnType<typeof usePatientPortalBookServiceMutation>;
export type PatientPortalBookServiceMutationResult = Apollo.MutationResult<PatientPortalBookServiceMutation>;
export type PatientPortalBookServiceMutationOptions = Apollo.BaseMutationOptions<PatientPortalBookServiceMutation, PatientPortalBookServiceMutationVariables>;
export const ProviderPaymentActivitiesDocument = gql`
    query ProviderPaymentActivities($limit: Int, $offset: Int) {
  providerPaymentActivities(limit: $limit, offset: $offset) {
    id
    entityType
    entityId
    activityType
    actorType
    performedByProviderUser {
      id
      name
      profileImageMedia {
        url
      }
    }
    performedAt
    extraMetadata
  }
}
    `;

/**
 * __useProviderPaymentActivitiesQuery__
 *
 * To run a query within a React component, call `useProviderPaymentActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderPaymentActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderPaymentActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useProviderPaymentActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderPaymentActivitiesQuery, ProviderPaymentActivitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderPaymentActivitiesQuery, ProviderPaymentActivitiesQueryVariables>(ProviderPaymentActivitiesDocument, options);
      }
export function useProviderPaymentActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderPaymentActivitiesQuery, ProviderPaymentActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderPaymentActivitiesQuery, ProviderPaymentActivitiesQueryVariables>(ProviderPaymentActivitiesDocument, options);
        }
export type ProviderPaymentActivitiesQueryHookResult = ReturnType<typeof useProviderPaymentActivitiesQuery>;
export type ProviderPaymentActivitiesLazyQueryHookResult = ReturnType<typeof useProviderPaymentActivitiesLazyQuery>;
export type ProviderPaymentActivitiesQueryResult = Apollo.QueryResult<ProviderPaymentActivitiesQuery, ProviderPaymentActivitiesQueryVariables>;
export const ProviderProgramMediaDocument = gql`
    query ProviderProgramMedia($programId: String!) {
  patient(programId: $programId) {
    providerMedia {
      ...providerProgramMediaData
    }
  }
}
    ${ProviderProgramMediaDataFragmentDoc}`;

/**
 * __useProviderProgramMediaQuery__
 *
 * To run a query within a React component, call `useProviderProgramMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderProgramMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderProgramMediaQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProviderProgramMediaQuery(baseOptions: Apollo.QueryHookOptions<ProviderProgramMediaQuery, ProviderProgramMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderProgramMediaQuery, ProviderProgramMediaQueryVariables>(ProviderProgramMediaDocument, options);
      }
export function useProviderProgramMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderProgramMediaQuery, ProviderProgramMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderProgramMediaQuery, ProviderProgramMediaQueryVariables>(ProviderProgramMediaDocument, options);
        }
export type ProviderProgramMediaQueryHookResult = ReturnType<typeof useProviderProgramMediaQuery>;
export type ProviderProgramMediaLazyQueryHookResult = ReturnType<typeof useProviderProgramMediaLazyQuery>;
export type ProviderProgramMediaQueryResult = Apollo.QueryResult<ProviderProgramMediaQuery, ProviderProgramMediaQueryVariables>;
export const MarkProgramSeenDocument = gql`
    mutation MarkProgramSeen($programId: String!) {
  markProgramSeen(programId: $programId) {
    ...patientData
  }
}
    ${PatientDataFragmentDoc}`;
export type MarkProgramSeenMutationFn = Apollo.MutationFunction<MarkProgramSeenMutation, MarkProgramSeenMutationVariables>;

/**
 * __useMarkProgramSeenMutation__
 *
 * To run a mutation, you first call `useMarkProgramSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkProgramSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markProgramSeenMutation, { data, loading, error }] = useMarkProgramSeenMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useMarkProgramSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkProgramSeenMutation, MarkProgramSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkProgramSeenMutation, MarkProgramSeenMutationVariables>(MarkProgramSeenDocument, options);
      }
export type MarkProgramSeenMutationHookResult = ReturnType<typeof useMarkProgramSeenMutation>;
export type MarkProgramSeenMutationResult = Apollo.MutationResult<MarkProgramSeenMutation>;
export type MarkProgramSeenMutationOptions = Apollo.BaseMutationOptions<MarkProgramSeenMutation, MarkProgramSeenMutationVariables>;
export const UploadProviderProgramMediaDocument = gql`
    mutation UploadProviderProgramMedia($input: UploadProviderProgramMediaInput!) {
  uploadProviderProgramMedia(input: $input) {
    ...providerProgramMediaData
  }
}
    ${ProviderProgramMediaDataFragmentDoc}`;
export type UploadProviderProgramMediaMutationFn = Apollo.MutationFunction<UploadProviderProgramMediaMutation, UploadProviderProgramMediaMutationVariables>;

/**
 * __useUploadProviderProgramMediaMutation__
 *
 * To run a mutation, you first call `useUploadProviderProgramMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProviderProgramMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProviderProgramMediaMutation, { data, loading, error }] = useUploadProviderProgramMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadProviderProgramMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadProviderProgramMediaMutation, UploadProviderProgramMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProviderProgramMediaMutation, UploadProviderProgramMediaMutationVariables>(UploadProviderProgramMediaDocument, options);
      }
export type UploadProviderProgramMediaMutationHookResult = ReturnType<typeof useUploadProviderProgramMediaMutation>;
export type UploadProviderProgramMediaMutationResult = Apollo.MutationResult<UploadProviderProgramMediaMutation>;
export type UploadProviderProgramMediaMutationOptions = Apollo.BaseMutationOptions<UploadProviderProgramMediaMutation, UploadProviderProgramMediaMutationVariables>;
export const DeleteProviderProgramMediaDocument = gql`
    mutation DeleteProviderProgramMedia($providerProgramMediaId: String!) {
  deleteProviderProgramMedia(providerProgramMediaId: $providerProgramMediaId)
}
    `;
export type DeleteProviderProgramMediaMutationFn = Apollo.MutationFunction<DeleteProviderProgramMediaMutation, DeleteProviderProgramMediaMutationVariables>;

/**
 * __useDeleteProviderProgramMediaMutation__
 *
 * To run a mutation, you first call `useDeleteProviderProgramMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderProgramMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderProgramMediaMutation, { data, loading, error }] = useDeleteProviderProgramMediaMutation({
 *   variables: {
 *      providerProgramMediaId: // value for 'providerProgramMediaId'
 *   },
 * });
 */
export function useDeleteProviderProgramMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderProgramMediaMutation, DeleteProviderProgramMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderProgramMediaMutation, DeleteProviderProgramMediaMutationVariables>(DeleteProviderProgramMediaDocument, options);
      }
export type DeleteProviderProgramMediaMutationHookResult = ReturnType<typeof useDeleteProviderProgramMediaMutation>;
export type DeleteProviderProgramMediaMutationResult = Apollo.MutationResult<DeleteProviderProgramMediaMutation>;
export type DeleteProviderProgramMediaMutationOptions = Apollo.BaseMutationOptions<DeleteProviderProgramMediaMutation, DeleteProviderProgramMediaMutationVariables>;
export const ProgramTemplatesDocument = gql`
    query ProgramTemplates {
  programTemplates {
    id
    name
    status
    programLengthInMonths
    activePatientCount
  }
}
    `;

/**
 * __useProgramTemplatesQuery__
 *
 * To run a query within a React component, call `useProgramTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProgramTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<ProgramTemplatesQuery, ProgramTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramTemplatesQuery, ProgramTemplatesQueryVariables>(ProgramTemplatesDocument, options);
      }
export function useProgramTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramTemplatesQuery, ProgramTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramTemplatesQuery, ProgramTemplatesQueryVariables>(ProgramTemplatesDocument, options);
        }
export type ProgramTemplatesQueryHookResult = ReturnType<typeof useProgramTemplatesQuery>;
export type ProgramTemplatesLazyQueryHookResult = ReturnType<typeof useProgramTemplatesLazyQuery>;
export type ProgramTemplatesQueryResult = Apollo.QueryResult<ProgramTemplatesQuery, ProgramTemplatesQueryVariables>;
export const ProgramTemplateDocument = gql`
    query ProgramTemplate($programTemplateId: String!) {
  programTemplate(programTemplateId: $programTemplateId) {
    id
    name
    taskGroups {
      id
      title
      weight
      isResourceGroup
      tasks {
        id
        title
        type
        author
        weightInGroup
        contentType
        media {
          imageUrl
        }
      }
    }
  }
}
    `;

/**
 * __useProgramTemplateQuery__
 *
 * To run a query within a React component, call `useProgramTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramTemplateQuery({
 *   variables: {
 *      programTemplateId: // value for 'programTemplateId'
 *   },
 * });
 */
export function useProgramTemplateQuery(baseOptions: Apollo.QueryHookOptions<ProgramTemplateQuery, ProgramTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramTemplateQuery, ProgramTemplateQueryVariables>(ProgramTemplateDocument, options);
      }
export function useProgramTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramTemplateQuery, ProgramTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramTemplateQuery, ProgramTemplateQueryVariables>(ProgramTemplateDocument, options);
        }
export type ProgramTemplateQueryHookResult = ReturnType<typeof useProgramTemplateQuery>;
export type ProgramTemplateLazyQueryHookResult = ReturnType<typeof useProgramTemplateLazyQuery>;
export type ProgramTemplateQueryResult = Apollo.QueryResult<ProgramTemplateQuery, ProgramTemplateQueryVariables>;
export const ProgramTemplateNameDocument = gql`
    query ProgramTemplateName($programTemplateId: String!) {
  programTemplate(programTemplateId: $programTemplateId) {
    name
  }
}
    `;

/**
 * __useProgramTemplateNameQuery__
 *
 * To run a query within a React component, call `useProgramTemplateNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramTemplateNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramTemplateNameQuery({
 *   variables: {
 *      programTemplateId: // value for 'programTemplateId'
 *   },
 * });
 */
export function useProgramTemplateNameQuery(baseOptions: Apollo.QueryHookOptions<ProgramTemplateNameQuery, ProgramTemplateNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramTemplateNameQuery, ProgramTemplateNameQueryVariables>(ProgramTemplateNameDocument, options);
      }
export function useProgramTemplateNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramTemplateNameQuery, ProgramTemplateNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramTemplateNameQuery, ProgramTemplateNameQueryVariables>(ProgramTemplateNameDocument, options);
        }
export type ProgramTemplateNameQueryHookResult = ReturnType<typeof useProgramTemplateNameQuery>;
export type ProgramTemplateNameLazyQueryHookResult = ReturnType<typeof useProgramTemplateNameLazyQuery>;
export type ProgramTemplateNameQueryResult = Apollo.QueryResult<ProgramTemplateNameQuery, ProgramTemplateNameQueryVariables>;
export const ProgramTaskDocument = gql`
    query ProgramTask($programTaskId: String!) {
  programTask(programTaskId: $programTaskId) {
    id
    title
    type
    author
    content {
      title
      audioDuration
      audioFileName
    }
    media {
      htmlUrl
      htmlMediaId
      imageUrl
      imageMediaId
      audioUrl
      audioMediaId
    }
  }
}
    `;

/**
 * __useProgramTaskQuery__
 *
 * To run a query within a React component, call `useProgramTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramTaskQuery({
 *   variables: {
 *      programTaskId: // value for 'programTaskId'
 *   },
 * });
 */
export function useProgramTaskQuery(baseOptions: Apollo.QueryHookOptions<ProgramTaskQuery, ProgramTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProgramTaskQuery, ProgramTaskQueryVariables>(ProgramTaskDocument, options);
      }
export function useProgramTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProgramTaskQuery, ProgramTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProgramTaskQuery, ProgramTaskQueryVariables>(ProgramTaskDocument, options);
        }
export type ProgramTaskQueryHookResult = ReturnType<typeof useProgramTaskQuery>;
export type ProgramTaskLazyQueryHookResult = ReturnType<typeof useProgramTaskLazyQuery>;
export type ProgramTaskQueryResult = Apollo.QueryResult<ProgramTaskQuery, ProgramTaskQueryVariables>;
export const CreateProgramTemplateDocument = gql`
    mutation CreateProgramTemplate($input: CreateProgramTemplateInput!) {
  createProgramTemplate(input: $input) {
    id
  }
}
    `;
export type CreateProgramTemplateMutationFn = Apollo.MutationFunction<CreateProgramTemplateMutation, CreateProgramTemplateMutationVariables>;

/**
 * __useCreateProgramTemplateMutation__
 *
 * To run a mutation, you first call `useCreateProgramTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramTemplateMutation, { data, loading, error }] = useCreateProgramTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramTemplateMutation, CreateProgramTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramTemplateMutation, CreateProgramTemplateMutationVariables>(CreateProgramTemplateDocument, options);
      }
export type CreateProgramTemplateMutationHookResult = ReturnType<typeof useCreateProgramTemplateMutation>;
export type CreateProgramTemplateMutationResult = Apollo.MutationResult<CreateProgramTemplateMutation>;
export type CreateProgramTemplateMutationOptions = Apollo.BaseMutationOptions<CreateProgramTemplateMutation, CreateProgramTemplateMutationVariables>;
export const CreateProgramTaskDocument = gql`
    mutation CreateProgramTask($programTemplateId: String!, $input: ProgramTaskInput!) {
  createProgramTask(programTemplateId: $programTemplateId, input: $input)
}
    `;
export type CreateProgramTaskMutationFn = Apollo.MutationFunction<CreateProgramTaskMutation, CreateProgramTaskMutationVariables>;

/**
 * __useCreateProgramTaskMutation__
 *
 * To run a mutation, you first call `useCreateProgramTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramTaskMutation, { data, loading, error }] = useCreateProgramTaskMutation({
 *   variables: {
 *      programTemplateId: // value for 'programTemplateId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramTaskMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramTaskMutation, CreateProgramTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramTaskMutation, CreateProgramTaskMutationVariables>(CreateProgramTaskDocument, options);
      }
export type CreateProgramTaskMutationHookResult = ReturnType<typeof useCreateProgramTaskMutation>;
export type CreateProgramTaskMutationResult = Apollo.MutationResult<CreateProgramTaskMutation>;
export type CreateProgramTaskMutationOptions = Apollo.BaseMutationOptions<CreateProgramTaskMutation, CreateProgramTaskMutationVariables>;
export const UpdateProgramTaskDocument = gql`
    mutation UpdateProgramTask($programTaskId: String!, $input: TaskInput!) {
  updateProgramTask(programTaskId: $programTaskId, input: $input)
}
    `;
export type UpdateProgramTaskMutationFn = Apollo.MutationFunction<UpdateProgramTaskMutation, UpdateProgramTaskMutationVariables>;

/**
 * __useUpdateProgramTaskMutation__
 *
 * To run a mutation, you first call `useUpdateProgramTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramTaskMutation, { data, loading, error }] = useUpdateProgramTaskMutation({
 *   variables: {
 *      programTaskId: // value for 'programTaskId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramTaskMutation, UpdateProgramTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramTaskMutation, UpdateProgramTaskMutationVariables>(UpdateProgramTaskDocument, options);
      }
export type UpdateProgramTaskMutationHookResult = ReturnType<typeof useUpdateProgramTaskMutation>;
export type UpdateProgramTaskMutationResult = Apollo.MutationResult<UpdateProgramTaskMutation>;
export type UpdateProgramTaskMutationOptions = Apollo.BaseMutationOptions<UpdateProgramTaskMutation, UpdateProgramTaskMutationVariables>;
export const RemoveTaskFromProgramTemplateDocument = gql`
    mutation RemoveTaskFromProgramTemplate($taskId: String!, $programTemplateId: String!) {
  removeTaskFromProgramTemplate(
    taskId: $taskId
    programTemplateId: $programTemplateId
  )
}
    `;
export type RemoveTaskFromProgramTemplateMutationFn = Apollo.MutationFunction<RemoveTaskFromProgramTemplateMutation, RemoveTaskFromProgramTemplateMutationVariables>;

/**
 * __useRemoveTaskFromProgramTemplateMutation__
 *
 * To run a mutation, you first call `useRemoveTaskFromProgramTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskFromProgramTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskFromProgramTemplateMutation, { data, loading, error }] = useRemoveTaskFromProgramTemplateMutation({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      programTemplateId: // value for 'programTemplateId'
 *   },
 * });
 */
export function useRemoveTaskFromProgramTemplateMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskFromProgramTemplateMutation, RemoveTaskFromProgramTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskFromProgramTemplateMutation, RemoveTaskFromProgramTemplateMutationVariables>(RemoveTaskFromProgramTemplateDocument, options);
      }
export type RemoveTaskFromProgramTemplateMutationHookResult = ReturnType<typeof useRemoveTaskFromProgramTemplateMutation>;
export type RemoveTaskFromProgramTemplateMutationResult = Apollo.MutationResult<RemoveTaskFromProgramTemplateMutation>;
export type RemoveTaskFromProgramTemplateMutationOptions = Apollo.BaseMutationOptions<RemoveTaskFromProgramTemplateMutation, RemoveTaskFromProgramTemplateMutationVariables>;
export const MoveProgramTemplateTaskInGroupDocument = gql`
    mutation MoveProgramTemplateTaskInGroup($input: MoveProgramTemplateTaskInGroupInput!) {
  moveProgramTemplateTaskInGroup(input: $input) {
    id
    title
    weight
    isResourceGroup
    tasks {
      id
      title
      type
      author
      weightInGroup
      contentType
      media {
        imageUrl
      }
    }
  }
}
    `;
export type MoveProgramTemplateTaskInGroupMutationFn = Apollo.MutationFunction<MoveProgramTemplateTaskInGroupMutation, MoveProgramTemplateTaskInGroupMutationVariables>;

/**
 * __useMoveProgramTemplateTaskInGroupMutation__
 *
 * To run a mutation, you first call `useMoveProgramTemplateTaskInGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveProgramTemplateTaskInGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveProgramTemplateTaskInGroupMutation, { data, loading, error }] = useMoveProgramTemplateTaskInGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveProgramTemplateTaskInGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveProgramTemplateTaskInGroupMutation, MoveProgramTemplateTaskInGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveProgramTemplateTaskInGroupMutation, MoveProgramTemplateTaskInGroupMutationVariables>(MoveProgramTemplateTaskInGroupDocument, options);
      }
export type MoveProgramTemplateTaskInGroupMutationHookResult = ReturnType<typeof useMoveProgramTemplateTaskInGroupMutation>;
export type MoveProgramTemplateTaskInGroupMutationResult = Apollo.MutationResult<MoveProgramTemplateTaskInGroupMutation>;
export type MoveProgramTemplateTaskInGroupMutationOptions = Apollo.BaseMutationOptions<MoveProgramTemplateTaskInGroupMutation, MoveProgramTemplateTaskInGroupMutationVariables>;
export const RenameTaskGroupDocument = gql`
    mutation RenameTaskGroup($taskGroupId: String!, $title: String!) {
  renameTaskGroup(taskGroupId: $taskGroupId, title: $title)
}
    `;
export type RenameTaskGroupMutationFn = Apollo.MutationFunction<RenameTaskGroupMutation, RenameTaskGroupMutationVariables>;

/**
 * __useRenameTaskGroupMutation__
 *
 * To run a mutation, you first call `useRenameTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTaskGroupMutation, { data, loading, error }] = useRenameTaskGroupMutation({
 *   variables: {
 *      taskGroupId: // value for 'taskGroupId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useRenameTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<RenameTaskGroupMutation, RenameTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTaskGroupMutation, RenameTaskGroupMutationVariables>(RenameTaskGroupDocument, options);
      }
export type RenameTaskGroupMutationHookResult = ReturnType<typeof useRenameTaskGroupMutation>;
export type RenameTaskGroupMutationResult = Apollo.MutationResult<RenameTaskGroupMutation>;
export type RenameTaskGroupMutationOptions = Apollo.BaseMutationOptions<RenameTaskGroupMutation, RenameTaskGroupMutationVariables>;
export const CreateTaskGroupDocument = gql`
    mutation CreateTaskGroup($input: CreateTaskGroupInput!) {
  createTaskGroup(input: $input) {
    id
  }
}
    `;
export type CreateTaskGroupMutationFn = Apollo.MutationFunction<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>;

/**
 * __useCreateTaskGroupMutation__
 *
 * To run a mutation, you first call `useCreateTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskGroupMutation, { data, loading, error }] = useCreateTaskGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>(CreateTaskGroupDocument, options);
      }
export type CreateTaskGroupMutationHookResult = ReturnType<typeof useCreateTaskGroupMutation>;
export type CreateTaskGroupMutationResult = Apollo.MutationResult<CreateTaskGroupMutation>;
export type CreateTaskGroupMutationOptions = Apollo.BaseMutationOptions<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>;
export const DeleteTaskGroupDocument = gql`
    mutation DeleteTaskGroup($taskGroupId: String!) {
  deleteTaskGroup(taskGroupId: $taskGroupId)
}
    `;
export type DeleteTaskGroupMutationFn = Apollo.MutationFunction<DeleteTaskGroupMutation, DeleteTaskGroupMutationVariables>;

/**
 * __useDeleteTaskGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaskGroupMutation, { data, loading, error }] = useDeleteTaskGroupMutation({
 *   variables: {
 *      taskGroupId: // value for 'taskGroupId'
 *   },
 * });
 */
export function useDeleteTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaskGroupMutation, DeleteTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaskGroupMutation, DeleteTaskGroupMutationVariables>(DeleteTaskGroupDocument, options);
      }
export type DeleteTaskGroupMutationHookResult = ReturnType<typeof useDeleteTaskGroupMutation>;
export type DeleteTaskGroupMutationResult = Apollo.MutationResult<DeleteTaskGroupMutation>;
export type DeleteTaskGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTaskGroupMutation, DeleteTaskGroupMutationVariables>;
export const PatientDocument = gql`
    query Patient($programId: String!) {
  patient(programId: $programId) {
    ...patientData
  }
}
    ${PatientDataFragmentDoc}`;

/**
 * __usePatientQuery__
 *
 * To run a query within a React component, call `usePatientQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function usePatientQuery(baseOptions: Apollo.QueryHookOptions<PatientQuery, PatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientQuery, PatientQueryVariables>(PatientDocument, options);
      }
export function usePatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientQuery, PatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientQuery, PatientQueryVariables>(PatientDocument, options);
        }
export type PatientQueryHookResult = ReturnType<typeof usePatientQuery>;
export type PatientLazyQueryHookResult = ReturnType<typeof usePatientLazyQuery>;
export type PatientQueryResult = Apollo.QueryResult<PatientQuery, PatientQueryVariables>;
export const ContactsForProgramDocument = gql`
    query ContactsForProgram($programId: String!) {
  contactsForProgram(programId: $programId) {
    ...patientContactData
  }
}
    ${PatientContactDataFragmentDoc}`;

/**
 * __useContactsForProgramQuery__
 *
 * To run a query within a React component, call `useContactsForProgramQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsForProgramQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsForProgramQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useContactsForProgramQuery(baseOptions: Apollo.QueryHookOptions<ContactsForProgramQuery, ContactsForProgramQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsForProgramQuery, ContactsForProgramQueryVariables>(ContactsForProgramDocument, options);
      }
export function useContactsForProgramLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsForProgramQuery, ContactsForProgramQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsForProgramQuery, ContactsForProgramQueryVariables>(ContactsForProgramDocument, options);
        }
export type ContactsForProgramQueryHookResult = ReturnType<typeof useContactsForProgramQuery>;
export type ContactsForProgramLazyQueryHookResult = ReturnType<typeof useContactsForProgramLazyQuery>;
export type ContactsForProgramQueryResult = Apollo.QueryResult<ContactsForProgramQuery, ContactsForProgramQueryVariables>;
export const AssignPatientsToProgramDocument = gql`
    mutation AssignPatientsToProgram($input: AssignPatientsToProgramInput!) {
  assignPatientsToProgram(input: $input) {
    updatedPatients {
      ...patientLeadData
    }
  }
}
    ${PatientLeadDataFragmentDoc}`;
export type AssignPatientsToProgramMutationFn = Apollo.MutationFunction<AssignPatientsToProgramMutation, AssignPatientsToProgramMutationVariables>;

/**
 * __useAssignPatientsToProgramMutation__
 *
 * To run a mutation, you first call `useAssignPatientsToProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignPatientsToProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignPatientsToProgramMutation, { data, loading, error }] = useAssignPatientsToProgramMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignPatientsToProgramMutation(baseOptions?: Apollo.MutationHookOptions<AssignPatientsToProgramMutation, AssignPatientsToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignPatientsToProgramMutation, AssignPatientsToProgramMutationVariables>(AssignPatientsToProgramDocument, options);
      }
export type AssignPatientsToProgramMutationHookResult = ReturnType<typeof useAssignPatientsToProgramMutation>;
export type AssignPatientsToProgramMutationResult = Apollo.MutationResult<AssignPatientsToProgramMutation>;
export type AssignPatientsToProgramMutationOptions = Apollo.BaseMutationOptions<AssignPatientsToProgramMutation, AssignPatientsToProgramMutationVariables>;
export const SendProgramInvitesToPatientsDocument = gql`
    mutation SendProgramInvitesToPatients($input: SendProgramInvitesToPatientsInput!) {
  sendProgramInvitesToPatients(input: $input) {
    updatedPatients {
      ...patientLeadData
    }
    clientSeatLimitError {
      seatsRemaining
    }
  }
}
    ${PatientLeadDataFragmentDoc}`;
export type SendProgramInvitesToPatientsMutationFn = Apollo.MutationFunction<SendProgramInvitesToPatientsMutation, SendProgramInvitesToPatientsMutationVariables>;

/**
 * __useSendProgramInvitesToPatientsMutation__
 *
 * To run a mutation, you first call `useSendProgramInvitesToPatientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProgramInvitesToPatientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProgramInvitesToPatientsMutation, { data, loading, error }] = useSendProgramInvitesToPatientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendProgramInvitesToPatientsMutation(baseOptions?: Apollo.MutationHookOptions<SendProgramInvitesToPatientsMutation, SendProgramInvitesToPatientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProgramInvitesToPatientsMutation, SendProgramInvitesToPatientsMutationVariables>(SendProgramInvitesToPatientsDocument, options);
      }
export type SendProgramInvitesToPatientsMutationHookResult = ReturnType<typeof useSendProgramInvitesToPatientsMutation>;
export type SendProgramInvitesToPatientsMutationResult = Apollo.MutationResult<SendProgramInvitesToPatientsMutation>;
export type SendProgramInvitesToPatientsMutationOptions = Apollo.BaseMutationOptions<SendProgramInvitesToPatientsMutation, SendProgramInvitesToPatientsMutationVariables>;
export const DeactivatePatientsDocument = gql`
    mutation DeactivatePatients($input: DeactivatePatientsInput!) {
  deactivatePatients(input: $input) {
    deactivatedPatients {
      id
      programInstanceId
    }
  }
}
    `;
export type DeactivatePatientsMutationFn = Apollo.MutationFunction<DeactivatePatientsMutation, DeactivatePatientsMutationVariables>;

/**
 * __useDeactivatePatientsMutation__
 *
 * To run a mutation, you first call `useDeactivatePatientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePatientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePatientsMutation, { data, loading, error }] = useDeactivatePatientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivatePatientsMutation(baseOptions?: Apollo.MutationHookOptions<DeactivatePatientsMutation, DeactivatePatientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivatePatientsMutation, DeactivatePatientsMutationVariables>(DeactivatePatientsDocument, options);
      }
export type DeactivatePatientsMutationHookResult = ReturnType<typeof useDeactivatePatientsMutation>;
export type DeactivatePatientsMutationResult = Apollo.MutationResult<DeactivatePatientsMutation>;
export type DeactivatePatientsMutationOptions = Apollo.BaseMutationOptions<DeactivatePatientsMutation, DeactivatePatientsMutationVariables>;
export const SetPatientFirstAppointmentDateDocument = gql`
    mutation SetPatientFirstAppointmentDate($programId: String!, $firstAppointmentDate: Datetime!) {
  setPatientFirstAppointmentDate(
    programId: $programId
    firstAppointmentDate: $firstAppointmentDate
  ) {
    ...patientData
  }
}
    ${PatientDataFragmentDoc}`;
export type SetPatientFirstAppointmentDateMutationFn = Apollo.MutationFunction<SetPatientFirstAppointmentDateMutation, SetPatientFirstAppointmentDateMutationVariables>;

/**
 * __useSetPatientFirstAppointmentDateMutation__
 *
 * To run a mutation, you first call `useSetPatientFirstAppointmentDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPatientFirstAppointmentDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPatientFirstAppointmentDateMutation, { data, loading, error }] = useSetPatientFirstAppointmentDateMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      firstAppointmentDate: // value for 'firstAppointmentDate'
 *   },
 * });
 */
export function useSetPatientFirstAppointmentDateMutation(baseOptions?: Apollo.MutationHookOptions<SetPatientFirstAppointmentDateMutation, SetPatientFirstAppointmentDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPatientFirstAppointmentDateMutation, SetPatientFirstAppointmentDateMutationVariables>(SetPatientFirstAppointmentDateDocument, options);
      }
export type SetPatientFirstAppointmentDateMutationHookResult = ReturnType<typeof useSetPatientFirstAppointmentDateMutation>;
export type SetPatientFirstAppointmentDateMutationResult = Apollo.MutationResult<SetPatientFirstAppointmentDateMutation>;
export type SetPatientFirstAppointmentDateMutationOptions = Apollo.BaseMutationOptions<SetPatientFirstAppointmentDateMutation, SetPatientFirstAppointmentDateMutationVariables>;
export const PatientFeedDocument = gql`
    query PatientFeed($programId: String!, $feedType: FeedType!, $paginationIndex: Int) {
  patientFeed(
    programId: $programId
    feedType: $feedType
    paginationIndex: $paginationIndex
  ) {
    activities {
      taskType
      title
      createdAt
    }
    checkIns {
      score
      createdAt
    }
  }
}
    `;

/**
 * __usePatientFeedQuery__
 *
 * To run a query within a React component, call `usePatientFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientFeedQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      feedType: // value for 'feedType'
 *      paginationIndex: // value for 'paginationIndex'
 *   },
 * });
 */
export function usePatientFeedQuery(baseOptions: Apollo.QueryHookOptions<PatientFeedQuery, PatientFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientFeedQuery, PatientFeedQueryVariables>(PatientFeedDocument, options);
      }
export function usePatientFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientFeedQuery, PatientFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientFeedQuery, PatientFeedQueryVariables>(PatientFeedDocument, options);
        }
export type PatientFeedQueryHookResult = ReturnType<typeof usePatientFeedQuery>;
export type PatientFeedLazyQueryHookResult = ReturnType<typeof usePatientFeedLazyQuery>;
export type PatientFeedQueryResult = Apollo.QueryResult<PatientFeedQuery, PatientFeedQueryVariables>;
export const PatientsV2Document = gql`
    query PatientsV2($patientLifecycleStatuses: [PatientLifecycleStatusV2!], $searchQuery: String, $sortOrder: ProgramSortOrder, $filter: PatientsV2Filter, $pageSize: Int, $page: Int) {
  patientsV2(
    patientLifecycleStatuses: $patientLifecycleStatuses
    searchQuery: $searchQuery
    sortOrder: $sortOrder
    filter: $filter
    pageSize: $pageSize
    page: $page
  ) {
    ...patientTableData
  }
}
    ${PatientTableDataFragmentDoc}`;

/**
 * __usePatientsV2Query__
 *
 * To run a query within a React component, call `usePatientsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePatientsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientsV2Query({
 *   variables: {
 *      patientLifecycleStatuses: // value for 'patientLifecycleStatuses'
 *      searchQuery: // value for 'searchQuery'
 *      sortOrder: // value for 'sortOrder'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePatientsV2Query(baseOptions?: Apollo.QueryHookOptions<PatientsV2Query, PatientsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientsV2Query, PatientsV2QueryVariables>(PatientsV2Document, options);
      }
export function usePatientsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientsV2Query, PatientsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientsV2Query, PatientsV2QueryVariables>(PatientsV2Document, options);
        }
export type PatientsV2QueryHookResult = ReturnType<typeof usePatientsV2Query>;
export type PatientsV2LazyQueryHookResult = ReturnType<typeof usePatientsV2LazyQuery>;
export type PatientsV2QueryResult = Apollo.QueryResult<PatientsV2Query, PatientsV2QueryVariables>;
export const PatientsCountV2Document = gql`
    query PatientsCountV2($filter: PatientsV2Filter) {
  activePatientsCount: patientsCountV2(
    patientLifecycleStatuses: [Active]
    filter: $filter
  )
  archivedPatientsCount: patientsCountV2(
    patientLifecycleStatuses: [Archived]
    filter: $filter
  )
}
    `;

/**
 * __usePatientsCountV2Query__
 *
 * To run a query within a React component, call `usePatientsCountV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePatientsCountV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientsCountV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePatientsCountV2Query(baseOptions?: Apollo.QueryHookOptions<PatientsCountV2Query, PatientsCountV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientsCountV2Query, PatientsCountV2QueryVariables>(PatientsCountV2Document, options);
      }
export function usePatientsCountV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientsCountV2Query, PatientsCountV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientsCountV2Query, PatientsCountV2QueryVariables>(PatientsCountV2Document, options);
        }
export type PatientsCountV2QueryHookResult = ReturnType<typeof usePatientsCountV2Query>;
export type PatientsCountV2LazyQueryHookResult = ReturnType<typeof usePatientsCountV2LazyQuery>;
export type PatientsCountV2QueryResult = Apollo.QueryResult<PatientsCountV2Query, PatientsCountV2QueryVariables>;
export const PatientsV2NamesDocument = gql`
    query PatientsV2Names($patientLifecycleStatuses: [PatientLifecycleStatusV2!], $assignedPatients: Boolean) {
  patientNames(
    patientLifecycleStatuses: $patientLifecycleStatuses
    assignedPatients: $assignedPatients
  ) {
    ...patientNameData
  }
}
    ${PatientNameDataFragmentDoc}`;

/**
 * __usePatientsV2NamesQuery__
 *
 * To run a query within a React component, call `usePatientsV2NamesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientsV2NamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientsV2NamesQuery({
 *   variables: {
 *      patientLifecycleStatuses: // value for 'patientLifecycleStatuses'
 *      assignedPatients: // value for 'assignedPatients'
 *   },
 * });
 */
export function usePatientsV2NamesQuery(baseOptions?: Apollo.QueryHookOptions<PatientsV2NamesQuery, PatientsV2NamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientsV2NamesQuery, PatientsV2NamesQueryVariables>(PatientsV2NamesDocument, options);
      }
export function usePatientsV2NamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientsV2NamesQuery, PatientsV2NamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientsV2NamesQuery, PatientsV2NamesQueryVariables>(PatientsV2NamesDocument, options);
        }
export type PatientsV2NamesQueryHookResult = ReturnType<typeof usePatientsV2NamesQuery>;
export type PatientsV2NamesLazyQueryHookResult = ReturnType<typeof usePatientsV2NamesLazyQuery>;
export type PatientsV2NamesQueryResult = Apollo.QueryResult<PatientsV2NamesQuery, PatientsV2NamesQueryVariables>;
export const UpdateProviderDocument = gql`
    mutation UpdateProvider($input: UpdateProviderInput!) {
  updateProvider(input: $input) {
    name
    primaryColor
    secondaryColor
    supportEmail
    timezone
    squareLogoMedia {
      url
    }
    wordmarkLogoMedia {
      url
    }
    emailImageMedia {
      url
    }
    clientPortalBookServicesEnabled
    clientPortalBookCalendlyEnabled
    clientPortalAssessmentTrendsEnabled
  }
}
    `;
export type UpdateProviderMutationFn = Apollo.MutationFunction<UpdateProviderMutation, UpdateProviderMutationVariables>;

/**
 * __useUpdateProviderMutation__
 *
 * To run a mutation, you first call `useUpdateProviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderMutation, { data, loading, error }] = useUpdateProviderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderMutation, UpdateProviderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderMutation, UpdateProviderMutationVariables>(UpdateProviderDocument, options);
      }
export type UpdateProviderMutationHookResult = ReturnType<typeof useUpdateProviderMutation>;
export type UpdateProviderMutationResult = Apollo.MutationResult<UpdateProviderMutation>;
export type UpdateProviderMutationOptions = Apollo.BaseMutationOptions<UpdateProviderMutation, UpdateProviderMutationVariables>;
export const AddPatientsV2Document = gql`
    mutation AddPatientsV2($input: AddPatientsV2Input!) {
  addPatientsV2(input: $input) {
    newPatients {
      ...patientLeadData
    }
    validationErrors {
      inputId
      isDuplicate
      nameInvalid
      emailInvalid
      phoneNumberInvalid
      tagsInvalid
    }
  }
}
    ${PatientLeadDataFragmentDoc}`;
export type AddPatientsV2MutationFn = Apollo.MutationFunction<AddPatientsV2Mutation, AddPatientsV2MutationVariables>;

/**
 * __useAddPatientsV2Mutation__
 *
 * To run a mutation, you first call `useAddPatientsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientsV2Mutation, { data, loading, error }] = useAddPatientsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPatientsV2Mutation(baseOptions?: Apollo.MutationHookOptions<AddPatientsV2Mutation, AddPatientsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientsV2Mutation, AddPatientsV2MutationVariables>(AddPatientsV2Document, options);
      }
export type AddPatientsV2MutationHookResult = ReturnType<typeof useAddPatientsV2Mutation>;
export type AddPatientsV2MutationResult = Apollo.MutationResult<AddPatientsV2Mutation>;
export type AddPatientsV2MutationOptions = Apollo.BaseMutationOptions<AddPatientsV2Mutation, AddPatientsV2MutationVariables>;
export const ResendPatientInvitesDocument = gql`
    mutation ResendPatientInvites($input: ResendPatientInvitesInput!) {
  resendPatientInvites(input: $input) {
    updatedPatients {
      ...patientLeadData
    }
  }
}
    ${PatientLeadDataFragmentDoc}`;
export type ResendPatientInvitesMutationFn = Apollo.MutationFunction<ResendPatientInvitesMutation, ResendPatientInvitesMutationVariables>;

/**
 * __useResendPatientInvitesMutation__
 *
 * To run a mutation, you first call `useResendPatientInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPatientInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPatientInvitesMutation, { data, loading, error }] = useResendPatientInvitesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendPatientInvitesMutation(baseOptions?: Apollo.MutationHookOptions<ResendPatientInvitesMutation, ResendPatientInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPatientInvitesMutation, ResendPatientInvitesMutationVariables>(ResendPatientInvitesDocument, options);
      }
export type ResendPatientInvitesMutationHookResult = ReturnType<typeof useResendPatientInvitesMutation>;
export type ResendPatientInvitesMutationResult = Apollo.MutationResult<ResendPatientInvitesMutation>;
export type ResendPatientInvitesMutationOptions = Apollo.BaseMutationOptions<ResendPatientInvitesMutation, ResendPatientInvitesMutationVariables>;
export const SendTestProviderEmailDocument = gql`
    mutation SendTestProviderEmail($isBanner: Boolean!) {
  sendTestProviderEmail(isBanner: $isBanner)
}
    `;
export type SendTestProviderEmailMutationFn = Apollo.MutationFunction<SendTestProviderEmailMutation, SendTestProviderEmailMutationVariables>;

/**
 * __useSendTestProviderEmailMutation__
 *
 * To run a mutation, you first call `useSendTestProviderEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestProviderEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestProviderEmailMutation, { data, loading, error }] = useSendTestProviderEmailMutation({
 *   variables: {
 *      isBanner: // value for 'isBanner'
 *   },
 * });
 */
export function useSendTestProviderEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestProviderEmailMutation, SendTestProviderEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestProviderEmailMutation, SendTestProviderEmailMutationVariables>(SendTestProviderEmailDocument, options);
      }
export type SendTestProviderEmailMutationHookResult = ReturnType<typeof useSendTestProviderEmailMutation>;
export type SendTestProviderEmailMutationResult = Apollo.MutationResult<SendTestProviderEmailMutation>;
export type SendTestProviderEmailMutationOptions = Apollo.BaseMutationOptions<SendTestProviderEmailMutation, SendTestProviderEmailMutationVariables>;
export const PublicProviderServiceDocument = gql`
    query PublicProviderService($slug: String!, $serviceSlug: String!) {
  publicProviderService(slug: $slug, serviceSlug: $serviceSlug) {
    ...publicProviderServiceData
  }
}
    ${PublicProviderServiceDataFragmentDoc}`;

/**
 * __usePublicProviderServiceQuery__
 *
 * To run a query within a React component, call `usePublicProviderServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProviderServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProviderServiceQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      serviceSlug: // value for 'serviceSlug'
 *   },
 * });
 */
export function usePublicProviderServiceQuery(baseOptions: Apollo.QueryHookOptions<PublicProviderServiceQuery, PublicProviderServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProviderServiceQuery, PublicProviderServiceQueryVariables>(PublicProviderServiceDocument, options);
      }
export function usePublicProviderServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProviderServiceQuery, PublicProviderServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProviderServiceQuery, PublicProviderServiceQueryVariables>(PublicProviderServiceDocument, options);
        }
export type PublicProviderServiceQueryHookResult = ReturnType<typeof usePublicProviderServiceQuery>;
export type PublicProviderServiceLazyQueryHookResult = ReturnType<typeof usePublicProviderServiceLazyQuery>;
export type PublicProviderServiceQueryResult = Apollo.QueryResult<PublicProviderServiceQuery, PublicProviderServiceQueryVariables>;
export const ProviderServiceDocument = gql`
    query ProviderService($providerServiceId: String!) {
  providerService(providerServiceId: $providerServiceId) {
    ...providerServiceData
  }
}
    ${ProviderServiceDataFragmentDoc}`;

/**
 * __useProviderServiceQuery__
 *
 * To run a query within a React component, call `useProviderServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderServiceQuery({
 *   variables: {
 *      providerServiceId: // value for 'providerServiceId'
 *   },
 * });
 */
export function useProviderServiceQuery(baseOptions: Apollo.QueryHookOptions<ProviderServiceQuery, ProviderServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderServiceQuery, ProviderServiceQueryVariables>(ProviderServiceDocument, options);
      }
export function useProviderServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderServiceQuery, ProviderServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderServiceQuery, ProviderServiceQueryVariables>(ProviderServiceDocument, options);
        }
export type ProviderServiceQueryHookResult = ReturnType<typeof useProviderServiceQuery>;
export type ProviderServiceLazyQueryHookResult = ReturnType<typeof useProviderServiceLazyQuery>;
export type ProviderServiceQueryResult = Apollo.QueryResult<ProviderServiceQuery, ProviderServiceQueryVariables>;
export const ProviderServicesDocument = gql`
    query ProviderServices {
  providerServices {
    ...providerServiceData
  }
}
    ${ProviderServiceDataFragmentDoc}`;

/**
 * __useProviderServicesQuery__
 *
 * To run a query within a React component, call `useProviderServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderServicesQuery(baseOptions?: Apollo.QueryHookOptions<ProviderServicesQuery, ProviderServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderServicesQuery, ProviderServicesQueryVariables>(ProviderServicesDocument, options);
      }
export function useProviderServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderServicesQuery, ProviderServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderServicesQuery, ProviderServicesQueryVariables>(ProviderServicesDocument, options);
        }
export type ProviderServicesQueryHookResult = ReturnType<typeof useProviderServicesQuery>;
export type ProviderServicesLazyQueryHookResult = ReturnType<typeof useProviderServicesLazyQuery>;
export type ProviderServicesQueryResult = Apollo.QueryResult<ProviderServicesQuery, ProviderServicesQueryVariables>;
export const CreateProviderServiceDocument = gql`
    mutation CreateProviderService($input: CreateProviderServiceInput!) {
  createProviderService(input: $input) {
    ...providerServiceData
  }
}
    ${ProviderServiceDataFragmentDoc}`;
export type CreateProviderServiceMutationFn = Apollo.MutationFunction<CreateProviderServiceMutation, CreateProviderServiceMutationVariables>;

/**
 * __useCreateProviderServiceMutation__
 *
 * To run a mutation, you first call `useCreateProviderServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProviderServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProviderServiceMutation, { data, loading, error }] = useCreateProviderServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProviderServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProviderServiceMutation, CreateProviderServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProviderServiceMutation, CreateProviderServiceMutationVariables>(CreateProviderServiceDocument, options);
      }
export type CreateProviderServiceMutationHookResult = ReturnType<typeof useCreateProviderServiceMutation>;
export type CreateProviderServiceMutationResult = Apollo.MutationResult<CreateProviderServiceMutation>;
export type CreateProviderServiceMutationOptions = Apollo.BaseMutationOptions<CreateProviderServiceMutation, CreateProviderServiceMutationVariables>;
export const UpdateProviderServiceDocument = gql`
    mutation UpdateProviderService($input: UpdateProviderServiceInput!) {
  updateProviderService(input: $input) {
    ...providerServiceData
  }
}
    ${ProviderServiceDataFragmentDoc}`;
export type UpdateProviderServiceMutationFn = Apollo.MutationFunction<UpdateProviderServiceMutation, UpdateProviderServiceMutationVariables>;

/**
 * __useUpdateProviderServiceMutation__
 *
 * To run a mutation, you first call `useUpdateProviderServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderServiceMutation, { data, loading, error }] = useUpdateProviderServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderServiceMutation, UpdateProviderServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderServiceMutation, UpdateProviderServiceMutationVariables>(UpdateProviderServiceDocument, options);
      }
export type UpdateProviderServiceMutationHookResult = ReturnType<typeof useUpdateProviderServiceMutation>;
export type UpdateProviderServiceMutationResult = Apollo.MutationResult<UpdateProviderServiceMutation>;
export type UpdateProviderServiceMutationOptions = Apollo.BaseMutationOptions<UpdateProviderServiceMutation, UpdateProviderServiceMutationVariables>;
export const ArchiveProviderServiceDocument = gql`
    mutation ArchiveProviderService($providerServiceId: String!) {
  archiveProviderService(providerServiceId: $providerServiceId)
}
    `;
export type ArchiveProviderServiceMutationFn = Apollo.MutationFunction<ArchiveProviderServiceMutation, ArchiveProviderServiceMutationVariables>;

/**
 * __useArchiveProviderServiceMutation__
 *
 * To run a mutation, you first call `useArchiveProviderServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveProviderServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveProviderServiceMutation, { data, loading, error }] = useArchiveProviderServiceMutation({
 *   variables: {
 *      providerServiceId: // value for 'providerServiceId'
 *   },
 * });
 */
export function useArchiveProviderServiceMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveProviderServiceMutation, ArchiveProviderServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveProviderServiceMutation, ArchiveProviderServiceMutationVariables>(ArchiveProviderServiceDocument, options);
      }
export type ArchiveProviderServiceMutationHookResult = ReturnType<typeof useArchiveProviderServiceMutation>;
export type ArchiveProviderServiceMutationResult = Apollo.MutationResult<ArchiveProviderServiceMutation>;
export type ArchiveProviderServiceMutationOptions = Apollo.BaseMutationOptions<ArchiveProviderServiceMutation, ArchiveProviderServiceMutationVariables>;
export const __ProviderUserNotificationTypeDocument = gql`
    query __ProviderUserNotificationType {
  __typename
}
    `;

/**
 * __use__ProviderUserNotificationTypeQuery__
 *
 * To run a query within a React component, call `use__ProviderUserNotificationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `use__ProviderUserNotificationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = use__ProviderUserNotificationTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function use__ProviderUserNotificationTypeQuery(baseOptions?: Apollo.QueryHookOptions<__ProviderUserNotificationTypeQuery, __ProviderUserNotificationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<__ProviderUserNotificationTypeQuery, __ProviderUserNotificationTypeQueryVariables>(__ProviderUserNotificationTypeDocument, options);
      }
export function use__ProviderUserNotificationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<__ProviderUserNotificationTypeQuery, __ProviderUserNotificationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<__ProviderUserNotificationTypeQuery, __ProviderUserNotificationTypeQueryVariables>(__ProviderUserNotificationTypeDocument, options);
        }
export type __ProviderUserNotificationTypeQueryHookResult = ReturnType<typeof use__ProviderUserNotificationTypeQuery>;
export type __ProviderUserNotificationTypeLazyQueryHookResult = ReturnType<typeof use__ProviderUserNotificationTypeLazyQuery>;
export type __ProviderUserNotificationTypeQueryResult = Apollo.QueryResult<__ProviderUserNotificationTypeQuery, __ProviderUserNotificationTypeQueryVariables>;
export const MeProviderDocument = gql`
    query MeProvider {
  meProvider {
    ...meProviderData
  }
}
    ${MeProviderDataFragmentDoc}`;

/**
 * __useMeProviderQuery__
 *
 * To run a query within a React component, call `useMeProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderQuery, MeProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderQuery, MeProviderQueryVariables>(MeProviderDocument, options);
      }
export function useMeProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderQuery, MeProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderQuery, MeProviderQueryVariables>(MeProviderDocument, options);
        }
export type MeProviderQueryHookResult = ReturnType<typeof useMeProviderQuery>;
export type MeProviderLazyQueryHookResult = ReturnType<typeof useMeProviderLazyQuery>;
export type MeProviderQueryResult = Apollo.QueryResult<MeProviderQuery, MeProviderQueryVariables>;
export const MeProviderUserNotificationsDocument = gql`
    query MeProviderUserNotifications {
  meProvider {
    notifications {
      ...notificationData
    }
  }
}
    ${NotificationDataFragmentDoc}`;

/**
 * __useMeProviderUserNotificationsQuery__
 *
 * To run a query within a React component, call `useMeProviderUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderUserNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderUserNotificationsQuery, MeProviderUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderUserNotificationsQuery, MeProviderUserNotificationsQueryVariables>(MeProviderUserNotificationsDocument, options);
      }
export function useMeProviderUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderUserNotificationsQuery, MeProviderUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderUserNotificationsQuery, MeProviderUserNotificationsQueryVariables>(MeProviderUserNotificationsDocument, options);
        }
export type MeProviderUserNotificationsQueryHookResult = ReturnType<typeof useMeProviderUserNotificationsQuery>;
export type MeProviderUserNotificationsLazyQueryHookResult = ReturnType<typeof useMeProviderUserNotificationsLazyQuery>;
export type MeProviderUserNotificationsQueryResult = Apollo.QueryResult<MeProviderUserNotificationsQuery, MeProviderUserNotificationsQueryVariables>;
export const MeProviderUserNotificationControlsDocument = gql`
    query MeProviderUserNotificationControls {
  meProvider {
    hasMultipleTeamMembers
    patientDataPermission
    notificationControls {
      patientActivationEmailOption
      patientActivityCompletionEmailOption
      patientAssessmentCompletionEmailOption
      patientCommentEmailOption
      careTeamNotificationsEnabled
      allClientsFormCompletionEnabled
    }
  }
}
    `;

/**
 * __useMeProviderUserNotificationControlsQuery__
 *
 * To run a query within a React component, call `useMeProviderUserNotificationControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderUserNotificationControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderUserNotificationControlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderUserNotificationControlsQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderUserNotificationControlsQuery, MeProviderUserNotificationControlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderUserNotificationControlsQuery, MeProviderUserNotificationControlsQueryVariables>(MeProviderUserNotificationControlsDocument, options);
      }
export function useMeProviderUserNotificationControlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderUserNotificationControlsQuery, MeProviderUserNotificationControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderUserNotificationControlsQuery, MeProviderUserNotificationControlsQueryVariables>(MeProviderUserNotificationControlsDocument, options);
        }
export type MeProviderUserNotificationControlsQueryHookResult = ReturnType<typeof useMeProviderUserNotificationControlsQuery>;
export type MeProviderUserNotificationControlsLazyQueryHookResult = ReturnType<typeof useMeProviderUserNotificationControlsLazyQuery>;
export type MeProviderUserNotificationControlsQueryResult = Apollo.QueryResult<MeProviderUserNotificationControlsQuery, MeProviderUserNotificationControlsQueryVariables>;
export const CalendlyTeamProviderUsersDocument = gql`
    query CalendlyTeamProviderUsers {
  calendlyTeamProviderUsers {
    id
    email
    name
    profileImageUrl
  }
}
    `;

/**
 * __useCalendlyTeamProviderUsersQuery__
 *
 * To run a query within a React component, call `useCalendlyTeamProviderUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyTeamProviderUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyTeamProviderUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlyTeamProviderUsersQuery(baseOptions?: Apollo.QueryHookOptions<CalendlyTeamProviderUsersQuery, CalendlyTeamProviderUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyTeamProviderUsersQuery, CalendlyTeamProviderUsersQueryVariables>(CalendlyTeamProviderUsersDocument, options);
      }
export function useCalendlyTeamProviderUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyTeamProviderUsersQuery, CalendlyTeamProviderUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyTeamProviderUsersQuery, CalendlyTeamProviderUsersQueryVariables>(CalendlyTeamProviderUsersDocument, options);
        }
export type CalendlyTeamProviderUsersQueryHookResult = ReturnType<typeof useCalendlyTeamProviderUsersQuery>;
export type CalendlyTeamProviderUsersLazyQueryHookResult = ReturnType<typeof useCalendlyTeamProviderUsersLazyQuery>;
export type CalendlyTeamProviderUsersQueryResult = Apollo.QueryResult<CalendlyTeamProviderUsersQuery, CalendlyTeamProviderUsersQueryVariables>;
export const MeProviderUserProfileImageUrlDocument = gql`
    query MeProviderUserProfileImageUrl {
  meProvider {
    profileImageMedia {
      url
    }
    provider {
      ownerProfileImageMedia {
        url
      }
    }
  }
}
    `;

/**
 * __useMeProviderUserProfileImageUrlQuery__
 *
 * To run a query within a React component, call `useMeProviderUserProfileImageUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderUserProfileImageUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderUserProfileImageUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderUserProfileImageUrlQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderUserProfileImageUrlQuery, MeProviderUserProfileImageUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderUserProfileImageUrlQuery, MeProviderUserProfileImageUrlQueryVariables>(MeProviderUserProfileImageUrlDocument, options);
      }
export function useMeProviderUserProfileImageUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderUserProfileImageUrlQuery, MeProviderUserProfileImageUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderUserProfileImageUrlQuery, MeProviderUserProfileImageUrlQueryVariables>(MeProviderUserProfileImageUrlDocument, options);
        }
export type MeProviderUserProfileImageUrlQueryHookResult = ReturnType<typeof useMeProviderUserProfileImageUrlQuery>;
export type MeProviderUserProfileImageUrlLazyQueryHookResult = ReturnType<typeof useMeProviderUserProfileImageUrlLazyQuery>;
export type MeProviderUserProfileImageUrlQueryResult = Apollo.QueryResult<MeProviderUserProfileImageUrlQuery, MeProviderUserProfileImageUrlQueryVariables>;
export const MeProviderProgramTagsDocument = gql`
    query MeProviderProgramTags {
  meProvider {
    provider {
      programTags {
        ...programTagData
      }
    }
  }
}
    ${ProgramTagDataFragmentDoc}`;

/**
 * __useMeProviderProgramTagsQuery__
 *
 * To run a query within a React component, call `useMeProviderProgramTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderProgramTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderProgramTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderProgramTagsQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderProgramTagsQuery, MeProviderProgramTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderProgramTagsQuery, MeProviderProgramTagsQueryVariables>(MeProviderProgramTagsDocument, options);
      }
export function useMeProviderProgramTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderProgramTagsQuery, MeProviderProgramTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderProgramTagsQuery, MeProviderProgramTagsQueryVariables>(MeProviderProgramTagsDocument, options);
        }
export type MeProviderProgramTagsQueryHookResult = ReturnType<typeof useMeProviderProgramTagsQuery>;
export type MeProviderProgramTagsLazyQueryHookResult = ReturnType<typeof useMeProviderProgramTagsLazyQuery>;
export type MeProviderProgramTagsQueryResult = Apollo.QueryResult<MeProviderProgramTagsQuery, MeProviderProgramTagsQueryVariables>;
export const MeProviderProgramTagsWithCountDocument = gql`
    query MeProviderProgramTagsWithCount {
  meProvider {
    provider {
      programTags {
        ...programTagWithCountData
      }
    }
  }
}
    ${ProgramTagWithCountDataFragmentDoc}`;

/**
 * __useMeProviderProgramTagsWithCountQuery__
 *
 * To run a query within a React component, call `useMeProviderProgramTagsWithCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderProgramTagsWithCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderProgramTagsWithCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderProgramTagsWithCountQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderProgramTagsWithCountQuery, MeProviderProgramTagsWithCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderProgramTagsWithCountQuery, MeProviderProgramTagsWithCountQueryVariables>(MeProviderProgramTagsWithCountDocument, options);
      }
export function useMeProviderProgramTagsWithCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderProgramTagsWithCountQuery, MeProviderProgramTagsWithCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderProgramTagsWithCountQuery, MeProviderProgramTagsWithCountQueryVariables>(MeProviderProgramTagsWithCountDocument, options);
        }
export type MeProviderProgramTagsWithCountQueryHookResult = ReturnType<typeof useMeProviderProgramTagsWithCountQuery>;
export type MeProviderProgramTagsWithCountLazyQueryHookResult = ReturnType<typeof useMeProviderProgramTagsWithCountLazyQuery>;
export type MeProviderProgramTagsWithCountQueryResult = Apollo.QueryResult<MeProviderProgramTagsWithCountQuery, MeProviderProgramTagsWithCountQueryVariables>;
export const MeProviderSubscriptionStateDocument = gql`
    query MeProviderSubscriptionState {
  meProvider {
    hasPremiumAccess
    isProviderSubscribed
    hasBeenSubscribed
    isTrialing
    trialEndsAt
    provider {
      subscriptionTierV2
      subscriptionEndsAt
      seatUsage {
        clientSeats
        staffSeats
        usedClientSeats
        usedStaffSeats
      }
    }
  }
}
    `;

/**
 * __useMeProviderSubscriptionStateQuery__
 *
 * To run a query within a React component, call `useMeProviderSubscriptionStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderSubscriptionStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderSubscriptionStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderSubscriptionStateQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderSubscriptionStateQuery, MeProviderSubscriptionStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderSubscriptionStateQuery, MeProviderSubscriptionStateQueryVariables>(MeProviderSubscriptionStateDocument, options);
      }
export function useMeProviderSubscriptionStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderSubscriptionStateQuery, MeProviderSubscriptionStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderSubscriptionStateQuery, MeProviderSubscriptionStateQueryVariables>(MeProviderSubscriptionStateDocument, options);
        }
export type MeProviderSubscriptionStateQueryHookResult = ReturnType<typeof useMeProviderSubscriptionStateQuery>;
export type MeProviderSubscriptionStateLazyQueryHookResult = ReturnType<typeof useMeProviderSubscriptionStateLazyQuery>;
export type MeProviderSubscriptionStateQueryResult = Apollo.QueryResult<MeProviderSubscriptionStateQuery, MeProviderSubscriptionStateQueryVariables>;
export const MeProviderSignUpConfigDocument = gql`
    query MeProviderSignUpConfig {
  meProvider {
    signUpConfig {
      isCommunityHub
    }
  }
}
    `;

/**
 * __useMeProviderSignUpConfigQuery__
 *
 * To run a query within a React component, call `useMeProviderSignUpConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeProviderSignUpConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeProviderSignUpConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeProviderSignUpConfigQuery(baseOptions?: Apollo.QueryHookOptions<MeProviderSignUpConfigQuery, MeProviderSignUpConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeProviderSignUpConfigQuery, MeProviderSignUpConfigQueryVariables>(MeProviderSignUpConfigDocument, options);
      }
export function useMeProviderSignUpConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeProviderSignUpConfigQuery, MeProviderSignUpConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeProviderSignUpConfigQuery, MeProviderSignUpConfigQueryVariables>(MeProviderSignUpConfigDocument, options);
        }
export type MeProviderSignUpConfigQueryHookResult = ReturnType<typeof useMeProviderSignUpConfigQuery>;
export type MeProviderSignUpConfigLazyQueryHookResult = ReturnType<typeof useMeProviderSignUpConfigLazyQuery>;
export type MeProviderSignUpConfigQueryResult = Apollo.QueryResult<MeProviderSignUpConfigQuery, MeProviderSignUpConfigQueryVariables>;
export const InvitedProviderUserDocument = gql`
    query InvitedProviderUser($inviteCode: String!) {
  invitedProviderUser(inviteCode: $inviteCode) {
    providerName
    email
    role
    inviterProviderUserName
    providerSquareLogoUrl
  }
}
    `;

/**
 * __useInvitedProviderUserQuery__
 *
 * To run a query within a React component, call `useInvitedProviderUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvitedProviderUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitedProviderUserQuery({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *   },
 * });
 */
export function useInvitedProviderUserQuery(baseOptions: Apollo.QueryHookOptions<InvitedProviderUserQuery, InvitedProviderUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvitedProviderUserQuery, InvitedProviderUserQueryVariables>(InvitedProviderUserDocument, options);
      }
export function useInvitedProviderUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvitedProviderUserQuery, InvitedProviderUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvitedProviderUserQuery, InvitedProviderUserQueryVariables>(InvitedProviderUserDocument, options);
        }
export type InvitedProviderUserQueryHookResult = ReturnType<typeof useInvitedProviderUserQuery>;
export type InvitedProviderUserLazyQueryHookResult = ReturnType<typeof useInvitedProviderUserLazyQuery>;
export type InvitedProviderUserQueryResult = Apollo.QueryResult<InvitedProviderUserQuery, InvitedProviderUserQueryVariables>;
export const ProviderUserMembersDocument = gql`
    query ProviderUserMembers {
  providerUserMembers {
    ...providerUserMemberData
  }
}
    ${ProviderUserMemberDataFragmentDoc}`;

/**
 * __useProviderUserMembersQuery__
 *
 * To run a query within a React component, call `useProviderUserMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderUserMembersQuery(baseOptions?: Apollo.QueryHookOptions<ProviderUserMembersQuery, ProviderUserMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserMembersQuery, ProviderUserMembersQueryVariables>(ProviderUserMembersDocument, options);
      }
export function useProviderUserMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserMembersQuery, ProviderUserMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserMembersQuery, ProviderUserMembersQueryVariables>(ProviderUserMembersDocument, options);
        }
export type ProviderUserMembersQueryHookResult = ReturnType<typeof useProviderUserMembersQuery>;
export type ProviderUserMembersLazyQueryHookResult = ReturnType<typeof useProviderUserMembersLazyQuery>;
export type ProviderUserMembersQueryResult = Apollo.QueryResult<ProviderUserMembersQuery, ProviderUserMembersQueryVariables>;
export const ProviderUserMembersV2Document = gql`
    query ProviderUserMembersV2($activeProviderUsersOnly: Boolean) {
  providerUserMembers(activeProviderUsersOnly: $activeProviderUsersOnly) {
    ...providerUserMemberData
  }
}
    ${ProviderUserMemberDataFragmentDoc}`;

/**
 * __useProviderUserMembersV2Query__
 *
 * To run a query within a React component, call `useProviderUserMembersV2Query` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserMembersV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserMembersV2Query({
 *   variables: {
 *      activeProviderUsersOnly: // value for 'activeProviderUsersOnly'
 *   },
 * });
 */
export function useProviderUserMembersV2Query(baseOptions?: Apollo.QueryHookOptions<ProviderUserMembersV2Query, ProviderUserMembersV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserMembersV2Query, ProviderUserMembersV2QueryVariables>(ProviderUserMembersV2Document, options);
      }
export function useProviderUserMembersV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserMembersV2Query, ProviderUserMembersV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserMembersV2Query, ProviderUserMembersV2QueryVariables>(ProviderUserMembersV2Document, options);
        }
export type ProviderUserMembersV2QueryHookResult = ReturnType<typeof useProviderUserMembersV2Query>;
export type ProviderUserMembersV2LazyQueryHookResult = ReturnType<typeof useProviderUserMembersV2LazyQuery>;
export type ProviderUserMembersV2QueryResult = Apollo.QueryResult<ProviderUserMembersV2Query, ProviderUserMembersV2QueryVariables>;
export const BillingInfoDocument = gql`
    query BillingInfo {
  meProvider {
    billingInfo {
      nextBillingDate
      activePatientCount
      forecastedActivePatientCount
      forecastedCost
    }
    provider {
      subscriptionTier
      subscriptionTierV2
      seatUsage {
        clientSeats
        staffSeats
        usedClientSeats
      }
      paymentPlan {
        upfrontFee
        pmpmFee
        monthlyFee
      }
    }
  }
}
    `;

/**
 * __useBillingInfoQuery__
 *
 * To run a query within a React component, call `useBillingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingInfoQuery(baseOptions?: Apollo.QueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
      }
export function useBillingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingInfoQuery, BillingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingInfoQuery, BillingInfoQueryVariables>(BillingInfoDocument, options);
        }
export type BillingInfoQueryHookResult = ReturnType<typeof useBillingInfoQuery>;
export type BillingInfoLazyQueryHookResult = ReturnType<typeof useBillingInfoLazyQuery>;
export type BillingInfoQueryResult = Apollo.QueryResult<BillingInfoQuery, BillingInfoQueryVariables>;
export const ProviderUserLoginDocument = gql`
    mutation ProviderUserLogin($email: String!, $password: String!, $isMobile: Boolean) {
  providerUserLogin(email: $email, password: $password, isMobile: $isMobile) {
    tokenPayload {
      authToken
      providerUserId
      providerId
      role
      isV2
    }
    meProvider {
      ...meProviderData
    }
    signUpConfig {
      isCommunityHub
    }
  }
}
    ${MeProviderDataFragmentDoc}`;
export type ProviderUserLoginMutationFn = Apollo.MutationFunction<ProviderUserLoginMutation, ProviderUserLoginMutationVariables>;

/**
 * __useProviderUserLoginMutation__
 *
 * To run a mutation, you first call `useProviderUserLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUserLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUserLoginMutation, { data, loading, error }] = useProviderUserLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useProviderUserLoginMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUserLoginMutation, ProviderUserLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUserLoginMutation, ProviderUserLoginMutationVariables>(ProviderUserLoginDocument, options);
      }
export type ProviderUserLoginMutationHookResult = ReturnType<typeof useProviderUserLoginMutation>;
export type ProviderUserLoginMutationResult = Apollo.MutationResult<ProviderUserLoginMutation>;
export type ProviderUserLoginMutationOptions = Apollo.BaseMutationOptions<ProviderUserLoginMutation, ProviderUserLoginMutationVariables>;
export const ProviderUserLogoutDocument = gql`
    mutation ProviderUserLogout {
  providerUserLogout
}
    `;
export type ProviderUserLogoutMutationFn = Apollo.MutationFunction<ProviderUserLogoutMutation, ProviderUserLogoutMutationVariables>;

/**
 * __useProviderUserLogoutMutation__
 *
 * To run a mutation, you first call `useProviderUserLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUserLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUserLogoutMutation, { data, loading, error }] = useProviderUserLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useProviderUserLogoutMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUserLogoutMutation, ProviderUserLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUserLogoutMutation, ProviderUserLogoutMutationVariables>(ProviderUserLogoutDocument, options);
      }
export type ProviderUserLogoutMutationHookResult = ReturnType<typeof useProviderUserLogoutMutation>;
export type ProviderUserLogoutMutationResult = Apollo.MutationResult<ProviderUserLogoutMutation>;
export type ProviderUserLogoutMutationOptions = Apollo.BaseMutationOptions<ProviderUserLogoutMutation, ProviderUserLogoutMutationVariables>;
export const CompleteOnboardingDocument = gql`
    mutation CompleteOnboarding {
  completeOnboarding
}
    `;
export type CompleteOnboardingMutationFn = Apollo.MutationFunction<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;

/**
 * __useCompleteOnboardingMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingMutation, { data, loading, error }] = useCompleteOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>(CompleteOnboardingDocument, options);
      }
export type CompleteOnboardingMutationHookResult = ReturnType<typeof useCompleteOnboardingMutation>;
export type CompleteOnboardingMutationResult = Apollo.MutationResult<CompleteOnboardingMutation>;
export type CompleteOnboardingMutationOptions = Apollo.BaseMutationOptions<CompleteOnboardingMutation, CompleteOnboardingMutationVariables>;
export const ValidateProviderUserEmailDocument = gql`
    mutation ValidateProviderUserEmail($email: String!) {
  validateProviderUserEmail(email: $email)
}
    `;
export type ValidateProviderUserEmailMutationFn = Apollo.MutationFunction<ValidateProviderUserEmailMutation, ValidateProviderUserEmailMutationVariables>;

/**
 * __useValidateProviderUserEmailMutation__
 *
 * To run a mutation, you first call `useValidateProviderUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateProviderUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateProviderUserEmailMutation, { data, loading, error }] = useValidateProviderUserEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useValidateProviderUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ValidateProviderUserEmailMutation, ValidateProviderUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ValidateProviderUserEmailMutation, ValidateProviderUserEmailMutationVariables>(ValidateProviderUserEmailDocument, options);
      }
export type ValidateProviderUserEmailMutationHookResult = ReturnType<typeof useValidateProviderUserEmailMutation>;
export type ValidateProviderUserEmailMutationResult = Apollo.MutationResult<ValidateProviderUserEmailMutation>;
export type ValidateProviderUserEmailMutationOptions = Apollo.BaseMutationOptions<ValidateProviderUserEmailMutation, ValidateProviderUserEmailMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const ValidateRecoveryCodeDocument = gql`
    query ValidateRecoveryCode($recoveryCode: String!) {
  validateRecoveryCode(recoveryCode: $recoveryCode)
}
    `;

/**
 * __useValidateRecoveryCodeQuery__
 *
 * To run a query within a React component, call `useValidateRecoveryCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateRecoveryCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateRecoveryCodeQuery({
 *   variables: {
 *      recoveryCode: // value for 'recoveryCode'
 *   },
 * });
 */
export function useValidateRecoveryCodeQuery(baseOptions: Apollo.QueryHookOptions<ValidateRecoveryCodeQuery, ValidateRecoveryCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateRecoveryCodeQuery, ValidateRecoveryCodeQueryVariables>(ValidateRecoveryCodeDocument, options);
      }
export function useValidateRecoveryCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateRecoveryCodeQuery, ValidateRecoveryCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateRecoveryCodeQuery, ValidateRecoveryCodeQueryVariables>(ValidateRecoveryCodeDocument, options);
        }
export type ValidateRecoveryCodeQueryHookResult = ReturnType<typeof useValidateRecoveryCodeQuery>;
export type ValidateRecoveryCodeLazyQueryHookResult = ReturnType<typeof useValidateRecoveryCodeLazyQuery>;
export type ValidateRecoveryCodeQueryResult = Apollo.QueryResult<ValidateRecoveryCodeQuery, ValidateRecoveryCodeQueryVariables>;
export const SignUpConfigDocument = gql`
    query SignUpConfig($slug: String) {
  signUpConfig(slug: $slug) {
    skipIntroCarousel
    isCommunityHub
    hideLoginLink
    headerText
    subheaderText
    partnerName
    logoLinkUrl
    testimonialQuote
    testimonialName
    testimonialTitle
    testimonialAvatarMedia {
      url
    }
    additionalLogoMedia {
      url
    }
    sidepanelBgMedia {
      url
    }
    sidepanelCommunityMedia {
      url
    }
  }
}
    `;

/**
 * __useSignUpConfigQuery__
 *
 * To run a query within a React component, call `useSignUpConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpConfigQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useSignUpConfigQuery(baseOptions?: Apollo.QueryHookOptions<SignUpConfigQuery, SignUpConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignUpConfigQuery, SignUpConfigQueryVariables>(SignUpConfigDocument, options);
      }
export function useSignUpConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignUpConfigQuery, SignUpConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignUpConfigQuery, SignUpConfigQueryVariables>(SignUpConfigDocument, options);
        }
export type SignUpConfigQueryHookResult = ReturnType<typeof useSignUpConfigQuery>;
export type SignUpConfigLazyQueryHookResult = ReturnType<typeof useSignUpConfigLazyQuery>;
export type SignUpConfigQueryResult = Apollo.QueryResult<SignUpConfigQuery, SignUpConfigQueryVariables>;
export const ChangePasswordWithRecoveryCodeDocument = gql`
    mutation ChangePasswordWithRecoveryCode($recoveryCode: String!, $newPassword: String!) {
  changePasswordWithRecoveryCode(
    recoveryCode: $recoveryCode
    newPassword: $newPassword
  )
}
    `;
export type ChangePasswordWithRecoveryCodeMutationFn = Apollo.MutationFunction<ChangePasswordWithRecoveryCodeMutation, ChangePasswordWithRecoveryCodeMutationVariables>;

/**
 * __useChangePasswordWithRecoveryCodeMutation__
 *
 * To run a mutation, you first call `useChangePasswordWithRecoveryCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordWithRecoveryCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordWithRecoveryCodeMutation, { data, loading, error }] = useChangePasswordWithRecoveryCodeMutation({
 *   variables: {
 *      recoveryCode: // value for 'recoveryCode'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordWithRecoveryCodeMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordWithRecoveryCodeMutation, ChangePasswordWithRecoveryCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordWithRecoveryCodeMutation, ChangePasswordWithRecoveryCodeMutationVariables>(ChangePasswordWithRecoveryCodeDocument, options);
      }
export type ChangePasswordWithRecoveryCodeMutationHookResult = ReturnType<typeof useChangePasswordWithRecoveryCodeMutation>;
export type ChangePasswordWithRecoveryCodeMutationResult = Apollo.MutationResult<ChangePasswordWithRecoveryCodeMutation>;
export type ChangePasswordWithRecoveryCodeMutationOptions = Apollo.BaseMutationOptions<ChangePasswordWithRecoveryCodeMutation, ChangePasswordWithRecoveryCodeMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  changePassword(oldPassword: $oldPassword, newPassword: $newPassword)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const UploadProviderUserProfileImageDocument = gql`
    mutation UploadProviderUserProfileImage($file: Upload!) {
  uploadProviderUserProfileImage(file: $file)
}
    `;
export type UploadProviderUserProfileImageMutationFn = Apollo.MutationFunction<UploadProviderUserProfileImageMutation, UploadProviderUserProfileImageMutationVariables>;

/**
 * __useUploadProviderUserProfileImageMutation__
 *
 * To run a mutation, you first call `useUploadProviderUserProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProviderUserProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProviderUserProfileImageMutation, { data, loading, error }] = useUploadProviderUserProfileImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadProviderUserProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadProviderUserProfileImageMutation, UploadProviderUserProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProviderUserProfileImageMutation, UploadProviderUserProfileImageMutationVariables>(UploadProviderUserProfileImageDocument, options);
      }
export type UploadProviderUserProfileImageMutationHookResult = ReturnType<typeof useUploadProviderUserProfileImageMutation>;
export type UploadProviderUserProfileImageMutationResult = Apollo.MutationResult<UploadProviderUserProfileImageMutation>;
export type UploadProviderUserProfileImageMutationOptions = Apollo.BaseMutationOptions<UploadProviderUserProfileImageMutation, UploadProviderUserProfileImageMutationVariables>;
export const ResetOnboardingDocument = gql`
    mutation ResetOnboarding {
  resetOnboarding
}
    `;
export type ResetOnboardingMutationFn = Apollo.MutationFunction<ResetOnboardingMutation, ResetOnboardingMutationVariables>;

/**
 * __useResetOnboardingMutation__
 *
 * To run a mutation, you first call `useResetOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOnboardingMutation, { data, loading, error }] = useResetOnboardingMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<ResetOnboardingMutation, ResetOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetOnboardingMutation, ResetOnboardingMutationVariables>(ResetOnboardingDocument, options);
      }
export type ResetOnboardingMutationHookResult = ReturnType<typeof useResetOnboardingMutation>;
export type ResetOnboardingMutationResult = Apollo.MutationResult<ResetOnboardingMutation>;
export type ResetOnboardingMutationOptions = Apollo.BaseMutationOptions<ResetOnboardingMutation, ResetOnboardingMutationVariables>;
export const ProviderSignUpDocument = gql`
    mutation ProviderSignUp($input: ProviderSignUpInput!) {
  providerSignUp(input: $input) {
    tokenPayload {
      authToken
      providerUserId
      providerId
      role
      isV2
    }
    meProvider {
      ...meProviderData
    }
    signUpConfig {
      skipIntroCarousel
      hideLoginLink
    }
  }
}
    ${MeProviderDataFragmentDoc}`;
export type ProviderSignUpMutationFn = Apollo.MutationFunction<ProviderSignUpMutation, ProviderSignUpMutationVariables>;

/**
 * __useProviderSignUpMutation__
 *
 * To run a mutation, you first call `useProviderSignUpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderSignUpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerSignUpMutation, { data, loading, error }] = useProviderSignUpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderSignUpMutation(baseOptions?: Apollo.MutationHookOptions<ProviderSignUpMutation, ProviderSignUpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderSignUpMutation, ProviderSignUpMutationVariables>(ProviderSignUpDocument, options);
      }
export type ProviderSignUpMutationHookResult = ReturnType<typeof useProviderSignUpMutation>;
export type ProviderSignUpMutationResult = Apollo.MutationResult<ProviderSignUpMutation>;
export type ProviderSignUpMutationOptions = Apollo.BaseMutationOptions<ProviderSignUpMutation, ProviderSignUpMutationVariables>;
export const ProviderUserInviteSignupDocument = gql`
    mutation ProviderUserInviteSignup($inviteCode: String!, $name: String!, $password: String!) {
  providerUserInviteSignup(
    inviteCode: $inviteCode
    name: $name
    password: $password
  ) {
    tokenPayload {
      authToken
      providerUserId
      providerId
      role
      isV2
    }
    meProvider {
      ...meProviderData
    }
  }
}
    ${MeProviderDataFragmentDoc}`;
export type ProviderUserInviteSignupMutationFn = Apollo.MutationFunction<ProviderUserInviteSignupMutation, ProviderUserInviteSignupMutationVariables>;

/**
 * __useProviderUserInviteSignupMutation__
 *
 * To run a mutation, you first call `useProviderUserInviteSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProviderUserInviteSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [providerUserInviteSignupMutation, { data, loading, error }] = useProviderUserInviteSignupMutation({
 *   variables: {
 *      inviteCode: // value for 'inviteCode'
 *      name: // value for 'name'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useProviderUserInviteSignupMutation(baseOptions?: Apollo.MutationHookOptions<ProviderUserInviteSignupMutation, ProviderUserInviteSignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProviderUserInviteSignupMutation, ProviderUserInviteSignupMutationVariables>(ProviderUserInviteSignupDocument, options);
      }
export type ProviderUserInviteSignupMutationHookResult = ReturnType<typeof useProviderUserInviteSignupMutation>;
export type ProviderUserInviteSignupMutationResult = Apollo.MutationResult<ProviderUserInviteSignupMutation>;
export type ProviderUserInviteSignupMutationOptions = Apollo.BaseMutationOptions<ProviderUserInviteSignupMutation, ProviderUserInviteSignupMutationVariables>;
export const UpdateProviderUserDocument = gql`
    mutation UpdateProviderUser($input: UpdateProviderUserInput!) {
  updateProviderUser(input: $input) {
    ...meProviderData
  }
}
    ${MeProviderDataFragmentDoc}`;
export type UpdateProviderUserMutationFn = Apollo.MutationFunction<UpdateProviderUserMutation, UpdateProviderUserMutationVariables>;

/**
 * __useUpdateProviderUserMutation__
 *
 * To run a mutation, you first call `useUpdateProviderUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderUserMutation, { data, loading, error }] = useUpdateProviderUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderUserMutation, UpdateProviderUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderUserMutation, UpdateProviderUserMutationVariables>(UpdateProviderUserDocument, options);
      }
export type UpdateProviderUserMutationHookResult = ReturnType<typeof useUpdateProviderUserMutation>;
export type UpdateProviderUserMutationResult = Apollo.MutationResult<UpdateProviderUserMutation>;
export type UpdateProviderUserMutationOptions = Apollo.BaseMutationOptions<UpdateProviderUserMutation, UpdateProviderUserMutationVariables>;
export const SendProviderUserInvitesDocument = gql`
    mutation SendProviderUserInvites($providerUserInvites: [ProviderUserInviteInput!]!) {
  sendProviderUserInvites(providerUserInvites: $providerUserInvites)
}
    `;
export type SendProviderUserInvitesMutationFn = Apollo.MutationFunction<SendProviderUserInvitesMutation, SendProviderUserInvitesMutationVariables>;

/**
 * __useSendProviderUserInvitesMutation__
 *
 * To run a mutation, you first call `useSendProviderUserInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendProviderUserInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendProviderUserInvitesMutation, { data, loading, error }] = useSendProviderUserInvitesMutation({
 *   variables: {
 *      providerUserInvites: // value for 'providerUserInvites'
 *   },
 * });
 */
export function useSendProviderUserInvitesMutation(baseOptions?: Apollo.MutationHookOptions<SendProviderUserInvitesMutation, SendProviderUserInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendProviderUserInvitesMutation, SendProviderUserInvitesMutationVariables>(SendProviderUserInvitesDocument, options);
      }
export type SendProviderUserInvitesMutationHookResult = ReturnType<typeof useSendProviderUserInvitesMutation>;
export type SendProviderUserInvitesMutationResult = Apollo.MutationResult<SendProviderUserInvitesMutation>;
export type SendProviderUserInvitesMutationOptions = Apollo.BaseMutationOptions<SendProviderUserInvitesMutation, SendProviderUserInvitesMutationVariables>;
export const ResendProviderUserInviteDocument = gql`
    mutation ResendProviderUserInvite($providerUserId: String!) {
  resendProviderUserInvite(providerUserId: $providerUserId)
}
    `;
export type ResendProviderUserInviteMutationFn = Apollo.MutationFunction<ResendProviderUserInviteMutation, ResendProviderUserInviteMutationVariables>;

/**
 * __useResendProviderUserInviteMutation__
 *
 * To run a mutation, you first call `useResendProviderUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendProviderUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendProviderUserInviteMutation, { data, loading, error }] = useResendProviderUserInviteMutation({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useResendProviderUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendProviderUserInviteMutation, ResendProviderUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendProviderUserInviteMutation, ResendProviderUserInviteMutationVariables>(ResendProviderUserInviteDocument, options);
      }
export type ResendProviderUserInviteMutationHookResult = ReturnType<typeof useResendProviderUserInviteMutation>;
export type ResendProviderUserInviteMutationResult = Apollo.MutationResult<ResendProviderUserInviteMutation>;
export type ResendProviderUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendProviderUserInviteMutation, ResendProviderUserInviteMutationVariables>;
export const DeleteProviderUserInviteDocument = gql`
    mutation DeleteProviderUserInvite($providerUserId: String!) {
  deleteProviderUserInvite(providerUserId: $providerUserId)
}
    `;
export type DeleteProviderUserInviteMutationFn = Apollo.MutationFunction<DeleteProviderUserInviteMutation, DeleteProviderUserInviteMutationVariables>;

/**
 * __useDeleteProviderUserInviteMutation__
 *
 * To run a mutation, you first call `useDeleteProviderUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderUserInviteMutation, { data, loading, error }] = useDeleteProviderUserInviteMutation({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useDeleteProviderUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderUserInviteMutation, DeleteProviderUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderUserInviteMutation, DeleteProviderUserInviteMutationVariables>(DeleteProviderUserInviteDocument, options);
      }
export type DeleteProviderUserInviteMutationHookResult = ReturnType<typeof useDeleteProviderUserInviteMutation>;
export type DeleteProviderUserInviteMutationResult = Apollo.MutationResult<DeleteProviderUserInviteMutation>;
export type DeleteProviderUserInviteMutationOptions = Apollo.BaseMutationOptions<DeleteProviderUserInviteMutation, DeleteProviderUserInviteMutationVariables>;
export const DeactivateProviderUserDocument = gql`
    mutation DeactivateProviderUser($providerUserId: String!) {
  deactivateProviderUser(providerUserId: $providerUserId) {
    ...providerUserMemberData
  }
}
    ${ProviderUserMemberDataFragmentDoc}`;
export type DeactivateProviderUserMutationFn = Apollo.MutationFunction<DeactivateProviderUserMutation, DeactivateProviderUserMutationVariables>;

/**
 * __useDeactivateProviderUserMutation__
 *
 * To run a mutation, you first call `useDeactivateProviderUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateProviderUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateProviderUserMutation, { data, loading, error }] = useDeactivateProviderUserMutation({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useDeactivateProviderUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateProviderUserMutation, DeactivateProviderUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateProviderUserMutation, DeactivateProviderUserMutationVariables>(DeactivateProviderUserDocument, options);
      }
export type DeactivateProviderUserMutationHookResult = ReturnType<typeof useDeactivateProviderUserMutation>;
export type DeactivateProviderUserMutationResult = Apollo.MutationResult<DeactivateProviderUserMutation>;
export type DeactivateProviderUserMutationOptions = Apollo.BaseMutationOptions<DeactivateProviderUserMutation, DeactivateProviderUserMutationVariables>;
export const ReactivateProviderUserDocument = gql`
    mutation ReactivateProviderUser($providerUserId: String!) {
  reactivateProviderUser(providerUserId: $providerUserId) {
    ...providerUserMemberData
  }
}
    ${ProviderUserMemberDataFragmentDoc}`;
export type ReactivateProviderUserMutationFn = Apollo.MutationFunction<ReactivateProviderUserMutation, ReactivateProviderUserMutationVariables>;

/**
 * __useReactivateProviderUserMutation__
 *
 * To run a mutation, you first call `useReactivateProviderUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateProviderUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateProviderUserMutation, { data, loading, error }] = useReactivateProviderUserMutation({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useReactivateProviderUserMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateProviderUserMutation, ReactivateProviderUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateProviderUserMutation, ReactivateProviderUserMutationVariables>(ReactivateProviderUserDocument, options);
      }
export type ReactivateProviderUserMutationHookResult = ReturnType<typeof useReactivateProviderUserMutation>;
export type ReactivateProviderUserMutationResult = Apollo.MutationResult<ReactivateProviderUserMutation>;
export type ReactivateProviderUserMutationOptions = Apollo.BaseMutationOptions<ReactivateProviderUserMutation, ReactivateProviderUserMutationVariables>;
export const UpdateProviderUserRoleDocument = gql`
    mutation UpdateProviderUserRole($providerUserId: String!, $role: ProviderUserRole!, $patientDataPermission: PatientDataPermission!) {
  updateProviderUserRole(
    providerUserId: $providerUserId
    role: $role
    patientDataPermission: $patientDataPermission
  ) {
    ...providerUserMemberData
  }
}
    ${ProviderUserMemberDataFragmentDoc}`;
export type UpdateProviderUserRoleMutationFn = Apollo.MutationFunction<UpdateProviderUserRoleMutation, UpdateProviderUserRoleMutationVariables>;

/**
 * __useUpdateProviderUserRoleMutation__
 *
 * To run a mutation, you first call `useUpdateProviderUserRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderUserRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderUserRoleMutation, { data, loading, error }] = useUpdateProviderUserRoleMutation({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *      role: // value for 'role'
 *      patientDataPermission: // value for 'patientDataPermission'
 *   },
 * });
 */
export function useUpdateProviderUserRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderUserRoleMutation, UpdateProviderUserRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderUserRoleMutation, UpdateProviderUserRoleMutationVariables>(UpdateProviderUserRoleDocument, options);
      }
export type UpdateProviderUserRoleMutationHookResult = ReturnType<typeof useUpdateProviderUserRoleMutation>;
export type UpdateProviderUserRoleMutationResult = Apollo.MutationResult<UpdateProviderUserRoleMutation>;
export type UpdateProviderUserRoleMutationOptions = Apollo.BaseMutationOptions<UpdateProviderUserRoleMutation, UpdateProviderUserRoleMutationVariables>;
export const ProviderUserPatientsDocument = gql`
    query ProviderUserPatients($providerUserId: String!) {
  providerUserPatients(providerUserId: $providerUserId) {
    ...patientNameData
  }
}
    ${PatientNameDataFragmentDoc}`;

/**
 * __useProviderUserPatientsQuery__
 *
 * To run a query within a React component, call `useProviderUserPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserPatientsQuery({
 *   variables: {
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useProviderUserPatientsQuery(baseOptions: Apollo.QueryHookOptions<ProviderUserPatientsQuery, ProviderUserPatientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserPatientsQuery, ProviderUserPatientsQueryVariables>(ProviderUserPatientsDocument, options);
      }
export function useProviderUserPatientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserPatientsQuery, ProviderUserPatientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserPatientsQuery, ProviderUserPatientsQueryVariables>(ProviderUserPatientsDocument, options);
        }
export type ProviderUserPatientsQueryHookResult = ReturnType<typeof useProviderUserPatientsQuery>;
export type ProviderUserPatientsLazyQueryHookResult = ReturnType<typeof useProviderUserPatientsLazyQuery>;
export type ProviderUserPatientsQueryResult = Apollo.QueryResult<ProviderUserPatientsQuery, ProviderUserPatientsQueryVariables>;
export const AddPatientsToProviderUsersDocument = gql`
    mutation AddPatientsToProviderUsers($input: ProviderUsersToPatientsInput!) {
  addPatientsToProviderUsers(input: $input)
}
    `;
export type AddPatientsToProviderUsersMutationFn = Apollo.MutationFunction<AddPatientsToProviderUsersMutation, AddPatientsToProviderUsersMutationVariables>;

/**
 * __useAddPatientsToProviderUsersMutation__
 *
 * To run a mutation, you first call `useAddPatientsToProviderUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPatientsToProviderUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPatientsToProviderUsersMutation, { data, loading, error }] = useAddPatientsToProviderUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPatientsToProviderUsersMutation(baseOptions?: Apollo.MutationHookOptions<AddPatientsToProviderUsersMutation, AddPatientsToProviderUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPatientsToProviderUsersMutation, AddPatientsToProviderUsersMutationVariables>(AddPatientsToProviderUsersDocument, options);
      }
export type AddPatientsToProviderUsersMutationHookResult = ReturnType<typeof useAddPatientsToProviderUsersMutation>;
export type AddPatientsToProviderUsersMutationResult = Apollo.MutationResult<AddPatientsToProviderUsersMutation>;
export type AddPatientsToProviderUsersMutationOptions = Apollo.BaseMutationOptions<AddPatientsToProviderUsersMutation, AddPatientsToProviderUsersMutationVariables>;
export const RemovePatientsFromProviderUsersDocument = gql`
    mutation RemovePatientsFromProviderUsers($input: ProviderUsersToPatientsInput!) {
  removePatientsFromProviderUsers(input: $input)
}
    `;
export type RemovePatientsFromProviderUsersMutationFn = Apollo.MutationFunction<RemovePatientsFromProviderUsersMutation, RemovePatientsFromProviderUsersMutationVariables>;

/**
 * __useRemovePatientsFromProviderUsersMutation__
 *
 * To run a mutation, you first call `useRemovePatientsFromProviderUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePatientsFromProviderUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePatientsFromProviderUsersMutation, { data, loading, error }] = useRemovePatientsFromProviderUsersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemovePatientsFromProviderUsersMutation(baseOptions?: Apollo.MutationHookOptions<RemovePatientsFromProviderUsersMutation, RemovePatientsFromProviderUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePatientsFromProviderUsersMutation, RemovePatientsFromProviderUsersMutationVariables>(RemovePatientsFromProviderUsersDocument, options);
      }
export type RemovePatientsFromProviderUsersMutationHookResult = ReturnType<typeof useRemovePatientsFromProviderUsersMutation>;
export type RemovePatientsFromProviderUsersMutationResult = Apollo.MutationResult<RemovePatientsFromProviderUsersMutation>;
export type RemovePatientsFromProviderUsersMutationOptions = Apollo.BaseMutationOptions<RemovePatientsFromProviderUsersMutation, RemovePatientsFromProviderUsersMutationVariables>;
export const SearchProviderUsersDocument = gql`
    query SearchProviderUsers($input: SearchProviderUsersInput) {
  searchProviderUsers(input: $input) {
    providerUsers {
      ...basicProviderUserData
    }
    totalCount
    page
    pageSize
    totalPages
  }
}
    ${BasicProviderUserDataFragmentDoc}`;

/**
 * __useSearchProviderUsersQuery__
 *
 * To run a query within a React component, call `useSearchProviderUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProviderUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProviderUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchProviderUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchProviderUsersQuery, SearchProviderUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProviderUsersQuery, SearchProviderUsersQueryVariables>(SearchProviderUsersDocument, options);
      }
export function useSearchProviderUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProviderUsersQuery, SearchProviderUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProviderUsersQuery, SearchProviderUsersQueryVariables>(SearchProviderUsersDocument, options);
        }
export type SearchProviderUsersQueryHookResult = ReturnType<typeof useSearchProviderUsersQuery>;
export type SearchProviderUsersLazyQueryHookResult = ReturnType<typeof useSearchProviderUsersLazyQuery>;
export type SearchProviderUsersQueryResult = Apollo.QueryResult<SearchProviderUsersQuery, SearchProviderUsersQueryVariables>;
export const GetProviderApiCredentialsDocument = gql`
    query GetProviderApiCredentials {
  providersApiCredentials {
    ...providerApiCredentialData
  }
}
    ${ProviderApiCredentialDataFragmentDoc}`;

/**
 * __useGetProviderApiCredentialsQuery__
 *
 * To run a query within a React component, call `useGetProviderApiCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderApiCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderApiCredentialsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderApiCredentialsQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderApiCredentialsQuery, GetProviderApiCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderApiCredentialsQuery, GetProviderApiCredentialsQueryVariables>(GetProviderApiCredentialsDocument, options);
      }
export function useGetProviderApiCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderApiCredentialsQuery, GetProviderApiCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderApiCredentialsQuery, GetProviderApiCredentialsQueryVariables>(GetProviderApiCredentialsDocument, options);
        }
export type GetProviderApiCredentialsQueryHookResult = ReturnType<typeof useGetProviderApiCredentialsQuery>;
export type GetProviderApiCredentialsLazyQueryHookResult = ReturnType<typeof useGetProviderApiCredentialsLazyQuery>;
export type GetProviderApiCredentialsQueryResult = Apollo.QueryResult<GetProviderApiCredentialsQuery, GetProviderApiCredentialsQueryVariables>;
export const CreateApiCredentialDocument = gql`
    mutation CreateApiCredential($input: ProvidersCreateApiCredentialInput!) {
  providersCreateApiCredential(input: $input) {
    success
    error
    apiCredential {
      ...providerApiCredentialData
      secret
    }
  }
}
    ${ProviderApiCredentialDataFragmentDoc}`;
export type CreateApiCredentialMutationFn = Apollo.MutationFunction<CreateApiCredentialMutation, CreateApiCredentialMutationVariables>;

/**
 * __useCreateApiCredentialMutation__
 *
 * To run a mutation, you first call `useCreateApiCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiCredentialMutation, { data, loading, error }] = useCreateApiCredentialMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApiCredentialMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiCredentialMutation, CreateApiCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiCredentialMutation, CreateApiCredentialMutationVariables>(CreateApiCredentialDocument, options);
      }
export type CreateApiCredentialMutationHookResult = ReturnType<typeof useCreateApiCredentialMutation>;
export type CreateApiCredentialMutationResult = Apollo.MutationResult<CreateApiCredentialMutation>;
export type CreateApiCredentialMutationOptions = Apollo.BaseMutationOptions<CreateApiCredentialMutation, CreateApiCredentialMutationVariables>;
export const DeactivateApiCredentialDocument = gql`
    mutation DeactivateApiCredential($apiClientId: String!) {
  providersDeactivateApiCredential(apiClientId: $apiClientId) {
    success
    error
  }
}
    `;
export type DeactivateApiCredentialMutationFn = Apollo.MutationFunction<DeactivateApiCredentialMutation, DeactivateApiCredentialMutationVariables>;

/**
 * __useDeactivateApiCredentialMutation__
 *
 * To run a mutation, you first call `useDeactivateApiCredentialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateApiCredentialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateApiCredentialMutation, { data, loading, error }] = useDeactivateApiCredentialMutation({
 *   variables: {
 *      apiClientId: // value for 'apiClientId'
 *   },
 * });
 */
export function useDeactivateApiCredentialMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateApiCredentialMutation, DeactivateApiCredentialMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateApiCredentialMutation, DeactivateApiCredentialMutationVariables>(DeactivateApiCredentialDocument, options);
      }
export type DeactivateApiCredentialMutationHookResult = ReturnType<typeof useDeactivateApiCredentialMutation>;
export type DeactivateApiCredentialMutationResult = Apollo.MutationResult<DeactivateApiCredentialMutation>;
export type DeactivateApiCredentialMutationOptions = Apollo.BaseMutationOptions<DeactivateApiCredentialMutation, DeactivateApiCredentialMutationVariables>;
export const UpcomingScheduledEventsDocument = gql`
    query UpcomingScheduledEvents($input: ScheduledEventsInput!) {
  scheduledEvents(input: $input) {
    ...UpcomingScheduledEvent
  }
}
    ${UpcomingScheduledEventFragmentDoc}`;

/**
 * __useUpcomingScheduledEventsQuery__
 *
 * To run a query within a React component, call `useUpcomingScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingScheduledEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingScheduledEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpcomingScheduledEventsQuery(baseOptions: Apollo.QueryHookOptions<UpcomingScheduledEventsQuery, UpcomingScheduledEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingScheduledEventsQuery, UpcomingScheduledEventsQueryVariables>(UpcomingScheduledEventsDocument, options);
      }
export function useUpcomingScheduledEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingScheduledEventsQuery, UpcomingScheduledEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingScheduledEventsQuery, UpcomingScheduledEventsQueryVariables>(UpcomingScheduledEventsDocument, options);
        }
export type UpcomingScheduledEventsQueryHookResult = ReturnType<typeof useUpcomingScheduledEventsQuery>;
export type UpcomingScheduledEventsLazyQueryHookResult = ReturnType<typeof useUpcomingScheduledEventsLazyQuery>;
export type UpcomingScheduledEventsQueryResult = Apollo.QueryResult<UpcomingScheduledEventsQuery, UpcomingScheduledEventsQueryVariables>;
export const PatientScheduledEventsDocument = gql`
    query PatientScheduledEvents($input: ScheduledEventsInput!) {
  scheduledEvents(input: $input) {
    ...PatientScheduledEvent
  }
}
    ${PatientScheduledEventFragmentDoc}`;

/**
 * __usePatientScheduledEventsQuery__
 *
 * To run a query within a React component, call `usePatientScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientScheduledEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientScheduledEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePatientScheduledEventsQuery(baseOptions: Apollo.QueryHookOptions<PatientScheduledEventsQuery, PatientScheduledEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientScheduledEventsQuery, PatientScheduledEventsQueryVariables>(PatientScheduledEventsDocument, options);
      }
export function usePatientScheduledEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientScheduledEventsQuery, PatientScheduledEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientScheduledEventsQuery, PatientScheduledEventsQueryVariables>(PatientScheduledEventsDocument, options);
        }
export type PatientScheduledEventsQueryHookResult = ReturnType<typeof usePatientScheduledEventsQuery>;
export type PatientScheduledEventsLazyQueryHookResult = ReturnType<typeof usePatientScheduledEventsLazyQuery>;
export type PatientScheduledEventsQueryResult = Apollo.QueryResult<PatientScheduledEventsQuery, PatientScheduledEventsQueryVariables>;
export const CalendarScheduledEventsDocument = gql`
    query CalendarScheduledEvents($input: ScheduledEventsInput!) {
  scheduledEvents(input: $input) {
    ...CalendarScheduledEvent
  }
}
    ${CalendarScheduledEventFragmentDoc}`;

/**
 * __useCalendarScheduledEventsQuery__
 *
 * To run a query within a React component, call `useCalendarScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarScheduledEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarScheduledEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarScheduledEventsQuery(baseOptions: Apollo.QueryHookOptions<CalendarScheduledEventsQuery, CalendarScheduledEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarScheduledEventsQuery, CalendarScheduledEventsQueryVariables>(CalendarScheduledEventsDocument, options);
      }
export function useCalendarScheduledEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarScheduledEventsQuery, CalendarScheduledEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarScheduledEventsQuery, CalendarScheduledEventsQueryVariables>(CalendarScheduledEventsDocument, options);
        }
export type CalendarScheduledEventsQueryHookResult = ReturnType<typeof useCalendarScheduledEventsQuery>;
export type CalendarScheduledEventsLazyQueryHookResult = ReturnType<typeof useCalendarScheduledEventsLazyQuery>;
export type CalendarScheduledEventsQueryResult = Apollo.QueryResult<CalendarScheduledEventsQuery, CalendarScheduledEventsQueryVariables>;
export const ScheduledEventsDocument = gql`
    query ScheduledEvents($input: ScheduledEventsInput!) {
  scheduledEvents(input: $input) {
    ...BasicScheduledEvent
  }
}
    ${BasicScheduledEventFragmentDoc}`;

/**
 * __useScheduledEventsQuery__
 *
 * To run a query within a React component, call `useScheduledEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduledEventsQuery(baseOptions: Apollo.QueryHookOptions<ScheduledEventsQuery, ScheduledEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledEventsQuery, ScheduledEventsQueryVariables>(ScheduledEventsDocument, options);
      }
export function useScheduledEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledEventsQuery, ScheduledEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledEventsQuery, ScheduledEventsQueryVariables>(ScheduledEventsDocument, options);
        }
export type ScheduledEventsQueryHookResult = ReturnType<typeof useScheduledEventsQuery>;
export type ScheduledEventsLazyQueryHookResult = ReturnType<typeof useScheduledEventsLazyQuery>;
export type ScheduledEventsQueryResult = Apollo.QueryResult<ScheduledEventsQuery, ScheduledEventsQueryVariables>;
export const ScheduledEventDocument = gql`
    query ScheduledEvent($calendlyEventUri: String!) {
  scheduledEvent(calendlyEventUri: $calendlyEventUri) {
    ...CompleteScheduledEvent
  }
}
    ${CompleteScheduledEventFragmentDoc}`;

/**
 * __useScheduledEventQuery__
 *
 * To run a query within a React component, call `useScheduledEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduledEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduledEventQuery({
 *   variables: {
 *      calendlyEventUri: // value for 'calendlyEventUri'
 *   },
 * });
 */
export function useScheduledEventQuery(baseOptions: Apollo.QueryHookOptions<ScheduledEventQuery, ScheduledEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduledEventQuery, ScheduledEventQueryVariables>(ScheduledEventDocument, options);
      }
export function useScheduledEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduledEventQuery, ScheduledEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduledEventQuery, ScheduledEventQueryVariables>(ScheduledEventDocument, options);
        }
export type ScheduledEventQueryHookResult = ReturnType<typeof useScheduledEventQuery>;
export type ScheduledEventLazyQueryHookResult = ReturnType<typeof useScheduledEventLazyQuery>;
export type ScheduledEventQueryResult = Apollo.QueryResult<ScheduledEventQuery, ScheduledEventQueryVariables>;
export const CalendlySchedulingUrlDocument = gql`
    query CalendlySchedulingUrl {
  calendlySchedulingUrl
}
    `;

/**
 * __useCalendlySchedulingUrlQuery__
 *
 * To run a query within a React component, call `useCalendlySchedulingUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlySchedulingUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlySchedulingUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlySchedulingUrlQuery(baseOptions?: Apollo.QueryHookOptions<CalendlySchedulingUrlQuery, CalendlySchedulingUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlySchedulingUrlQuery, CalendlySchedulingUrlQueryVariables>(CalendlySchedulingUrlDocument, options);
      }
export function useCalendlySchedulingUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlySchedulingUrlQuery, CalendlySchedulingUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlySchedulingUrlQuery, CalendlySchedulingUrlQueryVariables>(CalendlySchedulingUrlDocument, options);
        }
export type CalendlySchedulingUrlQueryHookResult = ReturnType<typeof useCalendlySchedulingUrlQuery>;
export type CalendlySchedulingUrlLazyQueryHookResult = ReturnType<typeof useCalendlySchedulingUrlLazyQuery>;
export type CalendlySchedulingUrlQueryResult = Apollo.QueryResult<CalendlySchedulingUrlQuery, CalendlySchedulingUrlQueryVariables>;
export const CalendlyEventTypesDocument = gql`
    query CalendlyEventTypes {
  calendlyEventTypes {
    ...CalendlyEventData
  }
}
    ${CalendlyEventDataFragmentDoc}`;

/**
 * __useCalendlyEventTypesQuery__
 *
 * To run a query within a React component, call `useCalendlyEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlyEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<CalendlyEventTypesQuery, CalendlyEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyEventTypesQuery, CalendlyEventTypesQueryVariables>(CalendlyEventTypesDocument, options);
      }
export function useCalendlyEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyEventTypesQuery, CalendlyEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyEventTypesQuery, CalendlyEventTypesQueryVariables>(CalendlyEventTypesDocument, options);
        }
export type CalendlyEventTypesQueryHookResult = ReturnType<typeof useCalendlyEventTypesQuery>;
export type CalendlyEventTypesLazyQueryHookResult = ReturnType<typeof useCalendlyEventTypesLazyQuery>;
export type CalendlyEventTypesQueryResult = Apollo.QueryResult<CalendlyEventTypesQuery, CalendlyEventTypesQueryVariables>;
export const CalendlyImportStatusDocument = gql`
    query CalendlyImportStatus {
  calendlyImportStatus
}
    `;

/**
 * __useCalendlyImportStatusQuery__
 *
 * To run a query within a React component, call `useCalendlyImportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyImportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyImportStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlyImportStatusQuery(baseOptions?: Apollo.QueryHookOptions<CalendlyImportStatusQuery, CalendlyImportStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyImportStatusQuery, CalendlyImportStatusQueryVariables>(CalendlyImportStatusDocument, options);
      }
export function useCalendlyImportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyImportStatusQuery, CalendlyImportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyImportStatusQuery, CalendlyImportStatusQueryVariables>(CalendlyImportStatusDocument, options);
        }
export type CalendlyImportStatusQueryHookResult = ReturnType<typeof useCalendlyImportStatusQuery>;
export type CalendlyImportStatusLazyQueryHookResult = ReturnType<typeof useCalendlyImportStatusLazyQuery>;
export type CalendlyImportStatusQueryResult = Apollo.QueryResult<CalendlyImportStatusQuery, CalendlyImportStatusQueryVariables>;
export const ChangeCalendlyEventTypeVisibilityDocument = gql`
    mutation ChangeCalendlyEventTypeVisibility($calendlyEventTypeUri: String!, $shouldBeVisible: Boolean!) {
  changeCalendlyEventTypeVisibility(
    calendlyEventTypeUri: $calendlyEventTypeUri
    shouldBeVisible: $shouldBeVisible
  )
}
    `;
export type ChangeCalendlyEventTypeVisibilityMutationFn = Apollo.MutationFunction<ChangeCalendlyEventTypeVisibilityMutation, ChangeCalendlyEventTypeVisibilityMutationVariables>;

/**
 * __useChangeCalendlyEventTypeVisibilityMutation__
 *
 * To run a mutation, you first call `useChangeCalendlyEventTypeVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCalendlyEventTypeVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCalendlyEventTypeVisibilityMutation, { data, loading, error }] = useChangeCalendlyEventTypeVisibilityMutation({
 *   variables: {
 *      calendlyEventTypeUri: // value for 'calendlyEventTypeUri'
 *      shouldBeVisible: // value for 'shouldBeVisible'
 *   },
 * });
 */
export function useChangeCalendlyEventTypeVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCalendlyEventTypeVisibilityMutation, ChangeCalendlyEventTypeVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCalendlyEventTypeVisibilityMutation, ChangeCalendlyEventTypeVisibilityMutationVariables>(ChangeCalendlyEventTypeVisibilityDocument, options);
      }
export type ChangeCalendlyEventTypeVisibilityMutationHookResult = ReturnType<typeof useChangeCalendlyEventTypeVisibilityMutation>;
export type ChangeCalendlyEventTypeVisibilityMutationResult = Apollo.MutationResult<ChangeCalendlyEventTypeVisibilityMutation>;
export type ChangeCalendlyEventTypeVisibilityMutationOptions = Apollo.BaseMutationOptions<ChangeCalendlyEventTypeVisibilityMutation, ChangeCalendlyEventTypeVisibilityMutationVariables>;
export const CancelCalendlyEventDocument = gql`
    mutation CancelCalendlyEvent($calendlyEventUri: String!, $reasonForCancellation: String) {
  cancelCalendlyEvent(
    calendlyEventUri: $calendlyEventUri
    reasonForCancellation: $reasonForCancellation
  )
}
    `;
export type CancelCalendlyEventMutationFn = Apollo.MutationFunction<CancelCalendlyEventMutation, CancelCalendlyEventMutationVariables>;

/**
 * __useCancelCalendlyEventMutation__
 *
 * To run a mutation, you first call `useCancelCalendlyEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelCalendlyEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelCalendlyEventMutation, { data, loading, error }] = useCancelCalendlyEventMutation({
 *   variables: {
 *      calendlyEventUri: // value for 'calendlyEventUri'
 *      reasonForCancellation: // value for 'reasonForCancellation'
 *   },
 * });
 */
export function useCancelCalendlyEventMutation(baseOptions?: Apollo.MutationHookOptions<CancelCalendlyEventMutation, CancelCalendlyEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelCalendlyEventMutation, CancelCalendlyEventMutationVariables>(CancelCalendlyEventDocument, options);
      }
export type CancelCalendlyEventMutationHookResult = ReturnType<typeof useCancelCalendlyEventMutation>;
export type CancelCalendlyEventMutationResult = Apollo.MutationResult<CancelCalendlyEventMutation>;
export type CancelCalendlyEventMutationOptions = Apollo.BaseMutationOptions<CancelCalendlyEventMutation, CancelCalendlyEventMutationVariables>;
export const ImportCalendlyDataDocument = gql`
    mutation ImportCalendlyData {
  importCalendlyData
}
    `;
export type ImportCalendlyDataMutationFn = Apollo.MutationFunction<ImportCalendlyDataMutation, ImportCalendlyDataMutationVariables>;

/**
 * __useImportCalendlyDataMutation__
 *
 * To run a mutation, you first call `useImportCalendlyDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCalendlyDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCalendlyDataMutation, { data, loading, error }] = useImportCalendlyDataMutation({
 *   variables: {
 *   },
 * });
 */
export function useImportCalendlyDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportCalendlyDataMutation, ImportCalendlyDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCalendlyDataMutation, ImportCalendlyDataMutationVariables>(ImportCalendlyDataDocument, options);
      }
export type ImportCalendlyDataMutationHookResult = ReturnType<typeof useImportCalendlyDataMutation>;
export type ImportCalendlyDataMutationResult = Apollo.MutationResult<ImportCalendlyDataMutation>;
export type ImportCalendlyDataMutationOptions = Apollo.BaseMutationOptions<ImportCalendlyDataMutation, ImportCalendlyDataMutationVariables>;
export const LinkInviteeEmailToProgramDocument = gql`
    mutation LinkInviteeEmailToProgram($inviteeEmail: String!, $programId: String!) {
  linkInviteeEmailToProgram(inviteeEmail: $inviteeEmail, programId: $programId)
}
    `;
export type LinkInviteeEmailToProgramMutationFn = Apollo.MutationFunction<LinkInviteeEmailToProgramMutation, LinkInviteeEmailToProgramMutationVariables>;

/**
 * __useLinkInviteeEmailToProgramMutation__
 *
 * To run a mutation, you first call `useLinkInviteeEmailToProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkInviteeEmailToProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkInviteeEmailToProgramMutation, { data, loading, error }] = useLinkInviteeEmailToProgramMutation({
 *   variables: {
 *      inviteeEmail: // value for 'inviteeEmail'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useLinkInviteeEmailToProgramMutation(baseOptions?: Apollo.MutationHookOptions<LinkInviteeEmailToProgramMutation, LinkInviteeEmailToProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkInviteeEmailToProgramMutation, LinkInviteeEmailToProgramMutationVariables>(LinkInviteeEmailToProgramDocument, options);
      }
export type LinkInviteeEmailToProgramMutationHookResult = ReturnType<typeof useLinkInviteeEmailToProgramMutation>;
export type LinkInviteeEmailToProgramMutationResult = Apollo.MutationResult<LinkInviteeEmailToProgramMutation>;
export type LinkInviteeEmailToProgramMutationOptions = Apollo.BaseMutationOptions<LinkInviteeEmailToProgramMutation, LinkInviteeEmailToProgramMutationVariables>;
export const UnlinkInviteeEmailFromProgramDocument = gql`
    mutation UnlinkInviteeEmailFromProgram($inviteeEmail: String!, $programId: String!) {
  unlinkInviteeEmailFromProgram(
    inviteeEmail: $inviteeEmail
    programId: $programId
  )
}
    `;
export type UnlinkInviteeEmailFromProgramMutationFn = Apollo.MutationFunction<UnlinkInviteeEmailFromProgramMutation, UnlinkInviteeEmailFromProgramMutationVariables>;

/**
 * __useUnlinkInviteeEmailFromProgramMutation__
 *
 * To run a mutation, you first call `useUnlinkInviteeEmailFromProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkInviteeEmailFromProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkInviteeEmailFromProgramMutation, { data, loading, error }] = useUnlinkInviteeEmailFromProgramMutation({
 *   variables: {
 *      inviteeEmail: // value for 'inviteeEmail'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useUnlinkInviteeEmailFromProgramMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkInviteeEmailFromProgramMutation, UnlinkInviteeEmailFromProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkInviteeEmailFromProgramMutation, UnlinkInviteeEmailFromProgramMutationVariables>(UnlinkInviteeEmailFromProgramDocument, options);
      }
export type UnlinkInviteeEmailFromProgramMutationHookResult = ReturnType<typeof useUnlinkInviteeEmailFromProgramMutation>;
export type UnlinkInviteeEmailFromProgramMutationResult = Apollo.MutationResult<UnlinkInviteeEmailFromProgramMutation>;
export type UnlinkInviteeEmailFromProgramMutationOptions = Apollo.BaseMutationOptions<UnlinkInviteeEmailFromProgramMutation, UnlinkInviteeEmailFromProgramMutationVariables>;
export const UninvitedEventInviteesDocument = gql`
    query UninvitedEventInvitees {
  uninvitedEventInvitees {
    email
    firstName
    lastName
  }
}
    `;

/**
 * __useUninvitedEventInviteesQuery__
 *
 * To run a query within a React component, call `useUninvitedEventInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUninvitedEventInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUninvitedEventInviteesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUninvitedEventInviteesQuery(baseOptions?: Apollo.QueryHookOptions<UninvitedEventInviteesQuery, UninvitedEventInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UninvitedEventInviteesQuery, UninvitedEventInviteesQueryVariables>(UninvitedEventInviteesDocument, options);
      }
export function useUninvitedEventInviteesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UninvitedEventInviteesQuery, UninvitedEventInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UninvitedEventInviteesQuery, UninvitedEventInviteesQueryVariables>(UninvitedEventInviteesDocument, options);
        }
export type UninvitedEventInviteesQueryHookResult = ReturnType<typeof useUninvitedEventInviteesQuery>;
export type UninvitedEventInviteesLazyQueryHookResult = ReturnType<typeof useUninvitedEventInviteesLazyQuery>;
export type UninvitedEventInviteesQueryResult = Apollo.QueryResult<UninvitedEventInviteesQuery, UninvitedEventInviteesQueryVariables>;
export const CalendlyPractitionerEventTypesDocument = gql`
    query CalendlyPractitionerEventTypes {
  calendlyPractitionerEventTypes {
    practitioner {
      id
      name
      profileImageUrl
      role
    }
    eventTypes {
      name
      color
      calendlyEventTypeUri
      isVisible
      description
      duration
      schedulingUrl
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useCalendlyPractitionerEventTypesQuery__
 *
 * To run a query within a React component, call `useCalendlyPractitionerEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyPractitionerEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyPractitionerEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlyPractitionerEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<CalendlyPractitionerEventTypesQuery, CalendlyPractitionerEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyPractitionerEventTypesQuery, CalendlyPractitionerEventTypesQueryVariables>(CalendlyPractitionerEventTypesDocument, options);
      }
export function useCalendlyPractitionerEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyPractitionerEventTypesQuery, CalendlyPractitionerEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyPractitionerEventTypesQuery, CalendlyPractitionerEventTypesQueryVariables>(CalendlyPractitionerEventTypesDocument, options);
        }
export type CalendlyPractitionerEventTypesQueryHookResult = ReturnType<typeof useCalendlyPractitionerEventTypesQuery>;
export type CalendlyPractitionerEventTypesLazyQueryHookResult = ReturnType<typeof useCalendlyPractitionerEventTypesLazyQuery>;
export type CalendlyPractitionerEventTypesQueryResult = Apollo.QueryResult<CalendlyPractitionerEventTypesQuery, CalendlyPractitionerEventTypesQueryVariables>;
export const CalendlyProviderEventTypesDocument = gql`
    query CalendlyProviderEventTypes {
  calendlyProviderEventTypes {
    name
    ownerUri
    eventTypes {
      name
      color
      calendlyEventTypeUri
      isVisible
      description
      duration
      schedulingUrl
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useCalendlyProviderEventTypesQuery__
 *
 * To run a query within a React component, call `useCalendlyProviderEventTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendlyProviderEventTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendlyProviderEventTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendlyProviderEventTypesQuery(baseOptions?: Apollo.QueryHookOptions<CalendlyProviderEventTypesQuery, CalendlyProviderEventTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendlyProviderEventTypesQuery, CalendlyProviderEventTypesQueryVariables>(CalendlyProviderEventTypesDocument, options);
      }
export function useCalendlyProviderEventTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendlyProviderEventTypesQuery, CalendlyProviderEventTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendlyProviderEventTypesQuery, CalendlyProviderEventTypesQueryVariables>(CalendlyProviderEventTypesDocument, options);
        }
export type CalendlyProviderEventTypesQueryHookResult = ReturnType<typeof useCalendlyProviderEventTypesQuery>;
export type CalendlyProviderEventTypesLazyQueryHookResult = ReturnType<typeof useCalendlyProviderEventTypesLazyQuery>;
export type CalendlyProviderEventTypesQueryResult = Apollo.QueryResult<CalendlyProviderEventTypesQuery, CalendlyProviderEventTypesQueryVariables>;
export const ServiceGroupsDocument = gql`
    query ServiceGroups {
  serviceGroups {
    ...serviceGroupData
  }
}
    ${ServiceGroupDataFragmentDoc}`;

/**
 * __useServiceGroupsQuery__
 *
 * To run a query within a React component, call `useServiceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceGroupsQuery, ServiceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceGroupsQuery, ServiceGroupsQueryVariables>(ServiceGroupsDocument, options);
      }
export function useServiceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceGroupsQuery, ServiceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceGroupsQuery, ServiceGroupsQueryVariables>(ServiceGroupsDocument, options);
        }
export type ServiceGroupsQueryHookResult = ReturnType<typeof useServiceGroupsQuery>;
export type ServiceGroupsLazyQueryHookResult = ReturnType<typeof useServiceGroupsLazyQuery>;
export type ServiceGroupsQueryResult = Apollo.QueryResult<ServiceGroupsQuery, ServiceGroupsQueryVariables>;
export const CreateServiceGroupDocument = gql`
    mutation CreateServiceGroup($input: CreateServiceGroupInput!) {
  createServiceGroup(input: $input) {
    ...serviceGroupData
  }
}
    ${ServiceGroupDataFragmentDoc}`;
export type CreateServiceGroupMutationFn = Apollo.MutationFunction<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>;

/**
 * __useCreateServiceGroupMutation__
 *
 * To run a mutation, you first call `useCreateServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceGroupMutation, { data, loading, error }] = useCreateServiceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>(CreateServiceGroupDocument, options);
      }
export type CreateServiceGroupMutationHookResult = ReturnType<typeof useCreateServiceGroupMutation>;
export type CreateServiceGroupMutationResult = Apollo.MutationResult<CreateServiceGroupMutation>;
export type CreateServiceGroupMutationOptions = Apollo.BaseMutationOptions<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>;
export const UpdateServiceGroupDocument = gql`
    mutation UpdateServiceGroup($input: UpdateServiceGroupInput!) {
  updateServiceGroup(input: $input) {
    ...serviceGroupData
  }
}
    ${ServiceGroupDataFragmentDoc}`;
export type UpdateServiceGroupMutationFn = Apollo.MutationFunction<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>;

/**
 * __useUpdateServiceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceGroupMutation, { data, loading, error }] = useUpdateServiceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>(UpdateServiceGroupDocument, options);
      }
export type UpdateServiceGroupMutationHookResult = ReturnType<typeof useUpdateServiceGroupMutation>;
export type UpdateServiceGroupMutationResult = Apollo.MutationResult<UpdateServiceGroupMutation>;
export type UpdateServiceGroupMutationOptions = Apollo.BaseMutationOptions<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>;
export const DeleteServiceGroupDocument = gql`
    mutation DeleteServiceGroup($serviceGroupId: String!) {
  deleteServiceGroup(serviceGroupId: $serviceGroupId)
}
    `;
export type DeleteServiceGroupMutationFn = Apollo.MutationFunction<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>;

/**
 * __useDeleteServiceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceGroupMutation, { data, loading, error }] = useDeleteServiceGroupMutation({
 *   variables: {
 *      serviceGroupId: // value for 'serviceGroupId'
 *   },
 * });
 */
export function useDeleteServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>(DeleteServiceGroupDocument, options);
      }
export type DeleteServiceGroupMutationHookResult = ReturnType<typeof useDeleteServiceGroupMutation>;
export type DeleteServiceGroupMutationResult = Apollo.MutationResult<DeleteServiceGroupMutation>;
export type DeleteServiceGroupMutationOptions = Apollo.BaseMutationOptions<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>;
export const ReorderServicesDocument = gql`
    mutation ReorderServices($input: [ReorderServicesInput!]!) {
  reorderServices(input: $input)
}
    `;
export type ReorderServicesMutationFn = Apollo.MutationFunction<ReorderServicesMutation, ReorderServicesMutationVariables>;

/**
 * __useReorderServicesMutation__
 *
 * To run a mutation, you first call `useReorderServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderServicesMutation, { data, loading, error }] = useReorderServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderServicesMutation(baseOptions?: Apollo.MutationHookOptions<ReorderServicesMutation, ReorderServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderServicesMutation, ReorderServicesMutationVariables>(ReorderServicesDocument, options);
      }
export type ReorderServicesMutationHookResult = ReturnType<typeof useReorderServicesMutation>;
export type ReorderServicesMutationResult = Apollo.MutationResult<ReorderServicesMutation>;
export type ReorderServicesMutationOptions = Apollo.BaseMutationOptions<ReorderServicesMutation, ReorderServicesMutationVariables>;
export const ReorderServiceGroupsDocument = gql`
    mutation ReorderServiceGroups($input: [ReorderServiceGroupsInput!]!) {
  reorderServiceGroups(input: $input)
}
    `;
export type ReorderServiceGroupsMutationFn = Apollo.MutationFunction<ReorderServiceGroupsMutation, ReorderServiceGroupsMutationVariables>;

/**
 * __useReorderServiceGroupsMutation__
 *
 * To run a mutation, you first call `useReorderServiceGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderServiceGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderServiceGroupsMutation, { data, loading, error }] = useReorderServiceGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderServiceGroupsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderServiceGroupsMutation, ReorderServiceGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderServiceGroupsMutation, ReorderServiceGroupsMutationVariables>(ReorderServiceGroupsDocument, options);
      }
export type ReorderServiceGroupsMutationHookResult = ReturnType<typeof useReorderServiceGroupsMutation>;
export type ReorderServiceGroupsMutationResult = Apollo.MutationResult<ReorderServiceGroupsMutation>;
export type ReorderServiceGroupsMutationOptions = Apollo.BaseMutationOptions<ReorderServiceGroupsMutation, ReorderServiceGroupsMutationVariables>;
export const ServiceIntakePackageDocument = gql`
    query ServiceIntakePackage($serviceIntakePackageId: String!) {
  serviceIntakePackage(serviceIntakePackageId: $serviceIntakePackageId) {
    id
    storefrontSlug
    serviceSlug
    serviceSubmissionRedirectUrl
    intakeFormProgramActivity {
      ...programActivityData
    }
    calendlyEventType {
      name
      description
      calendlyEventTypeUri
      schedulingUrl
    }
    completedCalendlyBookingAt
  }
}
    ${ProgramActivityDataFragmentDoc}`;

/**
 * __useServiceIntakePackageQuery__
 *
 * To run a query within a React component, call `useServiceIntakePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceIntakePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceIntakePackageQuery({
 *   variables: {
 *      serviceIntakePackageId: // value for 'serviceIntakePackageId'
 *   },
 * });
 */
export function useServiceIntakePackageQuery(baseOptions: Apollo.QueryHookOptions<ServiceIntakePackageQuery, ServiceIntakePackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceIntakePackageQuery, ServiceIntakePackageQueryVariables>(ServiceIntakePackageDocument, options);
      }
export function useServiceIntakePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceIntakePackageQuery, ServiceIntakePackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceIntakePackageQuery, ServiceIntakePackageQueryVariables>(ServiceIntakePackageDocument, options);
        }
export type ServiceIntakePackageQueryHookResult = ReturnType<typeof useServiceIntakePackageQuery>;
export type ServiceIntakePackageLazyQueryHookResult = ReturnType<typeof useServiceIntakePackageLazyQuery>;
export type ServiceIntakePackageQueryResult = Apollo.QueryResult<ServiceIntakePackageQuery, ServiceIntakePackageQueryVariables>;
export const CompleteServiceCalendlyBookingDocument = gql`
    mutation CompleteServiceCalendlyBooking($serviceIntakePackageId: String!) {
  completeServiceCalendlyBooking(serviceIntakePackageId: $serviceIntakePackageId)
}
    `;
export type CompleteServiceCalendlyBookingMutationFn = Apollo.MutationFunction<CompleteServiceCalendlyBookingMutation, CompleteServiceCalendlyBookingMutationVariables>;

/**
 * __useCompleteServiceCalendlyBookingMutation__
 *
 * To run a mutation, you first call `useCompleteServiceCalendlyBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteServiceCalendlyBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeServiceCalendlyBookingMutation, { data, loading, error }] = useCompleteServiceCalendlyBookingMutation({
 *   variables: {
 *      serviceIntakePackageId: // value for 'serviceIntakePackageId'
 *   },
 * });
 */
export function useCompleteServiceCalendlyBookingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteServiceCalendlyBookingMutation, CompleteServiceCalendlyBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteServiceCalendlyBookingMutation, CompleteServiceCalendlyBookingMutationVariables>(CompleteServiceCalendlyBookingDocument, options);
      }
export type CompleteServiceCalendlyBookingMutationHookResult = ReturnType<typeof useCompleteServiceCalendlyBookingMutation>;
export type CompleteServiceCalendlyBookingMutationResult = Apollo.MutationResult<CompleteServiceCalendlyBookingMutation>;
export type CompleteServiceCalendlyBookingMutationOptions = Apollo.BaseMutationOptions<CompleteServiceCalendlyBookingMutation, CompleteServiceCalendlyBookingMutationVariables>;
export const CompleteServiceIntakeDocument = gql`
    mutation CompleteServiceIntake($serviceIntakePackageId: String!) {
  completeServiceIntake(serviceIntakePackageId: $serviceIntakePackageId)
}
    `;
export type CompleteServiceIntakeMutationFn = Apollo.MutationFunction<CompleteServiceIntakeMutation, CompleteServiceIntakeMutationVariables>;

/**
 * __useCompleteServiceIntakeMutation__
 *
 * To run a mutation, you first call `useCompleteServiceIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteServiceIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeServiceIntakeMutation, { data, loading, error }] = useCompleteServiceIntakeMutation({
 *   variables: {
 *      serviceIntakePackageId: // value for 'serviceIntakePackageId'
 *   },
 * });
 */
export function useCompleteServiceIntakeMutation(baseOptions?: Apollo.MutationHookOptions<CompleteServiceIntakeMutation, CompleteServiceIntakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteServiceIntakeMutation, CompleteServiceIntakeMutationVariables>(CompleteServiceIntakeDocument, options);
      }
export type CompleteServiceIntakeMutationHookResult = ReturnType<typeof useCompleteServiceIntakeMutation>;
export type CompleteServiceIntakeMutationResult = Apollo.MutationResult<CompleteServiceIntakeMutation>;
export type CompleteServiceIntakeMutationOptions = Apollo.BaseMutationOptions<CompleteServiceIntakeMutation, CompleteServiceIntakeMutationVariables>;
export const ProviderStorefrontDocument = gql`
    query ProviderStorefront {
  providerStorefront {
    ...providerStorefrontData
  }
}
    ${ProviderStorefrontDataFragmentDoc}`;

/**
 * __useProviderStorefrontQuery__
 *
 * To run a query within a React component, call `useProviderStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderStorefrontQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderStorefrontQuery(baseOptions?: Apollo.QueryHookOptions<ProviderStorefrontQuery, ProviderStorefrontQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderStorefrontQuery, ProviderStorefrontQueryVariables>(ProviderStorefrontDocument, options);
      }
export function useProviderStorefrontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderStorefrontQuery, ProviderStorefrontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderStorefrontQuery, ProviderStorefrontQueryVariables>(ProviderStorefrontDocument, options);
        }
export type ProviderStorefrontQueryHookResult = ReturnType<typeof useProviderStorefrontQuery>;
export type ProviderStorefrontLazyQueryHookResult = ReturnType<typeof useProviderStorefrontLazyQuery>;
export type ProviderStorefrontQueryResult = Apollo.QueryResult<ProviderStorefrontQuery, ProviderStorefrontQueryVariables>;
export const IntakePackageDocument = gql`
    query IntakePackage {
  intakePackage {
    storefrontSlug
    intakeFormProgramActivity {
      ...programActivityData
    }
    calendlyEventType {
      name
      description
      calendlyEventTypeUri
      schedulingUrl
    }
    completedStorefrontCalendlyBookingAt
  }
}
    ${ProgramActivityDataFragmentDoc}`;

/**
 * __useIntakePackageQuery__
 *
 * To run a query within a React component, call `useIntakePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntakePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntakePackageQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntakePackageQuery(baseOptions?: Apollo.QueryHookOptions<IntakePackageQuery, IntakePackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntakePackageQuery, IntakePackageQueryVariables>(IntakePackageDocument, options);
      }
export function useIntakePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntakePackageQuery, IntakePackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntakePackageQuery, IntakePackageQueryVariables>(IntakePackageDocument, options);
        }
export type IntakePackageQueryHookResult = ReturnType<typeof useIntakePackageQuery>;
export type IntakePackageLazyQueryHookResult = ReturnType<typeof useIntakePackageLazyQuery>;
export type IntakePackageQueryResult = Apollo.QueryResult<IntakePackageQuery, IntakePackageQueryVariables>;
export const PublicStorefrontDocument = gql`
    query PublicStorefront($slug: String!) {
  publicStorefront(slug: $slug) {
    providerName
    profileImageUrl
    providerRoleTitle
    providerCtaFormLabel
    providerCtaButtonText
    bannerImageUrl
    bannerPosition
    profileImageUrl
    tagline
    about
    services
    publicServices {
      ...publicProviderServiceData
    }
  }
}
    ${PublicProviderServiceDataFragmentDoc}`;

/**
 * __usePublicStorefrontQuery__
 *
 * To run a query within a React component, call `usePublicStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicStorefrontQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function usePublicStorefrontQuery(baseOptions: Apollo.QueryHookOptions<PublicStorefrontQuery, PublicStorefrontQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicStorefrontQuery, PublicStorefrontQueryVariables>(PublicStorefrontDocument, options);
      }
export function usePublicStorefrontLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicStorefrontQuery, PublicStorefrontQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicStorefrontQuery, PublicStorefrontQueryVariables>(PublicStorefrontDocument, options);
        }
export type PublicStorefrontQueryHookResult = ReturnType<typeof usePublicStorefrontQuery>;
export type PublicStorefrontLazyQueryHookResult = ReturnType<typeof usePublicStorefrontLazyQuery>;
export type PublicStorefrontQueryResult = Apollo.QueryResult<PublicStorefrontQuery, PublicStorefrontQueryVariables>;
export const UpdateProviderStorefrontDocument = gql`
    mutation UpdateProviderStorefront($input: UpdateProviderStorefrontInput!) {
  updateProviderStorefront(input: $input) {
    ...providerStorefrontData
  }
}
    ${ProviderStorefrontDataFragmentDoc}`;
export type UpdateProviderStorefrontMutationFn = Apollo.MutationFunction<UpdateProviderStorefrontMutation, UpdateProviderStorefrontMutationVariables>;

/**
 * __useUpdateProviderStorefrontMutation__
 *
 * To run a mutation, you first call `useUpdateProviderStorefrontMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProviderStorefrontMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProviderStorefrontMutation, { data, loading, error }] = useUpdateProviderStorefrontMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProviderStorefrontMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProviderStorefrontMutation, UpdateProviderStorefrontMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProviderStorefrontMutation, UpdateProviderStorefrontMutationVariables>(UpdateProviderStorefrontDocument, options);
      }
export type UpdateProviderStorefrontMutationHookResult = ReturnType<typeof useUpdateProviderStorefrontMutation>;
export type UpdateProviderStorefrontMutationResult = Apollo.MutationResult<UpdateProviderStorefrontMutation>;
export type UpdateProviderStorefrontMutationOptions = Apollo.BaseMutationOptions<UpdateProviderStorefrontMutation, UpdateProviderStorefrontMutationVariables>;
export const CompleteStorefrontCalendlyBookingDocument = gql`
    mutation CompleteStorefrontCalendlyBooking {
  completeStorefrontCalendlyBooking
}
    `;
export type CompleteStorefrontCalendlyBookingMutationFn = Apollo.MutationFunction<CompleteStorefrontCalendlyBookingMutation, CompleteStorefrontCalendlyBookingMutationVariables>;

/**
 * __useCompleteStorefrontCalendlyBookingMutation__
 *
 * To run a mutation, you first call `useCompleteStorefrontCalendlyBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStorefrontCalendlyBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStorefrontCalendlyBookingMutation, { data, loading, error }] = useCompleteStorefrontCalendlyBookingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteStorefrontCalendlyBookingMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStorefrontCalendlyBookingMutation, CompleteStorefrontCalendlyBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStorefrontCalendlyBookingMutation, CompleteStorefrontCalendlyBookingMutationVariables>(CompleteStorefrontCalendlyBookingDocument, options);
      }
export type CompleteStorefrontCalendlyBookingMutationHookResult = ReturnType<typeof useCompleteStorefrontCalendlyBookingMutation>;
export type CompleteStorefrontCalendlyBookingMutationResult = Apollo.MutationResult<CompleteStorefrontCalendlyBookingMutation>;
export type CompleteStorefrontCalendlyBookingMutationOptions = Apollo.BaseMutationOptions<CompleteStorefrontCalendlyBookingMutation, CompleteStorefrontCalendlyBookingMutationVariables>;
export const CompleteStorefrontIntakeDocument = gql`
    mutation CompleteStorefrontIntake {
  completeStorefrontIntake
}
    `;
export type CompleteStorefrontIntakeMutationFn = Apollo.MutationFunction<CompleteStorefrontIntakeMutation, CompleteStorefrontIntakeMutationVariables>;

/**
 * __useCompleteStorefrontIntakeMutation__
 *
 * To run a mutation, you first call `useCompleteStorefrontIntakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteStorefrontIntakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeStorefrontIntakeMutation, { data, loading, error }] = useCompleteStorefrontIntakeMutation({
 *   variables: {
 *   },
 * });
 */
export function useCompleteStorefrontIntakeMutation(baseOptions?: Apollo.MutationHookOptions<CompleteStorefrontIntakeMutation, CompleteStorefrontIntakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteStorefrontIntakeMutation, CompleteStorefrontIntakeMutationVariables>(CompleteStorefrontIntakeDocument, options);
      }
export type CompleteStorefrontIntakeMutationHookResult = ReturnType<typeof useCompleteStorefrontIntakeMutation>;
export type CompleteStorefrontIntakeMutationResult = Apollo.MutationResult<CompleteStorefrontIntakeMutation>;
export type CompleteStorefrontIntakeMutationOptions = Apollo.BaseMutationOptions<CompleteStorefrontIntakeMutation, CompleteStorefrontIntakeMutationVariables>;
export const StripeCheckoutPortalDocument = gql`
    query StripeCheckoutPortal($isOnboarding: Boolean, $webRedirectPath: String, $choseAnnual: Boolean, $tierSelection: SubscriptionTierV2, $extraSeatCount: Int) {
  stripeCheckoutPortal(
    isOnboarding: $isOnboarding
    webRedirectPath: $webRedirectPath
    choseAnnual: $choseAnnual
    tierSelection: $tierSelection
    extraSeatCount: $extraSeatCount
  ) {
    url
  }
}
    `;

/**
 * __useStripeCheckoutPortalQuery__
 *
 * To run a query within a React component, call `useStripeCheckoutPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCheckoutPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCheckoutPortalQuery({
 *   variables: {
 *      isOnboarding: // value for 'isOnboarding'
 *      webRedirectPath: // value for 'webRedirectPath'
 *      choseAnnual: // value for 'choseAnnual'
 *      tierSelection: // value for 'tierSelection'
 *      extraSeatCount: // value for 'extraSeatCount'
 *   },
 * });
 */
export function useStripeCheckoutPortalQuery(baseOptions?: Apollo.QueryHookOptions<StripeCheckoutPortalQuery, StripeCheckoutPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCheckoutPortalQuery, StripeCheckoutPortalQueryVariables>(StripeCheckoutPortalDocument, options);
      }
export function useStripeCheckoutPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCheckoutPortalQuery, StripeCheckoutPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCheckoutPortalQuery, StripeCheckoutPortalQueryVariables>(StripeCheckoutPortalDocument, options);
        }
export type StripeCheckoutPortalQueryHookResult = ReturnType<typeof useStripeCheckoutPortalQuery>;
export type StripeCheckoutPortalLazyQueryHookResult = ReturnType<typeof useStripeCheckoutPortalLazyQuery>;
export type StripeCheckoutPortalQueryResult = Apollo.QueryResult<StripeCheckoutPortalQuery, StripeCheckoutPortalQueryVariables>;
export const StripeCustomerPortalDocument = gql`
    query StripeCustomerPortal {
  stripeCustomerPortal {
    url
  }
}
    `;

/**
 * __useStripeCustomerPortalQuery__
 *
 * To run a query within a React component, call `useStripeCustomerPortalQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeCustomerPortalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeCustomerPortalQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeCustomerPortalQuery(baseOptions?: Apollo.QueryHookOptions<StripeCustomerPortalQuery, StripeCustomerPortalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeCustomerPortalQuery, StripeCustomerPortalQueryVariables>(StripeCustomerPortalDocument, options);
      }
export function useStripeCustomerPortalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeCustomerPortalQuery, StripeCustomerPortalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeCustomerPortalQuery, StripeCustomerPortalQueryVariables>(StripeCustomerPortalDocument, options);
        }
export type StripeCustomerPortalQueryHookResult = ReturnType<typeof useStripeCustomerPortalQuery>;
export type StripeCustomerPortalLazyQueryHookResult = ReturnType<typeof useStripeCustomerPortalLazyQuery>;
export type StripeCustomerPortalQueryResult = Apollo.QueryResult<StripeCustomerPortalQuery, StripeCustomerPortalQueryVariables>;
export const ProviderIsOnLegacyV2PricingDocument = gql`
    query ProviderIsOnLegacyV2Pricing {
  meProvider {
    provider {
      isOnLegacyV2Pricing
    }
  }
}
    `;

/**
 * __useProviderIsOnLegacyV2PricingQuery__
 *
 * To run a query within a React component, call `useProviderIsOnLegacyV2PricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderIsOnLegacyV2PricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderIsOnLegacyV2PricingQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderIsOnLegacyV2PricingQuery(baseOptions?: Apollo.QueryHookOptions<ProviderIsOnLegacyV2PricingQuery, ProviderIsOnLegacyV2PricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderIsOnLegacyV2PricingQuery, ProviderIsOnLegacyV2PricingQueryVariables>(ProviderIsOnLegacyV2PricingDocument, options);
      }
export function useProviderIsOnLegacyV2PricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderIsOnLegacyV2PricingQuery, ProviderIsOnLegacyV2PricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderIsOnLegacyV2PricingQuery, ProviderIsOnLegacyV2PricingQueryVariables>(ProviderIsOnLegacyV2PricingDocument, options);
        }
export type ProviderIsOnLegacyV2PricingQueryHookResult = ReturnType<typeof useProviderIsOnLegacyV2PricingQuery>;
export type ProviderIsOnLegacyV2PricingLazyQueryHookResult = ReturnType<typeof useProviderIsOnLegacyV2PricingLazyQuery>;
export type ProviderIsOnLegacyV2PricingQueryResult = Apollo.QueryResult<ProviderIsOnLegacyV2PricingQuery, ProviderIsOnLegacyV2PricingQueryVariables>;
export const StripeCheckoutSuccessDocument = gql`
    mutation StripeCheckoutSuccess($checkoutSessionId: String!) {
  stripeCheckoutSuccess(checkoutSessionId: $checkoutSessionId)
}
    `;
export type StripeCheckoutSuccessMutationFn = Apollo.MutationFunction<StripeCheckoutSuccessMutation, StripeCheckoutSuccessMutationVariables>;

/**
 * __useStripeCheckoutSuccessMutation__
 *
 * To run a mutation, you first call `useStripeCheckoutSuccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeCheckoutSuccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeCheckoutSuccessMutation, { data, loading, error }] = useStripeCheckoutSuccessMutation({
 *   variables: {
 *      checkoutSessionId: // value for 'checkoutSessionId'
 *   },
 * });
 */
export function useStripeCheckoutSuccessMutation(baseOptions?: Apollo.MutationHookOptions<StripeCheckoutSuccessMutation, StripeCheckoutSuccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeCheckoutSuccessMutation, StripeCheckoutSuccessMutationVariables>(StripeCheckoutSuccessDocument, options);
      }
export type StripeCheckoutSuccessMutationHookResult = ReturnType<typeof useStripeCheckoutSuccessMutation>;
export type StripeCheckoutSuccessMutationResult = Apollo.MutationResult<StripeCheckoutSuccessMutation>;
export type StripeCheckoutSuccessMutationOptions = Apollo.BaseMutationOptions<StripeCheckoutSuccessMutation, StripeCheckoutSuccessMutationVariables>;
export const UpdateStripeSubscriptionDocument = gql`
    mutation UpdateStripeSubscription {
  updateStripeSubscription
}
    `;
export type UpdateStripeSubscriptionMutationFn = Apollo.MutationFunction<UpdateStripeSubscriptionMutation, UpdateStripeSubscriptionMutationVariables>;

/**
 * __useUpdateStripeSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateStripeSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStripeSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStripeSubscriptionMutation, { data, loading, error }] = useUpdateStripeSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateStripeSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStripeSubscriptionMutation, UpdateStripeSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStripeSubscriptionMutation, UpdateStripeSubscriptionMutationVariables>(UpdateStripeSubscriptionDocument, options);
      }
export type UpdateStripeSubscriptionMutationHookResult = ReturnType<typeof useUpdateStripeSubscriptionMutation>;
export type UpdateStripeSubscriptionMutationResult = Apollo.MutationResult<UpdateStripeSubscriptionMutation>;
export type UpdateStripeSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateStripeSubscriptionMutation, UpdateStripeSubscriptionMutationVariables>;
export const AddProgramTagDocument = gql`
    mutation AddProgramTag($input: AddProgramTagInput!) {
  addProgramTag(input: $input) {
    updatedProgramTags {
      ...programTagWithCountData
    }
  }
}
    ${ProgramTagWithCountDataFragmentDoc}`;
export type AddProgramTagMutationFn = Apollo.MutationFunction<AddProgramTagMutation, AddProgramTagMutationVariables>;

/**
 * __useAddProgramTagMutation__
 *
 * To run a mutation, you first call `useAddProgramTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProgramTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProgramTagMutation, { data, loading, error }] = useAddProgramTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProgramTagMutation(baseOptions?: Apollo.MutationHookOptions<AddProgramTagMutation, AddProgramTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProgramTagMutation, AddProgramTagMutationVariables>(AddProgramTagDocument, options);
      }
export type AddProgramTagMutationHookResult = ReturnType<typeof useAddProgramTagMutation>;
export type AddProgramTagMutationResult = Apollo.MutationResult<AddProgramTagMutation>;
export type AddProgramTagMutationOptions = Apollo.BaseMutationOptions<AddProgramTagMutation, AddProgramTagMutationVariables>;
export const RemoveProgramTagDocument = gql`
    mutation RemoveProgramTag($input: RemoveProgramTagInput!) {
  removeProgramTag(input: $input) {
    updatedProgramTags {
      ...programTagWithCountData
    }
  }
}
    ${ProgramTagWithCountDataFragmentDoc}`;
export type RemoveProgramTagMutationFn = Apollo.MutationFunction<RemoveProgramTagMutation, RemoveProgramTagMutationVariables>;

/**
 * __useRemoveProgramTagMutation__
 *
 * To run a mutation, you first call `useRemoveProgramTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProgramTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProgramTagMutation, { data, loading, error }] = useRemoveProgramTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProgramTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProgramTagMutation, RemoveProgramTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProgramTagMutation, RemoveProgramTagMutationVariables>(RemoveProgramTagDocument, options);
      }
export type RemoveProgramTagMutationHookResult = ReturnType<typeof useRemoveProgramTagMutation>;
export type RemoveProgramTagMutationResult = Apollo.MutationResult<RemoveProgramTagMutation>;
export type RemoveProgramTagMutationOptions = Apollo.BaseMutationOptions<RemoveProgramTagMutation, RemoveProgramTagMutationVariables>;
export const CreateProgramTagDocument = gql`
    mutation CreateProgramTag($input: ProgramTagInput!) {
  createProgramTag(input: $input) {
    ...programTagWithCountData
  }
}
    ${ProgramTagWithCountDataFragmentDoc}`;
export type CreateProgramTagMutationFn = Apollo.MutationFunction<CreateProgramTagMutation, CreateProgramTagMutationVariables>;

/**
 * __useCreateProgramTagMutation__
 *
 * To run a mutation, you first call `useCreateProgramTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProgramTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProgramTagMutation, { data, loading, error }] = useCreateProgramTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProgramTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateProgramTagMutation, CreateProgramTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProgramTagMutation, CreateProgramTagMutationVariables>(CreateProgramTagDocument, options);
      }
export type CreateProgramTagMutationHookResult = ReturnType<typeof useCreateProgramTagMutation>;
export type CreateProgramTagMutationResult = Apollo.MutationResult<CreateProgramTagMutation>;
export type CreateProgramTagMutationOptions = Apollo.BaseMutationOptions<CreateProgramTagMutation, CreateProgramTagMutationVariables>;
export const UpdateProgramTagDocument = gql`
    mutation UpdateProgramTag($input: UpdateProgramTagInput!) {
  updateProgramTag(input: $input) {
    ...programTagData
  }
}
    ${ProgramTagDataFragmentDoc}`;
export type UpdateProgramTagMutationFn = Apollo.MutationFunction<UpdateProgramTagMutation, UpdateProgramTagMutationVariables>;

/**
 * __useUpdateProgramTagMutation__
 *
 * To run a mutation, you first call `useUpdateProgramTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramTagMutation, { data, loading, error }] = useUpdateProgramTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProgramTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProgramTagMutation, UpdateProgramTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProgramTagMutation, UpdateProgramTagMutationVariables>(UpdateProgramTagDocument, options);
      }
export type UpdateProgramTagMutationHookResult = ReturnType<typeof useUpdateProgramTagMutation>;
export type UpdateProgramTagMutationResult = Apollo.MutationResult<UpdateProgramTagMutation>;
export type UpdateProgramTagMutationOptions = Apollo.BaseMutationOptions<UpdateProgramTagMutation, UpdateProgramTagMutationVariables>;
export const DeleteProgramTagDocument = gql`
    mutation DeleteProgramTag($programTagId: String!) {
  deleteProgramTag(programTagId: $programTagId) {
    ...programTagData
  }
}
    ${ProgramTagDataFragmentDoc}`;
export type DeleteProgramTagMutationFn = Apollo.MutationFunction<DeleteProgramTagMutation, DeleteProgramTagMutationVariables>;

/**
 * __useDeleteProgramTagMutation__
 *
 * To run a mutation, you first call `useDeleteProgramTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProgramTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProgramTagMutation, { data, loading, error }] = useDeleteProgramTagMutation({
 *   variables: {
 *      programTagId: // value for 'programTagId'
 *   },
 * });
 */
export function useDeleteProgramTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProgramTagMutation, DeleteProgramTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProgramTagMutation, DeleteProgramTagMutationVariables>(DeleteProgramTagDocument, options);
      }
export type DeleteProgramTagMutationHookResult = ReturnType<typeof useDeleteProgramTagMutation>;
export type DeleteProgramTagMutationResult = Apollo.MutationResult<DeleteProgramTagMutation>;
export type DeleteProgramTagMutationOptions = Apollo.BaseMutationOptions<DeleteProgramTagMutation, DeleteProgramTagMutationVariables>;
export const ReorderProgramTagsDocument = gql`
    mutation ReorderProgramTags($input: [ReorderProgramTagInput!]!) {
  reorderProgramTags(input: $input)
}
    `;
export type ReorderProgramTagsMutationFn = Apollo.MutationFunction<ReorderProgramTagsMutation, ReorderProgramTagsMutationVariables>;

/**
 * __useReorderProgramTagsMutation__
 *
 * To run a mutation, you first call `useReorderProgramTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderProgramTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderProgramTagsMutation, { data, loading, error }] = useReorderProgramTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReorderProgramTagsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderProgramTagsMutation, ReorderProgramTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderProgramTagsMutation, ReorderProgramTagsMutationVariables>(ReorderProgramTagsDocument, options);
      }
export type ReorderProgramTagsMutationHookResult = ReturnType<typeof useReorderProgramTagsMutation>;
export type ReorderProgramTagsMutationResult = Apollo.MutationResult<ReorderProgramTagsMutation>;
export type ReorderProgramTagsMutationOptions = Apollo.BaseMutationOptions<ReorderProgramTagsMutation, ReorderProgramTagsMutationVariables>;
export const ProviderSummaryDocument = gql`
    query ProviderSummary($providerId: ID!, $input: ProviderSummaryInput!) {
  providerPerformanceSummary(providerId: $providerId, input: $input) {
    totalSessions {
      current
      previous
      changeInPercentage
      changeInValue
      direction
      impact
    }
    totalPractitioners {
      current
      previous
      changeInPercentage
      changeInValue
      direction
      impact
    }
    totalClients {
      current
      previous
      changeInPercentage
      changeInValue
      direction
      impact
    }
    averageResponseTime {
      current
      previous
      changeInPercentage
      changeInValue
      direction
      impact
    }
    averageTimeToFirstResponse {
      current
      previous
      changeInPercentage
      changeInValue
      direction
      impact
    }
  }
}
    `;

/**
 * __useProviderSummaryQuery__
 *
 * To run a query within a React component, call `useProviderSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderSummaryQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProviderSummaryQuery(baseOptions: Apollo.QueryHookOptions<ProviderSummaryQuery, ProviderSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderSummaryQuery, ProviderSummaryQueryVariables>(ProviderSummaryDocument, options);
      }
export function useProviderSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderSummaryQuery, ProviderSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderSummaryQuery, ProviderSummaryQueryVariables>(ProviderSummaryDocument, options);
        }
export type ProviderSummaryQueryHookResult = ReturnType<typeof useProviderSummaryQuery>;
export type ProviderSummaryLazyQueryHookResult = ReturnType<typeof useProviderSummaryLazyQuery>;
export type ProviderSummaryQueryResult = Apollo.QueryResult<ProviderSummaryQuery, ProviderSummaryQueryVariables>;
export const PractitionerAssignmentsDocument = gql`
    query PractitionerAssignments($providerId: ID!) {
  practitionerAssignments(providerId: $providerId) {
    practitioner {
      id
      name
      role
      profileImageUrl
    }
    assignedClients {
      id
      name
      profileImageUrl
      latestProgramId
      tags {
        id
        name
      }
    }
  }
}
    `;

/**
 * __usePractitionerAssignmentsQuery__
 *
 * To run a query within a React component, call `usePractitionerAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePractitionerAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePractitionerAssignmentsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function usePractitionerAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<PractitionerAssignmentsQuery, PractitionerAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PractitionerAssignmentsQuery, PractitionerAssignmentsQueryVariables>(PractitionerAssignmentsDocument, options);
      }
export function usePractitionerAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PractitionerAssignmentsQuery, PractitionerAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PractitionerAssignmentsQuery, PractitionerAssignmentsQueryVariables>(PractitionerAssignmentsDocument, options);
        }
export type PractitionerAssignmentsQueryHookResult = ReturnType<typeof usePractitionerAssignmentsQuery>;
export type PractitionerAssignmentsLazyQueryHookResult = ReturnType<typeof usePractitionerAssignmentsLazyQuery>;
export type PractitionerAssignmentsQueryResult = Apollo.QueryResult<PractitionerAssignmentsQuery, PractitionerAssignmentsQueryVariables>;
export const ClientsPerformanceSummaryDocument = gql`
    query ClientsPerformanceSummary($input: ClientsPerformanceSummaryInput!) {
  clientsPerformanceSummary(input: $input) {
    totals {
      totalAlerts
      totalSessions
      averageResponseTime
      averageTimeToFirstResponse
    }
    clients {
      id
      name
      startedAt
      tags {
        id
        name
        color
      }
      metrics {
        totalAlerts
        totalSessions
        averageResponseTime
        averageTimeToFirstResponse
      }
    }
  }
}
    `;

/**
 * __useClientsPerformanceSummaryQuery__
 *
 * To run a query within a React component, call `useClientsPerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsPerformanceSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientsPerformanceSummaryQuery(baseOptions: Apollo.QueryHookOptions<ClientsPerformanceSummaryQuery, ClientsPerformanceSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsPerformanceSummaryQuery, ClientsPerformanceSummaryQueryVariables>(ClientsPerformanceSummaryDocument, options);
      }
export function useClientsPerformanceSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsPerformanceSummaryQuery, ClientsPerformanceSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsPerformanceSummaryQuery, ClientsPerformanceSummaryQueryVariables>(ClientsPerformanceSummaryDocument, options);
        }
export type ClientsPerformanceSummaryQueryHookResult = ReturnType<typeof useClientsPerformanceSummaryQuery>;
export type ClientsPerformanceSummaryLazyQueryHookResult = ReturnType<typeof useClientsPerformanceSummaryLazyQuery>;
export type ClientsPerformanceSummaryQueryResult = Apollo.QueryResult<ClientsPerformanceSummaryQuery, ClientsPerformanceSummaryQueryVariables>;
export const TeamPerformanceInsightsMetricsDocument = gql`
    query TeamPerformanceInsightsMetrics($providerId: ID!, $input: TeamPerformanceInsightsMetricsInput!) {
  teamPerformanceInsightsMetrics(providerId: $providerId, input: $input) {
    rangeStart
    rangeEnd
    timezone
    sessionsBooked {
      value
    }
    newClients {
      value
    }
  }
}
    `;

/**
 * __useTeamPerformanceInsightsMetricsQuery__
 *
 * To run a query within a React component, call `useTeamPerformanceInsightsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamPerformanceInsightsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamPerformanceInsightsMetricsQuery({
 *   variables: {
 *      providerId: // value for 'providerId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeamPerformanceInsightsMetricsQuery(baseOptions: Apollo.QueryHookOptions<TeamPerformanceInsightsMetricsQuery, TeamPerformanceInsightsMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamPerformanceInsightsMetricsQuery, TeamPerformanceInsightsMetricsQueryVariables>(TeamPerformanceInsightsMetricsDocument, options);
      }
export function useTeamPerformanceInsightsMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamPerformanceInsightsMetricsQuery, TeamPerformanceInsightsMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamPerformanceInsightsMetricsQuery, TeamPerformanceInsightsMetricsQueryVariables>(TeamPerformanceInsightsMetricsDocument, options);
        }
export type TeamPerformanceInsightsMetricsQueryHookResult = ReturnType<typeof useTeamPerformanceInsightsMetricsQuery>;
export type TeamPerformanceInsightsMetricsLazyQueryHookResult = ReturnType<typeof useTeamPerformanceInsightsMetricsLazyQuery>;
export type TeamPerformanceInsightsMetricsQueryResult = Apollo.QueryResult<TeamPerformanceInsightsMetricsQuery, TeamPerformanceInsightsMetricsQueryVariables>;
export const GetHandPickedLanguagesDocument = gql`
    query GetHandPickedLanguages {
  handPickedLanguages
}
    `;

/**
 * __useGetHandPickedLanguagesQuery__
 *
 * To run a query within a React component, call `useGetHandPickedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandPickedLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandPickedLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHandPickedLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetHandPickedLanguagesQuery, GetHandPickedLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandPickedLanguagesQuery, GetHandPickedLanguagesQueryVariables>(GetHandPickedLanguagesDocument, options);
      }
export function useGetHandPickedLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandPickedLanguagesQuery, GetHandPickedLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandPickedLanguagesQuery, GetHandPickedLanguagesQueryVariables>(GetHandPickedLanguagesDocument, options);
        }
export type GetHandPickedLanguagesQueryHookResult = ReturnType<typeof useGetHandPickedLanguagesQuery>;
export type GetHandPickedLanguagesLazyQueryHookResult = ReturnType<typeof useGetHandPickedLanguagesLazyQuery>;
export type GetHandPickedLanguagesQueryResult = Apollo.QueryResult<GetHandPickedLanguagesQuery, GetHandPickedLanguagesQueryVariables>;
export const GetLanguagesDocument = gql`
    query GetLanguages($filterQuery: String) {
  languages(filterQuery: $filterQuery)
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      filterQuery: // value for 'filterQuery'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetHandPickedTimezonesDocument = gql`
    query GetHandPickedTimezones {
  handPickedTimezones {
    value
    offset
  }
}
    `;

/**
 * __useGetHandPickedTimezonesQuery__
 *
 * To run a query within a React component, call `useGetHandPickedTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandPickedTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandPickedTimezonesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHandPickedTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<GetHandPickedTimezonesQuery, GetHandPickedTimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandPickedTimezonesQuery, GetHandPickedTimezonesQueryVariables>(GetHandPickedTimezonesDocument, options);
      }
export function useGetHandPickedTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandPickedTimezonesQuery, GetHandPickedTimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandPickedTimezonesQuery, GetHandPickedTimezonesQueryVariables>(GetHandPickedTimezonesDocument, options);
        }
export type GetHandPickedTimezonesQueryHookResult = ReturnType<typeof useGetHandPickedTimezonesQuery>;
export type GetHandPickedTimezonesLazyQueryHookResult = ReturnType<typeof useGetHandPickedTimezonesLazyQuery>;
export type GetHandPickedTimezonesQueryResult = Apollo.QueryResult<GetHandPickedTimezonesQuery, GetHandPickedTimezonesQueryVariables>;
export const GetTimezonesDocument = gql`
    query GetTimezones($filterQuery: String) {
  timezones(filterQuery: $filterQuery) {
    value
    offset
  }
}
    `;

/**
 * __useGetTimezonesQuery__
 *
 * To run a query within a React component, call `useGetTimezonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimezonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimezonesQuery({
 *   variables: {
 *      filterQuery: // value for 'filterQuery'
 *   },
 * });
 */
export function useGetTimezonesQuery(baseOptions?: Apollo.QueryHookOptions<GetTimezonesQuery, GetTimezonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(GetTimezonesDocument, options);
      }
export function useGetTimezonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimezonesQuery, GetTimezonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimezonesQuery, GetTimezonesQueryVariables>(GetTimezonesDocument, options);
        }
export type GetTimezonesQueryHookResult = ReturnType<typeof useGetTimezonesQuery>;
export type GetTimezonesLazyQueryHookResult = ReturnType<typeof useGetTimezonesLazyQuery>;
export type GetTimezonesQueryResult = Apollo.QueryResult<GetTimezonesQuery, GetTimezonesQueryVariables>;
export const GetReferralSourcesDocument = gql`
    query GetReferralSources($filterQuery: String) {
  referralSources(filterQuery: $filterQuery)
}
    `;

/**
 * __useGetReferralSourcesQuery__
 *
 * To run a query within a React component, call `useGetReferralSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralSourcesQuery({
 *   variables: {
 *      filterQuery: // value for 'filterQuery'
 *   },
 * });
 */
export function useGetReferralSourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetReferralSourcesQuery, GetReferralSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralSourcesQuery, GetReferralSourcesQueryVariables>(GetReferralSourcesDocument, options);
      }
export function useGetReferralSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralSourcesQuery, GetReferralSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralSourcesQuery, GetReferralSourcesQueryVariables>(GetReferralSourcesDocument, options);
        }
export type GetReferralSourcesQueryHookResult = ReturnType<typeof useGetReferralSourcesQuery>;
export type GetReferralSourcesLazyQueryHookResult = ReturnType<typeof useGetReferralSourcesLazyQuery>;
export type GetReferralSourcesQueryResult = Apollo.QueryResult<GetReferralSourcesQuery, GetReferralSourcesQueryVariables>;
export const GetHandPickedCountriesDocument = gql`
    query GetHandPickedCountries {
  handPickedCountries
}
    `;

/**
 * __useGetHandPickedCountriesQuery__
 *
 * To run a query within a React component, call `useGetHandPickedCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHandPickedCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHandPickedCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHandPickedCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetHandPickedCountriesQuery, GetHandPickedCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHandPickedCountriesQuery, GetHandPickedCountriesQueryVariables>(GetHandPickedCountriesDocument, options);
      }
export function useGetHandPickedCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHandPickedCountriesQuery, GetHandPickedCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHandPickedCountriesQuery, GetHandPickedCountriesQueryVariables>(GetHandPickedCountriesDocument, options);
        }
export type GetHandPickedCountriesQueryHookResult = ReturnType<typeof useGetHandPickedCountriesQuery>;
export type GetHandPickedCountriesLazyQueryHookResult = ReturnType<typeof useGetHandPickedCountriesLazyQuery>;
export type GetHandPickedCountriesQueryResult = Apollo.QueryResult<GetHandPickedCountriesQuery, GetHandPickedCountriesQueryVariables>;
export const GetCountriesDocument = gql`
    query GetCountries($filterQuery: String) {
  countries(filterQuery: $filterQuery)
}
    `;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      filterQuery: // value for 'filterQuery'
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
      }
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
        }
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;